<template>
  <div class="cloud-shell" :class="{ 'is-interaction-locked': interactionLocked, 'is-daily-root': activeAppFolder == 'daily' && !activeAppDetailMode && !settingModalVisible }">
    <div v-if="showUserMenuMask" class="user-popover-mask" @click="closeUserMenu"></div>
    <div class="cloud-page" :class="{ collapsed: menuCollapsed }">
      <aside v-if="false" class="cloud-sidebar">
        <div class="brand-row">
          <img v-if="!menuCollapsed" src="@/assets/wap/logo.png" alt="viwoods" class="brand-logo" />
          <button class="collapse-button" type="button" @click="menuCollapsed = !menuCollapsed" aria-label="Toggle menu">
            <img src="@/assets/wap/emnu_shouqi.png" alt="" />
          </button>
        </div>

        <nav class="side-nav">
          <button
            v-for="item in menuItems"
            :key="item.key"
            type="button"
            class="side-item"
            :class="{ active: currentMenuKey == item.key }"
            @click="changeMenu(item.key)"
          >
            <img class="menu-icon" :src="item.icon" alt="" />
            <span v-if="!menuCollapsed" class="menu-label">{{ item.label }}</span>
          </button>
        </nav>

        <a-dropdown
          :trigger="['click']"
          placement="topLeft"
          :overlayClassName="userMenuOverlayClass"
          :align="{ offset: [0, 4] }"
          :visible="userMenuVisible"
          @visibleChange="handleUserMenuVisibleChange"
        >
          <button class="user-entry" type="button">
            <span class="user-avatar">{{ userInitial }}</span>
            <span v-if="!menuCollapsed" class="user-entry-meta">
              <span class="user-name">{{ displayAccountName }}</span>
            </span>
          </button>
          <template #overlay>
            <div class="user-popover" @click.stop>
              <div class="popover-profile" :title="fullAccountName">
                <span class="popover-avatar">{{ userInitial }}</span>
                <span class="popover-profile-meta">
                  <span class="popover-name">{{ displayAccountName }}</span>
                  <span v-if="displayAccountDetail" class="popover-detail">{{ displayAccountDetail }}</span>
                </span>
              </div>

              <button class="popover-action" type="button" @click.stop="openSettingModal">
                <img class="popover-icon" src="@/assets/wap/center_setting.png" alt="" />
                <span class="popover-text">{{ uiText.setting }}</span>
                <img class="popover-open" src="@/assets/wap/center_open.png" alt="" />
              </button>

              <button class="popover-action" type="button" @click.stop="openLanguageModal">
                <img class="popover-icon" src="@/assets/wap/center_language.png" alt="" />
                <span class="popover-text">{{ uiText.language }}</span>
                <img class="popover-open" src="@/assets/wap/center_open.png" alt="" />
              </button>

              <button class="popover-action" type="button" @click.stop="openExitModal">
                <img class="popover-icon" src="@/assets/wap/center_exit.png" alt="" />
                <span class="popover-text">{{ uiText.logout }}</span>
                <img class="popover-open" src="@/assets/wap/center_open.png" alt="" />
              </button>
            </div>
          </template>
        </a-dropdown>
      </aside>

      <main
        class="cloud-main"
        :class="{
          'is-recent-detail': (activeAppFolder == 'paper' || activeAppFolder == 'meeting' || activeAppFolder == 'knowledge' || activeAppFolder == 'learning' || activeAppFolder == 'memo' || activeAppFolder == 'daily') && (activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files'),
          'is-recent-paper-detail': (activeAppFolder == 'paper' || activeAppFolder == 'daily') && (activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files'),
          'is-recent-daily-preview-detail': activeAppFolder == 'daily' && (activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files'),
          'is-recent-meeting-detail': activeAppFolder == 'meeting' && (activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files'),
          'is-recent-knowledge-detail': activeAppFolder == 'knowledge' && (activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files'),
          'is-recent-memo-detail': activeAppFolder == 'memo' && (activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files'),
          'is-recent-preview-current-line': (activeAppFolder == 'paper' || activeAppFolder == 'meeting' || activeAppFolder == 'knowledge' || activeAppFolder == 'learning' || activeAppFolder == 'memo' || activeAppFolder == 'daily') && (activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files'),
          'is-recent-preview-grid-detail': (activeAppFolder == 'paper' || activeAppFolder == 'meeting' || activeAppFolder == 'knowledge' || activeAppFolder == 'memo' || activeAppFolder == 'daily') && (activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files'),
          'is-search-file-preview-detail': globalSearchFilePreviewActive,
          'is-search-paper-preview-detail': globalSearchFilePreviewActive && (activeAppFolder == 'paper' || activeAppFolder == 'daily'),
          'is-search-meeting-preview-detail': globalSearchFilePreviewActive && activeAppFolder == 'meeting',
          'is-search-knowledge-preview-detail': globalSearchFilePreviewActive && activeAppFolder == 'knowledge',
          'is-search-memo-preview-detail': globalSearchFilePreviewActive && activeAppFolder == 'memo',
          'is-search-daily-preview-detail': globalSearchFilePreviewActive && activeAppFolder == 'daily',
          'is-search-file-preview-current-line': globalSearchFilePreviewActive,
          'is-search-file-preview-grid-detail': globalSearchFilePreviewActive && activeAppFolder != 'learning',
          'is-active-preview-detail': activeAppDetailMode
        }"
        @touchstart="handleRecentPreviewTouchStart"
        @touchmove="handleRecentPreviewTouchMove"
        @touchend="handleRecentPreviewTouchEnd"
        @touchcancel="resetRecentPreviewTouchState"
      >
        <section v-if="settingModalVisible" class="mobile-user-center">
          <header class="mobile-user-center-header">
            <button
              v-if="settingActiveTab != 'root'"
              class="mobile-user-center-back"
              type="button"
              :aria-label="uiText.back"
              @click="backToMobileSettings"
            >
              <span></span>
            </button>
            <h1>{{ mobileSettingPageTitle }}</h1>
          </header>

          <div ref="mobileUserCenterScroll" class="mobile-user-center-scroll">
            <div v-if="settingActiveTab == 'root'" class="mobile-settings-home">
              <button class="mobile-settings-profile-card" type="button" @click="selectSettingTab('account')">
                <span class="mobile-settings-avatar">{{ userInitial }}</span>
                <span class="mobile-settings-profile-meta">
                  <strong>{{ displayAccountName }}</strong>
                  <span v-if="mobileAccountSummary">{{ mobileAccountSummary }}</span>
                </span>
              </button>

              <nav class="mobile-settings-menu">
                <button type="button" class="mobile-settings-menu-row" @click="openLanguageModal">
                  <img src="@/assets/wap/center_language.png" alt="" />
                  <span>{{ uiText.language }}</span>
                  <i></i>
                </button>
                <button type="button" class="mobile-settings-menu-row" @click="selectSettingTab('cloud')">
                  <img src="@/assets/wap/setting-viwoods.png" alt="" />
                  <span>{{ uiText.viwoodsCloud }}</span>
                  <i></i>
                </button>
                <button v-if="showServerSettingTab" type="button" class="mobile-settings-menu-row" @click="selectSettingTab('server')">
                  <img src="@/assets/wap/server.svg" alt="" />
                  <span>{{ uiText.server }}</span>
                  <i></i>
                </button>
                <button type="button" class="mobile-settings-menu-row" @click="openFeedback">
                  <img src="@/assets/wap/setting-question.png" alt="" />
                  <span>{{ uiText.feedback }}</span>
                  <i></i>
                </button>
              </nav>
            </div>

            <div v-else-if="settingActiveTab == 'account'" class="mobile-setting-detail mobile-account-page">
              <section class="mobile-account-profile">
                <span class="mobile-settings-avatar">{{ userInitial }}</span>
                <div class="mobile-account-name-row">
                  <strong>{{ displayAccountName }}</strong>
                  <button class="setting-edit-button" type="button" :title="uiText.edit" @click="startEditUsername"></button>
                </div>
              </section>

              <div class="mobile-account-info">
                <div class="mobile-account-info-row">
                  <span>{{ uiText.emailLabel }}</span>
                  <strong>{{ email || uiText.unbound }}</strong>
                </div>
                <div class="mobile-account-info-row">
                  <span>{{ uiText.phoneLabel }}</span>
                  <strong :class="{ muted: !phoneAccount }">{{ phoneAccount || uiText.unbound }}</strong>
                </div>
                <button class="mobile-account-info-row mobile-account-link-row" type="button" @click="openSettingPasswordReset">
                  <span>{{ uiText.changePassword }}</span>
                  <i></i>
                </button>
              </div>

              <button class="mobile-account-logout" type="button" @click="openExitFromSetting">
                <img src="@/assets/wap/center_exit.png" alt="" />
                <span>{{ uiText.logout }}</span>
              </button>
            </div>

            <div v-else-if="settingActiveTab == 'cloud'" class="mobile-setting-detail mobile-cloud-page">
              <a-spin :spinning="cloudStatusLoading">
                <section class="mobile-cloud-summary">
                  <div class="mobile-cloud-summary-head">
                    <span>{{ uiText.cloudStorageSpace }}</span>
                    <strong>{{ cloudStorageUsedText }}/{{ cloudStorageMaxText }}</strong>
                  </div>
                  <div class="mobile-cloud-progress">
                    <span :style="{ width: cloudStoragePercent + '%' }"></span>
                  </div>
                </section>

                <h2>{{ uiText.cloudUsage }}</h2>
                <div class="mobile-cloud-usage-list">
                  <div v-for="item in mobileCloudUsageItems" :key="item.key" class="mobile-cloud-usage-row">
                    <span class="mobile-cloud-usage-name">
                      <img :src="item.icon" alt="" />
                      <strong>{{ item.label }}</strong>
                    </span>
                    <span class="mobile-cloud-usage-value">{{ formatStorageSize(item.value) }}</span>
                  </div>
                </div>
              </a-spin>
            </div>

            <div v-else-if="settingActiveTab == 'server' && showServerSettingTab" class="mobile-setting-detail mobile-server-page">
              <a-radio-group v-model="cloudServerKey" class="mobile-server-options" @change="changeCloudServer">
                <a-radio
                  v-for="item in cloudServerOptions"
                  :key="item.key"
                  class="mobile-server-option"
                  :value="item.key"
                >
                  {{ item.label }}
                </a-radio>
              </a-radio-group>
            </div>
          </div>
        </section>

        <paper-sync v-else-if="activeAppFolder == 'paper'" ref="activeAppSync" :language="selectedLanguage" :initial-refresh-state="resolveInitialAppRefreshState('paper')" :skip-initial-list-load="shouldSkipActiveResourceInitialListLoad" :detail-back-root="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'search'" :recent-preview-mode="activeAppReturnMenu == 'recent'" :my-files-recording-preview-mode="activeAppReturnMenu == 'files'" :search-preview-mode="globalSearchFilePreviewActive" :mobile-preview-grid-additive-long-press-selection="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files' || globalSearchFilePreviewActive" @back-root="closeAppFolder" @global-search="openGlobalSearchPage()" @detail-mode-change="handleActiveAppDetailModeChange" @selection-mode-change="handleActiveAppSelectionModeChange"></paper-sync>
        <learning-sync v-else-if="activeAppFolder == 'learning'" ref="activeAppSync" :language="selectedLanguage" :app-type="activeAppFolderAppType" folder-type="learning" :initial-refresh-state="resolveInitialAppRefreshState('learning')" :skip-initial-list-load="shouldSkipActiveResourceInitialListLoad" :detail-back-root="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'search'" :hosted-learning-detail="activeAppReturnMenu == 'files'" :mobile-preview-grid-additive-long-press-selection="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files' || globalSearchFilePreviewActive" @back-root="closeAppFolder" @global-search="openGlobalSearchPage()" @open-learning-detail="openMyFileLearningDetail" @detail-mode-change="handleActiveAppDetailModeChange" @selection-mode-change="handleActiveAppSelectionModeChange"></learning-sync>
        <daily-sync v-else-if="activeAppFolder == 'daily'" ref="activeAppSync" :language="selectedLanguage" :app-type="activeAppFolderAppType" :initial-active-tab="dailyInitialActiveTab" :initial-refresh-state="resolveInitialAppRefreshState('daily')" :skip-initial-dashboard-load="shouldSkipActiveDailyInitialLoad" :detail-back-root="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'search'" :search-preview-grid-additive-long-press-selection="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files' || activeAppReturnMenu == 'daily' || globalSearchFilePreviewActive" @back-root="closeAppFolder" @global-search="openGlobalSearchPage()" @detail-mode-change="handleActiveAppDetailModeChange" @selection-mode-change="handleActiveAppSelectionModeChange"></daily-sync>
        <memo-sync v-else-if="activeAppFolder == 'memo'" ref="activeAppSync" :language="selectedLanguage" :app-type="activeAppFolderAppType" :initial-refresh-state="resolveInitialAppRefreshState('memo')" :skip-initial-list-load="shouldSkipActiveResourceInitialListLoad" :detail-back-root="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'search'" :mobile-preview-grid-additive-long-press-selection="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files' || globalSearchFilePreviewActive" @back-root="closeAppFolder" @global-search="openGlobalSearchPage()" @detail-mode-change="handleActiveAppDetailModeChange" @selection-mode-change="handleActiveAppSelectionModeChange"></memo-sync>
        <meeting-sync v-else-if="activeAppFolder == 'meeting'" ref="activeAppSync" :language="selectedLanguage" :initial-refresh-state="resolveInitialAppRefreshState('meeting')" :skip-initial-list-load="shouldSkipActiveResourceInitialListLoad" :detail-back-root="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'search'" :recent-preview-mode="activeAppReturnMenu == 'recent'" :my-files-recording-preview-mode="activeAppReturnMenu == 'files'" :search-preview-mode="globalSearchFilePreviewActive" :mobile-preview-grid-additive-long-press-selection="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files' || globalSearchFilePreviewActive" @back-root="closeAppFolder" @global-search="openGlobalSearchPage()" @detail-mode-change="handleActiveAppDetailModeChange" @selection-mode-change="handleActiveAppSelectionModeChange"></meeting-sync>
        <knowledge-base-sync v-else-if="activeAppFolder == 'knowledge'" ref="activeAppSync" :language="selectedLanguage" :initial-refresh-state="resolveInitialAppRefreshState('knowledge')" :skip-initial-list-load="shouldSkipActiveResourceInitialListLoad" :detail-back-root="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'search'" :mobile-preview-grid-additive-long-press-selection="activeAppReturnMenu == 'recent' || activeAppReturnMenu == 'files' || globalSearchFilePreviewActive" @back-root="closeAppFolder" @global-search="openGlobalSearchPage()" @detail-mode-change="handleActiveAppDetailModeChange" @selection-mode-change="handleActiveAppSelectionModeChange"></knowledge-base-sync>
        <template v-else>
        <header class="content-header" :class="{ 'is-search-page': globalSearchOpen, 'is-recent-page': !globalSearchOpen && activeMenu == 'recent', 'is-myfile-page': !globalSearchOpen && activeMenu == 'files', 'is-recent-learning-detail': recentLearningModalOpen, 'is-search-learning-detail': globalSearchLearningPreviewActive }">
          <template v-if="globalSearchOpen">
            <button class="search-back-button" type="button" @mousedown.prevent @click="handleGlobalSearchBack" :aria-label="uiText.back">
              <img :src="globalSearchIcons.back" alt="" />
            </button>
            <div class="search-page-box global-search-box">
              <button class="global-search-submit-button" type="button" :aria-label="uiText.search" @mousedown.prevent @click="triggerGlobalSearch(true)">
                <img :src="globalSearchIcons.search" alt="" />
              </button>
              <input ref="globalSearchInput" v-model="globalSearchKeyword" type="text" :placeholder="uiText.search" :maxlength="inputMaxLength" @compositionstart="handleGlobalSearchCompositionStart" @compositionend="handleGlobalSearchCompositionEnd" @input="handleGlobalSearchInput" @blur="handleGlobalSearchInputBlur" @keyup.enter="triggerGlobalSearch(true, $event)" />
            </div>
            <button class="global-search-close-button" type="button" :aria-label="uiText.cancel" @mousedown.prevent @click="clearGlobalSearchKeyword">
              <img :src="globalSearchIcons.close" alt="" />
            </button>
          </template>
          <template v-else>
            <div class="content-header-title">
              <h1>{{ contentTitle }}</h1>
            </div>
            <div class="content-header-actions">
              <button v-if="showHeaderSearchButton" class="icon-button search-button" type="button" @click="openGlobalSearchPage()" :aria-label="uiText.search">
                <img :src="recentIcons.search" alt="" />
              </button>
              <button v-if="showRecentHeaderViewSwitch" class="icon-button recent-view-trigger" type="button" @click.stop="toggleRecentViewSheet" aria-label="View">
                <img :src="recentIcons.sort" alt="" />
              </button>
              <button v-if="showMyFileHeaderViewSwitch" class="icon-button myfile-view-trigger" type="button" @click.stop="toggleMyFileViewSheet" aria-label="View">
                <img :src="recentIcons.sort" alt="" />
              </button>
            </div>
          </template>
        </header>

        <div v-if="showContentToolbar && activeMenu != 'recent' && activeMenu != 'files'" class="content-toolbar">
          <div class="view-switch" role="group">
            <img :src="viewSwitchIcon" alt="" />
            <button
              type="button"
              class="view-button view-list-hotspot"
              :class="{ active: viewMode == 'list' }"
              @click="setViewMode('list')"
              aria-label="List view"
            ></button>
            <button
              type="button"
              class="view-button view-grid-hotspot"
              :class="{ active: viewMode == 'grid' }"
              @click="setViewMode('grid')"
              aria-label="Grid view"
            ></button>
          </div>
        </div>

        <div v-if="cloudStatus == 1 && globalSearchOpen" class="global-search-toolbar">
          <div class="global-search-filter" @click.stop @mousedown="markGlobalSearchBlurIgnored" @touchstart.passive="markGlobalSearchBlurIgnored">
            <button class="global-search-filter-button" type="button" @click="toggleGlobalSearchTypeMenu">
              <img class="global-search-filter-icon" :src="activeGlobalSearchTypeIcon" alt="" />
              <span>{{ activeGlobalSearchTypeLabel }}</span>
              <span class="global-search-filter-arrow" :class="{ open: globalSearchTypeMenuOpen }"></span>
            </button>
            <div v-if="globalSearchTypeMenuOpen" class="global-search-filter-mask" @click="globalSearchTypeMenuOpen = false"></div>
            <div v-if="globalSearchTypeMenuOpen" class="global-search-filter-menu">
              <div class="global-search-filter-menu-header">
                <strong>{{ uiText.filter || '筛选' }}</strong>
                <span
                  class="global-search-filter-menu-close"
                  role="button"
                  tabindex="0"
                  :aria-label="uiText.cancel"
                  @click.stop="globalSearchTypeMenuOpen = false"
                  @keydown.enter.stop.prevent="globalSearchTypeMenuOpen = false"
                  @keydown.space.stop.prevent="globalSearchTypeMenuOpen = false"
                >
                  <img :src="globalSearchIcons.close" alt="" />
                </span>
              </div>
              <button
                v-for="item in globalSearchTypeOptions"
                :key="item.value"
                type="button"
                :class="{ active: globalSearchAppType == item.value }"
                @click="setGlobalSearchType(item.value)"
              >
                <img class="global-search-menu-icon" :src="item.icon" alt="" />
                <span>{{ item.label }}</span>
                <img v-if="globalSearchAppType == item.value" class="global-search-menu-check" :src="globalSearchIcons.check" alt="" />
              </button>
            </div>
          </div>

          <button class="icon-button global-search-view-trigger" type="button" @click.stop="toggleGlobalSearchViewSheet" aria-label="View">
            <img :src="globalSearchIcons.viewSwitch" alt="" />
          </button>
        </div>

        <div
          v-if="showRecentSelectionBar"
          ref="recentSelectionLayer"
          class="recent-selection-layer"
          :class="{ dragging: recentSelectionBarDragging }"
          :style="recentSelectionBarLayerStyle"
          @mousedown.stop="startRecentSelectionBarDrag"
          @click.stop
        >
          <div class="recent-selection-bar">
            <span>{{ uiText.selectedPrefix }} {{ selectedRecentCount }} {{ uiText.selectedSuffix }}</span>
            <button class="recent-selection-close" type="button" :aria-label="uiText.cancel" @click="clearRecentSelection">
              <span></span>
            </button>
          </div>
        </div>

        <div
          v-if="showRecentQuickActionMask"
          class="recent-quick-action-mask"
          @click="closeRecentItemActions"
        ></div>

        <div v-if="showRecentBottomActionBar" class="recent-selection-actions" @click.stop>
          <button type="button" :disabled="!canDownloadRecentActionItems" :aria-label="uiText.download" @click="downloadRecentActionItems">
            <img :src="recentDownloadIcon" alt="" />
          </button>
        </div>

        <div
          v-if="showGlobalSearchSelectionBar"
          ref="globalSearchSelectionLayer"
          class="global-search-selection-layer"
          :class="{ dragging: globalSearchSelectionBarDragging }"
          :style="globalSearchSelectionBarLayerStyle"
          @mousedown.stop="startGlobalSearchSelectionBarDrag"
          @click.stop
        >
          <div class="global-search-selection-bar">
            <span>{{ uiText.selectedPrefix }} {{ selectedGlobalSearchCount }} {{ uiText.selectedSuffix }}</span>
            <button class="global-search-selection-close" type="button" :aria-label="uiText.cancel" @click="clearGlobalSearchSelection">
              <span></span>
            </button>
          </div>
        </div>

        <div
          v-if="showGlobalSearchQuickActionMask"
          class="global-search-quick-action-mask"
          @click="closeGlobalSearchItemActions"
        ></div>

        <div v-if="showGlobalSearchBottomActionBar" class="global-search-selection-actions" @click.stop>
          <button type="button" :disabled="!canDownloadGlobalSearchActionItems" :aria-label="uiText.download" @click="downloadGlobalSearchActionItems">
            <img :src="recentDownloadIcon" alt="" />
          </button>
        </div>

        <section
          ref="cloudContentArea"
          class="content-area"
          :class="{ 'is-empty': !loading && cloudStatus == 0, 'is-search-page': globalSearchOpen, 'has-toolbar': showContentToolbar && activeMenu != 'files', 'is-global-search': globalSearchOpen, 'is-recent-page': !globalSearchOpen && activeMenu == 'recent', 'is-myfile-page': !globalSearchOpen && activeMenu == 'files' }"
          @scroll.passive="handleCloudContentScroll"
          @touchstart.passive="handleCloudPullRefreshStart"
          @touchmove="handleCloudPullRefreshMove"
          @touchend="handleCloudPullRefreshEnd"
          @touchcancel="cancelCloudPullRefreshGesture"
          @click.capture="handleCloudPullRefreshClickCapture"
        >
          <mobile-pull-refresh-indicator
            :distance="globalSearchOpen ? globalSearchPullRefreshDistance : recentPullRefreshDistance"
            :refreshing="globalSearchOpen ? globalSearchPullRefreshing : recentPullRefreshing"
            :threshold="globalSearchOpen ? globalSearchPullRefreshThreshold : recentPullRefreshThreshold"
          />
          <a-spin :spinning="cloudListLoading" wrapper-class-name="cloud-list-spin">
            <div class="cloud-list-content">
              <div v-if="!cloudListLoading && cloudStatus == 0" class="empty-state">
                <img class="cloud-empty-image" src="@/assets/wap/cloud_empty.png" alt="" />
                <p>{{ uiText.emptyCloud }}</p>
              </div>

              <div v-if="!cloudListLoading && cloudStatus == 1 && globalSearchOpen && globalSearchKeyword && globalSearchLoaded && visibleGlobalSearchItems.length == 0" class="global-search-empty">
                <img class="global-search-empty-image" :src="globalSearchIcons.empty" alt="" />
                <p>{{ uiText.empty }}</p>
              </div>

              <div v-if="!cloudListLoading && cloudStatus == 1 && globalSearchOpen && !globalSearchKeyword" class="global-search-empty is-idle">
                <img class="global-search-empty-image" :src="globalSearchIcons.empty" alt="" />
                <p>{{ uiText.empty }}</p>
              </div>

              <div v-if="!cloudListLoading && cloudStatus == 1 && globalSearchOpen && globalSearchViewMode == 'grid' && visibleGlobalSearchItems.length > 0" ref="globalSearchGrid" class="global-search-grid">
                <div
                  v-for="(item, index) in visibleGlobalSearchItems"
                  :key="item.id"
                  class="global-search-card"
                  :class="getGlobalSearchGridItemClasses(item, index)"
                  role="button"
                  tabindex="0"
                  :title="item.name"
                  :data-global-search-id="item.id"
                  @mousedown="handleGlobalSearchResultPointerDown"
                  @touchstart.passive="startGlobalSearchTouch(item, $event)"
                  @touchmove="moveGlobalSearchTouch"
                  @touchend="endGlobalSearchTouch"
                  @touchcancel="cancelGlobalSearchTouch"
                  @contextmenu.prevent="handleGlobalSearchContextMenu(item)"
                  @click="handleGlobalSearchItemClick(item, $event)"
                  @dblclick.stop.prevent="handleGlobalSearchItemDblClick(item, $event)"
                  @keyup.enter="handleGlobalSearchItemKeyup(item)"
                >
                  <span class="global-search-cover" :class="{ empty: !shouldDisplayGlobalSearchGridCover(item), blank: isGlobalSearchBlankCover(item, 'grid'), 'folded-cover': shouldShowRecentGridCoverFold(item) }">
                    <img v-if="shouldDisplayGlobalSearchGridCover(item)" class="global-search-cover-image" :src="getPaperGridCoverImageUrl(item)" alt="" loading="lazy" decoding="async" @error="markPaperGridCoverFailed(item)" />
                    <img v-else-if="shouldDisplayGlobalSearchFallbackCover(item, 'grid')" class="global-search-cover-default" :class="{ 'folder-template': isGlobalSearchTemplateFolder(item), 'folder-child-icon': isRecentFolderLike(item) && !isGlobalSearchTemplateFolder(item) }" :src="getGlobalSearchFallbackCover(item, 'grid')" alt="" />
                  </span>
                  <span class="global-search-card-title-row">
                    <span class="global-search-card-name" :title="item.name">{{ item.name }}</span>
                    <img v-if="item.favorite" class="global-search-favorite-status global-search-card-favorite-status" :src="recentFavoriteIcon" alt="" />
                  </span>
                  <span class="global-search-card-meta">
                    <span>{{ formatRecentDate(getRecentDisplayDate(item)) }}</span>
                    <span class="resource-grid-count" :title="formatRecentGridCount(item)">{{ formatRecentGridCount(item) }}</span>
                  </span>
                </div>
              </div>

              <div v-if="!cloudListLoading && cloudStatus == 1 && globalSearchOpen && globalSearchViewMode == 'list' && visibleGlobalSearchItems.length > 0" class="global-search-table">
                <div
                  v-for="item in visibleGlobalSearchItems"
                  :key="item.id"
                  class="global-search-row"
                  :class="{ selected: isGlobalSearchSelected(item) }"
                  role="button"
                  tabindex="0"
                  :title="item.name"
                  :data-global-search-id="item.id"
                  @mousedown="handleGlobalSearchResultPointerDown"
                  @touchstart.passive="startGlobalSearchTouch(item, $event)"
                  @touchmove="moveGlobalSearchTouch"
                  @touchend="endGlobalSearchTouch"
                  @touchcancel="cancelGlobalSearchTouch"
                  @contextmenu.prevent="handleGlobalSearchContextMenu(item)"
                  @click="handleGlobalSearchItemClick(item, $event)"
                  @dblclick.stop.prevent="handleGlobalSearchItemDblClick(item, $event)"
                  @keyup.enter="handleGlobalSearchItemKeyup(item)"
                >
                  <span class="global-search-row-cover" :class="{ empty: !shouldDisplayGlobalSearchCover(item), blank: isGlobalSearchBlankCover(item), locked: item.encrypted, 'has-cover': shouldDisplayGlobalSearchCover(item), 'folder-like': isRecentFolderLike(item) }">
                    <img v-if="shouldDisplayGlobalSearchCover(item)" class="global-search-row-cover-image" :src="item.cover" alt="" loading="lazy" decoding="async" @error="markRecentCoverFailed(item)" />
                    <img v-else-if="shouldDisplayGlobalSearchFallbackCover(item, 'list')" class="global-search-row-cover-default" :class="{ 'encrypt-icon': item.encrypted, 'folder-template': isGlobalSearchTemplateFolder(item), 'folder-child-icon': isRecentFolderLike(item) && !isGlobalSearchTemplateFolder(item) }" :src="getGlobalSearchFallbackCover(item, 'list')" alt="" />
                  </span>
                  <span class="global-search-row-main">
                    <span class="global-search-row-title-line">
                      <strong>{{ item.name }}</strong>
                      <img v-if="item.favorite" class="global-search-favorite-status" :src="recentFavoriteIcon" alt="" />
                    </span>
                    <span class="global-search-row-meta">
                      <span>{{ formatRecentCount(item) }}</span>
                      <i></i>
                      <span>{{ formatRecentDate(getRecentDisplayDate(item)) }}</span>
                    </span>
                  </span>
                  <span class="global-search-row-more-wrap" @touchstart.stop @touchmove.stop @touchend.stop @contextmenu.stop.prevent @click.stop>
                    <button class="global-search-more-button" type="button" :title="uiText.download" @click="openGlobalSearchItemActions(item)">
                      <svg viewBox="0 0 12 4" aria-hidden="true" focusable="false">
                        <circle cx="2" cy="2" r="1.25"></circle>
                        <circle cx="6" cy="2" r="1.25"></circle>
                        <circle cx="10" cy="2" r="1.25"></circle>
                      </svg>
                    </button>
                  </span>
                </div>
              </div>

              <div v-if="!cloudListLoading && cloudStatus == 1 && !globalSearchOpen && activeMenu == 'recent' && visibleRecentItems.length == 0" class="recent-empty">
                <img class="empty-image" src="@/assets/wap/empty_data.png" alt="" />
                <p>{{ uiText.empty }}</p>
              </div>

              <div v-if="!cloudListLoading && cloudStatus == 1 && !globalSearchOpen && activeMenu == 'recent' && !searchOpen && viewMode == 'grid' && visibleRecentItems.length > 0" ref="recentGrid" class="recent-grid">
                <div
                  v-for="(item, index) in visibleRecentItems"
                  :key="item.id"
                  class="recent-card"
                  :class="getRecentGridItemClasses(item, index)"
                  role="button"
                  tabindex="0"
                  :title="item.name"
                  :data-recent-id="item.id"
                  @touchstart.passive="startRecentTouch(item, $event)"
                  @touchmove="moveRecentTouch"
                  @touchend="endRecentTouch"
                  @touchcancel="cancelRecentTouch"
                  @contextmenu.prevent="handleRecentContextMenu(item)"
                  @click="handleRecentItemClick(item, $event)"
                  @dblclick.stop.prevent="handleRecentItemDblClick(item, $event)"
                  @keyup.enter="handleRecentItemKeyup(item)"
                >
                  <span class="recent-cover" :class="{ empty: !shouldDisplayRecentCover(item), 'folded-cover': shouldShowRecentGridCoverFold(item) }">
                    <img v-if="!shouldDisplayRecentCover(item) || isRecentMemoCoverPending(item)" key="recent-grid-cover-fallback" class="recent-cover-default" :class="{ 'memo-cover-fallback': resolveAppFolderType(item) == 'memo' }" width="30" height="30" :style="getRecentFallbackCoverStyle(item, 'grid')" :src="getRecentFallbackCover(item, 'grid')" alt="" />
                    <img v-if="shouldDisplayRecentCover(item)" key="recent-grid-cover-image" class="recent-cover-image" :class="{ 'memo-cover-image': resolveAppFolderType(item) == 'memo', 'is-pending': isRecentMemoCoverPending(item) }" :src="item.cover" alt="" loading="lazy" decoding="async" @load="markRecentCoverLoaded(item)" @error="markRecentCoverFailed(item)" />
                  </span>
                  <span class="recent-card-title-row">
                    <span class="recent-card-name" :title="item.name">{{ item.name }}</span>
                    <img v-if="item.favorite" class="recent-favorite-status recent-card-favorite-status" :src="recentFavoriteIcon" alt="" />
                  </span>
                  <span class="recent-card-meta">
                    <span>{{ formatRecentDate(getRecentDisplayDate(item)) }}</span>
                    <span class="resource-grid-count" :title="formatRecentGridCount(item)">{{ formatRecentGridCount(item) }}</span>
                  </span>
                </div>
              </div>

              <div v-if="!cloudListLoading && cloudStatus == 1 && !globalSearchOpen && activeMenu == 'recent' && (searchOpen || viewMode != 'grid') && visibleRecentItems.length > 0" class="recent-table">
                <div
                  v-for="item in visibleRecentItems"
                  :key="item.id"
                  class="recent-row"
                  :class="{ selected: isRecentSelected(item) }"
                  role="button"
                  tabindex="0"
                  :title="item.name"
                  :data-recent-id="item.id"
                  @touchstart.passive="startRecentTouch(item, $event)"
                  @touchmove="moveRecentTouch"
                  @touchend="endRecentTouch"
                  @touchcancel="cancelRecentTouch"
                  @contextmenu.prevent="handleRecentContextMenu(item)"
                  @click="handleRecentItemClick(item, $event)"
                  @dblclick.stop.prevent="handleRecentItemDblClick(item, $event)"
                  @keyup.enter="handleRecentItemKeyup(item)"
                >
                  <span class="recent-row-cover" :class="{ empty: !shouldDisplayRecentCover(item), locked: item.encrypted, 'has-cover': shouldDisplayRecentCover(item) }">
                    <img v-if="!shouldDisplayRecentCover(item) || isRecentMemoCoverPending(item)" key="recent-list-cover-fallback" class="recent-row-cover-default" :class="{ 'encrypt-icon': item.encrypted, 'folder-icon': isRecentFolderLike(item) && !item.encrypted, 'memo-cover-fallback': resolveAppFolderType(item) == 'memo' }" :width="getRecentFallbackCoverSize(item, 'list').width" :height="getRecentFallbackCoverSize(item, 'list').height" :style="getRecentFallbackCoverStyle(item, 'list')" :src="getRecentFallbackCover(item, 'list')" alt="" />
                    <img v-if="shouldDisplayRecentCover(item)" key="recent-list-cover-image" class="recent-row-cover-image" :class="{ 'memo-cover-image': resolveAppFolderType(item) == 'memo', 'is-pending': isRecentMemoCoverPending(item) }" :src="item.cover" alt="" loading="lazy" decoding="async" @load="markRecentCoverLoaded(item)" @error="markRecentCoverFailed(item)" />
                  </span>
                  <span class="recent-row-main">
                    <span class="recent-row-title-line">
                      <strong>{{ item.name }}</strong>
                      <img v-if="item.favorite" class="recent-favorite-status" :src="recentFavoriteIcon" alt="" />
                    </span>
                    <span class="recent-row-meta">
                      <span>{{ formatRecentCount(item) }}</span>
                      <i></i>
                      <span>{{ formatRecentDate(getRecentDisplayDate(item)) }}</span>
                    </span>
                  </span>
                  <span class="recent-row-more-wrap" @touchstart.stop @touchmove.stop @touchend.stop @contextmenu.stop.prevent @click.stop>
                    <button class="recent-more-button" type="button" :title="uiText.download" @click="openRecentItemActions(item)">
                      <svg viewBox="0 0 12 4" aria-hidden="true" focusable="false">
                        <circle cx="2" cy="2" r="1.25"></circle>
                        <circle cx="6" cy="2" r="1.25"></circle>
                        <circle cx="10" cy="2" r="1.25"></circle>
                      </svg>
                    </button>
                    <div v-if="recentMoreMenuId == item.id" class="recent-more-menu" @click.stop>
                      <button type="button" :disabled="!isRecentDownloadableItem(item)" @click.stop="downloadRecentItem(item)">
                        <img :src="recentDownloadIcon" alt="" />
                        <span>{{ uiText.download }}</span>
                      </button>
                    </div>
                  </span>
                </div>
              </div>

              <div v-if="!cloudListLoading && cloudStatus == 1 && !globalSearchOpen && activeMenu == 'files' && !searchOpen && myFileViewMode == 'grid'" class="folder-grid">
                <button
                  v-for="item in visibleCloudItems"
                  :key="item.id"
                  class="folder-card"
                  :class="{ selected: selectedFolderRowId == item.id }"
                  type="button"
                  :title="item.name"
                  @click="openFolder(item)"
                >
                  <span class="folder-art">
                    <img :src="item.icon" alt="" />
                  </span>
                  <span class="folder-name">{{ item.name }}</span>
                  <span v-if="formatFolderCount(item.count)" class="folder-card-count">{{ formatFolderCount(item.count) }}</span>
                </button>
              </div>

              <div v-if="!cloudListLoading && cloudStatus == 1 && !globalSearchOpen && activeMenu == 'files' && (searchOpen || myFileViewMode != 'grid')" class="folder-list">
                <button
                  v-for="item in visibleCloudItems"
                  :key="item.id"
                  class="folder-row"
                  :class="{ selected: selectedFolderRowId == item.id }"
                  type="button"
                  :title="item.name"
                  @click="openFolder(item)"
                >
                  <span class="folder-art small">
                    <img :src="item.listIcon" alt="" />
                  </span>
                  <span class="folder-row-main">
                    <span class="folder-name">{{ item.name }}</span>
                    <span class="folder-count">{{ formatFolderCount(item.count) }}</span>
                  </span>
                </button>
              </div>
              <div v-if="cloudListAppendLoading" class="list-bottom-loading">
                <a-spin size="small" :spinning="true" />
                <span>{{ uiText.loading }}</span>
              </div>
            </div>
          </a-spin>
        </section>
        </template>
        <div
          v-if="recentPreviewZoomToast"
          :key="recentPreviewZoomToastKey"
          class="recent-preview-zoom-toast"
          role="status"
          aria-live="polite"
        >{{ recentPreviewZoomToast }}</div>
      </main>
      <nav v-if="(!activeAppFolder || (activeAppReturnMenu == 'files' && !activeAppDetailMode) || (activeAppFolder == 'daily' && !activeAppDetailMode)) && !activeAppSelectionMode && !globalSearchOpen && !showRecentSelectionBar && !recentLearningModalOpen" class="mobile-tabbar">
        <button
          v-for="item in mobileTabItems"
          :key="item.key"
          type="button"
          class="mobile-tab"
          :class="{ active: !settingModalVisible && currentMenuKey == item.key }"
          @click="changeMenu(item.key)"
        >
          <span class="mobile-tab-icon-frame">
            <img :src="item.mobileIcon" alt="" />
          </span>
        </button>
        <button class="mobile-tab mobile-user-tab" :class="{ active: settingModalVisible }" type="button" @click="openSettingModal">
          <span class="mobile-tab-icon-frame">
            <img :src="recentIcons.navMine" alt="" />
          </span>
        </button>
      </nav>
    </div>

    <div v-if="recentViewSheetOpen" class="recent-sheet-mask" @click="closeRecentViewSheet"></div>
    <section v-if="recentViewSheetOpen" class="recent-view-sheet" @click.stop>
      <h3>视图</h3>
      <button type="button" class="recent-sheet-row" :class="{ active: viewMode == 'grid' }" @click="setRecentViewModeFromSheet('grid')">
        <img class="recent-sheet-icon" :src="recentIcons.pageGrid" alt="" />
        <span>网格</span>
        <i v-if="viewMode == 'grid'" class="recent-sheet-check"></i>
      </button>
      <button type="button" class="recent-sheet-row" :class="{ active: viewMode == 'list' }" @click="setRecentViewModeFromSheet('list')">
        <img class="recent-sheet-icon" :src="recentIcons.previewList" alt="" />
        <span>列表</span>
        <i v-if="viewMode == 'list'" class="recent-sheet-check"></i>
      </button>
    </section>

    <div v-if="myFileViewSheetOpen" class="myfile-sheet-mask" @click="closeMyFileViewSheet"></div>
    <section v-if="myFileViewSheetOpen" class="myfile-view-sheet" @click.stop>
      <h3>视图</h3>
      <button type="button" class="myfile-sheet-row" :class="{ active: myFileViewMode == 'grid' }" @click="setMyFileViewModeFromSheet('grid')">
        <img class="myfile-sheet-icon" :src="recentIcons.pageGrid" alt="" />
        <span>网格</span>
        <i v-if="myFileViewMode == 'grid'" class="myfile-sheet-check"></i>
      </button>
      <button type="button" class="myfile-sheet-row" :class="{ active: myFileViewMode == 'list' }" @click="setMyFileViewModeFromSheet('list')">
        <img class="myfile-sheet-icon" :src="recentIcons.previewList" alt="" />
        <span>列表</span>
        <i v-if="myFileViewMode == 'list'" class="myfile-sheet-check"></i>
      </button>
    </section>

    <div v-if="globalSearchViewSheetOpen" class="global-search-view-sheet-mask" @click="closeGlobalSearchViewSheet"></div>
    <section v-if="globalSearchViewSheetOpen" class="global-search-view-sheet" @click.stop>
      <h3>视图</h3>
      <button type="button" class="global-search-view-sheet-row" :class="{ active: globalSearchViewMode == 'grid' }" @click="setGlobalSearchViewMode('grid')">
        <img class="global-search-view-sheet-icon" :src="recentIcons.pageGrid" alt="" />
        <span>网格</span>
        <i v-if="globalSearchViewMode == 'grid'" class="global-search-view-sheet-check"></i>
      </button>
      <button type="button" class="global-search-view-sheet-row" :class="{ active: globalSearchViewMode == 'list' }" @click="setGlobalSearchViewMode('list')">
        <img class="global-search-view-sheet-icon" :src="recentIcons.previewList" alt="" />
        <span>列表</span>
        <i v-if="globalSearchViewMode == 'list'" class="global-search-view-sheet-check"></i>
      </button>
    </section>

    <div v-if="languageModalVisible" class="mobile-language-sheet-layer">
      <button class="mobile-language-sheet-mask" type="button" :aria-label="uiText.cancel" @click="closeLanguageModal"></button>
      <section class="mobile-language-sheet" role="dialog" aria-modal="true" :aria-label="uiText.language" @click.stop>
        <header>
          <h2>{{ uiText.language }}</h2>
          <button type="button" :aria-label="uiText.cancel" @click="closeLanguageModal">
            <span></span>
          </button>
        </header>
        <div class="mobile-language-list">
          <button
            v-for="item in languageList"
            :key="item.id"
            type="button"
            class="mobile-language-option"
            :class="{ active: pendingLanguage == item.id }"
            @click="selectLanguage(item.id)"
          >
            <i></i>
            <span>{{ item.label }}</span>
          </button>
        </div>
      </section>
    </div>

    <a-modal
      v-model="usernameRenameVisible"
      width="394px"
      centered
      wrapClassName="cloud-rename-modal"
      :footer="null"
      :closable="false"
      :maskClosable="!updatingUsername"
      @cancel="cancelEditUsername"
    >
      <section class="rename-panel">
        <header class="rename-head">
          <h3>{{ uiText.rename }}</h3>
          <button class="rename-close" type="button" :aria-label="uiText.cancel" @click="cancelEditUsername"></button>
        </header>
        <a-input
          ref="usernameRenameInput"
          v-model.trim="editUsername"
          class="rename-input"
          :placeholder="uiText.username"
          :max-length="usernameMaxLength"
          @keyup.enter="saveUsername"
        />
        <footer class="rename-actions">
          <button class="rename-button rename-cancel" type="button" @click="cancelEditUsername">{{ uiText.cancel }}</button>
          <button class="rename-button rename-confirm" type="button" :disabled="updatingUsername" @click="saveUsername">{{ uiText.ok }}</button>
        </footer>
      </section>
    </a-modal>

    <a-modal
      v-model="settingPasswordVisible"
      width="488px"
      centered
      wrapClassName="cloud-password-modal"
      :footer="null"
      :closable="false"
      @cancel="closeSettingPasswordModal"
    >
      <div class="setting-password-frame">
        <section class="setting-password-panel" @click="settingAreaOpen = false">
          <button class="password-reset-back" type="button" :aria-label="uiText.back" @click.stop="settingResetGoBack">
            <span></span>
          </button>

          <div v-if="settingResetStep == 'account'" class="reset-main reset-account">
            <h1>{{ uiText.changePassword }}</h1>
            <p class="login-subtitle">{{ settingResetAccountSubtitle }}</p>

            <div v-if="settingResetMode == 'phone'" ref="settingResetPhoneField" class="phone-field reset-field" :class="{ focused: settingResetPhoneFocused }" @click.stop>
              <button class="area-code" type="button" @click.stop="changeSettingStartChoose">
                <span>{{ settingResetForm.areaCode ? settingResetForm.areaCode : uiText.areaCode }}</span>
                <span class="area-arrow" :class="{ open: settingAreaOpen }"></span>
              </button>
              <div v-if="settingAreaOpen" class="area-options" :style="settingResetAreaOptionsStyle">
                <div
                  v-for="code in areaCodes"
                  :key="code.name"
                  class="area-option"
                  @click.stop="changeSettingResetAreaCode(code)"
                >
                  <span class="area-country">
                    <img :src="code.img" alt="" />
                    <span>{{ code.enName }} ({{ code.name }})</span>
                  </span>
                  <span>{{ code.areaCode }}</span>
                </div>
              </div>
              <a-input
                v-model="settingResetForm.phone"
                class="login-input phone-input"
                :placeholder="uiText.phoneLabel"
                :max-length="inputMaxLength"
                @focus="settingResetPhoneFocused = true; settingAreaOpen = false"
                @blur="settingResetPhoneFocused = false"
                @keyup.enter="sendSettingResetCode"
              />
              <button v-if="settingResetForm.phone" class="input-clear" type="button" aria-label="Clear" @click.stop="clearSettingResetField('phone')"></button>
            </div>

            <div v-if="settingResetMode == 'email'" class="clearable-field reset-field">
              <a-input
                v-model="settingResetForm.email"
                class="login-input"
                :placeholder="uiText.emailLabel"
                :max-length="inputMaxLength"
                @keyup.enter="sendSettingResetCode"
              />
              <button v-if="settingResetForm.email" class="input-clear" type="button" aria-label="Clear" @click.stop="clearSettingResetField('email')"></button>
            </div>

            <a-button
              class="login-submit reset-submit"
              type="primary"
              :loading="settingResetLoading || settingResetSending"
              :class="{ ready: canSubmitSettingResetAccount }"
              :disabled="!canSubmitSettingResetAccount"
              @click.stop="sendSettingResetCode"
            >
              {{ uiText.continue }}
            </a-button>

            <div class="divider reset-divider">
              <span></span>
              <em>{{ uiText.orUse }}</em>
              <span></span>
            </div>

            <button class="switch-login reset-switch" type="button" @click.stop="switchSettingResetMode(settingResetMode == 'phone' ? 'email' : 'phone')">
              {{ settingResetMode == 'phone' ? uiText.emailReset : uiText.phoneReset }}
            </button>
          </div>

          <div v-if="settingResetStep == 'code'" class="reset-main reset-code">
            <h1>{{ uiText.verificationCode }}</h1>
            <p class="login-subtitle">{{ settingResetCodeText }}</p>

            <div class="code-field reset-field">
              <div class="clearable-field code-input-field">
                <a-input
                  v-model="settingResetForm.code"
                  class="login-input"
                  :placeholder="uiText.verificationCode"
                  :max-length="inputMaxLength"
                  @keyup.enter="checkSettingResetCode"
                />
                <button v-if="settingResetForm.code" class="input-clear" type="button" aria-label="Clear" @click.stop="clearSettingResetField('code')"></button>
              </div>
            </div>
            <button class="reset-resend" type="button" @click.stop="sendSettingResetCode">
              <span v-if="settingResetSending">{{ uiText.sending }}</span>
              <span v-else-if="settingResetReSendTime > 0">{{ settingResetReSendTime }}s {{ uiText.resendAfter }}</span>
              <span v-else>{{ uiText.resendCode }}</span>
            </button>

            <a-button
              class="login-submit reset-submit"
              type="primary"
              :loading="settingResetLoading"
              :class="{ ready: canSubmitSettingResetCode }"
              :disabled="!canSubmitSettingResetCode"
              @click.stop="checkSettingResetCode"
            >
              {{ uiText.continue }}
            </a-button>
          </div>

          <div v-if="settingResetStep == 'password'" class="reset-main reset-password">
            <h1>{{ uiText.newPassword }}</h1>
            <p v-if="uiText.passwordSubtitle" class="login-subtitle">{{ uiText.passwordSubtitle }}</p>

            <div class="clearable-field clearable-password-field reset-field">
              <a-input-password
                v-model="settingResetForm.password"
                class="login-input password-input"
                :placeholder="uiText.passwordPlaceholder"
                :max-length="inputMaxLength"
                @keyup.enter="submitSettingResetPassword"
              />
              <button v-if="settingResetForm.password" class="input-clear" type="button" aria-label="Clear" @click.stop="clearSettingResetField('password')"></button>
            </div>

            <div class="clearable-field clearable-password-field reset-field">
              <a-input-password
                v-model="settingResetForm.confirmPassword"
                class="login-input password-input"
                :placeholder="uiText.confirmPassword"
                :max-length="inputMaxLength"
                @keyup.enter="submitSettingResetPassword"
              />
              <button v-if="settingResetForm.confirmPassword" class="input-clear" type="button" aria-label="Clear" @click.stop="clearSettingResetField('confirmPassword')"></button>
            </div>

            <a-button
              class="login-submit reset-submit"
              type="primary"
              :loading="settingResetLoading"
              :class="{ ready: canSubmitSettingResetPassword }"
              :disabled="!canSubmitSettingResetPassword"
              @click.stop="submitSettingResetPassword"
            >
              {{ uiText.continue }}
            </a-button>
          </div>
        </section>
      </div>
    </a-modal>

    <a-modal
      v-model="exitModalVisible"
      width="450px"
      centered
      wrapClassName="cloud-exit-modal"
      :cancelText="uiText.cancel"
      :okText="uiText.ok"
      @ok="confirmLogout"
      @cancel="exitModalVisible = false"
    >
      <template #title>
        <span class="exit-modal-title">{{ uiText.logout }}</span>
      </template>
      <p class="exit-confirm-text">{{ uiText.confirmLogout }}</p>
    </a-modal>

    <div v-if="recentLearningModalOpen" class="recent-learning-mask" :class="{ 'preview-open': recentLearningAnnotationPreviewOpen, 'is-my-files-learning': myFilesLearningModalActive }" @click="closeRecentLearningModal"></div>
    <section v-if="recentLearningModalOpen" class="recent-learning-modal" :class="{ 'loading-open': recentLearningLoading, 'preview-open': recentLearningAnnotationPreviewOpen, 'summary-open': !recentLearningLoading && !recentLearningError && recentLearningActiveTab == 'summary', 'detail-open': !recentLearningLoading && !recentLearningError && recentLearningActiveTab != 'summary' && !recentLearningAnnotationPreviewOpen && !recentLearningHighlightDetailOpen, 'annotations-open': !recentLearningLoading && !recentLearningError && recentLearningActiveTab == 'annotations' && !recentLearningAnnotationPreviewOpen, 'is-my-files-learning': myFilesLearningModalActive }" @click.stop>
      <div v-if="recentLearningLoading || recentLearningError" class="recent-learning-resolving" :class="{ error: recentLearningError }">
        <strong>{{ recentLearningError ? uiText.openUnavailable : uiText.loading + '...' }}</strong>
        <p v-if="recentLearningError">{{ recentLearningError }}</p>
      </div>
      <section v-if="!recentLearningLoading && !recentLearningError && recentLearningActiveTab == 'summary'" class="recent-learning-summary-panel">
        <button class="recent-learning-close" type="button" :aria-label="uiText.cancel" @click="closeRecentLearningModal">
          <span></span>
        </button>
        <header class="recent-learning-head">
          <div class="recent-learning-main">
            <strong :title="recentLearningTitle">{{ recentLearningTitle }}</strong>
            <p class="recent-learning-meta">
              <span class="recent-learning-size">{{ recentLearningFileSizeText }}</span>
              <span class="recent-learning-chip">{{ recentLearningFileFormatText }}</span>
            </p>
          </div>
        </header>

        <div class="recent-learning-list">
          <div class="recent-learning-row is-progress">
            <strong>{{ uiText.readingProgress }}</strong>
            <span class="recent-learning-progress">
              <i :style="{ width: recentLearningProgressText }"></i>
            </span>
            <em>{{ recentLearningProgressText }}</em>
          </div>
          <button
            v-for="row in recentLearningRows"
            :key="row.key"
            class="recent-learning-row"
            type="button"
            @click="openRecentLearningTab(row.key)"
          >
            <strong>{{ row.label }}</strong>
            <em>{{ row.count }}</em>
          </button>
        </div>
      </section>

      <section
        v-else-if="!recentLearningLoading && !recentLearningError && recentLearningAnnotationPreviewOpen"
        class="recent-learning-preview-panel"
        @touchstart="handleRecentPreviewTouchStart"
        @touchmove="handleRecentPreviewTouchMove"
        @touchend="handleRecentPreviewTouchEnd"
        @touchcancel="resetRecentPreviewTouchState"
      >
        <header class="recent-learning-preview-head">
          <div class="recent-learning-preview-title">
            <button class="recent-learning-preview-back" type="button" :aria-label="uiText.back" @click="handleRecentLearningAnnotationPreviewBack">
              <span></span>
            </button>
            <strong>{{ recentLearningAnnotationPreviewHeaderTitle }}</strong>
          </div>
          <div class="recent-learning-preview-actions">
            <button
              class="recent-learning-preview-tool"
              type="button"
              :disabled="!canDownloadCurrentRecentLearningAnnotationPreview"
              :title="uiText.download"
              @click.stop="downloadCurrentRecentLearningAnnotationPreview"
            >
              <img :src="recentLearningIcons.download" alt="" />
            </button>
            <button
              v-if="!recentLearningAnnotationPreviewGridOpen"
              class="recent-learning-preview-tool"
              type="button"
              :class="{ active: recentLearningAnnotationPreviewGridOpen }"
              :disabled="recentLearningAnnotationPreviewGridOpen || recentLearningAnnotations.length == 0"
              :title="uiText.pageGrid"
              @click.stop="toggleRecentLearningAnnotationPreviewGrid"
            >
              <img :src="recentLearningIcons.pageGrid" alt="" />
            </button>
            <button
              v-if="!recentLearningAnnotationPreviewGridOpen"
              class="recent-learning-preview-tool recent-learning-preview-zoom-tool"
              type="button"
              :disabled="recentLearningAnnotationPreviewGridOpen || recentLearningAnnotationPreviewZoomLevel >= 5"
              :title="uiText.zoomIn"
              @click.stop="zoomInRecentLearningAnnotationPreview"
            >
              <img :src="recentLearningIcons.zoomIn" alt="" />
              <span v-if="isPreviewZoomTipVisible('recent-learning-annotation', 'in')" class="preview-zoom-tip">{{ previewZoomTip.text }}</span>
            </button>
            <button
              v-if="!recentLearningAnnotationPreviewGridOpen"
              class="recent-learning-preview-tool recent-learning-preview-zoom-tool"
              type="button"
              :disabled="recentLearningAnnotationPreviewGridOpen || recentLearningAnnotationPreviewZoomLevel <= -3"
              :title="uiText.zoomOut"
              @click.stop="zoomOutRecentLearningAnnotationPreview"
            >
              <img :src="recentLearningIcons.zoomOut" alt="" />
              <span v-if="isPreviewZoomTipVisible('recent-learning-annotation', 'out')" class="preview-zoom-tip">{{ previewZoomTip.text }}</span>
            </button>
          </div>
        </header>

        <section class="recent-learning-preview-body" :class="{ 'pages-open': recentLearningAnnotationPreviewGridOpen }">
          <div v-if="recentLearningAnnotationPreviewGridOpen" ref="recentLearningAnnotationPreviewGrid" class="recent-learning-preview-pages-grid">
            <button
              v-for="(annotation, index) in recentLearningAnnotations"
              :key="annotation.id"
              type="button"
              class="mobile-preview-grid-item"
              data-preview-grid-scope="recent-learning-annotation"
              :data-preview-grid-id="annotation.id"
              :class="{ active: recentLearningActiveAnnotation && recentLearningActiveAnnotation.id == annotation.id, selected: isRecentLearningAnnotationPreviewSelected(annotation.id), 'grid-edge-top': isRecentLearningAnnotationPreviewGridTopEdge(index), 'grid-selected-row-start': isRecentLearningAnnotationPreviewGridSelectedRowStart(index), 'grid-selection-continues-below': isRecentLearningAnnotationPreviewGridSelectionContinuesBelow(index) }"
              @touchstart.passive="startMobilePreviewGridTouch('recent-learning-annotation', annotation.id, $event, true)"
              @touchmove="moveMobilePreviewGridTouch"
              @touchend="endMobilePreviewGridTouch"
              @touchcancel="cancelMobilePreviewGridTouch"
              @contextmenu.prevent="handleMobilePreviewGridContextMenu('recent-learning-annotation', annotation.id, true)"
              @click="handleMobilePreviewGridItemClick('recent-learning-annotation', annotation.id)"
            >
              <span>
                <i class="recent-learning-preview-page-thumb">
                  <img v-if="annotation.pageImageUrl" class="recent-learning-annotation-page" :src="annotation.pageImageUrl" alt="" loading="lazy" decoding="async" />
                  <img v-if="annotation.imageUrl" class="recent-learning-annotation-ink" :src="annotation.imageUrl" alt="" loading="lazy" decoding="async" />
                  <em v-if="!annotation.pageImageUrl && !annotation.imageUrl" class="recent-learning-page-fallback"></em>
                </i>
              </span>
              <strong :title="annotation.pageLabel || annotation.title">{{ annotation.pageLabel || annotation.title }}</strong>
            </button>
          </div>
          <div
            v-else
            ref="recentLearningAnnotationPreviewShell"
            class="recent-learning-preview-shell"
            :class="{ dragging: recentLearningAnnotationPreviewDragState }"
            :style="{ '--recent-learning-preview-zoom': recentLearningAnnotationPreviewZoomValue }"
            @mousedown="startRecentLearningAnnotationPreviewDrag"
          >
            <div class="recent-learning-preview-zoom">
              <div class="recent-learning-preview-stage">
                <div v-if="recentLearningActiveAnnotation" class="recent-learning-preview-page">
                  <img v-if="recentLearningActiveAnnotation.pageImageUrl" class="recent-learning-annotation-page" :src="recentLearningActiveAnnotation.pageImageUrl" alt="" decoding="async" @dragstart.prevent />
                  <img v-if="recentLearningActiveAnnotation.imageUrl" class="recent-learning-annotation-ink" :src="recentLearningActiveAnnotation.imageUrl" alt="" decoding="async" @dragstart.prevent />
                </div>
                <div v-else class="recent-learning-preview-empty"></div>
              </div>
            </div>
          </div>
        </section>

        <div v-if="!recentLearningAnnotationPreviewGridOpen && recentLearningAnnotations.length > 0" class="recent-learning-preview-controls">
          <div class="recent-learning-preview-count">
            <button type="button" :disabled="recentLearningAnnotationPreviewIndex <= 0" @click="goPrevRecentLearningAnnotationPreview"></button>
            <span>{{ recentLearningAnnotationPreviewIndex + 1 }}/{{ recentLearningAnnotations.length }}</span>
            <button type="button" :disabled="recentLearningAnnotationPreviewIndex >= recentLearningAnnotations.length - 1" @click="goNextRecentLearningAnnotationPreview"></button>
          </div>
        </div>
        <div
          v-if="recentPreviewZoomToast"
          :key="recentPreviewZoomToastKey"
          class="recent-preview-zoom-toast"
          role="status"
          aria-live="polite"
        >{{ recentPreviewZoomToast }}</div>
      </section>

      <section v-else-if="!recentLearningLoading && !recentLearningError && recentLearningHighlightDetailOpen && recentLearningActiveHighlight" class="recent-learning-highlight-page">
        <header>
          <button class="recent-learning-highlight-back" type="button" :aria-label="uiText.back" @click="closeRecentLearningHighlightDetail">
            <span></span>
          </button>
          <strong :title="recentLearningActiveHighlight.title">{{ recentLearningActiveHighlight.title }}</strong>
          <button class="recent-learning-tabs-close" type="button" :aria-label="uiText.cancel" @click="closeRecentLearningModal">
            <span></span>
          </button>
        </header>
        <article>
          <section class="recent-learning-highlight-body">
            <p class="recent-learning-highlight-meta">
              <span>{{ formatRecentDate(recentLearningActiveHighlight.createdAt) || '--' }}</span>
            </p>
            <p class="recent-learning-highlight-text">{{ recentLearningActiveHighlight.content }}</p>
          </section>
        </article>
      </section>

      <section v-else-if="!recentLearningLoading && !recentLearningError" class="recent-learning-detail-panel">
        <nav ref="recentLearningTabs" class="recent-learning-tabs" role="tablist">
          <div class="recent-learning-tabs-main">
            <button class="recent-learning-tabs-back" type="button" :aria-label="uiText.back" @click="returnToRecentLearningSummary">
              <span></span>
            </button>
            <button
              v-for="tab in recentLearningTabs"
              :key="tab.key"
              type="button"
              :class="['recent-learning-tab-button', { active: recentLearningActiveTab == tab.key, 'is-title-overflow': isRecentLearningTabTitleOverflow(tab.key) }]"
              :data-recent-learning-tab-key="tab.key"
              :title="tab.label"
              @touchstart.passive="startRecentLearningTabTitleTouch(tab, $event)"
              @touchmove="moveRecentLearningTabTitleTouch"
              @touchend="endRecentLearningTabTitleTouch"
              @touchcancel="cancelRecentLearningTabTitleTouch"
              @contextmenu.prevent
              @selectstart.prevent
              @dragstart.prevent
              @click="handleRecentLearningTabButtonClick(tab)"
            >
              <span ref="recentLearningTabLabel">{{ tab.label }}</span>
              <em>{{ tab.count }}</em>
            </button>
          </div>
          <div class="recent-learning-tabs-right">
            <button class="recent-learning-tabs-close" type="button" :aria-label="uiText.cancel" @click="closeRecentLearningModal">
              <span></span>
            </button>
          </div>
          <div v-if="recentLearningTabTitlePopup" class="recent-learning-tab-title-popover" :style="recentLearningTabTitlePopoverStyle" aria-hidden="true" @contextmenu.prevent @selectstart.prevent @dragstart.prevent>
            <span>{{ recentLearningTabTitlePopup.label }}</span>
          </div>
        </nav>

        <div v-if="recentLearningActiveTab == 'bookmarks'" class="recent-learning-detail-content" :class="{ 'is-empty': recentLearningBookmarks.length == 0 }">
          <div v-if="recentLearningBookmarks.length > 0" class="recent-learning-list-box recent-learning-bookmark-list">
            <button
              v-for="bookmark in recentLearningBookmarks"
              :key="bookmark.id"
              class="recent-learning-info-row recent-learning-bookmark-row"
              type="button"
            >
              <span class="recent-learning-bookmark-main">
                <strong :title="bookmark.title">{{ bookmark.title }}</strong>
                <em>{{ formatRecentDate(bookmark.createdAt) }}</em>
              </span>
              <span class="recent-learning-row-page">{{ formatRecentLearningPageBadge(bookmark) }}</span>
            </button>
          </div>
          <div v-else class="recent-learning-empty-box">
            <img :src="recentLearningIcons.empty" alt="" />
            <span>{{ uiText.empty }}</span>
          </div>
        </div>

        <div v-if="recentLearningActiveTab == 'highlights'" class="recent-learning-detail-content" :class="{ 'is-empty': recentLearningHighlights.length == 0 }">
          <div v-if="recentLearningHighlights.length > 0" class="recent-learning-list-box recent-learning-highlight-list">
            <button
              v-for="highlight in recentLearningHighlights"
              :key="highlight.id"
              class="recent-learning-info-row recent-learning-highlight-row"
              :class="{ active: recentLearningActiveHighlight && recentLearningActiveHighlight.id == highlight.id }"
              type="button"
              @click="openRecentLearningHighlight(highlight)"
            >
              <span class="recent-learning-highlight-main">
                <strong :title="highlight.title">{{ highlight.title }}</strong>
                <em>{{ formatRecentDate(highlight.createdAt) || '--' }}</em>
              </span>
              <i></i>
            </button>
          </div>
          <div v-else class="recent-learning-empty-box">
            <img :src="recentLearningIcons.empty" alt="" />
            <span>{{ uiText.empty }}</span>
          </div>
        </div>

        <div v-if="recentLearningActiveTab == 'annotations'" class="recent-learning-detail-content is-annotations" :class="{ 'is-empty': filteredRecentLearningAnnotations.length == 0 }">
          <div class="recent-learning-annotation-toolbar" @click.stop>
            <a-select
              v-model="recentLearningAnnotationScreenSize"
              class="recent-learning-annotation-source-select"
              :aria-label="uiText.allSources"
              :dropdown-match-select-width="true"
            >
              <a-select-option value="">{{ uiText.allSources }}</a-select-option>
              <a-select-option v-for="screenSize in recentLearningAnnotationScreenSizes" :key="screenSize" :value="screenSize">
                {{ screenSize }}
              </a-select-option>
            </a-select>
            <div class="recent-learning-view-switch" role="group">
              <img :src="recentLearningAnnotationViewSwitchIcon" alt="" />
              <button
                type="button"
                class="recent-learning-view-hotspot recent-learning-view-list"
                :aria-label="uiText.listView"
                @click="setRecentLearningAnnotationViewMode('list')"
              ></button>
              <button
                type="button"
                class="recent-learning-view-hotspot recent-learning-view-grid"
                :aria-label="uiText.gridView"
                @click="setRecentLearningAnnotationViewMode('grid')"
              ></button>
            </div>
          </div>

          <div v-if="filteredRecentLearningAnnotations.length > 0 && recentLearningAnnotationViewMode == 'grid'" ref="recentLearningAnnotationGrid" class="recent-learning-annotation-grid">
            <button
              v-for="(annotation, index) in filteredRecentLearningAnnotations"
              :key="annotation.id"
              class="recent-learning-annotation-card"
              :class="getRecentLearningAnnotationGridItemClasses(annotation, index)"
              type="button"
              @click="openRecentLearningAnnotationPreview(annotation)"
            >
              <span class="recent-learning-annotation-cover">
                <img v-if="annotation.pageImageUrl" class="recent-learning-annotation-page" :src="annotation.pageImageUrl" alt="" loading="lazy" decoding="async" />
                <img v-if="annotation.imageUrl" class="recent-learning-annotation-ink" :src="annotation.imageUrl" alt="" loading="lazy" decoding="async" />
                <span v-if="annotation.screenSize" class="recent-learning-annotation-screen-size">{{ annotation.screenSize }}</span>
              </span>
              <strong :title="annotation.title">{{ annotation.title }}</strong>
              <em>{{ formatRecentDate(annotation.createdAt) }}</em>
            </button>
          </div>

          <div v-if="filteredRecentLearningAnnotations.length > 0 && recentLearningAnnotationViewMode == 'list'" class="recent-learning-list-box recent-learning-annotation-list">
            <button
              v-for="annotation in filteredRecentLearningAnnotations"
              :key="annotation.id"
              class="recent-learning-annotation-row"
              :class="{ active: recentLearningActiveAnnotationId && recentLearningActiveAnnotationId == annotation.id }"
              type="button"
              @click="openRecentLearningAnnotationPreview(annotation)"
            >
              <span class="recent-learning-annotation-cover small">
                <img v-if="annotation.pageImageUrl" class="recent-learning-annotation-page" :src="annotation.pageImageUrl" alt="" loading="lazy" decoding="async" />
                <img v-if="annotation.imageUrl" class="recent-learning-annotation-ink" :src="annotation.imageUrl" alt="" loading="lazy" decoding="async" />
              </span>
              <span class="recent-learning-annotation-main">
                <strong :title="annotation.title">{{ annotation.title }}</strong>
                <em>{{ formatRecentDate(annotation.createdAt) }}</em>
              </span>
              <i class="recent-learning-row-arrow"></i>
            </button>
          </div>

          <div v-if="filteredRecentLearningAnnotations.length == 0" class="recent-learning-empty-box">
            <img :src="recentLearningIcons.empty" alt="" />
            <span>{{ uiText.empty }}</span>
          </div>
        </div>
      </section>
    </section>

    <div v-if="recentPasswordModalOpen" class="paper-download-mask" @click="closeRecentPasswordModal"></div>
    <section v-if="recentPasswordModalOpen" class="paper-download-modal recent-password-modal" @click.stop>
      <header>
        <strong>{{ recentPasswordUi.title }}</strong>
        <button type="button" :aria-label="uiText.cancel" @click="closeRecentPasswordModal">
          <span></span>
        </button>
      </header>
      <div class="paper-download-options recent-password-content">
        <div class="recent-password-field" :class="{ error: recentPasswordError }">
          <input
            ref="recentPasswordInput"
            v-model="recentPasswordInput"
            :type="recentPasswordVisible ? 'text' : 'password'"
            :placeholder="recentPasswordUi.placeholder"
            :maxlength="inputMaxLength"
            :disabled="recentPasswordSubmitting"
            @keyup.enter="confirmRecentPassword"
          />
          <button
            type="button"
            :disabled="recentPasswordSubmitting"
            :aria-label="recentPasswordVisible ? recentPasswordUi.hide : recentPasswordUi.show"
            @click="toggleRecentPasswordVisible"
          >
            <span :class="{ visible: recentPasswordVisible }"></span>
          </button>
        </div>
        <p v-if="recentPasswordError" class="recent-password-error">{{ recentPasswordError }}</p>
      </div>
      <footer>
        <button type="button" :disabled="recentPasswordSubmitting" @click="closeRecentPasswordModal">{{ uiText.cancel }}</button>
        <button type="button" :disabled="recentPasswordSubmitting" @click="confirmRecentPassword">{{ recentPasswordSubmitting ? recentPasswordUi.confirming : uiText.ok }}</button>
      </footer>
    </section>

    <div v-if="paperDownloadFormatModalOpen" class="paper-download-mask paper-download-format-mask" @click="closePaperDownloadFormatModal"></div>
    <section v-if="paperDownloadFormatModalOpen" class="paper-download-modal paper-download-format-modal" @click.stop>
      <header>
        <strong>{{ uiText.downloadFormat }}</strong>
        <button type="button" :aria-label="uiText.cancel" @click="closePaperDownloadFormatModal">
          <span></span>
        </button>
      </header>
      <div class="paper-download-options">
        <label>
          <input v-model="paperDownloadFormat" type="radio" value="pdf" />
          <span>PDF</span>
        </label>
        <label>
          <input v-model="paperDownloadFormat" type="radio" value="png" />
          <span>PNG</span>
        </label>
      </div>
      <footer>
        <button type="button" @click="closePaperDownloadFormatModal">{{ uiText.cancel }}</button>
        <button type="button" @click="confirmPaperDownloadFormat">{{ uiText.ok }}</button>
      </footer>
    </section>

    <div v-if="recentDownloadFormatModalOpen" class="paper-download-mask paper-download-format-mask" @click="closeRecentDownloadFormatModal"></div>
    <section v-if="recentDownloadFormatModalOpen" class="paper-download-modal paper-download-format-modal" @click.stop>
      <header>
        <strong>{{ uiText.downloadFormat }}</strong>
        <button type="button" :aria-label="uiText.cancel" @click="closeRecentDownloadFormatModal">
          <span></span>
        </button>
      </header>
      <div class="paper-download-options">
        <label>
          <input v-model="recentDownloadFormat" type="radio" value="pdf" />
          <span>PDF</span>
        </label>
        <label>
          <input v-model="recentDownloadFormat" type="radio" value="png" />
          <span>PNG</span>
        </label>
      </div>
      <footer>
        <button type="button" @click="closeRecentDownloadFormatModal">{{ uiText.cancel }}</button>
        <button type="button" :disabled="recentDownloadSubmitting" @click="confirmRecentDownloadFormat">{{ uiText.ok }}</button>
      </footer>
    </section>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
import JSZip from 'jszip'
import pako from 'pako'
import {
  refreshLogin,
  getTimeId,
  getAreaCode,
  updateUser,
  getCloudStatus,
  getRootFolder,
  getHistoryPage,
  searchResourceSync,
  getPaperSyncDetail,
  getLearningSyncDetail,
  getMemoSyncDetail,
  getMeetingSyncDetail,
  getKnowledgeBaseSyncDetail,
  sendSmsCodeAuth,
  sendEmailCodeAuth,
  checkCodeAuth,
  resetPasswordAuth,
  checkCloudPassword
} from '@/api/api'
import { setToken, removeToken, setLanguage, getLanguage } from '@/api/auth'
import { isNetworkError } from '@/utils/network'
import { getPhoneValidationMessage } from '@/utils/phone'
import PaperSync from './PaperSync.vue'
import LearningSync from './LearningSync.vue'
import DailySync from './DailySync.vue'
import MemoSync from './MemoSync.vue'
import MeetingSync from './MeetingSync.vue'
import KnowledgeBaseSync from './KnowledgeBaseSync.vue'
import MobilePullRefreshIndicator from '@/wap/components/MobilePullRefreshIndicator.vue'
import downloadCenterMixin from '@/mixins/downloadCenterMixin'
import directFilePreviewMixin from '@/mixins/directFilePreviewMixin'
import mobilePreviewGridSelectionMixin from '@/mixins/mobilePreviewGridSelectionMixin'
import previewPerformanceMixin from '@/mixins/previewPerformanceMixin'
import recentDownloadWorkerMixin from '@/mixins/recentDownloadWorkerMixin'
import { classifyMobileTouchGesture } from '@/utils/mobileTouchGesture'
import uploadCenter from '@/utils/uploadCenter'
import { getAppUiText, normalizeLanguage } from '@/utils/language/common'
import {
  clearCloudAppStates,
  clearCloudHomeState,
  getCloudAppState,
  getCloudHomeState,
  setCloudAppState,
  setCloudHomeState
} from '@/utils/cloudState'
import {
  getMobileCloudViewMode,
  MOBILE_CLOUD_VIEW_MODE_EVENT,
  normalizeMobileCloudViewMode,
  setMobileCloudViewMode
} from '@/utils/mobileCloudViewState'
import {
  CLOUD_SERVER_CN,
  CLOUD_SERVER_SG,
  CLOUD_SERVER_US,
  getActiveCloudServerKey,
  isCloudTestEnvironment,
  normalizeCloudServerKey,
  setCloudServerKey
} from '@/utils/cloudServer'
import { selectItemWithWindowsRange } from '@/utils/rangeSelection'

const EMPTY_COUNT_FOLDER_ICON = require('@/assets/wap/layer-stack.png')
const RECENT_DOWNLOAD_ICON = require('@/assets/wap/recent-download.png')
const RECENT_FAVORITE_FILLED_ICON = require('@/assets/wap/paper/favorite-filled.png')
const RECENT_LEARNING_ICON_VIEW_GRID = require('@/assets/wap/learning/view-grid.png')
const RECENT_LEARNING_ICON_VIEW_LIST = require('@/assets/wap/learning/view-list.png')
const RECENT_LEARNING_ICON_PAGE_GRID = require('@/assets/wap/learning/page-grid.png')
const RECENT_LEARNING_ICON_ZOOM_IN = require('@/assets/wap/learning/zoom-in.png')
const RECENT_LEARNING_ICON_ZOOM_OUT = require('@/assets/wap/learning/zoom-out.png')
const RECENT_LEARNING_ICON_DOWNLOAD = require('@/assets/wap/paper/download.png')
const RECENT_LEARNING_EMPTY_ICON = require('@/assets/wap/learning/record-empty.png')
const RECENT_DAILY_EMPTY_COVER = require('@/assets/wap/daily/daily-empty-cover.png')
const RECENT_WAP_ICONS = {
  search: require('@/assets/wap/recent-search.png'),
  sort: require('@/assets/wap/recent-sort.png'),
  download: RECENT_DOWNLOAD_ICON,
  multiPage: require('@/assets/wap/recent-multi-page.png'),
  pageGrid: require('@/assets/wap/recent-page-grid.png'),
  previewList: require('@/assets/wap/recent-preview-list.png'),
  back: require('@/assets/wap/recent-back.png'),
  navRecent: require('@/assets/common/recent-menu-icon.svg'),
  navFiles: require('@/assets/wap/recent-nav-files.png'),
  navDaily: require('@/assets/wap/recent-nav-daily.png'),
  navMine: require('@/assets/wap/recent-nav-mine.png'),
  favorite: require('@/assets/wap/paper/favorite.png'),
  favoriteFilled: RECENT_FAVORITE_FILLED_ICON,
  encrypt: require('@/assets/wap/paper/encrypt-file.png')
}
const GLOBAL_SEARCH_ICONS = {
  search: require('@/assets/wap/global-search-svg/search.svg'),
  back: require('@/assets/wap/global-search-svg/back.svg'),
  close: require('@/assets/wap/global-search-svg/close.svg'),
  empty: require('@/assets/wap/global-search-svg/empty.svg'),
  viewSwitch: require('@/assets/wap/global-search-svg/sort.svg'),
  all: require('@/assets/wap/global-search-svg/all.svg'),
  folder: require('@/assets/wap/global-search-svg/folder.svg'),
  folderFilled: require('@/assets/wap/paper/grid-folder-filled.png'),
  folderEmpty: require('@/assets/wap/paper/grid-folder-empty.png'),
  check: require('@/assets/wap/global-search/对勾@2x.png'),
  paper: require('@/assets/wap/global-search-svg/paper.svg'),
  meeting: require('@/assets/wap/global-search-svg/meeting.svg'),
  learning: require('@/assets/wap/global-search/learning-filter@2x.png'),
  knowledge: require('@/assets/wap/global-search-svg/knowledge.svg'),
  memo: require('@/assets/wap/global-search-svg/memo.svg'),
  daily: require('@/assets/wap/global-search-svg/daily.svg')
}
const RECENT_APP_FALLBACK_COVERS = {
  paper: {
    placeholder: require('@/assets/wap/paper/paper_empty.png'),
    folderListFilled: require('@/assets/wap/paper/list-folder-filled.png'),
    folderListEmpty: require('@/assets/wap/paper/list-folder-empty.png'),
    folderGridFilled: require('@/assets/wap/paper/grid-folder-filled.png'),
    folderGridEmpty: require('@/assets/wap/paper/grid-folder-empty.png'),
    templateListFilled: require('@/assets/wap/paper/list-template-filled.png'),
    templateListEmpty: require('@/assets/wap/paper/list-template-empty.png'),
    templateGridFilled: require('@/assets/wap/paper/grid-template-filled.png'),
    templateGridEmpty: require('@/assets/wap/paper/grid-template-empty.png'),
    fileListPdf: require('@/assets/wap/paper/list-pdf.png'),
    fileListPaper: require('@/assets/wap/paper/list-paper.png'),
    fileListEncrypt: require('@/assets/wap/paper/list-encrypt.png'),
    fileGridPdf: require('@/assets/wap/paper/grid-pdf.png'),
    fileGridPaper: require('@/assets/wap/paper/grid-paper.png'),
    fileGridEncrypt: require('@/assets/wap/paper/grid-encrypt.png')
  },
  meeting: {
    placeholder: require('@/assets/wap/meeting/list-placeholder.png'),
    folderListFilled: require('@/assets/wap/meeting/list-folder-filled.png'),
    folderListEmpty: require('@/assets/wap/meeting/list-folder-empty.png'),
    folderGridFilled: require('@/assets/wap/meeting/grid-folder-filled.png'),
    folderGridEmpty: require('@/assets/wap/meeting/grid-folder-empty.png'),
    templateListFilled: require('@/assets/wap/meeting/list-template-filled.png'),
    templateListEmpty: require('@/assets/wap/meeting/list-template-empty.png'),
    templateGridFilled: require('@/assets/wap/meeting/grid-template-filled.png'),
    templateGridEmpty: require('@/assets/wap/meeting/grid-template-empty.png'),
    fileListPdf: require('@/assets/wap/meeting/list-pdf.png'),
    fileListPaper: require('@/assets/wap/meeting/list-paper.png'),
    fileListEncrypt: require('@/assets/wap/meeting/list-encrypt.png'),
    fileGridPdf: require('@/assets/wap/meeting/grid-pdf.png'),
    fileGridPaper: require('@/assets/wap/meeting/grid-paper.png'),
    fileGridEncrypt: require('@/assets/wap/meeting/grid-encrypt.png')
  },
  learning: {
    folderListFilled: require('@/assets/wap/learning/list-folder-filled.png'),
    folderListEmpty: require('@/assets/wap/learning/list-folder-empty.png'),
    folderGridFilled: require('@/assets/wap/learning/grid-folder-filled.png'),
    folderGridEmpty: require('@/assets/wap/learning/grid-folder-empty.png'),
    templateListFilled: require('@/assets/wap/learning/list-template-filled.png'),
    templateListEmpty: require('@/assets/wap/learning/list-template-empty.png'),
    templateGridFilled: require('@/assets/wap/learning/grid-template-filled.png'),
    templateGridEmpty: require('@/assets/wap/learning/grid-template-empty.png'),
    fileListPdf: require('@/assets/wap/learning/list-pdf.png'),
    fileListPaper: require('@/assets/wap/learning/list-paper.png'),
    fileListEncrypt: require('@/assets/wap/learning/list-encrypt.png'),
    fileGridPdf: require('@/assets/wap/learning/grid-pdf.png'),
    fileGridPaper: require('@/assets/wap/learning/grid-paper.png'),
    fileGridEncrypt: require('@/assets/wap/learning/grid-encrypt.png'),
    fileEpub: require('@/assets/wap/learning/file-epub.png'),
    fileAzw: require('@/assets/wap/learning/file-azw.png'),
    fileMobi: require('@/assets/wap/learning/file-mobi.png')
  },
  knowledge: {
    folderListFilled: require('@/assets/wap/knowledge-base/list-folder-filled.png'),
    folderListEmpty: require('@/assets/wap/knowledge-base/list-folder-empty.png'),
    folderGridFilled: require('@/assets/wap/knowledge-base/grid-folder-filled.png'),
    folderGridEmpty: require('@/assets/wap/knowledge-base/grid-folder-empty.png'),
    templateListFilled: require('@/assets/wap/knowledge-base/list-template-filled.png'),
    templateListEmpty: require('@/assets/wap/knowledge-base/list-template-empty.png'),
    templateGridFilled: require('@/assets/wap/knowledge-base/grid-template-filled.png'),
    templateGridEmpty: require('@/assets/wap/knowledge-base/grid-template-empty.png'),
    fileListPdf: require('@/assets/wap/knowledge-base/list-pdf.png'),
    fileListPaper: require('@/assets/wap/knowledge-base/list-paper.png'),
    fileListEncrypt: require('@/assets/wap/knowledge-base/list-encrypt.png'),
    fileGridPdf: require('@/assets/wap/knowledge-base/grid-pdf.png'),
    fileGridPaper: require('@/assets/wap/knowledge-base/grid-paper.png'),
    fileGridEncrypt: require('@/assets/wap/knowledge-base/grid-encrypt.png'),
    resourceType12: require('@/assets/wap/knowledge-base/resource-type-1-2.png'),
    resourceType3: require('@/assets/wap/knowledge-base/resource-type-3.png')
  },
  memo: {
    placeholder: require('@/assets/wap/memo/list-placeholder.png'),
    folderListFilled: require('@/assets/wap/memo/list-folder-filled.png'),
    folderListEmpty: require('@/assets/wap/memo/list-folder-empty.png'),
    folderGridFilled: require('@/assets/wap/memo/grid-folder-filled.png'),
    folderGridEmpty: require('@/assets/wap/memo/grid-folder-empty.png'),
    templateListFilled: require('@/assets/wap/memo/list-template-filled.png'),
    templateListEmpty: require('@/assets/wap/memo/list-template-empty.png'),
    templateGridFilled: require('@/assets/wap/memo/grid-template-filled.png'),
    templateGridEmpty: require('@/assets/wap/memo/grid-template-empty.png'),
    fileListPdf: require('@/assets/wap/memo/list-pdf.png'),
    fileListPaper: require('@/assets/wap/memo/list-paper.png'),
    fileListEncrypt: require('@/assets/wap/memo/list-encrypt.png'),
    fileGridPdf: require('@/assets/wap/memo/grid-pdf.png'),
    fileGridPaper: require('@/assets/wap/memo/grid-paper.png'),
    fileGridEncrypt: require('@/assets/wap/memo/grid-encrypt.png')
  }
}
RECENT_APP_FALLBACK_COVERS.daily = RECENT_APP_FALLBACK_COVERS.learning

const RECENT_GRID_FALLBACK_COVER_STYLE = Object.freeze({
  width: '30px',
  minWidth: '30px',
  maxWidth: '30px',
  height: '30px',
  minHeight: '30px',
  maxHeight: '30px',
  flex: '0 0 30px',
  objectFit: 'contain',
  display: 'block',
  boxSizing: 'content-box'
})
const RECENT_GRID_FALLBACK_COVER_SIZE = Object.freeze({
  width: 30,
  height: 30
})
const RECENT_ROW_FALLBACK_COVER_STYLE = Object.freeze({
  width: '32px',
  minWidth: '32px',
  maxWidth: '32px',
  height: '32px',
  minHeight: '32px',
  maxHeight: '32px',
  flex: '0 0 32px',
  objectFit: 'contain',
  display: 'block',
  boxSizing: 'content-box'
})
const RECENT_ROW_FALLBACK_COVER_SIZE = Object.freeze({
  width: 32,
  height: 32
})
const RECENT_ROW_FOLDER_FALLBACK_COVER_STYLE = Object.freeze({
  width: '46px',
  minWidth: '46px',
  maxWidth: '46px',
  height: '46px',
  minHeight: '46px',
  maxHeight: '46px',
  flex: '0 0 46px',
  objectFit: 'contain',
  display: 'block',
  boxSizing: 'content-box'
})
const RECENT_ROW_FOLDER_FALLBACK_COVER_SIZE = Object.freeze({
  width: 46,
  height: 46
})
const RECENT_ROW_ENCRYPT_FALLBACK_COVER_STYLE = Object.freeze({
  width: '22px',
  minWidth: '22px',
  maxWidth: '22px',
  height: '22px',
  minHeight: '22px',
  maxHeight: 'none',
  flex: '0 0 22px',
  objectFit: 'contain',
  display: 'block',
  boxSizing: 'content-box'
})
const RECENT_ROW_ENCRYPT_FALLBACK_COVER_SIZE = Object.freeze({
  width: 22,
  height: 22
})

const LANGUAGE_OPTIONS = [
  { id: 'zh', label: 'Chinese (\u7b80\u4f53\u4e2d\u6587)' },
  { id: 'tw', label: 'Chinese (\u7e41\u9ad4\u4e2d\u6587)' },
  { id: 'nl', label: 'Dutch (Nederlands)' },
  { id: 'uk', label: 'English (English UK)' },
  { id: 'us', label: 'English (English US)' },
  { id: 'fr', label: 'French (Fran\u00e7ais)' },
  { id: 'de', label: 'German (Deutsch)' },
  { id: 'it', label: 'Italian (Italiano)' },
  { id: 'ja', label: 'Japanese (\u65e5\u672c\u8a9e)' },
  { id: 'ko', label: 'Korean (\ud55c\uad6d\uc5b4)' },
  { id: 'pt', label: 'Portuguese (Portugu\u00eas)' },
  { id: 'ru', label: 'Russian (\u0420\u0443\u0441\u0441\u043a\u0438\u0439)' },
  { id: 'es', label: 'Spanish (Espa\u00f1ol)' }
]

const CLOUD_TEXTS = {
  zh: {
    recent: '\u6700\u8fd1\u8bbf\u95ee',
    files: '\u6211\u7684\u6587\u4ef6',
    daily: 'Daily',
    search: '\u641c\u7d22',
    emptyCloud: '\u672a\u68c0\u6d4b\u5230\u4e91\u7aef\u6570\u636e\uff0c\u8bf7\u786e\u4fdd\u60a8\u7684 Viwoods \u8bbe\u5907\u5df2\u5f00\u542f\u4e91\u540c\u6b65\u3002',
    emptyRecent: '\u6682\u65e0\u6700\u8fd1\u8bbf\u95ee',
    emptySearch: '\u6682\u65e0\u641c\u7d22\u7ed3\u679c',
    allTypes: '\u5168\u90e8',
    openUnavailable: '\u8be5\u7c7b\u578b\u6682\u65e0\u8be6\u60c5\u9884\u89c8',
    download: '\u4e0b\u8f7d',
    downloadFormat: '\u4e0b\u8f7d\u683c\u5f0f',
    downloadUnavailable: '\u6682\u65e0\u53ef\u4e0b\u8f7d\u7684\u6587\u4ef6',
    downloadFormatUnavailable: '\u8be5\u6587\u4ef6\u6682\u4e0d\u652f\u6301\u6b64\u683c\u5f0f\u4e0b\u8f7d',
    actionUnavailable: '\u6682\u672a\u5f00\u653e',
    selectedPrefix: '\u5df2\u9009',
    selectedSuffix: '\u9879',
    loading: '\u52a0\u8f7d\u4e2d',
    readingProgress: '\u9605\u8bfb\u8fdb\u5ea6',
    bookmarks: '\u4e66\u7b7e',
    highlights: '\u9ad8\u4eae',
    annotations: '\u624b\u5199\u6279\u6ce8',
    listView: '\u5217\u8868\u89c6\u56fe',
    gridView: '\u7f51\u683c\u89c6\u56fe',
    pageGrid: '\u9875\u9762\u5217\u8868',
    zoomIn: '\u653e\u5927',
    zoomOut: '\u7f29\u5c0f',
    empty: '\u6682\u65e0\u6570\u636e',
    syncedSource: '\u5df2\u540c\u6b65\u6e90\u6587\u4ef6',
    unsyncedSource: '\u672a\u540c\u6b65\u6e90\u6587\u4ef6',
    unknownSync: '\u540c\u6b65\u72b6\u6001 -',
    itemUnit: '\u9879',
    language: '\u8bed\u8a00',
    logout: '\u9000\u51fa',
    confirmLogout: '\u662f\u5426\u786e\u8ba4\u9000\u51fa\u767b\u5f55\uff1f',
    cancel: '\u53d6\u6d88',
    ok: '\u786e\u5b9a',
    setting: '\u8bbe\u7f6e',
    account: '\u8d26\u53f7',
    viwoodsCloud: 'Viwoods \u4e91',
    feedback: '\u95ee\u9898\u53cd\u9988',
    username: '\u7528\u6237\u540d',
    emailLabel: '\u90ae\u7bb1',
    phoneLabel: '\u624b\u673a',
    areaCode: '\u533a\u53f7',
    unbound: '\u672a\u7ed1\u5b9a',
    edit: '\u7f16\u8f91',
    rename: '\u91cd\u547d\u540d',
    save: '\u4fdd\u5b58',
    back: '\u8fd4\u56de',
    changePassword: '\u4fee\u6539\u5bc6\u7801',
    emailReset: '\u90ae\u7bb1\u9a8c\u8bc1',
    phoneReset: '\u624b\u673a\u9a8c\u8bc1',
    resetEmailSubtitle: '\u8bf7\u8f93\u5165\u60a8\u7684\u90ae\u7bb1\uff0c\u6211\u4eec\u5c06\u5411\u60a8\u53d1\u9001\u9a8c\u8bc1\u7801\u3002',
    resetPhoneSubtitle: '\u8bf7\u8f93\u5165\u60a8\u7684\u624b\u673a\u53f7\uff0c\u6211\u4eec\u5c06\u5411\u60a8\u53d1\u9001\u9a8c\u8bc1\u7801\u3002',
    codeSubtitle: '\u5305\u542b 6 \u4f4d\u9a8c\u8bc1\u7801\u7684\u6d88\u606f\u5df2\u53d1\u9001\u81f3 %s',
    continue: '\u7ee7\u7eed',
    verificationCode: '\u9a8c\u8bc1\u7801',
    resendCode: '\u91cd\u65b0\u53d1\u9001\u9a8c\u8bc1\u7801',
    resendAfter: '\u540e\u91cd\u53d1',
    sending: '\u53d1\u9001\u4e2d',
    newPassword: '\u8f93\u5165\u65b0\u5bc6\u7801',
    passwordSubtitle: '',
    confirmPassword: '\u8bf7\u518d\u6b21\u8f93\u5165\u5bc6\u7801',
    passwordPlaceholder: '\u5bc6\u7801\u957f\u5ea6\u4e0d\u5c11\u4e8e 8 \u4e2a\u5b57\u7b26',
    passwordMin: '\u8bf7\u8f93\u5165\u4e0d\u5c11\u4e8e 8 \u4e2a\u5b57\u7b26\u7684\u5bc6\u7801',
    passwordMatch: '\u4e24\u6b21\u8f93\u5165\u7684\u5bc6\u7801\u4e0d\u4e00\u81f4',
    codeRequired: '\u8bf7\u8f93\u5165 6 \u4f4d\u9a8c\u8bc1\u7801',
    accountRequired: '\u8bf7\u8f93\u5165\u8d26\u53f7',
    usernameRequired: '\u8bf7\u8f93\u5165\u7528\u6237\u540d',
    updateSuccess: '\u4fee\u6539\u6210\u529f',
    updateFailed: '\u4fee\u6539\u5931\u8d25\uff0c\u8bf7\u7a0d\u540e\u91cd\u8bd5',
    passwordUpdateSuccess: '\u5bc6\u7801\u4fee\u6539\u6210\u529f',
    orUse: '\u6216\u8005\u4f7f\u7528',
    cloudStorageSpace: '\u4e91\u5b58\u50a8\u7a7a\u95f4',
    cloudUsage: '\u7a7a\u95f4\u4f7f\u7528\u7edf\u8ba1',
    server: '\u670d\u52a1\u5668',
    serverUnitedStates: '\u7f8e\u56fd',
    serverSingapore: '\u65b0\u52a0\u5761',
    serverChina: '\u4e2d\u56fd',
    testServerSwitchBlocked: '\u6d4b\u8bd5\u73af\u5883\u4e0d\u5141\u8bb8\u5207\u670d\u52a1\u5668',
    uploadServerSwitchBlocked: '\u6587\u4ef6\u6b63\u5728\u4e0a\u4f20\u4e2d\uff0c\u4e0d\u5141\u8bb8\u5207\u670d\u52a1\u5668'
  },
  tw: {
    recent: '\u6700\u8fd1\u8a2a\u554f',
    files: '\u6211\u7684\u6a94\u6848',
    daily: 'Daily',
    search: '\u641c\u5c0b',
    emptyCloud: '\u672a\u6aa2\u6e2c\u5230\u96f2\u7aef\u8cc7\u6599\uff0c\u8acb\u78ba\u4fdd\u60a8\u7684 Viwoods \u8a2d\u5099\u5df2\u958b\u555f\u96f2\u540c\u6b65\u3002',
    emptyRecent: '\u66ab\u7121\u6700\u8fd1\u8a2a\u554f',
    emptySearch: '\u66ab\u7121\u641c\u5c0b\u7d50\u679c',
    allTypes: '\u5168\u90e8',
    openUnavailable: '\u8a72\u985e\u578b\u66ab\u7121\u8a73\u60c5\u9810\u89bd',
    download: '\u4e0b\u8f09',
    downloadFormat: '\u4e0b\u8f09\u683c\u5f0f',
    downloadUnavailable: '\u66ab\u7121\u53ef\u4e0b\u8f09\u7684\u6a94\u6848',
    downloadFormatUnavailable: '\u8a72\u6a94\u6848\u66ab\u4e0d\u652f\u63f4\u6b64\u683c\u5f0f\u4e0b\u8f09',
    selectedPrefix: '\u5df2\u9078',
    selectedSuffix: '\u9805',
    loading: '\u52a0\u8f09\u4e2d',
    readingProgress: '\u95b1\u8b80\u9032\u5ea6',
    bookmarks: '\u66f8\u7c64',
    highlights: '\u9ad8\u4eae',
    annotations: '\u624b\u5beb\u6279\u8a3b',
    listView: '\u5217\u8868\u8996\u5716',
    gridView: '\u7db2\u683c\u8996\u5716',
    pageGrid: '\u9801\u9762\u5217\u8868',
    zoomIn: '\u653e\u5927',
    zoomOut: '\u7e2e\u5c0f',
    empty: '\u66ab\u7121\u8cc7\u6599',
    syncedSource: '\u5df2\u540c\u6b65\u6e90\u6a94\u6848',
    unsyncedSource: '\u672a\u540c\u6b65\u6e90\u6a94\u6848',
    unknownSync: '\u540c\u6b65\u72c0\u614b -',
    itemUnit: '\u9805',
    language: '\u8a9e\u8a00',
    logout: '\u767b\u51fa',
    confirmLogout: '\u662f\u5426\u78ba\u8a8d\u767b\u51fa\uff1f',
    cancel: '\u53d6\u6d88',
    ok: '\u78ba\u5b9a',
    setting: '\u8a2d\u7f6e',
    account: '\u5e33\u865f',
    viwoodsCloud: 'Viwoods \u96f2',
    feedback: '\u554f\u984c\u53cd\u994b',
    username: '\u7528\u6236\u540d',
    emailLabel: '\u90f5\u7bb1',
    phoneLabel: '\u624b\u6a5f',
    areaCode: '\u5340\u865f',
    unbound: '\u672a\u7d81\u5b9a',
    edit: '\u7de8\u8f2f',
    rename: '\u91cd\u547d\u540d',
    save: '\u4fdd\u5b58',
    back: '\u8fd4\u56de',
    changePassword: '\u4fee\u6539\u5bc6\u78bc',
    emailReset: '\u90f5\u7bb1\u9a57\u8b49',
    phoneReset: '\u624b\u6a5f\u9a57\u8b49',
    resetEmailSubtitle: '\u8acb\u8f38\u5165\u60a8\u7684\u90f5\u7bb1\uff0c\u6211\u5011\u5c07\u5411\u60a8\u767c\u9001\u9a57\u8b49\u78bc\u3002',
    resetPhoneSubtitle: '\u8acb\u8f38\u5165\u60a8\u7684\u624b\u6a5f\u865f\uff0c\u6211\u5011\u5c07\u5411\u60a8\u767c\u9001\u9a57\u8b49\u78bc\u3002',
    codeSubtitle: '\u5305\u542b 6 \u4f4d\u9a57\u8b49\u78bc\u7684\u8a0a\u606f\u5df2\u767c\u9001\u81f3 %s',
    continue: '\u7e7c\u7e8c',
    verificationCode: '\u9a57\u8b49\u78bc',
    resendCode: '\u91cd\u65b0\u767c\u9001\u9a57\u8b49\u78bc',
    resendAfter: '\u5f8c\u91cd\u767c',
    sending: '\u767c\u9001\u4e2d',
    newPassword: '\u8f38\u5165\u65b0\u5bc6\u78bc',
    passwordSubtitle: '',
    confirmPassword: '\u8acb\u518d\u6b21\u8f38\u5165\u5bc6\u78bc',
    passwordPlaceholder: '\u5bc6\u78bc\u9577\u5ea6\u4e0d\u5c11\u65bc 8 \u500b\u5b57\u5143',
    passwordMin: '\u8acb\u8f38\u5165\u4e0d\u5c11\u65bc 8 \u500b\u5b57\u5143\u7684\u5bc6\u78bc',
    passwordMatch: '\u5169\u6b21\u8f38\u5165\u7684\u5bc6\u78bc\u4e0d\u4e00\u81f4',
    codeRequired: '\u8acb\u8f38\u5165 6 \u4f4d\u9a57\u8b49\u78bc',
    accountRequired: '\u8acb\u8f38\u5165\u5e33\u865f',
    usernameRequired: '\u8acb\u8f38\u5165\u7528\u6236\u540d',
    updateSuccess: '\u4fee\u6539\u6210\u529f',
    updateFailed: '\u4fee\u6539\u5931\u6557\uff0c\u8acb\u7a0d\u5f8c\u91cd\u8a66',
    passwordUpdateSuccess: '\u5bc6\u78bc\u4fee\u6539\u6210\u529f',
    orUse: '\u6216\u8005\u4f7f\u7528',
    cloudStorageSpace: '\u96f2\u5132\u5b58\u7a7a\u9593',
    cloudUsage: '\u7a7a\u9593\u4f7f\u7528\u7d71\u8a08',
    server: '\u4f3a\u670d\u5668',
    serverUnitedStates: '\u7f8e\u570b',
    serverSingapore: '\u65b0\u52a0\u5761',
    serverChina: '\u4e2d\u570b',
    testServerSwitchBlocked: '\u6d4b\u8bd5\u73af\u5883\u4e0d\u5141\u8bb8\u5207\u670d\u52a1\u5668',
    uploadServerSwitchBlocked: '\u6587\u4ef6\u6b63\u5728\u4e0a\u4f20\u4e2d\uff0c\u4e0d\u5141\u8bb8\u5207\u670d\u52a1\u5668'
  },
  us: {
    recent: 'Recent',
    files: 'My Files',
    daily: 'Daily',
    search: 'Search',
    emptyCloud: 'No cloud data detected. Make sure cloud sync is enabled on your Viwoods device.',
    emptyRecent: 'No recent visits',
    emptySearch: 'No search results',
    allTypes: 'All',
    openUnavailable: 'Preview is unavailable for this item',
    download: 'Download',
    downloadFormat: 'Download format',
    downloadUnavailable: 'No downloadable file is available',
    downloadFormatUnavailable: 'This file cannot be downloaded in that format',
    actionUnavailable: 'Not available yet',
    selectedPrefix: 'Selected',
    selectedSuffix: 'items',
    loading: 'Loading',
    readingProgress: 'Reading progress',
    bookmarks: 'Bookmarks',
    highlights: 'Highlights',
    annotations: 'Handwritten notes',
    listView: 'List view',
    gridView: 'Grid view',
    pageGrid: 'Page grid',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    empty: 'No data',
    syncedSource: 'Source file synced',
    unsyncedSource: 'Source file not synced',
    unknownSync: 'Sync status -',
    itemUnit: 'item',
    language: 'Language',
    logout: 'Log out',
    confirmLogout: 'Are you sure you want to log out?',
    cancel: 'Cancel',
    ok: 'OK',
    setting: 'Settings',
    account: 'Account',
    viwoodsCloud: 'Viwoods Cloud',
    feedback: 'Feedback',
    username: 'Username',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    areaCode: 'Code',
    unbound: 'Not linked',
    edit: 'Edit',
    rename: 'Rename',
    save: 'Save',
    back: 'Back',
    changePassword: 'Change password',
    emailReset: 'Email verification',
    phoneReset: 'Phone verification',
    resetEmailSubtitle: 'Please enter your email. We will send a verification code.',
    resetPhoneSubtitle: 'Please enter your phone number. We will send a verification code.',
    codeSubtitle: 'A 6-digit verification code has been sent to %s',
    continue: 'Continue',
    verificationCode: 'Verification code',
    resendCode: 'Resend verification code',
    resendAfter: 'to resend',
    sending: 'Sending',
    newPassword: 'Enter new password',
    passwordSubtitle: '',
    confirmPassword: 'Please enter the password again',
    passwordPlaceholder: 'Password must be at least 8 characters',
    passwordMin: 'Please enter a password of at least 8 characters',
    passwordMatch: 'The two passwords do not match',
    codeRequired: 'Please enter the 6-digit verification code',
    accountRequired: 'Please enter the account',
    usernameRequired: 'Please enter the username',
    updateSuccess: 'Updated successfully',
    updateFailed: 'Update failed. Please try again later.',
    passwordUpdateSuccess: 'Password updated successfully',
    orUse: 'or use',
    cloudStorageSpace: 'Cloud storage',
    cloudUsage: 'Storage usage',
    server: 'Server',
    serverUnitedStates: 'United States',
    serverSingapore: 'Singapore',
    serverChina: 'China',
    testServerSwitchBlocked: '\u6d4b\u8bd5\u73af\u5883\u4e0d\u5141\u8bb8\u5207\u670d\u52a1\u5668',
    uploadServerSwitchBlocked: '\u6587\u4ef6\u6b63\u5728\u4e0a\u4f20\u4e2d\uff0c\u4e0d\u5141\u8bb8\u5207\u670d\u52a1\u5668'
  },
  uk: {
    recent: 'Recent',
    files: 'My Files',
    daily: 'Daily',
    search: 'Search',
    empty: 'No data',
    emptyCloud: 'No cloud data detected. Make sure cloud sync is enabled on your Viwoods device.',
    itemUnit: 'item',
    language: 'Language',
    logout: 'Log out',
    confirmLogout: 'Are you sure you want to log out?',
    cancel: 'Cancel',
    ok: 'OK'
  },
  nl: {
    recent: 'Recent bezocht',
    files: 'Mijn bestanden',
    daily: 'Daily',
    search: 'Zoeken',
    empty: 'Geen gegevens',
    emptyCloud: 'Geen cloudgegevens gevonden. Zorg dat cloudsynchronisatie is ingeschakeld op uw Viwoods-apparaat.',
    itemUnit: 'items',
    language: 'Taal',
    logout: 'Uitloggen',
    confirmLogout: 'Weet u zeker dat u wilt uitloggen?',
    cancel: 'Annuleren',
    ok: 'OK'
  },
  fr: {
    recent: 'R\u00e9cents',
    files: 'Mes fichiers',
    daily: 'Daily',
    search: 'Rechercher',
    empty: 'Aucune donn\u00e9e',
    emptyCloud: 'Aucune donn\u00e9e cloud d\u00e9tect\u00e9e. V\u00e9rifiez que la synchronisation cloud est activ\u00e9e sur votre appareil Viwoods.',
    itemUnit: '\u00e9l\u00e9ments',
    language: 'Langue',
    logout: 'Se d\u00e9connecter',
    confirmLogout: 'Voulez-vous vraiment vous d\u00e9connecter ?',
    cancel: 'Annuler',
    ok: 'OK'
  },
  de: {
    recent: 'Zuletzt besucht',
    files: 'Meine Dateien',
    daily: 'Daily',
    search: 'Suchen',
    empty: 'Keine Daten',
    emptyCloud: 'Keine Cloud-Daten gefunden. Stellen Sie sicher, dass die Cloud-Synchronisierung auf Ihrem Viwoods-Ger\u00e4t aktiviert ist.',
    itemUnit: 'Elemente',
    language: 'Sprache',
    logout: 'Abmelden',
    confirmLogout: 'M\u00f6chten Sie sich wirklich abmelden?',
    cancel: 'Abbrechen',
    ok: 'OK'
  },
  it: {
    recent: 'Recenti',
    files: 'I miei file',
    daily: 'Daily',
    search: 'Cerca',
    empty: 'Nessun dato',
    emptyCloud: 'Nessun dato cloud rilevato. Assicurati che la sincronizzazione cloud sia attiva sul tuo dispositivo Viwoods.',
    itemUnit: 'elementi',
    language: 'Lingua',
    logout: 'Esci',
    confirmLogout: 'Sei sicuro di voler uscire?',
    cancel: 'Annulla',
    ok: 'OK'
  },
  ja: {
    recent: '\u6700\u8fd1\u306e\u30a2\u30af\u30bb\u30b9',
    files: '\u30de\u30a4\u30d5\u30a1\u30a4\u30eb',
    daily: 'Daily',
    search: '\u691c\u7d22',
    empty: '\u30c7\u30fc\u30bf\u306a\u3057',
    emptyCloud: '\u30af\u30e9\u30a6\u30c9\u30c7\u30fc\u30bf\u304c\u691c\u51fa\u3055\u308c\u307e\u305b\u3093\u3002Viwoods \u30c7\u30d0\u30a4\u30b9\u3067\u30af\u30e9\u30a6\u30c9\u540c\u671f\u304c\u6709\u52b9\u306b\u306a\u3063\u3066\u3044\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044\u3002',
    itemUnit: '\u9805\u76ee',
    language: '\u8a00\u8a9e',
    logout: '\u30ed\u30b0\u30a2\u30a6\u30c8',
    confirmLogout: '\u30ed\u30b0\u30a2\u30a6\u30c8\u3057\u307e\u3059\u304b\uff1f',
    cancel: '\u30ad\u30e3\u30f3\u30bb\u30eb',
    ok: 'OK'
  },
  ko: {
    recent: '\ucd5c\uadfc \ubc29\ubb38',
    files: '\ub0b4 \ud30c\uc77c',
    daily: 'Daily',
    search: '\uac80\uc0c9',
    empty: '\ub370\uc774\ud130 \uc5c6\uc74c',
    emptyCloud: '\ud074\ub77c\uc6b0\ub4dc \ub370\uc774\ud130\uac00 \uac10\uc9c0\ub418\uc9c0 \uc54a\uc558\uc2b5\ub2c8\ub2e4. Viwoods \uc7a5\uce58\uc5d0\uc11c \ud074\ub77c\uc6b0\ub4dc \ub3d9\uae30\ud654\uac00 \ud65c\uc131\ud654\ub418\uc5c8\ub294\uc9c0 \ud655\uc778\ud558\uc138\uc694.',
    itemUnit: '\ud56d\ubaa9',
    language: '\uc5b8\uc5b4',
    logout: '\ub85c\uadf8\uc544\uc6c3',
    confirmLogout: '\ub85c\uadf8\uc544\uc6c3\ud558\uc2dc\uaca0\uc2b5\ub2c8\uae4c?',
    cancel: '\ucde8\uc18c',
    ok: '\ud655\uc778'
  },
  pt: {
    recent: 'Recentes',
    files: 'Meus arquivos',
    daily: 'Daily',
    search: 'Pesquisar',
    empty: 'Sem dados',
    emptyCloud: 'Nenhum dado na nuvem detectado. Verifique se a sincroniza\u00e7\u00e3o na nuvem est\u00e1 ativada no seu dispositivo Viwoods.',
    itemUnit: 'itens',
    language: 'Idioma',
    logout: 'Sair',
    confirmLogout: 'Tem certeza de que deseja sair?',
    cancel: 'Cancelar',
    ok: 'OK'
  },
  ru: {
    recent: '\u041d\u0435\u0434\u0430\u0432\u043d\u0438\u0435',
    files: '\u041c\u043e\u0438 \u0444\u0430\u0439\u043b\u044b',
    daily: 'Daily',
    search: '\u041f\u043e\u0438\u0441\u043a',
    empty: '\u041d\u0435\u0442 \u0434\u0430\u043d\u043d\u044b\u0445',
    emptyCloud: '\u041e\u0431\u043b\u0430\u0447\u043d\u044b\u0435 \u0434\u0430\u043d\u043d\u044b\u0435 \u043d\u0435 \u043e\u0431\u043d\u0430\u0440\u0443\u0436\u0435\u043d\u044b. \u0423\u0431\u0435\u0434\u0438\u0442\u0435\u0441\u044c, \u0447\u0442\u043e \u043e\u0431\u043b\u0430\u0447\u043d\u0430\u044f \u0441\u0438\u043d\u0445\u0440\u043e\u043d\u0438\u0437\u0430\u0446\u0438\u044f \u0432\u043a\u043b\u044e\u0447\u0435\u043d\u0430 \u043d\u0430 \u0432\u0430\u0448\u0435\u043c \u0443\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u0435 Viwoods.',
    itemUnit: '\u044d\u043b\u0435\u043c.',
    language: '\u042f\u0437\u044b\u043a',
    logout: '\u0412\u044b\u0439\u0442\u0438',
    confirmLogout: '\u0412\u044b \u0443\u0432\u0435\u0440\u0435\u043d\u044b, \u0447\u0442\u043e \u0445\u043e\u0442\u0438\u0442\u0435 \u0432\u044b\u0439\u0442\u0438?',
    cancel: '\u041e\u0442\u043c\u0435\u043d\u0430',
    ok: 'OK'
  },
  es: {
    recent: 'Recientes',
    files: 'Mis archivos',
    daily: 'Daily',
    search: 'Buscar',
    empty: 'Sin datos',
    emptyCloud: 'No se detectaron datos en la nube. Aseg\u00farate de que la sincronizaci\u00f3n en la nube est\u00e9 activada en tu dispositivo Viwoods.',
    itemUnit: 'elementos',
    language: 'Idioma',
    logout: 'Cerrar sesi\u00f3n',
    confirmLogout: '\u00bfSeguro que quieres cerrar sesi\u00f3n?',
    cancel: 'Cancelar',
    ok: 'OK'
  }
}

function getCloudText(language) {
  return Object.assign({}, CLOUD_TEXTS.us, CLOUD_TEXTS[language] || {})
}

const INPUT_MAX_LENGTH = 125
const USERNAME_MAX_LENGTH = 30
const CLOUD_PULL_DIRECTION_THRESHOLD = 12
const CLOUD_PULL_VERTICAL_RATIO = 1.4
const CLOUD_PULL_COMMIT_DISTANCE = 64
const CLOUD_PULL_MIN_VISIBLE_DURATION = 360
const RECENT_DETAIL_PREFETCH_CACHE_SCOPES = Object.freeze({
  paper: 'PaperSync',
  meeting: 'MeetingSync',
  memo: 'MemoSync',
  knowledge: 'KnowledgeBaseSync'
})

export default {
  name: 'CloudHome',
  mixins: [downloadCenterMixin, directFilePreviewMixin, mobilePreviewGridSelectionMixin, previewPerformanceMixin, recentDownloadWorkerMixin],
  components: {
    PaperSync,
    LearningSync,
    DailySync,
    MemoSync,
    MeetingSync,
    KnowledgeBaseSync,
    MobilePullRefreshIndicator
  },
  data() {
    return {
      inputMaxLength: INPUT_MAX_LENGTH,
      usernameMaxLength: USERNAME_MAX_LENGTH,
      loading: true,
      cloudStatus: 0,
      menuCollapsed: false,
      activeMenu: 'recent',
      activeAppFolder: '',
      activeAppFolderAppType: null,
      activeAppReturnMenu: 'recent',
      activeAppDetailMode: false,
      activeAppSelectionMode: false,
      dailyInitialActiveTab: 'todo',
      viewMode: getMobileCloudViewMode('list'),
      myFileViewMode: getMobileCloudViewMode('list'),
      searchOpen: false,
      searchKeyword: '',
      globalSearchOpen: false,
      globalSearchFilePreviewMode: false,
      globalSearchLearningPreviewMode: false,
      globalSearchKeyword: '',
      globalSearchItems: [],
      globalSearchLoading: false,
      globalSearchAppendLoading: false,
      globalSearchLoaded: false,
      globalSearchPageSize: 100,
      globalSearchPageIndex: 1,
      globalSearchTotalCount: 0,
      globalSearchLastPageSize: 0,
      globalSearchReachedEnd: false,
      globalSearchAppType: -1,
      globalSearchComposing: false,
      globalSearchIgnoreBlurUntil: 0,
      globalSearchTypeMenuOpen: false,
      globalSearchViewSheetOpen: false,
      globalSearchViewMode: getMobileCloudViewMode('list'),
      myFileViewSheetOpen: false,
      globalSearchRequestTimer: null,
      globalSearchRequestSeq: 0,
      selectedGlobalSearchId: '',
      selectedGlobalSearchIds: [],
      selectedGlobalSearchAnchorId: '',
      globalSearchItemClickTimer: null,
      globalSearchDoubleOpenState: null,
      globalSearchResultPointerDown: false,
      globalSearchMoreMenuId: '',
      globalSearchActionTargetId: '',
      globalSearchTouchTimer: null,
      globalSearchLongPressResetTimer: null,
      globalSearchTouchStartTime: 0,
      globalSearchTouchMoved: false,
      globalSearchLongPressTriggered: false,
      globalSearchTouchSelectionMode: '',
      globalSearchTouchSelectionActive: false,
      globalSearchTouchGestureType: 'pending',
      globalSearchTouchStartPoint: null,
      globalSearchTouchStartItemId: '',
      globalSearchPullTouchState: null,
      globalSearchPullRefreshDistance: 0,
      globalSearchPullRefreshThreshold: 88,
      globalSearchPullRefreshing: false,
      globalSearchPullRefreshResetTimer: null,
      globalSearchPullRefreshRequestSeq: 0,
      globalSearchReturnContext: null,
      mobilePreviewReturnScrollTops: {
        recent: null,
        search: null,
        files: null
      },
      mobilePreviewReturnScrollSeq: 0,
      globalSearchGridColumnCount: 1,
      globalSearchSelectionBarOffsetY: 0,
      globalSearchSelectionBarScrollbarOffset: 0,
      globalSearchSelectionBarDragging: false,
      globalSearchSelectionBarDragState: null,
      selectedFolderRowId: '',
      folderItemClickTimer: null,
      selectedRecentId: '',
      selectedRecentIds: [],
      selectedRecentAnchorId: '',
      recentItems: [],
      recentListLoading: false,
      recentAppendLoading: false,
      recentListLoaded: false,
      recentPullTouchState: null,
      recentPullRefreshDistance: 0,
      recentPullRefreshThreshold: 88,
      recentPullRefreshing: false,
      recentPullRefreshResetTimer: null,
      recentPullRefreshRequestSeq: 0,
      cloudPullRefreshClickBlockedUntil: 0,
      recentPageSize: 100,
      recentPageIndex: 1,
      recentTotalCount: 0,
      recentLastPageSize: 0,
      recentReachedEnd: false,
      recentGridColumnCount: 1,
      recentItemClickTimer: null,
      recentDoubleOpenState: null,
      recentMoreMenuId: '',
      recentActionTargetId: '',
      recentViewSheetOpen: false,
      recentActionSheetOpen: false,
      recentTouchTimer: null,
      recentLongPressResetTimer: null,
      recentTouchStartTime: 0,
      recentTouchMoved: false,
      recentLongPressTriggered: false,
      recentTouchSelectionMode: '',
      recentTouchSelectionActive: false,
      recentTouchGestureType: 'pending',
      recentTouchStartPoint: null,
      recentTouchStartItemId: '',
      recentPreviewTouchState: null,
      recentPreviewZoomToast: '',
      recentPreviewZoomToastKey: 0,
      recentPreviewZoomToastTimer: null,
      recentSelectionBarOffsetY: 0,
      recentSelectionBarScrollbarOffset: 0,
      recentSelectionBarDragging: false,
      recentSelectionBarDragState: null,
      recentPasswordModalOpen: false,
      recentPasswordTarget: null,
      recentPasswordInput: '',
      recentPasswordVisible: false,
      recentPasswordSubmitting: false,
      recentPasswordError: '',
      recentPasswordRequestSeq: 0,
      recentPasswordReturnContext: 'recent',
      recentPasswordAction: 'open',
      recentPasswordItems: [],
      recentPasswordOpenOptions: {},
      recentDownloadFormatModalOpen: false,
      recentDownloadFormat: 'pdf',
      recentDownloadItems: [],
      recentDownloadPassword: '',
      recentDownloadSelectionContext: '',
      recentDownloadSubmitting: false,
      paperDownloadFormatModalOpen: false,
      paperDownloadFormat: 'png',
      paperDownloadItems: [],
      paperDownloadDetailPages: [],
      paperDownloadFormatContext: 'items',
      learningAnnotationDownloadItems: [],
      paperDownloadListVisible: true,
      recentLearningModalOpen: false,
      recentLearningLoading: false,
      recentLearningError: '',
      recentLearningItem: null,
      recentLearningDetail: null,
      recentLearningCacheContext: 'recent',
      recentLearningRequestSeq: 0,
      recentLearningActiveTab: 'summary',
      recentLearningActiveHighlightId: '',
      recentLearningHighlightDetailOpen: false,
      recentLearningActiveAnnotationId: '',
      recentLearningAnnotationViewMode: 'grid',
      recentLearningAnnotationScreenSize: '',
      recentLearningAnnotationGridColumnCount: 1,
      recentLearningAnnotationPreviewOpen: false,
      recentLearningAnnotationPreviewGridOpen: false,
      recentLearningAnnotationPreviewGridColumnCount: 1,
      recentLearningAnnotationPreviewSelectedIds: [],
      recentLearningAnnotationPreviewSelectionAnchorId: '',
      recentLearningAnnotationPreviewZoomLevel: 0,
      recentLearningAnnotationPreviewZoomValue: 1,
      recentLearningAnnotationPreviewDragState: null,
      recentLearningTabOverflowKeys: [],
      recentLearningTabTitlePopup: null,
      recentLearningTabTitlePopupTimer: null,
      recentLearningTabTitleTouchTimer: null,
      recentLearningTabTitleTouchState: null,
      recentLearningTabTitleClickBlockedUntil: 0,
      recentLearningIcons: {
        empty: RECENT_LEARNING_EMPTY_ICON,
        download: RECENT_LEARNING_ICON_DOWNLOAD,
        pageGrid: RECENT_LEARNING_ICON_PAGE_GRID,
        zoomIn: RECENT_LEARNING_ICON_ZOOM_IN,
        zoomOut: RECENT_LEARNING_ICON_ZOOM_OUT
      },
      pendingRecentOpenItem: null,
      pendingRecentOpenOptions: null,
      username: '',
      email: '',
      areaCode: '',
      phone: '',
      selectedLanguage: 'us',
      pendingLanguage: 'us',
      userMenuVisible: false,
      keepUserMenuAfterSettingClose: false,
      languageModalVisible: false,
      exitModalVisible: false,
      settingModalVisible: false,
      usernameRenameVisible: false,
      settingActiveTab: 'root',
      editingUsername: false,
      editUsername: '',
      updatingUsername: false,
      settingPasswordVisible: false,
      settingResetMode: 'email',
      settingResetStep: 'account',
      settingResetLoading: false,
      settingResetSending: false,
      settingResetReSendTime: 0,
      settingResetTimer: null,
      settingResetCheckedCode: '',
      settingAreaOpen: false,
      settingResetPhoneFocused: false,
      settingResetAreaOptionsHeight: 0,
      settingResetForm: {
        email: '',
        phone: '',
        areaCode: '',
        code: '',
        password: '',
        confirmPassword: ''
      },
      cloudServerKey: getActiveCloudServerKey(),
      cloudStatusLoading: false,
      cloudStatusLoaded: false,
      rootFolderLoading: false,
      rootFolderLoaded: false,
      cloudListLoadingStartedWithToolbar: false,
      cloudHomeStateRestoring: false,
      pendingAppRefreshStateAppKey: '',
      pendingAppRefreshState: null,
      cloudStorage: {},
      areaCodes: [],
      languageList: LANGUAGE_OPTIONS,
      cloudItems: []
    }
  },
  computed: {
    uiText() {
      const language = normalizeLanguage(this.selectedLanguage)
      return Object.assign({}, getCloudText(language), {
        allSources: getAppUiText(language).allSources
      })
    },
    hasActiveModal() {
      return this.settingModalVisible || this.languageModalVisible || this.exitModalVisible || this.settingPasswordVisible
    },
    showUserMenuMask() {
      return this.userMenuVisible && !this.hasActiveModal
    },
    userMenuOverlayClass() {
      return this.hasActiveModal ? 'user-menu-overlay user-menu-overlay-under-modal' : 'user-menu-overlay'
    },
    menuItems() {
      return [
        { key: 'recent', label: this.uiText.recent, icon: require('@/assets/common/recent-menu-icon.svg') },
        { key: 'files', label: this.uiText.files, icon: require('@/assets/wap/emnu_my_file.png') },
        { key: 'daily', label: this.uiText.daily, icon: require('@/assets/wap/emnu_daily.png') }
      ]
    },
    recentIcons() {
      return RECENT_WAP_ICONS
    },
    mobileTabItems() {
      return [
        Object.assign({}, this.menuItems[0], { mobileIcon: RECENT_WAP_ICONS.navRecent }),
        Object.assign({}, this.menuItems[1], { mobileIcon: RECENT_WAP_ICONS.navFiles }),
        Object.assign({}, this.menuItems[2], { mobileIcon: RECENT_WAP_ICONS.navDaily })
      ]
    },
    showHeaderSearchButton() {
      return this.cloudStatus == 1 && !this.globalSearchOpen && (this.activeMenu == 'recent' || this.activeMenu == 'files')
    },
    showRecentHeaderViewSwitch() {
      return this.cloudStatus == 1 && !this.globalSearchOpen && this.activeMenu == 'recent'
    },
    showMyFileHeaderViewSwitch() {
      return this.cloudStatus == 1 && !this.globalSearchOpen && this.activeMenu == 'files'
    },
    currentMenuKey() {
      if (this.activeAppFolder) {
        return this.resolveMenuKeyForFolderType(this.activeAppFolder, this.activeAppReturnMenu || this.activeMenu)
      }
      return this.normalizeMenuKey(this.activeMenu)
    },
    shouldSkipActiveDailyInitialLoad() {
      const item = this.pendingRecentOpenItem
      const options = this.pendingRecentOpenOptions || {}
      return this.activeAppFolder == 'daily'
        && !!item
        && this.resolveAppFolderType(item) == 'daily'
        && (this.isRecentDailyTaskOrNoteItem(item) || (this.isDirectFilePreviewItem(item) && !this.isRecentFolderLike(item)) || this.activeAppReturnMenu == 'search' || options.sourceContext == 'search')
    },
    shouldSkipActiveResourceInitialListLoad() {
      const item = this.pendingRecentOpenItem
      if (!item || !['recent', 'search'].includes(this.activeAppReturnMenu) || this.isRecentFolderLike(item)) {
        return false
      }
      const folderType = this.resolveAppFolderType(item) || (this.isDirectFilePreviewItem(item) ? 'paper' : '')
      if (!folderType || this.activeAppFolder != folderType) {
        return false
      }
      if (folderType == 'learning') {
        return this.isDirectFilePreviewItem(item)
      }
      return ['paper', 'meeting', 'memo', 'knowledge'].includes(folderType)
    },
    globalSearchFilePreviewActive() {
      return this.globalSearchFilePreviewMode
        && this.activeAppReturnMenu == 'search'
        && ['paper', 'meeting', 'learning', 'memo', 'knowledge', 'daily'].includes(this.activeAppFolder)
    },
    globalSearchLearningPreviewActive() {
      return this.globalSearchLearningPreviewMode
        && this.activeAppReturnMenu == 'search'
        && this.recentLearningModalOpen
    },
    myFilesLearningModalActive() {
      return this.recentLearningModalOpen
        && this.recentLearningCacheContext == 'files'
        && this.activeAppFolder == 'learning'
        && this.activeAppReturnMenu == 'files'
    },
    contentTitle() {
      const item = this.menuItems.find(menu => menu.key == this.currentMenuKey)
      return item ? item.label : this.uiText.files
    },
    showContentToolbar() {
      if (this.cloudStatus != 1 || this.globalSearchOpen) {
        return false
      }
      return !this.cloudListLoading || this.cloudListLoadingStartedWithToolbar
    },
    viewSwitchIcon() {
      return this.viewMode == 'list'
        ? require('@/assets/wap/myfile-view-list.png')
        : require('@/assets/wap/myfile-view-grid.png')
    },
    recentDownloadIcon() {
      return RECENT_DOWNLOAD_ICON
    },
    recentFavoriteIcon() {
      return RECENT_FAVORITE_FILLED_ICON
    },
    globalSearchIcons() {
      return GLOBAL_SEARCH_ICONS
    },
    globalSearchTypeOptions() {
      return [
        { value: -1, label: this.uiText.allTypes, icon: GLOBAL_SEARCH_ICONS.all },
        { value: 1, label: 'Paper', icon: GLOBAL_SEARCH_ICONS.paper },
        { value: 2, label: 'Meeting', icon: GLOBAL_SEARCH_ICONS.meeting },
        { value: 3, label: 'Learning', icon: GLOBAL_SEARCH_ICONS.learning },
        { value: 4, label: 'Knowledge base', icon: GLOBAL_SEARCH_ICONS.knowledge },
        { value: 6, label: 'Memo', icon: GLOBAL_SEARCH_ICONS.memo },
        { value: 5, label: 'Daily', icon: GLOBAL_SEARCH_ICONS.daily }
      ]
    },
    activeGlobalSearchTypeOption() {
      return this.globalSearchTypeOptions.find(item => item.value == this.globalSearchAppType) || this.globalSearchTypeOptions[0]
    },
    activeGlobalSearchTypeLabel() {
      return this.activeGlobalSearchTypeOption ? this.activeGlobalSearchTypeOption.label : this.uiText.allTypes
    },
    activeGlobalSearchTypeIcon() {
      return this.activeGlobalSearchTypeOption ? this.activeGlobalSearchTypeOption.icon : GLOBAL_SEARCH_ICONS.all
    },
    globalSearchViewSwitchIcon() {
      return this.globalSearchViewMode == 'list'
        ? require('@/assets/wap/myfile-view-list.png')
        : require('@/assets/wap/myfile-view-grid.png')
    },
    recentPasswordUi() {
      const text = getAppUiText(this.selectedLanguage)
      return {
        title: text.passwordTitle,
        placeholder: text.passwordPlaceholder,
        hide: text.passwordHide,
        show: text.passwordShow,
        confirming: text.passwordConfirming,
        required: text.passwordRequired,
        wrong: text.passwordWrong,
        cryptoUnsupported: text.passwordCryptoUnsupported
      }
    },
    phoneAccount() {
      return this.phone ? `${this.areaCode || ''}${this.phone}` : ''
    },
    accountSource() {
      return this.displayAccountName
    },
    displayAccountName() {
      return this.username || this.email || this.phoneAccount || 'User'
    },
    displayAccountDetail() {
      return this.email || this.phoneAccount || ''
    },
    fullAccountName() {
      return this.displayAccountDetail
        ? `${this.displayAccountName} ${this.displayAccountDetail}`
        : this.displayAccountName
    },
    maskedAccountName() {
      return this.displayAccountName
    },
    userInitial() {
      const match = String(this.displayAccountName).trim().match(/[A-Za-z0-9\u4e00-\u9fa5]/)
      return match ? match[0].toUpperCase() : 'U'
    },
    mobileAccountSummary() {
      if (this.email) {
        return this.maskEmail(this.email)
      }
      if (this.phoneAccount) {
        return this.maskPhone(this.phoneAccount)
      }
      return ''
    },
    mobileSettingPageTitle() {
      if (this.settingActiveTab == 'account') {
        return this.uiText.account
      }
      if (this.settingActiveTab == 'cloud') {
        return this.uiText.viwoodsCloud
      }
      if (this.settingActiveTab == 'server') {
        return this.uiText.server
      }
      return this.uiText.setting
    },
    settingTabs() {
      const tabs = [
        { key: 'account', label: this.uiText.account, icon: require('@/assets/wap/setting-account.png') },
        { key: 'cloud', label: this.uiText.viwoodsCloud, icon: require('@/assets/wap/setting-viwoods.png') }
      ]
      if (this.showServerSettingTab) {
        tabs.push({ key: 'server', label: this.uiText.server, icon: require('@/assets/wap/server.svg') })
      }
      tabs.push({ key: 'feedback', label: this.uiText.feedback, icon: require('@/assets/wap/setting-question.png') })
      return tabs
    },
    showServerSettingTab() {
      if (typeof window === 'undefined' || !window.location) {
        return false
      }
      return new URLSearchParams(window.location.search || '').get('s') == '1'
    },
    cloudServerOptions() {
      return [
        { key: CLOUD_SERVER_US, label: this.uiText.serverUnitedStates },
        { key: CLOUD_SERVER_SG, label: this.uiText.serverSingapore },
        { key: CLOUD_SERVER_CN, label: this.uiText.serverChina }
      ]
    },
    canSubmitSettingResetAccount() {
      if (this.settingResetMode == 'email') {
        return !!this.settingResetForm.email
      }
      return !!(this.settingResetForm.areaCode && this.settingResetForm.phone)
    },
    canSubmitSettingResetCode() {
      return !!(this.settingResetForm.code && this.settingResetForm.code.length >= 6)
    },
    canSubmitSettingResetPassword() {
      return !!(
        this.settingResetForm.password &&
        this.settingResetForm.confirmPassword &&
        this.settingResetForm.password.length >= 8 &&
        this.settingResetForm.confirmPassword.length >= 8
      )
    },
    settingResetCodeText() {
      const target = this.settingResetMode == 'email'
        ? this.settingResetForm.email
        : `${this.settingResetForm.areaCode} ${this.settingResetForm.phone}`
      return this.uiText.codeSubtitle.replace('%s', target)
    },
    settingResetAccountSubtitle() {
      return this.settingResetMode == 'email'
        ? this.uiText.resetEmailSubtitle
        : this.uiText.resetPhoneSubtitle
    },
    settingResetAreaOptionsStyle() {
      if (!this.settingResetAreaOptionsHeight) {
        return {}
      }
      return {
        height: `${this.settingResetAreaOptionsHeight}px`,
        maxHeight: `${this.settingResetAreaOptionsHeight}px`
      }
    },
    cloudUsageItems() {
      const data = this.cloudStorage || {}
      return [
        { key: 'paper', label: 'Paper', icon: require('@/assets/wap/paper-i.png'), value: data.paperUsed },
        { key: 'meeting', label: 'Meeting', icon: require('@/assets/wap/setting-meeting.png'), value: data.meetingUsed },
        { key: 'learning', label: 'Learning', icon: require('@/assets/wap/setting-learning.png'), value: data.learningUsed },
        { key: 'memo', label: 'Memo', icon: require('@/assets/wap/setting-memo.png'), value: data.memoUsed !== undefined ? data.memoUsed : data.momoUsed },
        { key: 'daily', label: 'Daily', icon: require('@/assets/wap/setting-daily.png'), value: data.dailyUsed },
        { key: 'kb', label: 'Knowledge Base', icon: require('@/assets/wap/setting-kb.png'), value: data.kbUsed }
      ]
    },
    mobileCloudUsageItems() {
      const order = ['paper', 'meeting', 'learning', 'kb', 'memo', 'daily']
      return order.map(key => this.cloudUsageItems.find(item => item.key == key)).filter(Boolean)
    },
    cloudStorageUsedText() {
      return this.formatStorageSize(this.cloudStorage.storageUsed)
    },
    cloudStorageMaxText() {
      return this.formatStorageSize(this.cloudStorage.maxStorage)
    },
    cloudStoragePercent() {
      const used = this.getStorageSizeBytes(this.cloudStorage.storageUsed)
      const max = this.getStorageSizeBytes(this.cloudStorage.maxStorage)
      if (!max) {
        return 0
      }
      return Math.max(0, Math.min(100, (used / max) * 100))
    },
    interactionLocked() {
      return this.cloudListLoading
        || this.recentPullRefreshing
        || this.globalSearchPullRefreshing
        || this.cloudStatusLoading
        || this.globalSearchLoading
        || this.recentLearningLoading
        || this.recentPasswordSubmitting
        || this.recentDownloadSubmitting
        || this.updatingUsername
        || this.settingResetLoading
        || this.settingResetSending
    },
    cloudListLoading() {
      if (this.globalSearchOpen) {
        return this.loading || (this.globalSearchLoading && !this.globalSearchPullRefreshing)
      }
      return this.loading || (this.activeMenu == 'recent' ? (this.recentListLoading && !this.recentPullRefreshing) : (this.rootFolderLoading && !this.recentPullRefreshing))
    },
    cloudListAppendLoading() {
      if (this.globalSearchOpen) {
        return this.globalSearchAppendLoading
      }
      return this.activeMenu == 'recent' && this.recentAppendLoading
    },
    globalSearchPageCount() {
      return this.getCloudListPageCount(this.globalSearchTotalCount, this.globalSearchPageSize, this.globalSearchPageIndex)
    },
    globalSearchPaginationTotal() {
      return this.getCloudListPaginationTotal(this.globalSearchTotalCount, this.globalSearchItems, this.globalSearchPageIndex, this.globalSearchPageSize, this.globalSearchLastPageSize)
    },
    hasNextGlobalSearchPage() {
      return this.hasNextCloudListPage(this.globalSearchReachedEnd, this.globalSearchTotalCount, this.globalSearchPageIndex, this.globalSearchPageSize, this.globalSearchLastPageSize)
    },
    showGlobalSearchPagination() {
      return this.cloudStatus == 1 && this.globalSearchOpen && this.globalSearchKeyword && this.globalSearchLoaded && this.globalSearchPaginationTotal > 0
    },
    recentPageCount() {
      return this.getCloudListPageCount(this.recentTotalCount, this.recentPageSize, this.recentPageIndex)
    },
    recentPaginationTotal() {
      return this.getCloudListPaginationTotal(this.recentTotalCount, this.recentItems, this.recentPageIndex, this.recentPageSize, this.recentLastPageSize)
    },
    hasNextRecentPage() {
      return this.hasNextCloudListPage(this.recentReachedEnd, this.recentTotalCount, this.recentPageIndex, this.recentPageSize, this.recentLastPageSize)
    },
    showRecentPagination() {
      return this.cloudStatus == 1 && !this.globalSearchOpen && this.activeMenu == 'recent' && this.recentPaginationTotal > 0
    },
    visibleGlobalSearchItems() {
      return this.globalSearchItems
    },
    selectedGlobalSearchItems() {
      if (this.selectedGlobalSearchIds.length == 0) {
        return []
      }
      const selectedIds = new Set(this.selectedGlobalSearchIds.map(id => String(id)))
      return this.globalSearchItems.filter(item => item && selectedIds.has(String(item.id)))
    },
    selectedGlobalSearchCount() {
      return this.selectedGlobalSearchItems.length
    },
    globalSearchActionTargetItem() {
      if (!this.globalSearchActionTargetId) {
        return null
      }
      return this.globalSearchItems.find(item => item && item.id == this.globalSearchActionTargetId) || null
    },
    globalSearchActionItems() {
      if (this.selectedGlobalSearchItems.length > 0) {
        return this.selectedGlobalSearchItems
      }
      return this.globalSearchActionTargetItem ? [this.globalSearchActionTargetItem] : []
    },
    showGlobalSearchSelectionBar() {
      return !this.cloudListLoading && this.cloudStatus == 1 && this.globalSearchOpen && this.selectedGlobalSearchCount > 0
    },
    showGlobalSearchBottomActionBar() {
      return !this.cloudListLoading && this.cloudStatus == 1 && this.globalSearchOpen && this.globalSearchActionItems.length > 0
    },
    showGlobalSearchQuickActionMask() {
      return this.showGlobalSearchBottomActionBar && this.selectedGlobalSearchCount == 0 && !!this.globalSearchActionTargetItem
    },
    canDownloadGlobalSearchActionItems() {
      return this.globalSearchActionItems.length > 0 && this.globalSearchActionItems.every(item => this.isRecentDownloadableItem(item))
    },
    canDownloadSelectedGlobalSearchItems() {
      return this.selectedGlobalSearchItems.length > 0 && this.selectedGlobalSearchItems.every(item => this.isRecentDownloadableItem(item))
    },
    globalSearchSelectionBarLayerStyle() {
      return {
        transform: `translateY(${this.globalSearchSelectionBarOffsetY}px)`,
        right: `${this.globalSearchSelectionBarScrollbarOffset}px`
      }
    },
    visibleRecentItems() {
      const keyword = String(this.searchKeyword || '').toLowerCase()
      return !keyword
        ? this.recentItems
        : this.recentItems.filter(item => String(item.name || '').toLowerCase().includes(keyword))
    },
    selectedRecentItems() {
      if (this.selectedRecentIds.length == 0) {
        return []
      }
      const selectedIds = new Set(this.selectedRecentIds.map(id => String(id)))
      return this.recentItems.filter(item => item && selectedIds.has(String(item.id)))
    },
    selectedRecentCount() {
      return this.selectedRecentItems.length
    },
    recentActionTargetItem() {
      if (!this.recentActionTargetId) {
        return null
      }
      return this.recentItems.find(item => item && item.id == this.recentActionTargetId) || null
    },
    recentActionItems() {
      if (this.selectedRecentItems.length > 0) {
        return this.selectedRecentItems
      }
      return this.recentActionTargetItem ? [this.recentActionTargetItem] : []
    },
    showRecentSelectionBar() {
      return !this.globalSearchOpen && !this.cloudListLoading && this.cloudStatus == 1 && this.activeMenu == 'recent' && this.selectedRecentCount > 0
    },
    showRecentBottomActionBar() {
      return !this.globalSearchOpen && !this.cloudListLoading && this.cloudStatus == 1 && this.activeMenu == 'recent' && this.recentActionItems.length > 0
    },
    showRecentQuickActionMask() {
      return this.showRecentBottomActionBar && this.selectedRecentCount == 0 && !!this.recentActionTargetItem
    },
    canDownloadRecentActionItems() {
      return this.recentActionItems.length > 0 && this.recentActionItems.every(item => this.isRecentDownloadableItem(item))
    },
    canDownloadSelectedRecentItems() {
      return this.selectedRecentItems.length > 0 && this.selectedRecentItems.every(item => this.isRecentDownloadableItem(item))
    },
    canOpenSelectedRecentPages() {
      return this.selectedRecentItems.length == 1 && this.canOpenRecentPagesItem(this.selectedRecentItems[0])
    },
    recentSelectionBarLayerStyle() {
      return {
        transform: `translateY(${this.recentSelectionBarOffsetY}px)`,
        right: `${this.recentSelectionBarScrollbarOffset}px`
      }
    },
    recentLearningTitle() {
      return this.pickString(this.recentLearningDetail || {}, ['name', 'title', 'fileName', 'bookName']) ||
        (this.recentLearningItem && this.recentLearningItem.name ? this.recentLearningItem.name : 'Learning')
    },
    recentLearningProgressPercent() {
      const progress = this.recentLearningDetail && this.recentLearningDetail.readingProgress ? this.recentLearningDetail.readingProgress : {}
      const value = this.pickValue(progress, ['progressPercent', 'percent', 'progress'])
      const number = Number(value)
      return Number.isFinite(number) ? Math.max(0, Math.min(100, number)) : 0
    },
    recentLearningProgressText() {
      return `${this.formatRecentLearningPercent(this.recentLearningProgressPercent)}%`
    },
    recentLearningRows() {
      const detail = this.recentLearningDetail || {}
      return [
        { key: 'bookmarks', label: this.uiText.bookmarks, count: this.getRecentLearningCount(detail, 'bookmarks') },
        { key: 'highlights', label: this.uiText.highlights, count: this.getRecentLearningCount(detail, 'highlights') },
        { key: 'annotations', label: this.uiText.annotations, count: this.getRecentLearningCount(detail, 'annotations') }
      ]
    },
    recentLearningTabs() {
      return this.recentLearningRows
    },
    recentLearningTabOverflowKeySet() {
      return new Set(this.recentLearningTabOverflowKeys)
    },
    recentLearningTabTitlePopoverStyle() {
      return {
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }
    },
    recentLearningBookmarks() {
      return this.recentLearningDetail && Array.isArray(this.recentLearningDetail.bookmarks) ? this.recentLearningDetail.bookmarks : []
    },
    recentLearningHighlights() {
      return this.recentLearningDetail && Array.isArray(this.recentLearningDetail.highlights) ? this.recentLearningDetail.highlights : []
    },
    recentLearningAnnotations() {
      return this.recentLearningDetail && Array.isArray(this.recentLearningDetail.annotations) ? this.recentLearningDetail.annotations : []
    },
    recentLearningAnnotationScreenSizes() {
      const values = []
      const seen = new Set()
      this.recentLearningAnnotations.forEach(annotation => {
        const screenSize = String(annotation && annotation.screenSize ? annotation.screenSize : '').trim()
        if (screenSize && !seen.has(screenSize)) {
          seen.add(screenSize)
          values.push(screenSize)
        }
      })
      return values
    },
    filteredRecentLearningAnnotations() {
      const screenSize = String(this.recentLearningAnnotationScreenSize || '').trim()
      if (!screenSize) {
        return this.recentLearningAnnotations
      }
      return this.recentLearningAnnotations.filter(annotation => annotation.screenSize == screenSize)
    },
    recentLearningActiveHighlight() {
      if (!this.recentLearningActiveHighlightId) {
        return null
      }
      return this.recentLearningHighlights.find(item => item.id == this.recentLearningActiveHighlightId) || null
    },
    recentLearningActiveAnnotation() {
      return this.recentLearningAnnotations.find(item => item.id == this.recentLearningActiveAnnotationId) || null
    },
    recentLearningAnnotationViewSwitchIcon() {
      return this.recentLearningAnnotationViewMode == 'list'
        ? RECENT_LEARNING_ICON_VIEW_LIST
        : RECENT_LEARNING_ICON_VIEW_GRID
    },
    recentLearningAnnotationPreviewHeaderTitle() {
      if (this.recentLearningAnnotationPreviewGridOpen) {
        return this.recentLearningTitle || this.uiText.annotations
      }
      if (this.recentLearningActiveAnnotation && this.recentLearningActiveAnnotation.title) {
        return this.recentLearningActiveAnnotation.title
      }
      return this.recentLearningTitle || this.uiText.annotations
    },
    recentLearningAnnotationPreviewIndex() {
      const index = this.recentLearningAnnotations.findIndex(item => item.id == this.recentLearningActiveAnnotationId)
      return index >= 0 ? index : 0
    },
    recentLearningAnnotationPreviewSelectedAnnotations() {
      const selectedIds = new Set(this.recentLearningAnnotationPreviewSelectedIds)
      return this.recentLearningAnnotations.filter(item => selectedIds.has(item.id))
    },
    recentLearningAnnotationPreviewSelectedCount() {
      return this.recentLearningAnnotationPreviewSelectedAnnotations.length
    },
    canDownloadRecentLearningAnnotationPreviewSelection() {
      return this.recentLearningAnnotationPreviewSelectedCount > 0
    },
    canDownloadCurrentRecentLearningAnnotationPreview() {
      if (this.recentLearningAnnotationPreviewGridOpen) {
        return this.canDownloadRecentLearningAnnotationPreviewSelection
      }
      const annotation = this.recentLearningActiveAnnotation
      return !!(annotation && (annotation.imageUrl || annotation.pageImageUrl))
    },
    paperDownloadTaskSummary() {
      const total = this.paperDownloadTasks.length
      const running = this.paperDownloadTasks.filter(task => task.state == 'running').length
      const failed = this.paperDownloadTasks.filter(task => task.state == 'error').length
      if (running > 0) {
        return `${running}/${total} \u4e0b\u8f7d\u4e2d`
      }
      if (failed > 0) {
        return `${failed}/${total} \u5931\u8d25`
      }
      return `${total}/${total} \u5df2\u5b8c\u6210`
    },
    recentLearningFileFormatText() {
      return this.formatRecentLearningFileFormat(this.recentLearningDetail && this.recentLearningDetail.fileFormat)
    },
    recentLearningFileSizeText() {
      return this.formatRecentLearningFileSize(this.recentLearningDetail && this.recentLearningDetail.fileSizeBytes)
    },
    recentLearningSyncStatusCode() {
      return this.normalizeRecentLearningSyncStatus(this.recentLearningDetail && this.recentLearningDetail.syncStatus)
    },
    recentLearningSyncStatusClass() {
      if (this.recentLearningSyncStatusCode === 1) {
        return 'is-synced'
      }
      if (this.recentLearningSyncStatusCode === 0) {
        return 'is-unsynced'
      }
      return 'is-unknown'
    },
    recentLearningSyncStatusText() {
      if (this.recentLearningSyncStatusCode === 1) {
        return this.uiText.syncedSource
      }
      if (this.recentLearningSyncStatusCode === 0) {
        return this.uiText.unsyncedSource
      }
      return this.uiText.unknownSync
    },
    visibleCloudItems() {
      const keyword = String(this.searchKeyword || '').toLowerCase()
      const source = this.getVisibleFolderSource()
      if (!keyword) {
        return source
      }
      return source.filter(item => String(item.name || '').toLowerCase().includes(keyword))
    }
  },
  created() {
    this.restoreCloudHomeState()
  },
  watch: {
    cloudListLoading(loading, wasLoading) {
      if (loading && !wasLoading) {
        this.cloudListLoadingStartedWithToolbar = this.cloudStatus == 1 && !this.globalSearchOpen
      }
      if (!loading) {
        this.cloudListLoadingStartedWithToolbar = false
        if (!this.activeAppFolder) {
          const returnContext = this.globalSearchOpen ? 'search' : this.normalizeMenuKey(this.activeMenu)
          this.restoreMobilePreviewReturnScroll(returnContext)
        }
      }
    },
    viewMode() {
      this.updateRecentGridColumnCount()
      this.syncRecentSelectionBarScrollbarOffset()
      this.saveCloudHomeState()
    },
    myFileViewMode() {
      this.saveCloudHomeState()
    },
    globalSearchViewMode() {
      this.updateGlobalSearchGridColumnCount()
      this.syncGlobalSearchSelectionBarScrollbarOffset()
      this.saveCloudHomeState()
    },
    activeMenu() {
      this.resetRecentPullRefreshState()
      this.syncRecentSelectionBarScrollbarOffset()
      this.saveCloudHomeState()
    },
    activeAppFolder() {
      this.activeAppDetailMode = false
      this.activeAppSelectionMode = false
      this.resetRecentPreviewTouchState()
      this.clearRecentPreviewZoomToast()
      this.saveCloudHomeState()
    },
    activeAppFolderAppType() {
      this.saveCloudHomeState()
    },
    activeAppReturnMenu() {
      this.saveCloudHomeState()
    },
    globalSearchOpen() {
      this.resetGlobalSearchPullRefreshState()
      if (!this.globalSearchOpen) {
        this.closeGlobalSearchViewSheet()
        this.closeGlobalSearchItemActions()
        this.cancelGlobalSearchTouch()
      }
      this.syncGlobalSearchSelectionBarScrollbarOffset()
      this.syncRecentSelectionBarScrollbarOffset()
      this.saveCloudHomeState()
    },
    globalSearchKeyword() {
      this.saveCloudHomeState()
    },
    globalSearchAppType() {
      this.saveCloudHomeState()
    },
    selectedLanguage() {
      this.updateRecentLearningTabTitleOverflow()
    },
    recentLearningModalOpen(open) {
      if (open) {
        this.updateRecentLearningTabTitleOverflow()
      } else {
        this.recentLearningTabOverflowKeys = []
      }
    },
    recentLearningLoading() {
      this.updateRecentLearningTabTitleOverflow()
    },
    recentLearningActiveTab() {
      this.updateRecentLearningTabTitleOverflow()
    },
    recentLearningHighlightDetailOpen() {
      this.updateRecentLearningTabTitleOverflow()
    },
    recentLearningAnnotationPreviewOpen() {
      this.updateRecentLearningTabTitleOverflow()
    },
    recentLearningTabs() {
      this.updateRecentLearningTabTitleOverflow()
    },
    visibleGlobalSearchItems() {
      this.updateGlobalSearchGridColumnCount()
      this.syncGlobalSearchSelectionBarScrollbarOffset()
    },
    visibleRecentItems() {
      this.updateRecentGridColumnCount()
      this.syncRecentSelectionBarScrollbarOffset()
    }
  },
  mounted() {
    this.setWapPageLoading(false)
    const language = normalizeLanguage(getLanguage())
    if (language && this.languageList.some(item => item.id == language)) {
      this.selectedLanguage = language
      this.pendingLanguage = language
    }
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleCloudWindowResize)
      window.addEventListener(MOBILE_CLOUD_VIEW_MODE_EVENT, this.handleCloudViewModeChange)
      window.addEventListener('beforeunload', this.handleWindowBeforeUnload)
      window.addEventListener('pagehide', this.handleWindowBeforeUnload)
    }
    this.applySharedViewMode(getMobileCloudViewMode(this.viewMode))
    this.syncGlobalSearchSelectionBarScrollbarOffset()
    this.syncRecentSelectionBarScrollbarOffset()
    this.refreshSession()
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleCloudWindowResize)
      window.removeEventListener(MOBILE_CLOUD_VIEW_MODE_EVENT, this.handleCloudViewModeChange)
      window.removeEventListener('beforeunload', this.handleWindowBeforeUnload)
      window.removeEventListener('pagehide', this.handleWindowBeforeUnload)
    }
    this.clearGlobalSearchRequestTimer()
    this.clearGlobalSearchItemClickTimer()
    this.clearGlobalSearchTouchTimer()
    this.clearGlobalSearchLongPressResetTimer()
    this.resetGlobalSearchPullRefreshState()
    this.stopGlobalSearchSelectionBarDrag()
    this.clearRecentItemClickTimer()
    this.clearRecentTouchTimer()
    this.clearRecentLongPressResetTimer()
    this.clearRecentLearningTabTitleTouchTimer()
    this.clearRecentLearningTabTitlePopupTimer()
    this.clearFolderItemClickTimer()
    this.stopRecentSelectionBarDrag()
    this.stopRecentLearningAnnotationPreviewDrag()
    this.clearRecentPreviewZoomToast()
    this.stopSettingResetCountdown()
    this.resetRecentPullRefreshState()
    this.setWapPageLoading(false)
  },
  methods: {
    getActiveAppPreviewTouchContext(event) {
      if (!event || !event.target) {
        return null
      }
      const target = event.target.nodeType == 1 ? event.target : event.target.parentElement
      const shell = target && typeof target.closest == 'function'
        ? target.closest('.paper-preview-shell, .daily-preview-shell, .learning-annotation-preview-shell')
        : null
      const sync = this.$refs.activeAppSync
      if (!shell || !sync) {
        return null
      }
      if (shell == sync.$refs.paperPreviewShell && !sync.paperDetailLoading && !sync.pageGridOpen) {
        const allowPendingImageNavigation = this.activeAppFolder == 'knowledge' && sync.isKnowledgeBaseAppAiNotePreview
        return {
          shell,
          scrollElement: this.getRecentPreviewScrollElement(target, shell),
          sync,
          allowFastPageSwipe: true,
          keepCentered: ['paper', 'meeting', 'learning', 'memo', 'knowledge'].includes(this.activeAppFolder),
          centerScrollMethod: 'centerPaperPreviewScroll',
          zoomValueKey: 'zoomValue',
          setZoomLevelMethod: 'setPaperZoomLevel',
          resetZoomMethod: 'resetPaperZoom',
          previousPageMethod: 'goPrevPage',
          nextPageMethod: 'goNextPage',
          canPreviousPage: () => (allowPendingImageNavigation ? !sync.paperDetailLoading : !sync.isPaperPreviewNavigationLocked()) && sync.currentPageIndex > 0,
          canNextPage: () => (allowPendingImageNavigation ? !sync.paperDetailLoading : !sync.isPaperPreviewNavigationLocked()) && sync.currentPageIndex < sync.detailPages.length - 1,
          navigatePreviousPage: allowPendingImageNavigation
            ? () => sync.selectDetailPage(sync.detailPages[sync.currentPageIndex - 1].pageNo)
            : null,
          navigateNextPage: allowPendingImageNavigation
            ? () => sync.selectDetailPage(sync.detailPages[sync.currentPageIndex + 1].pageNo)
            : null
        }
      }
      if (shell == sync.$refs.dailyPreviewShell && !sync.dailyPreviewLoading && !sync.dailyPreviewGridOpen) {
        return {
          shell,
          scrollElement: this.getRecentPreviewScrollElement(target, shell),
          sync,
          allowFastPageSwipe: true,
          keepCentered: true,
          centerScrollMethod: 'centerDailyPreviewScroll',
          zoomValueKey: 'dailyPreviewZoomValue',
          setZoomLevelMethod: 'setDailyPreviewZoomLevel',
          resetZoomMethod: 'resetDailyPreviewZoom',
          previousPageMethod: 'goPrevDailyPreview',
          nextPageMethod: 'goNextDailyPreview',
          canPreviousPage: () => !sync.dailyPreviewPageLoading && sync.dailyPreviewIndex > 0,
          canNextPage: () => !sync.dailyPreviewPageLoading && sync.dailyPreviewIndex < sync.dailyPreviewItems.length - 1
        }
      }
      if (
        shell == sync.$refs.learningAnnotationPreviewShell &&
        sync.learningAnnotationPreviewOpen &&
        !sync.learningAnnotationPreviewGridOpen
      ) {
        return {
          shell,
          scrollElement: shell,
          sync,
          allowFastPageSwipe: true,
          keepCentered: true,
          centerScrollMethod: 'centerLearningAnnotationPreviewScroll',
          zoomValueKey: 'learningAnnotationPreviewZoomValue',
          setZoomLevelMethod: 'setLearningAnnotationPreviewZoomLevel',
          resetZoomMethod: 'resetLearningAnnotationPreviewZoom',
          previousPageMethod: 'goPrevLearningAnnotationPreview',
          nextPageMethod: 'goNextLearningAnnotationPreview',
          canPreviousPage: () => sync.learningAnnotationPreviewIndex > 0,
          canNextPage: () => sync.learningAnnotationPreviewIndex < sync.learningAnnotations.length - 1
        }
      }
      return null
    },
    getRecentPreviewTouchContext(event) {
      if (!event || !event.target) {
        return null
      }
      const target = event.target.nodeType == 1 ? event.target : event.target.parentElement
      const annotationShell = target && typeof target.closest == 'function' ? target.closest('.recent-learning-preview-shell') : null
      if (
        annotationShell &&
        annotationShell == this.$refs.recentLearningAnnotationPreviewShell &&
        this.recentLearningAnnotationPreviewOpen &&
        !this.recentLearningAnnotationPreviewGridOpen
      ) {
        return {
          shell: annotationShell,
          scrollElement: this.getRecentPreviewScrollElement(target, annotationShell),
          sync: this,
          allowFastPageSwipe: true,
          keepCentered: true,
          centerScrollMethod: 'centerRecentLearningAnnotationPreviewScroll',
          zoomValueKey: 'recentLearningAnnotationPreviewZoomValue',
          setZoomLevelMethod: 'setRecentLearningAnnotationPreviewZoomLevel',
          resetZoomMethod: 'resetRecentLearningAnnotationPreviewZoom',
          previousPageMethod: 'goPrevRecentLearningAnnotationPreview',
          nextPageMethod: 'goNextRecentLearningAnnotationPreview',
          canPreviousPage: () => this.recentLearningAnnotationPreviewIndex > 0,
          canNextPage: () => this.recentLearningAnnotationPreviewIndex < this.recentLearningAnnotations.length - 1
        }
      }
      return null
    },
    getRecentPreviewScrollElement(target, shell) {
      if (!shell) {
        return null
      }
      const textPage = target && typeof target.closest == 'function'
        ? target.closest('.knowledge-text-page')
        : null
      if (textPage && shell.contains(textPage) && textPage.scrollHeight > textPage.clientHeight + 1) {
        return textPage
      }
      return shell
    },
    getRecentDetailBackTouchContext(event) {
      const target = event && event.target && (event.target.nodeType == 1 ? event.target : event.target.parentElement)
      if (target && typeof target.closest == 'function' && target.closest('button, input, textarea, select, a')) {
        return null
      }
      if (this.globalSearchOpen) {
        if (this.selectedGlobalSearchIds.length > 0 || this.globalSearchMoreMenuId) {
          return null
        }
        return {
          back: () => this.handleGlobalSearchBack()
        }
      }
      const sync = this.$refs.activeAppSync
      if (
        !sync ||
        sync.interactionLocked ||
        sync.paperDetailLoading ||
        sync.paperPasswordModalOpen ||
        sync.paperDownloadFormatModalOpen ||
        sync.recordPanelOpen ||
        sync.hasPaperSelection ||
        (Array.isArray(sync.selectedDetailPageNos) && sync.selectedDetailPageNos.length > 0) ||
        sync.filterMenuOpen ||
        sync.sortMenuOpen ||
        sync.moreMenuId
      ) {
        return null
      }
      if (sync.searchOpen && typeof sync.toggleSearch == 'function') {
        return {
          back: () => sync.toggleSearch()
        }
      }
      if (sync.detailMode && typeof sync.handleDetailBack == 'function') {
        return {
          back: () => sync.handleDetailBack()
        }
      }
      if (!this.activeAppFolder) {
        return null
      }
      const folderPath = Array.isArray(sync.paperFolderPath) ? sync.paperFolderPath : []
      if (folderPath.length > 0 && typeof sync.openPaperBreadcrumb == 'function') {
        return {
          back: () => sync.openPaperBreadcrumb(folderPath.length - 1)
        }
      }
      return {
        back: () => this.closeAppFolder()
      }
    },
    getRecentPreviewTouchDistance(touches) {
      if (!touches || touches.length < 2) {
        return 0
      }
      return Math.hypot(touches[1].clientX - touches[0].clientX, touches[1].clientY - touches[0].clientY)
    },
    getRecentPreviewTouchCenter(touches) {
      if (!touches || touches.length < 2) {
        return null
      }
      return {
        x: (touches[0].clientX + touches[1].clientX) / 2,
        y: (touches[0].clientY + touches[1].clientY) / 2
      }
    },
    getRecentPreviewEventTimestamp(event) {
      const timestamp = Number(event && event.timeStamp)
      return Number.isFinite(timestamp) && timestamp >= 0 ? timestamp : Date.now()
    },
    getRecentPreviewTouchesForShell(shell, touches) {
      if (!touches || touches.length == 0) {
        return []
      }
      const candidates = Array.from(touches)
      if (!shell || typeof shell.contains != 'function') {
        return candidates
      }
      return candidates.filter(touch => {
        const target = touch && touch.target
        return !target || !target.nodeType || target == shell || shell.contains(target)
      })
    },
    getRecentPreviewPinchTouches(state, touches) {
      if (!touches || touches.length != 2) {
        return null
      }
      if (!state || !Array.isArray(state.pinchTouchIdentifiers) || state.pinchTouchIdentifiers.length != 2) {
        return [touches[0], touches[1]]
      }
      const first = this.getRecentPreviewTouchByIdentifier(touches, state.pinchTouchIdentifiers[0])
      const second = this.getRecentPreviewTouchByIdentifier(touches, state.pinchTouchIdentifiers[1])
      return first && second ? [first, second] : null
    },
    getRecentPreviewTouchByIdentifier(touches, identifier) {
      if (!touches || touches.length == 0) {
        return null
      }
      if (identifier === null || identifier === undefined) {
        return touches.length == 1 ? touches[0] : null
      }
      for (let index = 0; index < touches.length; index += 1) {
        if (touches[index].identifier === identifier) {
          return touches[index]
        }
      }
      return null
    },
    recordRecentPreviewSwipeSample(state, clientX, clientY, timestamp = Date.now()) {
      if (!state) {
        return
      }
      const samples = Array.isArray(state.swipeSamples) ? state.swipeSamples : []
      const lastSample = samples[samples.length - 1]
      if (lastSample && lastSample.time == timestamp) {
        lastSample.x = clientX
        lastSample.y = clientY
      } else {
        samples.push({ x: clientX, y: clientY, time: timestamp })
      }
      const cutoff = timestamp - 320
      while (samples.length > 12 || (samples.length > 2 && samples[1].time <= cutoff)) {
        samples.shift()
      }
      state.swipeSamples = samples
    },
    getRecentPreviewTerminalVelocity(state) {
      const samples = state && Array.isArray(state.swipeSamples) ? state.swipeSamples : []
      if (samples.length < 2) {
        return 0
      }
      const last = samples[samples.length - 1]
      const cutoff = last.time - 100
      let first = samples[samples.length - 2]
      for (let index = 0; index < samples.length - 1; index += 1) {
        if (samples[index].time >= cutoff) {
          first = samples[index]
          break
        }
      }
      const elapsed = Math.max(1, last.time - first.time)
      return Math.abs(last.x - first.x) / elapsed
    },
    isFastRecentPreviewSwipe(state, deltaX, deltaY, timestamp = Date.now()) {
      if (!state || state.allowFastPageSwipe !== true || state.swipeEligible === false || state.mode == 'drag' || state.mode == 'pinch') {
        return false
      }
      const absX = Math.abs(deltaX)
      const absY = Math.max(Math.abs(deltaY), Number(state.maxAbsY) || 0)
      const startZoomValue = Number(state.startZoomValue) || 1
      const isZoomed = startZoomValue > 1.001
      const viewportWidth = Math.max(1, Number(state.shell && state.shell.clientWidth) || (typeof window !== 'undefined' ? window.innerWidth : 375) || 375)
      const minDistance = isZoomed
        ? Math.min(78, Math.max(60, Math.round(viewportWidth * .18)))
        : Math.min(68, Math.max(48, Math.round(viewportWidth * .15)))
      const directionRatio = isZoomed ? 1.6 : 1.4
      if (absX < minDistance || absX <= absY * directionRatio) {
        return false
      }
      const stateStartTime = Number(state.startTime)
      const startTime = Number.isFinite(stateStartTime) ? stateStartTime : timestamp
      const elapsed = Math.max(1, timestamp - startTime)
      const maxDuration = isZoomed ? 240 : 300
      if (elapsed > maxDuration) {
        return false
      }
      const velocity = absX / elapsed
      const terminalVelocity = this.getRecentPreviewTerminalVelocity(state)
      const minVelocity = isZoomed ? .42 : .38
      const hasFastVelocity = velocity >= minVelocity && terminalVelocity >= minVelocity * .75
      const maxAbsX = Number(state.maxAbsX) || absX
      const maxReversal = isZoomed ? 10 : 18
      const direction = deltaX == 0 ? 0 : (deltaX > 0 ? 1 : -1)
      return hasFastVelocity &&
        maxAbsX - absX <= maxReversal &&
        (!state.swipeDirection || !direction || state.swipeDirection == direction)
    },
    shouldLockRecentPreviewDrag(state, deltaX, deltaY, timestamp = Date.now()) {
      if (!state || state.swipeEligible === false || state.mode == 'drag' || state.mode == 'pinch') {
        return true
      }
      const absX = Math.abs(deltaX)
      const absY = Math.abs(deltaY)
      const startZoomValue = Number(state.startZoomValue) || 1
      const isZoomed = startZoomValue > 1.001
      if (absY >= 24 && absY > absX * 1.2) {
        return true
      }
      const direction = deltaX == 0 ? 0 : (deltaX > 0 ? 1 : -1)
      if (direction && state.swipeDirection && direction != state.swipeDirection) {
        return true
      }
      if (direction && !state.swipeDirection && absX >= 12) {
        state.swipeDirection = direction
      }
      const maxAbsX = Number(state.maxAbsX) || 0
      const maxReversal = isZoomed ? 10 : 18
      if (maxAbsX - absX > maxReversal) {
        return true
      }
      const stateStartTime = Number(state.startTime)
      const startTime = Number.isFinite(stateStartTime) ? stateStartTime : timestamp
      const elapsed = Math.max(1, timestamp - startTime)
      const maxDuration = isZoomed ? 240 : 300
      if (elapsed > maxDuration && (absX >= 8 || absY >= 8)) {
        return true
      }
      return false
    },
    initializeRecentPreviewPinch(state, touches) {
      const pinchTouches = touches && touches.length >= 2 ? [touches[0], touches[1]] : null
      const center = this.getRecentPreviewTouchCenter(pinchTouches)
      const zoomElement = state && state.shell
        ? state.shell.querySelector('.paper-preview-zoom, .daily-preview-zoom, .learning-annotation-preview-zoom, .recent-learning-preview-zoom')
        : null
      const startZoomValue = state && state.sync ? (Number(state.sync[state.zoomValueKey]) || 1) : 1
      state.mode = 'pinch'
      state.swipeEligible = false
      state.pinchTouchIdentifiers = pinchTouches ? [pinchTouches[0].identifier, pinchTouches[1].identifier] : []
      state.startDistance = this.getRecentPreviewTouchDistance(pinchTouches)
      state.startZoomValue = startZoomValue
      state.pinchZoomElement = zoomElement
      state.pinchUpdateSequence = 0
      if (!center || !zoomElement) {
        state.pinchContentX = 0
        state.pinchContentY = 0
        return
      }
      const zoomRect = zoomElement.getBoundingClientRect()
      state.pinchContentX = (center.x - zoomRect.left) / startZoomValue
      state.pinchContentY = (center.y - zoomRect.top) / startZoomValue
    },
    keepRecentPreviewPinchCenter(state, touches) {
      const center = this.getRecentPreviewTouchCenter(touches)
      const shell = state && state.shell
      const zoomElement = state && state.pinchZoomElement
      if (!center || !shell || !zoomElement) {
        return
      }
      const zoomValue = Number(state.sync[state.zoomValueKey]) || 1
      const sequence = (state.pinchUpdateSequence || 0) + 1
      state.pinchUpdateSequence = sequence
      this.$nextTick(() => {
        const applyPinchCenter = () => {
          if (state.pinchUpdateSequence != sequence || !zoomElement.isConnected) {
            return
          }
          const shellRect = shell.getBoundingClientRect()
          const zoomRect = zoomElement.getBoundingClientRect()
          const contentLeft = zoomRect.left - shellRect.left + shell.scrollLeft
          const contentTop = zoomRect.top - shellRect.top + shell.scrollTop
          shell.scrollLeft = contentLeft + state.pinchContentX * zoomValue - (center.x - shellRect.left)
          shell.scrollTop = contentTop + state.pinchContentY * zoomValue - (center.y - shellRect.top)

          const activeState = this.recentPreviewTouchState
          if (activeState && activeState.shell == shell && activeState.mode == 'pending') {
            const scrollElement = activeState.scrollElement || shell
            activeState.scrollLeft = shell.scrollLeft
            activeState.scrollTop = scrollElement.scrollTop
          }
        }
        if (typeof window !== 'undefined' && typeof window.requestAnimationFrame == 'function') {
          window.requestAnimationFrame(applyPinchCenter)
          return
        }
        applyPinchCenter()
      })
    },
    showRecentPreviewZoomToast(state) {
      if (!state || !state.sync) {
        return
      }
      const startZoomValue = Number(state.startZoomValue) || 1
      const zoomValue = Number(state.sync[state.zoomValueKey]) || 1
      if (Math.abs(zoomValue - startZoomValue) < .01) {
        return
      }
      this.clearRecentPreviewZoomToast()
      this.recentPreviewZoomToast = `${Math.round(zoomValue * 100)}%`
      this.recentPreviewZoomToastKey += 1
      this.recentPreviewZoomToastTimer = window.setTimeout(() => {
        this.recentPreviewZoomToast = ''
        this.recentPreviewZoomToastTimer = null
      }, 1300)
    },
    clearRecentPreviewZoomToast() {
      if (this.recentPreviewZoomToastTimer) {
        clearTimeout(this.recentPreviewZoomToastTimer)
        this.recentPreviewZoomToastTimer = null
      }
      this.recentPreviewZoomToast = ''
    },
    handleRecentPreviewTouchStart(event) {
      const context = this.getActiveAppPreviewTouchContext(event) || this.getRecentPreviewTouchContext(event)
      if (!context || !event.touches || event.touches.length == 0) {
        this.resetRecentPreviewTouchState()
        return
      }
      if (event.touches.length > 2) {
        this.resetRecentPreviewTouchState()
        this.consumeRecentPreviewTouchEvent(event)
        return
      }
      const previewTouches = this.getRecentPreviewTouchesForShell(context.shell, event.touches)
      const touch = previewTouches[0]
      if (!touch) {
        this.resetRecentPreviewTouchState()
        return
      }
      const now = this.getRecentPreviewEventTimestamp(event)
      if (!context.shell) {
        this.recentPreviewTouchState = {
          mode: 'back-swipe',
          back: context.back,
          startX: touch.clientX,
          startY: touch.clientY,
          lastX: touch.clientX,
          lastY: touch.clientY
        }
        return
      }
      if (previewTouches.length >= 2) {
        const state = {
          shell: context.shell,
          scrollElement: context.scrollElement || context.shell,
          sync: context.sync,
          keepCentered: context.keepCentered,
          centerScrollMethod: context.centerScrollMethod,
          zoomValueKey: context.zoomValueKey,
          setZoomLevelMethod: context.setZoomLevelMethod,
          resetZoomMethod: context.resetZoomMethod,
          previousPageMethod: context.previousPageMethod,
          nextPageMethod: context.nextPageMethod,
          canPreviousPage: context.canPreviousPage,
          canNextPage: context.canNextPage,
          navigatePreviousPage: context.navigatePreviousPage,
          navigateNextPage: context.navigateNextPage,
          allowFastPageSwipe: context.allowFastPageSwipe === true,
          startTime: now,
          lastTime: now,
          swipeEligible: false,
          swipeSamples: [],
          maxAbsX: 0,
          maxAbsY: 0
        }
        this.initializeRecentPreviewPinch(state, previewTouches)
        this.recentPreviewTouchState = state
        this.consumeRecentPreviewTouchEvent(event)
        return
      }
      const startZoomValue = Number(context.sync[context.zoomValueKey]) || 1
      this.recentPreviewTouchState = {
        mode: 'pending',
        shell: context.shell,
        scrollElement: context.scrollElement || context.shell,
        sync: context.sync,
        keepCentered: context.keepCentered,
        centerScrollMethod: context.centerScrollMethod,
        zoomValueKey: context.zoomValueKey,
        setZoomLevelMethod: context.setZoomLevelMethod,
        resetZoomMethod: context.resetZoomMethod,
        previousPageMethod: context.previousPageMethod,
        nextPageMethod: context.nextPageMethod,
        canPreviousPage: context.canPreviousPage,
        canNextPage: context.canNextPage,
        navigatePreviousPage: context.navigatePreviousPage,
        navigateNextPage: context.navigateNextPage,
        allowFastPageSwipe: context.allowFastPageSwipe === true,
        primaryTouchIdentifier: touch.identifier,
        startX: touch.clientX,
        startY: touch.clientY,
        lastX: touch.clientX,
        lastY: touch.clientY,
        startTime: now,
        lastTime: now,
        startZoomValue,
        swipeEligible: context.allowFastPageSwipe === true,
        swipeSamples: [{ x: touch.clientX, y: touch.clientY, time: now }],
        swipeDirection: 0,
        maxAbsX: 0,
        maxAbsY: 0,
        scrollLeft: context.shell.scrollLeft,
        scrollTop: (context.scrollElement || context.shell).scrollTop
      }
    },
    handleRecentPreviewTouchMove(event) {
      const state = this.recentPreviewTouchState
      if (!state || !event.touches || event.touches.length == 0) {
        return
      }
      if (!state.shell) {
        const touch = event.touches[0]
        state.lastX = touch.clientX
        state.lastY = touch.clientY
        const deltaX = touch.clientX - state.startX
        const deltaY = touch.clientY - state.startY
        if (Math.abs(deltaX) >= 8 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15 && event.cancelable) {
          state.gestureConsumed = true
          event.preventDefault()
        }
        return
      }
      if (event.touches.length > 2) {
        this.resetRecentPreviewTouchState()
        this.consumeRecentPreviewTouchEvent(event)
        return
      }
      const previewTouches = this.getRecentPreviewTouchesForShell(state.shell, event.touches)
      if (previewTouches.length >= 2) {
        if (state.mode != 'pinch') {
          this.initializeRecentPreviewPinch(state, previewTouches)
        }
        const pinchTouches = this.getRecentPreviewPinchTouches(state, previewTouches)
        if (!pinchTouches) {
          this.resetRecentPreviewTouchState()
          this.consumeRecentPreviewTouchEvent(event)
          return
        }
        const distance = this.getRecentPreviewTouchDistance(pinchTouches)
        if (state.startDistance > 0 && distance > 0 && typeof state.sync[state.setZoomLevelMethod] == 'function') {
          const zoomValue = Math.min(2, Math.max(.4, state.startZoomValue * distance / state.startDistance))
          state.sync[state.setZoomLevelMethod]((zoomValue - 1) / .2, { keepScrollPosition: true })
          this.keepRecentPreviewPinchCenter(state, pinchTouches)
        }
        state.gestureConsumed = true
        this.consumeRecentPreviewTouchEvent(event)
        return
      }
      if (state.mode == 'pinch') {
        state.gestureConsumed = true
        this.consumeRecentPreviewTouchEvent(event)
        return
      }
      const touch = this.getRecentPreviewTouchByIdentifier(previewTouches, state.primaryTouchIdentifier)
      if (!touch) {
        this.resetRecentPreviewTouchState()
        return
      }
      const now = this.getRecentPreviewEventTimestamp(event)
      state.lastX = touch.clientX
      state.lastY = touch.clientY
      state.lastTime = now
      this.recordRecentPreviewSwipeSample(state, touch.clientX, touch.clientY, now)
      const deltaX = touch.clientX - state.startX
      const deltaY = touch.clientY - state.startY
      const absX = Math.abs(deltaX)
      const absY = Math.abs(deltaY)
      const scrollElement = state.scrollElement || state.shell
      const zoomValue = Number(state.sync[state.zoomValueKey]) || 1
      if (state.mode != 'drag' && this.shouldLockRecentPreviewDrag(state, deltaX, deltaY, now)) {
        state.mode = 'drag'
        state.swipeEligible = false
      }
      state.maxAbsX = Math.max(Number(state.maxAbsX) || 0, absX)
      state.maxAbsY = Math.max(Number(state.maxAbsY) || 0, absY)
      if (zoomValue > 1.001 && (absX >= 8 || absY >= 8)) {
        state.shell.scrollLeft = state.scrollLeft - deltaX
        scrollElement.scrollTop = state.scrollTop - deltaY
        state.gestureConsumed = true
        this.consumeRecentPreviewTouchEvent(event)
        return
      }
      if (absX >= 8 && absX > absY * 1.15) {
        if (state.mode == 'drag') {
          state.shell.scrollLeft = state.scrollLeft - deltaX
          scrollElement.scrollTop = state.scrollTop - deltaY
        }
        state.gestureConsumed = true
        this.consumeRecentPreviewTouchEvent(event)
        return
      }
      const canScrollY = scrollElement.scrollHeight > scrollElement.clientHeight + 1
      if (canScrollY && absY >= 8 && absY >= absX) {
        state.mode = 'drag'
        state.swipeEligible = false
        scrollElement.scrollTop = state.scrollTop - deltaY
        state.gestureConsumed = true
        this.consumeRecentPreviewTouchEvent(event)
        return
      }
      if (absX > 8 || absY > 8) {
        state.gestureConsumed = true
        this.consumeRecentPreviewTouchEvent(event)
      }
    },
    handleRecentPreviewTouchEnd(event) {
      const state = this.recentPreviewTouchState
      if (!state) {
        return
      }
      if (state.gestureConsumed || state.mode == 'pinch') {
        this.consumeRecentPreviewTouchEvent(event)
      }
      if (!state.shell) {
        this.resetRecentPreviewTouchState()
        const deltaX = state.lastX - state.startX
        const deltaY = state.lastY - state.startY
        if (deltaX < -50 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2 && typeof state.back == 'function') {
          state.back()
        }
        return
      }
      const previewTouches = this.getRecentPreviewTouchesForShell(state.shell, event && event.touches)
      if (state.mode == 'pinch' && previewTouches.length >= 2) {
        return
      }
      if (state.mode != 'pinch' && this.getRecentPreviewTouchByIdentifier(previewTouches, state.primaryTouchIdentifier)) {
        return
      }
      if (previewTouches.length > 0) {
        if (state.mode == 'pinch') {
          state.pinchUpdateSequence = (state.pinchUpdateSequence || 0) + 1
          this.showRecentPreviewZoomToast(state)
          this.centerRecentPreviewTouchState(state)
        }
        const touch = previewTouches[0]
        const now = this.getRecentPreviewEventTimestamp(event)
        this.recentPreviewTouchState = {
          mode: 'pending',
          shell: state.shell,
          scrollElement: state.scrollElement || state.shell,
          sync: state.sync,
          keepCentered: state.keepCentered,
          centerScrollMethod: state.centerScrollMethod,
          zoomValueKey: state.zoomValueKey,
          setZoomLevelMethod: state.setZoomLevelMethod,
          resetZoomMethod: state.resetZoomMethod,
          previousPageMethod: state.previousPageMethod,
          nextPageMethod: state.nextPageMethod,
          canPreviousPage: state.canPreviousPage,
          canNextPage: state.canNextPage,
          navigatePreviousPage: state.navigatePreviousPage,
          navigateNextPage: state.navigateNextPage,
          allowFastPageSwipe: state.allowFastPageSwipe === true,
          primaryTouchIdentifier: touch.identifier,
          startX: touch.clientX,
          startY: touch.clientY,
          lastX: touch.clientX,
          lastY: touch.clientY,
          startTime: now,
          lastTime: now,
          startZoomValue: Number(state.sync[state.zoomValueKey]) || 1,
          swipeEligible: false,
          swipeSamples: [{ x: touch.clientX, y: touch.clientY, time: now }],
          swipeDirection: 0,
          maxAbsX: 0,
          maxAbsY: 0,
          scrollLeft: state.shell.scrollLeft,
          scrollTop: (state.scrollElement || state.shell).scrollTop
        }
        return
      }
      if (state.mode == 'pinch') {
        this.resetRecentPreviewTouchState()
        this.showRecentPreviewZoomToast(state)
        this.centerRecentPreviewTouchState(state)
        return
      }
      const changedTouch = event && this.getRecentPreviewTouchByIdentifier(event.changedTouches, state.primaryTouchIdentifier)
      if (!changedTouch) {
        this.resetRecentPreviewTouchState()
        return
      }
      state.lastX = changedTouch.clientX
      state.lastY = changedTouch.clientY
      const deltaX = state.lastX - state.startX
      const deltaY = state.lastY - state.startY
      const absX = Math.abs(deltaX)
      const absY = Math.abs(deltaY)
      const endTime = this.getRecentPreviewEventTimestamp(event)
      this.recordRecentPreviewSwipeSample(state, state.lastX, state.lastY, endTime)
      if (state.mode == 'pending' && this.shouldLockRecentPreviewDrag(state, deltaX, deltaY, endTime)) {
        state.mode = 'drag'
        state.swipeEligible = false
      }
      state.maxAbsX = Math.max(Number(state.maxAbsX) || 0, absX)
      state.maxAbsY = Math.max(Number(state.maxAbsY) || 0, absY)
      const isFastSwipe = this.isFastRecentPreviewSwipe(state, deltaX, deltaY, endTime)
      const canNavigate = isFastSwipe && (
        (deltaX < 0 && (typeof state.navigateNextPage == 'function' || typeof state.sync[state.nextPageMethod] == 'function') && (typeof state.canNextPage != 'function' || state.canNextPage())) ||
        (deltaX > 0 && (typeof state.navigatePreviousPage == 'function' || typeof state.sync[state.previousPageMethod] == 'function') && (typeof state.canPreviousPage != 'function' || state.canPreviousPage()))
      )
      if (absX >= 8 || absY >= 8) {
        this.consumeRecentPreviewTouchEvent(event)
      }
      this.resetRecentPreviewTouchState()
      if (!canNavigate) {
        const zoomValue = Number(state.sync[state.zoomValueKey]) || 1
        if (zoomValue > 1.001 && (absX >= 8 || absY >= 8)) {
          const scrollElement = state.scrollElement || state.shell
          state.shell.scrollLeft = state.scrollLeft - deltaX
          scrollElement.scrollTop = state.scrollTop - deltaY
        }
        return
      }
      if (deltaX < 0) {
        if (typeof state.sync[state.resetZoomMethod] == 'function') {
          state.sync[state.resetZoomMethod]()
        }
        if (typeof state.navigateNextPage == 'function') {
          state.navigateNextPage()
        } else {
          state.sync[state.nextPageMethod]()
        }
      } else if (deltaX > 0) {
        if (typeof state.sync[state.resetZoomMethod] == 'function') {
          state.sync[state.resetZoomMethod]()
        }
        if (typeof state.navigatePreviousPage == 'function') {
          state.navigatePreviousPage()
        } else {
          state.sync[state.previousPageMethod]()
        }
      }
    },
    resetRecentPreviewTouchState() {
      if (this.recentPreviewTouchState) {
        this.recentPreviewTouchState.pinchUpdateSequence = (this.recentPreviewTouchState.pinchUpdateSequence || 0) + 1
      }
      this.recentPreviewTouchState = null
    },
    consumeRecentPreviewTouchEvent(event) {
      if (!event) {
        return
      }
      if (event.cancelable) {
        event.preventDefault()
      }
      if (typeof event.stopPropagation == 'function') {
        event.stopPropagation()
      }
    },
    centerRecentPreviewTouchState(state) {
      const method = state && state.centerScrollMethod
      if (!state || !state.keepCentered || !state.sync || !method || typeof state.sync[method] != 'function') {
        return
      }
      if ((Number(state.sync[state.zoomValueKey]) || 1) > 1.001) {
        return
      }
      state.sync[method]()
      this.$nextTick(() => {
        const syncTouchOrigin = () => {
          const activeState = this.recentPreviewTouchState
          if (activeState && activeState.shell == state.shell && activeState.mode == 'pending') {
            const scrollElement = activeState.scrollElement || activeState.shell
            activeState.scrollLeft = activeState.shell.scrollLeft
            activeState.scrollTop = scrollElement.scrollTop
          }
        }
        if (typeof window !== 'undefined' && typeof window.requestAnimationFrame == 'function') {
          window.requestAnimationFrame(syncTouchOrigin)
          return
        }
        syncTouchOrigin()
      })
    },

    applySharedViewMode(mode) {
      const viewMode = normalizeMobileCloudViewMode(mode)
      if (this.viewMode != viewMode) {
        this.viewMode = viewMode
      }
      if (this.myFileViewMode != viewMode) {
        this.myFileViewMode = viewMode
      }
      if (this.globalSearchViewMode != viewMode) {
        this.globalSearchViewMode = viewMode
      }
    },
    setSharedViewMode(mode) {
      const viewMode = setMobileCloudViewMode(mode)
      this.applySharedViewMode(viewMode)
      this.saveCloudHomeState()
    },
    handleCloudViewModeChange(event) {
      this.applySharedViewMode(event && event.detail ? event.detail.viewMode : '')
    },
    resolveInitialAppRefreshState(appKey) {
      return this.pendingAppRefreshStateAppKey == appKey ? this.pendingAppRefreshState : null
    },
    handleWindowBeforeUnload() {
      this.saveCloudHomeState()
      this.saveActiveAppRefreshState()
    },
    clearPendingAppRefreshState() {
      this.pendingAppRefreshStateAppKey = ''
      this.pendingAppRefreshState = null
    },
    clearCloudRefreshState() {
      clearCloudHomeState()
      clearCloudAppStates()
      this.clearPendingAppRefreshState()
    },
    changeCloudServer(event) {
      const eventValue = event && event.target ? event.target.value : this.cloudServerKey
      const nextKey = normalizeCloudServerKey(eventValue)
      const currentKey = getActiveCloudServerKey()
      if (!nextKey) {
        this.cloudServerKey = currentKey
        return
      }
      if (nextKey == currentKey) {
        this.cloudServerKey = currentKey
        return
      }
      if (isCloudTestEnvironment()) {
        this.cloudServerKey = setCloudServerKey(CLOUD_SERVER_US)
        this.$message.warning(this.uiText.testServerSwitchBlocked || '\u6d4b\u8bd5\u73af\u5883\u4e0d\u5141\u8bb8\u5207\u670d\u52a1\u5668')
        return
      }
      if (uploadCenter.getRunningCount() > 0) {
        this.cloudServerKey = currentKey
        this.$message.warning(this.uiText.uploadServerSwitchBlocked || '\u6587\u4ef6\u6b63\u5728\u4e0a\u4f20\u4e2d\uff0c\u4e0d\u5141\u8bb8\u5207\u670d\u52a1\u5668')
        return
      }
      this.saveActiveAppRefreshState()
      this.cloudServerKey = setCloudServerKey(nextKey)
      this.resetCloudDataForServerChange()
    },
    resetCloudDataForServerChange() {
      this.clearPendingAppRefreshState()
      this.clearMobilePreviewReturnScroll()
      this.cloudHomeStateRestoring = false
      this.rootFolderLoading = false
      this.rootFolderLoaded = false
      this.cloudStatusLoading = false
      this.cloudStatusLoaded = false
      this.cloudStorage = {}
      this.cloudItems = []
      this.recentItems = []
      this.recentListLoading = false
      this.recentAppendLoading = false
      this.recentListLoaded = false
      this.recentDoubleOpenState = null
      this.resetRecentPagination()
      this.clearGlobalSearchRequestTimer()
      this.clearGlobalSearchItemClickTimer()
      this.cancelGlobalSearchTouch()
      this.resetGlobalSearchPullRefreshState()
      this.globalSearchRequestSeq += 1
      this.globalSearchLoading = false
      this.globalSearchAppendLoading = false
      this.globalSearchLoaded = false
      this.globalSearchItems = []
      this.resetGlobalSearchPagination()
      this.activeMenu = 'recent'
      this.activeAppFolder = ''
      this.activeAppFolderAppType = null
      this.activeAppReturnMenu = 'recent'
      this.globalSearchFilePreviewMode = false
      this.globalSearchLearningPreviewMode = false
      this.searchOpen = false
      this.searchKeyword = ''
      this.globalSearchOpen = false
      this.globalSearchKeyword = ''
      this.globalSearchAppType = -1
      this.clearRecentSelection()
      this.clearGlobalSearchSelection()
      this.closeRecentMoreMenu()
      this.closeRecentActionSheet()
      this.closeRecentViewSheet()
      this.closeMyFileViewSheet()
      this.closeGlobalSearchMoreMenu()
      this.closeRecentLearningModal()
      this.applySharedViewMode(getMobileCloudViewMode(this.viewMode))
      this.pendingRecentOpenItem = null
      this.pendingRecentOpenOptions = null
    },
    saveActiveAppRefreshState() {
      const appKey = this.activeAppFolder
      const sync = this.$refs.activeAppSync
      if (!appKey || !sync || typeof sync.getRefreshState != 'function') {
        return
      }
      const state = sync.getRefreshState()
      if (!state || typeof state != 'object') {
        return
      }
      setCloudAppState(`wap-${appKey}`, state)
    },
    restoreCloudHomeState() {
      const state = getCloudHomeState()
      if (!state) {
        this.clearPendingAppRefreshState()
        return false
      }
      this.cloudHomeStateRestoring = true
      const folderType = this.isSupportedAppFolderType(state.activeAppFolder) ? state.activeAppFolder : ''
      const appRefreshState = folderType ? getCloudAppState(`wap-${folderType}`) : null
      this.pendingAppRefreshStateAppKey = appRefreshState ? folderType : ''
      this.pendingAppRefreshState = appRefreshState
      this.activeMenu = this.normalizeMenuKey(state.activeMenu || 'recent')
      this.activeAppFolder = folderType
      this.activeAppFolderAppType = folderType ? (state.activeAppFolderAppType || this.resolveDefaultAppTypeByFolderType(folderType)) : null
      this.activeAppReturnMenu = this.normalizeMenuKey(state.activeAppReturnMenu || this.activeMenu || 'recent')
      this.searchOpen = false
      this.searchKeyword = ''
      this.globalSearchOpen = !!state.globalSearchOpen && !folderType
      this.globalSearchFilePreviewMode = false
      this.globalSearchLearningPreviewMode = false
      this.globalSearchKeyword = typeof state.globalSearchKeyword == 'string' ? state.globalSearchKeyword : ''
      this.globalSearchAppType = Number.isFinite(Number(state.globalSearchAppType)) ? Number(state.globalSearchAppType) : -1
      this.globalSearchLoaded = false
      this.globalSearchItems = []
      this.applySharedViewMode(getMobileCloudViewMode(this.viewMode))
      if (this.globalSearchOpen) {
        this.activeMenu = 'files'
        this.activeAppReturnMenu = 'search'
        this.globalSearchTypeMenuOpen = false
        this.resetGlobalSearchPagination()
      }
      const pendingAppKey = this.pendingAppRefreshStateAppKey
      this.$nextTick(() => {
        this.cloudHomeStateRestoring = false
        if (pendingAppKey && this.pendingAppRefreshStateAppKey == pendingAppKey) {
          this.clearPendingAppRefreshState()
        }
      })
      return true
    },
    saveCloudHomeState() {
      if (this.cloudHomeStateRestoring || this.cloudStatus != 1) {
        return
      }
      setCloudHomeState({
        activeMenu: this.activeMenu,
        activeAppFolder: this.activeAppFolder,
        activeAppFolderAppType: this.activeAppFolderAppType,
        activeAppReturnMenu: this.activeAppReturnMenu,
        globalSearchOpen: this.globalSearchOpen,
        globalSearchKeyword: this.globalSearchKeyword,
        globalSearchAppType: this.globalSearchAppType
      })
    },

    getCloudListPageSize(pageSize) {
      const number = Number(pageSize)
      return Number.isFinite(number) && number > 0 ? Math.floor(number) : 100
    },
    getCloudListPageCount(total, pageSize, pageIndex) {
      const totalNumber = Number(total)
      if (!Number.isFinite(totalNumber) || totalNumber <= 0) {
        return Math.max(1, Number(pageIndex) || 1)
      }
      return Math.max(1, Math.ceil(totalNumber / this.getCloudListPageSize(pageSize)))
    },
    getCloudListPaginationTotal(total, items, pageIndex, pageSize, lastPageSize) {
      const totalNumber = Number(total)
      if (Number.isFinite(totalNumber) && totalNumber > 0) {
        return Math.floor(totalNumber)
      }
      const itemCount = Array.isArray(items) ? items.length : 0
      const inferredTotal = (Math.max(1, Number(pageIndex) || 1) - 1) * this.getCloudListPageSize(pageSize) + Math.max(0, Number(lastPageSize) || 0)
      return Math.max(itemCount, inferredTotal)
    },
    hasNextCloudListPage(reachedEnd, total, pageIndex, pageSize, lastPageSize) {
      if (reachedEnd) {
        return false
      }
      const totalNumber = Number(total)
      if (Number.isFinite(totalNumber) && totalNumber > 0) {
        return (Number(pageIndex) || 1) < this.getCloudListPageCount(totalNumber, pageSize, pageIndex)
      }
      return Math.max(0, Number(lastPageSize) || 0) >= this.getCloudListPageSize(pageSize)
    },
    normalizeCloudListLoadOptions(force, options, currentPage) {
      const source = force && typeof force == 'object' ? force : (options || {})
      const append = source.append === true
      let pageIndex = Number(source.pageIndex)
      if (!Number.isFinite(pageIndex) || pageIndex <= 0) {
        pageIndex = append ? (Number(currentPage) || 1) + 1 : 1
      }
      return {
        force: force === true || source.force === true || append,
        append,
        pageIndex: Math.max(1, Math.floor(pageIndex)),
        skipGlobalErrorMessage: source.skipGlobalErrorMessage
      }
    },
    extractCloudListTotalCount(payload, depth = 0) {
      if (!payload || typeof payload != 'object' || depth > 4) {
        return 0
      }
      const keys = ['total', 'totalCount', 'count', 'totalSize', 'totalElements', 'totalRecords', 'recordCount', 'allCount', 'dataTotal']
      for (let i = 0; i < keys.length; i++) {
        const value = Number(payload[keys[i]])
        if (Number.isFinite(value) && value >= 0) {
          return Math.floor(value)
        }
      }
      const values = Object.keys(payload).map(key => payload[key])
      for (let i = 0; i < values.length; i++) {
        const total = this.extractCloudListTotalCount(values[i], depth + 1)
        if (total > 0) {
          return total
        }
      }
      return 0
    },
    mergeCloudListItems(currentItems, nextItems) {
      const merged = Array.isArray(currentItems) ? currentItems.slice() : []
      const seen = new Set(merged.map(item => item && item.id).filter(Boolean))
      ;(Array.isArray(nextItems) ? nextItems : []).forEach(item => {
        const id = item && item.id
        if (id && seen.has(id)) {
          return
        }
        if (id) {
          seen.add(id)
        }
        merged.push(item)
      })
      return merged
    },
    applyRecentListPage(payload, nextItems, options) {
      const list = Array.isArray(nextItems) ? nextItems : []
      const total = this.extractCloudListTotalCount(payload)
      this.recentPageIndex = options.pageIndex
      this.recentLastPageSize = list.length
      this.recentTotalCount = total
      this.recentItems = options.append ? this.mergeCloudListItems(this.recentItems, list) : list
      this.recentReachedEnd = total > 0
        ? options.pageIndex >= this.getCloudListPageCount(total, this.recentPageSize, options.pageIndex) || list.length < this.recentPageSize
        : list.length < this.recentPageSize
    },
    applyGlobalSearchPage(payload, nextItems, options) {
      const list = Array.isArray(nextItems) ? nextItems : []
      const total = this.extractCloudListTotalCount(payload)
      this.globalSearchPageIndex = options.pageIndex
      this.globalSearchLastPageSize = list.length
      this.globalSearchTotalCount = total
      this.globalSearchItems = options.append ? this.mergeCloudListItems(this.globalSearchItems, list) : list
      this.globalSearchReachedEnd = total > 0
        ? options.pageIndex >= this.getCloudListPageCount(total, this.globalSearchPageSize, options.pageIndex) || list.length < this.globalSearchPageSize
        : list.length < this.globalSearchPageSize
    },
    resetRecentPagination() {
      this.recentPageIndex = 1
      this.recentTotalCount = 0
      this.recentLastPageSize = 0
      this.recentReachedEnd = false
      this.recentAppendLoading = false
    },
    resetGlobalSearchPagination() {
      this.globalSearchPageIndex = 1
      this.globalSearchTotalCount = 0
      this.globalSearchLastPageSize = 0
      this.globalSearchReachedEnd = false
      this.globalSearchAppendLoading = false
    },
    handleRecentPageChange(page) {
      const targetPage = Math.max(1, Math.floor(Number(page) || 1))
      if (this.recentListLoading || targetPage == this.recentPageIndex) {
        return
      }
      const append = targetPage == this.recentPageIndex + 1
      this.loadRecentHistory(true, { pageIndex: targetPage, append })
      if (!append) {
        this.scrollCloudContentToTop()
      }
    },
    handleGlobalSearchPageChange(page) {
      const targetPage = Math.max(1, Math.floor(Number(page) || 1))
      if (this.globalSearchLoading || targetPage == this.globalSearchPageIndex) {
        return
      }
      const append = targetPage == this.globalSearchPageIndex + 1
      this.loadGlobalSearch(true, { pageIndex: targetPage, append })
      if (!append) {
        this.scrollCloudContentToTop()
      }
    },
    handleCloudContentScroll(event) {
      const target = event && event.target ? event.target : this.$refs.cloudContentArea
      if (!target) {
        return
      }
      const distance = target.scrollHeight - target.scrollTop - target.clientHeight
      if (distance > 80) {
        return
      }
      if (this.globalSearchOpen) {
        if (this.globalSearchKeyword && this.hasNextGlobalSearchPage && !this.globalSearchLoading && !this.globalSearchAppendLoading) {
          this.loadGlobalSearch(true, { pageIndex: this.globalSearchPageIndex + 1, append: true })
        }
        return
      }
      if (this.activeMenu == 'recent' && this.hasNextRecentPage && !this.recentListLoading && !this.recentAppendLoading) {
        this.loadRecentHistory(true, { pageIndex: this.recentPageIndex + 1, append: true })
      }
    },
    handleCloudPullRefreshStart(event) {
      if (this.globalSearchOpen) {
        this.handleGlobalSearchPullRefreshStart(event)
        return
      }
      this.handleRecentPullRefreshStart(event)
    },
    handleCloudPullRefreshMove(event) {
      if (this.globalSearchOpen || this.globalSearchPullTouchState) {
        this.handleGlobalSearchPullRefreshMove(event)
        return
      }
      this.handleRecentPullRefreshMove(event)
    },
    handleCloudPullRefreshEnd() {
      if (this.globalSearchOpen || this.globalSearchPullTouchState) {
        this.handleGlobalSearchPullRefreshEnd()
        return
      }
      this.handleRecentPullRefreshEnd()
    },
    cancelCloudPullRefreshGesture() {
      if (this.globalSearchOpen || this.globalSearchPullTouchState) {
        this.cancelGlobalSearchPullRefreshGesture()
        return
      }
      this.cancelRecentPullRefreshGesture()
    },
    canStartGlobalSearchPullRefresh(event, target) {
      const area = this.$refs.cloudContentArea
      const keyword = String(this.globalSearchKeyword || '').trim()
      return !!(
        area
        && target
        && area.contains(target)
        && area.scrollTop <= 0
        && this.cloudStatus == 1
        && this.globalSearchOpen
        && keyword
        && !this.loading
        && !this.cloudStatusLoading
        && !this.globalSearchLoading
        && !this.globalSearchAppendLoading
        && !this.globalSearchPullRefreshing
        && !this.recentPullRefreshing
        && !this.hasActiveModal
        && !this.recentPasswordModalOpen
        && !this.recentDownloadFormatModalOpen
        && !this.paperDownloadFormatModalOpen
        && !this.recentLearningModalOpen
        && !this.userMenuVisible
        && !this.globalSearchTypeMenuOpen
        && !this.globalSearchViewSheetOpen
        && !this.globalSearchActionTargetId
        && !this.globalSearchMoreMenuId
        && !target.closest('input, textarea, select, button, [contenteditable="true"]')
        && event.touches
        && event.touches.length == 1
      )
    },
    handleGlobalSearchPullRefreshStart(event) {
      const target = event && event.target
        ? (event.target.nodeType == 1 ? event.target : event.target.parentElement)
        : null
      if (!this.canStartGlobalSearchPullRefresh(event, target)) {
        this.cancelGlobalSearchPullRefreshGesture()
        return
      }
      const touch = event.touches[0]
      this.globalSearchPullTouchState = {
        startX: touch.clientX,
        startY: touch.clientY,
        startTime: Date.now(),
        direction: '',
        committed: false,
        gestureType: 'pending'
      }
    },
    handleGlobalSearchPullRefreshMove(event) {
      const state = this.globalSearchPullTouchState
      const area = this.$refs.cloudContentArea
      if (!state || !area) {
        return
      }
      if (event.defaultPrevented) {
        this.cancelGlobalSearchPullRefreshGesture()
        return
      }
      if (!event.touches || event.touches.length != 1) {
        this.cancelGlobalSearchPullRefreshGesture()
        return
      }
      const touch = event.touches[0]
      const deltaX = touch.clientX - state.startX
      const deltaY = touch.clientY - state.startY
      const absX = Math.abs(deltaX)
      const absY = Math.abs(deltaY)
      if (state.committed) {
        if (event.cancelable) {
          event.preventDefault()
        }
        return
      }
      const gestureType = classifyMobileTouchGesture(state, touch, {
        moveTolerance: CLOUD_PULL_DIRECTION_THRESHOLD,
        verticalRatio: CLOUD_PULL_VERTICAL_RATIO,
        pullDistance: CLOUD_PULL_COMMIT_DISTANCE
      })
      if (gestureType == 'pending') {
        return
      }
      state.gestureType = gestureType
      if (typeof this.clearGlobalSearchTouchTimer == 'function') {
        this.clearGlobalSearchTouchTimer()
      }
      if (gestureType == 'selection' || gestureType == 'scroll' || area.scrollTop > 0) {
        this.globalSearchPullRefreshDistance = 0
        if (gestureType == 'selection') {
          this.cancelGlobalSearchPullRefreshGesture()
        }
        return
      }
      if (gestureType != 'pull-refresh' || deltaY <= 0 || absY <= absX * CLOUD_PULL_VERTICAL_RATIO) {
        this.globalSearchPullRefreshDistance = 0
        return
      }
      this.globalSearchPullRefreshDistance = 0
      this.cloudPullRefreshClickBlockedUntil = Date.now() + 500
      if (event.cancelable) {
        event.preventDefault()
      }
      if (deltaY < CLOUD_PULL_COMMIT_DISTANCE) {
        return
      }
      const target = event && event.target
        ? (event.target.nodeType == 1 ? event.target : event.target.parentElement)
        : null
      if (!this.canStartGlobalSearchPullRefresh(event, target)) {
        this.cancelGlobalSearchPullRefreshGesture()
        return
      }
      state.committed = true
      this.startGlobalSearchPullRefresh()
    },
    handleGlobalSearchPullRefreshEnd() {
      this.cancelGlobalSearchPullRefreshGesture()
    },
    startGlobalSearchPullRefresh() {
      if (this.globalSearchPullRefreshing) {
        return
      }
      this.clearGlobalSearchPullRefreshResetTimer()
      const refreshId = this.globalSearchPullRefreshRequestSeq + 1
      this.globalSearchPullRefreshRequestSeq = refreshId
      const startedAt = Date.now()
      let refreshTask
      this.globalSearchPullRefreshing = true
      this.globalSearchPullRefreshDistance = 0
      try {
        refreshTask = this.loadGlobalSearch(true, { pageIndex: 1, force: true })
      } catch (error) {
        refreshTask = Promise.reject(error)
      }
      this.finishCloudPullRefreshTask({
        refreshTask,
        refreshId,
        startedAt,
        requestSeqKey: 'globalSearchPullRefreshRequestSeq',
        resetTimerKey: 'globalSearchPullRefreshResetTimer',
        resetMethod: 'resetGlobalSearchPullRefreshState'
      })
    },
    cancelGlobalSearchPullRefreshGesture() {
      this.globalSearchPullTouchState = null
      this.globalSearchPullRefreshDistance = 0
    },
    clearGlobalSearchPullRefreshResetTimer() {
      if (this.globalSearchPullRefreshResetTimer) {
        clearTimeout(this.globalSearchPullRefreshResetTimer)
        this.globalSearchPullRefreshResetTimer = null
      }
    },
    resetGlobalSearchPullRefreshState() {
      this.clearGlobalSearchPullRefreshResetTimer()
      this.globalSearchPullRefreshRequestSeq += 1
      this.globalSearchPullTouchState = null
      this.globalSearchPullRefreshDistance = 0
      this.globalSearchPullRefreshing = false
    },
    canStartRecentPullRefresh(event, target) {
      const area = this.$refs.cloudContentArea
      return !!(
        area
        && target
        && area.contains(target)
        && area.scrollTop <= 0
        && this.cloudStatus == 1
        && !this.globalSearchOpen
        && (this.activeMenu == 'recent' || this.activeMenu == 'files')
        && !this.interactionLocked
        && !this.recentAppendLoading
        && !this.recentPullRefreshing
        && !this.hasActiveModal
        && !this.userMenuVisible
        && !this.recentViewSheetOpen
        && !this.recentActionSheetOpen
        && (!target.closest('input, textarea, select, button, [contenteditable="true"]') || (this.activeMenu == 'files' && !!target.closest('.folder-card, .folder-row')))
        && event.touches
        && event.touches.length == 1
      )
    },
    handleRecentPullRefreshStart(event) {
      const target = event && event.target
        ? (event.target.nodeType == 1 ? event.target : event.target.parentElement)
        : null
      if (!this.canStartRecentPullRefresh(event, target)) {
        this.cancelRecentPullRefreshGesture()
        return
      }
      const touch = event.touches[0]
      this.recentPullTouchState = {
        startX: touch.clientX,
        startY: touch.clientY,
        startTime: Date.now(),
        direction: '',
        committed: false,
        gestureType: 'pending'
      }
    },
    handleRecentPullRefreshMove(event) {
      const state = this.recentPullTouchState
      const area = this.$refs.cloudContentArea
      if (!state || !area) {
        return
      }
      if (event.defaultPrevented) {
        this.cancelRecentPullRefreshGesture()
        return
      }
      if (!event.touches || event.touches.length != 1) {
        this.cancelRecentPullRefreshGesture()
        return
      }
      const touch = event.touches[0]
      const deltaX = touch.clientX - state.startX
      const deltaY = touch.clientY - state.startY
      const absX = Math.abs(deltaX)
      const absY = Math.abs(deltaY)
      if (state.committed) {
        if (event.cancelable) {
          event.preventDefault()
        }
        return
      }
      const gestureType = classifyMobileTouchGesture(state, touch, {
        moveTolerance: CLOUD_PULL_DIRECTION_THRESHOLD,
        verticalRatio: CLOUD_PULL_VERTICAL_RATIO,
        pullDistance: CLOUD_PULL_COMMIT_DISTANCE
      })
      if (gestureType == 'pending') {
        return
      }
      state.gestureType = gestureType
      if (typeof this.clearRecentTouchTimer == 'function') {
        this.clearRecentTouchTimer()
      }
      if (gestureType == 'selection' || gestureType == 'scroll' || area.scrollTop > 0) {
        this.recentPullRefreshDistance = 0
        if (gestureType == 'selection') {
          this.cancelRecentPullRefreshGesture()
        }
        return
      }
      if (gestureType != 'pull-refresh' || deltaY <= 0 || absY <= absX * CLOUD_PULL_VERTICAL_RATIO) {
        this.recentPullRefreshDistance = 0
        return
      }
      this.recentPullRefreshDistance = 0
      this.cloudPullRefreshClickBlockedUntil = Date.now() + 500
      if (event.cancelable) {
        event.preventDefault()
      }
      if (deltaY < CLOUD_PULL_COMMIT_DISTANCE) {
        return
      }
      const target = event && event.target
        ? (event.target.nodeType == 1 ? event.target : event.target.parentElement)
        : null
      if (!this.canStartRecentPullRefresh(event, target)) {
        this.cancelRecentPullRefreshGesture()
        return
      }
      state.committed = true
      this.startRecentPullRefresh()
    },
    handleCloudPullRefreshClickCapture(event) {
      if (Date.now() > this.cloudPullRefreshClickBlockedUntil) {
        return
      }
      event.preventDefault()
      event.stopPropagation()
    },
    handleRecentPullRefreshEnd() {
      this.cancelRecentPullRefreshGesture()
    },
    startRecentPullRefresh() {
      if (this.recentPullRefreshing) {
        return
      }
      this.clearRecentPullRefreshResetTimer()
      const refreshId = this.recentPullRefreshRequestSeq + 1
      this.recentPullRefreshRequestSeq = refreshId
      const startedAt = Date.now()
      let refreshTask
      this.recentPullRefreshing = true
      this.recentPullRefreshDistance = 0
      try {
        refreshTask = this.activeMenu == 'files'
          ? this.loadRootFolders(true, { skipGlobalErrorMessage: true })
          : this.loadRecentHistory(true, { pageIndex: 1, force: true })
      } catch (error) {
        refreshTask = Promise.reject(error)
      }
      this.finishCloudPullRefreshTask({
        refreshTask,
        refreshId,
        startedAt,
        requestSeqKey: 'recentPullRefreshRequestSeq',
        resetTimerKey: 'recentPullRefreshResetTimer',
        resetMethod: 'resetRecentPullRefreshState'
      })
    },
    cancelRecentPullRefreshGesture() {
      this.recentPullTouchState = null
      this.recentPullRefreshDistance = 0
    },
    clearRecentPullRefreshResetTimer() {
      if (this.recentPullRefreshResetTimer) {
        clearTimeout(this.recentPullRefreshResetTimer)
        this.recentPullRefreshResetTimer = null
      }
    },
    resetRecentPullRefreshState() {
      this.clearRecentPullRefreshResetTimer()
      this.recentPullRefreshRequestSeq += 1
      this.recentPullTouchState = null
      this.recentPullRefreshDistance = 0
      this.recentPullRefreshing = false
    },
    finishCloudPullRefreshTask({ refreshTask, refreshId, startedAt, requestSeqKey, resetTimerKey, resetMethod }) {
      Promise.resolve(refreshTask).catch(() => {}).finally(() => {
        if (this._isBeingDestroyed || this._isDestroyed || this[requestSeqKey] != refreshId) {
          return
        }
        const elapsed = Date.now() - startedAt
        const delay = Math.max(0, CLOUD_PULL_MIN_VISIBLE_DURATION - elapsed)
        this[resetTimerKey] = window.setTimeout(() => {
          this[resetTimerKey] = null
          if (this[requestSeqKey] == refreshId && typeof this[resetMethod] == 'function') {
            this[resetMethod]()
          }
        }, delay)
      })
    },
    setWapPageLoading(visible) {
      if (typeof window === 'undefined') {
        return
      }
      const nextVisible = !!visible
      window.__viwoodsWapPageLoading = nextVisible
      window.dispatchEvent(new CustomEvent('viwoods-wap-page-loading', {
        detail: { visible: nextVisible }
      }))
    },
    scrollCloudContentToTop() {
      this.$nextTick(() => {
        const target = this.$refs.cloudContentArea
        if (target) {
          target.scrollTop = 0
        }
      })
    },
    normalizeMobilePreviewReturnContext(context) {
      if (context == 'search') {
        return 'search'
      }
      return this.normalizeMenuKey(context) == 'recent' ? 'recent' : 'files'
    },
    captureMobilePreviewReturnScroll(context) {
      const area = this.$refs.cloudContentArea
      if (!area) {
        return
      }
      const key = this.normalizeMobilePreviewReturnContext(context)
      this.mobilePreviewReturnScrollSeq += 1
      this.mobilePreviewReturnScrollTops[key] = Math.max(0, Number(area.scrollTop) || 0)
    },
    hasMobilePreviewReturnScroll(context) {
      const key = this.normalizeMobilePreviewReturnContext(context)
      const scrollTop = this.mobilePreviewReturnScrollTops[key]
      return scrollTop !== null && scrollTop !== undefined
    },
    isMobilePreviewReturnContextActive(context) {
      if (this.activeAppFolder || this.settingModalVisible) {
        return false
      }
      if (context == 'search') {
        return this.globalSearchOpen
      }
      return !this.globalSearchOpen && this.normalizeMenuKey(this.activeMenu) == context
    },
    restoreMobilePreviewReturnScroll(context) {
      const key = this.normalizeMobilePreviewReturnContext(context)
      const scrollTop = this.mobilePreviewReturnScrollTops[key]
      if (scrollTop === null || scrollTop === undefined || !this.isMobilePreviewReturnContextActive(key)) {
        return
      }
      const restoreSeq = this.mobilePreviewReturnScrollSeq + 1
      this.mobilePreviewReturnScrollSeq = restoreSeq
      const applyScroll = () => {
        if (restoreSeq != this.mobilePreviewReturnScrollSeq || !this.isMobilePreviewReturnContextActive(key)) {
          return
        }
        const area = this.$refs.cloudContentArea
        if (area) {
          area.scrollTop = scrollTop
          this.mobilePreviewReturnScrollTops[key] = null
        }
      }
      this.$nextTick(() => {
        applyScroll()
        if (this.hasMobilePreviewReturnScroll(key) && typeof window != 'undefined' && typeof window.requestAnimationFrame == 'function') {
          window.requestAnimationFrame(() => {
            applyScroll()
            if (this.hasMobilePreviewReturnScroll(key)) {
              window.requestAnimationFrame(applyScroll)
            }
          })
        }
      })
    },
    clearMobilePreviewReturnScroll(context = '') {
      this.mobilePreviewReturnScrollSeq += 1
      if (context) {
        const key = this.normalizeMobilePreviewReturnContext(context)
        this.mobilePreviewReturnScrollTops[key] = null
        return
      }
      this.mobilePreviewReturnScrollTops.recent = null
      this.mobilePreviewReturnScrollTops.search = null
      this.mobilePreviewReturnScrollTops.files = null
    },
    scrollActiveMobilePageToTop() {
      this.$nextTick(() => {
        let target = null
        if (this.settingModalVisible) {
          target = this.$refs.mobileUserCenterScroll
        } else if (this.activeAppFolder) {
          const sync = this.$refs.activeAppSync
          if (sync) {
            target = typeof sync.getMobilePullRefreshScrollTarget == 'function'
              ? sync.getMobilePullRefreshScrollTarget()
              : (sync.$refs.mobilePullRefreshArea || sync.$refs.paperListArea)
          }
        } else {
          target = this.$refs.cloudContentArea
        }
        const area = Array.isArray(target) ? target[0] : target
        if (area) {
          area.scrollTop = 0
        }
      })
    },
    scrollNewMobilePageToTop() {
      this.$nextTick(() => {
        this.scrollActiveMobilePageToTop()
      })
    },
    refreshSession() {
      this.loading = true
      return refreshLogin({ uri: '' }).then(ret => {
        if (ret.data.code == 200) {
          setToken(ret.data.data.token)
          return this.loadCloudProfile()
        }
        this.redirectToLogin()
      }).catch(error => {
        if (isNetworkError(error)) {
          this.loading = false
          return
        }
        this.redirectToLogin()
      }).finally(() => {
        this.setWapPageLoading(false)
      })
    },
    loadCloudProfile(options = {}) {
      this.loading = true
      const requestConfig = {
        skipGlobalErrorMessage: options.skipGlobalErrorMessage === undefined ? false : options.skipGlobalErrorMessage
      }
      return getTimeId({}, requestConfig).then(ret => {
        if (ret.data.code == 200) {
          const data = ret.data.data || {}
          this.username = data.username || ''
          this.email = data.email || ''
          this.areaCode = data.areaCode || ''
          this.phone = data.phone || ''
          const status = Number(data.cloudStatus)
          this.cloudStatus = status == 1 ? 1 : 0
          this.applyCloudStatus()
          this.loading = false
        }
        if (this.cloudStatus == 1) {
          if (this.globalSearchOpen) {
            return this.globalSearchKeyword
              ? this.loadGlobalSearch(true, requestConfig)
              : Promise.resolve([])
          }
          if (this.activeAppFolder) {
            return Promise.resolve([])
          }
          return this.activeMenu == 'recent'
            ? this.loadRecentHistory(true, requestConfig)
            : this.loadRootFolders(true, requestConfig)
        }
        this.cloudItems = []
        this.recentItems = []
        return Promise.resolve([])
      }).catch(() => {
        this.cloudStatus = 0
        this.applyCloudStatus()
        this.cloudItems = []
        this.recentItems = []
        return Promise.resolve([])
      }).finally(() => {
        this.loading = false
      })
    },
    applyCloudStatus() {
      if (this.cloudStatus == 0) {
        this.clearPendingAppRefreshState()
        this.activeMenu = 'recent'
        this.activeAppFolder = ''
        this.activeAppFolderAppType = null
        this.activeAppReturnMenu = 'recent'
        this.searchOpen = false
        this.searchKeyword = ''
        this.closeMyFileViewSheet()
        this.closeGlobalSearchPage(true)
        return
      }
      if (this.restoreCloudHomeState()) {
        return
      }
      this.activeMenu = 'recent'
      this.activeAppReturnMenu = 'recent'
      this.applySharedViewMode(getMobileCloudViewMode('list'))
    },
    loadRootFolders(force, options = {}) {
      if (this.cloudStatus != 1) {
        this.cloudItems = []
        this.rootFolderLoaded = false
        return Promise.resolve([])
      }
      if (this.rootFolderLoading || (this.rootFolderLoaded && !force)) {
        return Promise.resolve(this.cloudItems)
      }
      this.rootFolderLoading = true
      return getRootFolder({}, {
        skipGlobalErrorMessage: options.skipGlobalErrorMessage
      }).then(ret => {
        if (ret.data.code == 200) {
          this.cloudItems = this.normalizeRootFolders(ret.data.data)
          this.rootFolderLoaded = true
        } else {
          this.cloudItems = this.mergeDefaultRootFolders([])
          this.$message.error(ret.data.msg || ret.data.message)
        }
        return this.cloudItems
      }).catch(() => {
        this.cloudItems = this.mergeDefaultRootFolders([])
        return this.cloudItems
      }).finally(() => {
        this.rootFolderLoading = false
      })
    },
    loadRecentHistory(force, options = {}) {
      const pageOptions = this.normalizeCloudListLoadOptions(force, options, this.recentPageIndex)
      if (this.cloudStatus != 1) {
        this.recentItems = []
        this.recentListLoaded = false
        this.resetRecentPagination()
        return Promise.resolve([])
      }
      if (this.recentListLoading || this.recentAppendLoading || (this.recentListLoaded && !pageOptions.force && !pageOptions.append)) {
        return Promise.resolve(this.recentItems)
      }
      this.recentListLoading = !pageOptions.append
      this.recentAppendLoading = pageOptions.append
      return getHistoryPage({
        pageIndex: pageOptions.pageIndex,
        pageSize: this.recentPageSize,
        appType: -1
      }, {
        skipGlobalErrorMessage: pageOptions.skipGlobalErrorMessage
      }).then(ret => {
        const payload = this.resolveHistoryPayload(ret)
        if (payload === null) {
          if (!pageOptions.append) {
            this.recentItems = []
            this.resetRecentPagination()
          }
          this.$message.error(ret && ret.data ? (ret.data.msg || ret.data.message) : '')
          return this.recentItems
        }
        this.applyRecentListPage(payload, this.normalizeRecentItems(payload), pageOptions)
        this.recentListLoaded = true
        this.syncRecentSelectionWithItems()
        this.updateRecentGridColumnCount()
        return this.recentItems
      }).catch(() => {
        if (!pageOptions.append) {
          this.recentItems = []
          this.resetRecentPagination()
        }
        return this.recentItems
      }).finally(() => {
        this.recentListLoading = false
        this.recentAppendLoading = false
      })
    },
    openGlobalSearchPage(initialKeyword = '') {
      if (this.cloudStatus == 0) {
        return
      }
      const returnContext = this.resolveGlobalSearchReturnContext()
      const defaultSearchAppType = this.resolveGlobalSearchDefaultAppType()
      if (returnContext && !returnContext.folderType && this.$refs.cloudContentArea) {
        returnContext.scrollTop = this.$refs.cloudContentArea.scrollTop
      }
      this.closeUserMenu()
      this.closeMyFileViewSheet()
      this.cancelGlobalSearchTouch()
      this.resetGlobalSearchPullRefreshState()
      this.closeGlobalSearchViewSheet()
      this.closeGlobalSearchItemActions()
      this.globalSearchDoubleOpenState = null
      this.clearGlobalSearchSelection()
      this.closeGlobalSearchMoreMenu()
      this.activeAppFolder = ''
      this.activeAppFolderAppType = null
      this.activeAppReturnMenu = 'search'
      this.globalSearchFilePreviewMode = false
      this.globalSearchLearningPreviewMode = false
      this.globalSearchReturnContext = returnContext
      this.pendingRecentOpenItem = null
      this.pendingRecentOpenOptions = null
      this.searchOpen = false
      this.searchKeyword = ''
      this.globalSearchOpen = true
      this.globalSearchTypeMenuOpen = false
      this.globalSearchAppType = defaultSearchAppType
      this.globalSearchLoaded = false
      this.globalSearchItems = []
      this.resetGlobalSearchPagination()
      this.globalSearchKeyword = String(initialKeyword || '').trim()
      if (this.globalSearchKeyword) {
        this.loadGlobalSearch(true)
      }
      this.scrollNewMobilePageToTop()
      this.$nextTick(() => {
        if (this.$refs.globalSearchInput) {
          try {
            this.$refs.globalSearchInput.focus({ preventScroll: true })
          } catch (error) {
            this.$refs.globalSearchInput.focus()
          }
        }
      })
    },
    handleGlobalSearchBack() {
      const returnContext = this.globalSearchReturnContext
      this.closeGlobalSearchPage(true)
      if (this.restoreGlobalSearchReturn(returnContext)) {
        return
      }
      this.globalSearchReturnContext = null
      this.activeMenu = 'files'
      this.activeAppReturnMenu = 'files'
      if (this.cloudStatus == 1) {
        this.loadRootFolders()
      }
      this.scrollNewMobilePageToTop()
    },
    resolveGlobalSearchReturnContext() {
      if (this.activeAppReturnMenu == 'search' && this.globalSearchReturnContext) {
        return this.cloneGlobalSearchReturnContext(this.globalSearchReturnContext)
      }
      return this.buildGlobalSearchReturnContext()
    },
    resolveGlobalSearchDefaultAppType() {
      if (!this.activeAppFolder || !this.isSupportedAppFolderType(this.activeAppFolder)) {
        return -1
      }
      const activeAppType = Number(this.activeAppFolderAppType)
      if (Number.isFinite(activeAppType) && activeAppType > 0) {
        return activeAppType
      }
      const defaultAppType = Number(this.resolveDefaultAppTypeByFolderType(this.activeAppFolder))
      return Number.isFinite(defaultAppType) && defaultAppType > 0 ? defaultAppType : -1
    },
    buildGlobalSearchReturnContext() {
      const folderType = this.activeAppFolder
      if (!this.isSupportedAppFolderType(folderType)) {
        const sourceMenu = this.userMenuVisible
          ? 'mine'
          : this.normalizeGlobalSearchSourceMenu(this.activeMenu)
        const activeMenu = sourceMenu == 'mine'
          ? this.normalizeMenuKey(this.activeAppReturnMenu || 'files')
          : this.normalizeMenuKey(sourceMenu)
        return {
          folderType: '',
          sourceMenu,
          activeMenu,
          activeAppReturnMenu: activeMenu,
          appType: null,
          refreshState: null
        }
      }
      const refreshState = this.getActiveAppRefreshState()
      return {
        folderType,
        activeMenu: this.activeMenu,
        activeAppReturnMenu: this.activeAppReturnMenu,
        appType: this.activeAppFolderAppType || this.resolveDefaultAppTypeByFolderType(folderType),
        refreshState
      }
    },
    normalizeGlobalSearchSourceMenu(value) {
      const sourceMenu = String(value || '').trim().toLowerCase()
      return ['recent', 'files', 'daily', 'mine'].includes(sourceMenu) ? sourceMenu : 'files'
    },
    getActiveAppRefreshState() {
      const sync = this.$refs.activeAppSync
      if (!sync || typeof sync.getRefreshState != 'function') {
        return null
      }
      const state = sync.getRefreshState()
      return this.cloneGlobalSearchRefreshState(state)
    },
    cloneGlobalSearchReturnContext(returnContext) {
      if (!returnContext || typeof returnContext != 'object') {
        return null
      }
      const cloned = Object.assign({}, returnContext)
      if ('scrollTop' in cloned) {
        cloned.scrollTop = Math.max(0, Number(cloned.scrollTop) || 0)
      }
      cloned.refreshState = this.cloneGlobalSearchRefreshState(returnContext.refreshState)
      return cloned
    },
    cloneGlobalSearchRefreshState(state) {
      if (!state || typeof state != 'object') {
        return null
      }
      const cloned = Object.assign({}, state)
      if (Array.isArray(state.paperFolderPath)) {
        cloned.paperFolderPath = state.paperFolderPath.map(item => {
          return item && typeof item == 'object' ? Object.assign({}, item) : item
        }).filter(Boolean)
      }
      return cloned
    },
    restoreGlobalSearchReturn(returnContext) {
      if (!returnContext) {
        return false
      }
      if (!this.isSupportedAppFolderType(returnContext.folderType)) {
        const sourceMenu = this.normalizeGlobalSearchSourceMenu(returnContext.sourceMenu || returnContext.activeMenu)
        const menuKey = sourceMenu == 'mine'
          ? this.normalizeMenuKey(returnContext.activeMenu || returnContext.activeAppReturnMenu || 'files')
          : this.normalizeMenuKey(sourceMenu)
        this.globalSearchReturnContext = null
        this.activeMenu = menuKey
        this.activeAppReturnMenu = menuKey
        this.activeAppFolder = ''
        this.activeAppFolderAppType = null
        this.dailyInitialActiveTab = 'todo'
        this.userMenuVisible = false
        if (this.cloudStatus == 1) {
          if (menuKey == 'recent') {
            this.loadRecentHistory()
          } else {
            this.loadRootFolders()
          }
        }
        if (sourceMenu == 'mine') {
          this.$nextTick(() => {
            if (!this.globalSearchOpen && !this.activeAppFolder) {
              this.userMenuVisible = true
            }
          })
        }
        this.$nextTick(() => {
          const area = this.$refs.cloudContentArea
          if (area && !this.globalSearchOpen && !this.activeAppFolder) {
            area.scrollTop = Math.max(0, Number(returnContext.scrollTop) || 0)
          }
        })
        return true
      }
      const folderType = returnContext.folderType
      const refreshState = this.cloneGlobalSearchRefreshState(returnContext.refreshState)
      this.globalSearchReturnContext = null
      this.pendingAppRefreshStateAppKey = refreshState ? folderType : ''
      this.pendingAppRefreshState = refreshState
      this.dailyInitialActiveTab = folderType == 'daily'
        ? this.normalizeDailyActiveTab(refreshState && refreshState.dailyActiveTab)
        : 'todo'
      this.activeMenu = this.resolveMenuKeyForFolderType(folderType, returnContext.activeMenu || returnContext.activeAppReturnMenu || 'files')
      this.activeAppReturnMenu = returnContext.activeAppReturnMenu == 'search'
        ? 'search'
        : this.resolveMenuKeyForFolderType(folderType, returnContext.activeAppReturnMenu || returnContext.activeMenu || 'files')
      this.activeAppFolderAppType = returnContext.appType || this.resolveDefaultAppTypeByFolderType(folderType)
      this.activeAppFolder = folderType
      this.$nextTick(() => {
        if (this.pendingAppRefreshStateAppKey == folderType) {
          this.clearPendingAppRefreshState()
        }
      })
      return true
    },
    getActiveDailyTab() {
      const sync = this.$refs.activeAppSync
      return this.normalizeDailyActiveTab(sync && sync.dailyActiveTab)
    },
    normalizeDailyActiveTab(tab) {
      return ['todo', 'tasks', 'notes'].includes(tab) ? tab : 'todo'
    },
    closeGlobalSearchPage(clearKeyword = true) {
      this.clearGlobalSearchRequestTimer()
      this.clearGlobalSearchItemClickTimer()
      this.cancelGlobalSearchTouch()
      this.resetGlobalSearchPullRefreshState()
      this.stopGlobalSearchSelectionBarDrag()
      this.globalSearchRequestSeq += 1
      this.globalSearchLoading = false
      this.globalSearchAppendLoading = false
      this.globalSearchOpen = false
      this.globalSearchFilePreviewMode = false
      this.globalSearchLearningPreviewMode = false
      this.globalSearchTypeMenuOpen = false
      this.closeGlobalSearchViewSheet()
      this.closeMyFileViewSheet()
      this.closeGlobalSearchItemActions()
      this.closeGlobalSearchMoreMenu()
      this.clearGlobalSearchSelection()
      this.globalSearchDoubleOpenState = null
      if (clearKeyword) {
        this.globalSearchKeyword = ''
        this.globalSearchItems = []
        this.globalSearchLoaded = false
        this.resetGlobalSearchPagination()
        this.globalSearchAppType = -1
      }
    },
    clearGlobalSearchKeyword() {
      this.clearGlobalSearchRequestTimer()
      this.clearGlobalSearchItemClickTimer()
      this.cancelGlobalSearchTouch()
      this.resetGlobalSearchPullRefreshState()
      this.globalSearchRequestSeq += 1
      this.globalSearchLoading = false
      this.globalSearchAppendLoading = false
      this.globalSearchFilePreviewMode = false
      this.globalSearchLearningPreviewMode = false
      this.globalSearchComposing = false
      this.globalSearchKeyword = ''
      this.globalSearchItems = []
      this.globalSearchLoaded = false
      this.resetGlobalSearchPagination()
      this.globalSearchTypeMenuOpen = false
      this.closeGlobalSearchViewSheet()
      this.closeGlobalSearchItemActions()
      this.clearGlobalSearchSelection()
      this.closeGlobalSearchMoreMenu()
      this.globalSearchDoubleOpenState = null
      this.$nextTick(() => {
        if (this.$refs.globalSearchInput) {
          this.$refs.globalSearchInput.focus()
        }
      })
    },
    handleGlobalSearchInput(event) {
      const target = event && event.target ? event.target : null
      const value = target ? String(target.value || '') : String(this.globalSearchKeyword || '')
      if (this.globalSearchKeyword !== value) {
        this.globalSearchKeyword = value
      }
      this.clearGlobalSearchRequestTimer()
      if (this.globalSearchComposing) {
        return
      }
      this.resetGlobalSearchResults()
      this.queueGlobalSearch()
    },
    handleGlobalSearchInputBlur(event) {
      if (this.shouldIgnoreGlobalSearchInputBlur(event)) {
        return
      }
      this.triggerGlobalSearch(true, event)
    },
    markGlobalSearchBlurIgnored() {
      this.globalSearchIgnoreBlurUntil = Date.now() + 400
    },
    shouldIgnoreGlobalSearchInputBlur(event) {
      if (this.globalSearchResultPointerDown) {
        return true
      }
      const ignoreBlurUntil = Number(this.globalSearchIgnoreBlurUntil) || 0
      if (ignoreBlurUntil > 0) {
        this.globalSearchIgnoreBlurUntil = 0
        if (Date.now() <= ignoreBlurUntil) {
          return true
        }
      }
      const nextTarget = event && event.relatedTarget ? event.relatedTarget : null
      return this.isGlobalSearchResultElement(nextTarget) || this.isGlobalSearchFilterElement(nextTarget)
    },
    isGlobalSearchResultElement(target) {
      return !!(target && target.closest && target.closest('.global-search-card, .global-search-row'))
    },
    isGlobalSearchFilterElement(target) {
      return !!(target && target.closest && target.closest('.global-search-filter'))
    },
    handleGlobalSearchResultPointerDown() {
      this.globalSearchResultPointerDown = true
      if (typeof window === 'undefined') {
        this.globalSearchResultPointerDown = false
        return
      }
      window.setTimeout(() => {
        this.globalSearchResultPointerDown = false
      }, 100)
    },
    handleGlobalSearchCompositionStart() {
      this.globalSearchComposing = true
    },
    handleGlobalSearchCompositionEnd(event) {
      this.globalSearchComposing = false
      this.handleGlobalSearchInput(event)
    },
    resetGlobalSearchResults() {
      this.clearGlobalSearchItemClickTimer()
      this.cancelGlobalSearchTouch()
      this.resetGlobalSearchPullRefreshState()
      this.globalSearchRequestSeq += 1
      this.globalSearchItems = []
      this.resetGlobalSearchPagination()
      this.globalSearchLoaded = false
      this.globalSearchLoading = false
      this.globalSearchAppendLoading = false
      this.closeGlobalSearchViewSheet()
      this.closeGlobalSearchItemActions()
      this.clearGlobalSearchSelection()
      this.globalSearchDoubleOpenState = null
      this.scrollCloudContentToTop()
    },
    triggerGlobalSearch(immediate, event) {
      if (!this.globalSearchOpen) {
        return Promise.resolve([])
      }
      if (this.globalSearchComposing || (event && event.isComposing)) {
        return Promise.resolve(this.globalSearchItems)
      }
      this.clearGlobalSearchRequestTimer()
      const keyword = String(this.globalSearchKeyword || '').trim()
      if (!keyword) {
        this.resetGlobalSearchResults()
        return Promise.resolve([])
      }
      if (immediate) {
        return this.loadGlobalSearch(true)
      }
      this.queueGlobalSearch()
      return Promise.resolve(this.globalSearchItems)
    },
    queueGlobalSearch() {
      if (!this.globalSearchOpen) {
        return
      }
      this.clearGlobalSearchRequestTimer()
      const keyword = String(this.globalSearchKeyword || '').trim()
      if (!keyword) {
        this.resetGlobalSearchResults()
        return
      }
      this.globalSearchRequestTimer = window.setTimeout(() => {
        this.globalSearchRequestTimer = null
        this.loadGlobalSearch(true)
      }, 1000)
    },
    clearGlobalSearchRequestTimer() {
      if (this.globalSearchRequestTimer) {
        clearTimeout(this.globalSearchRequestTimer)
        this.globalSearchRequestTimer = null
      }
    },
    loadGlobalSearch(force, options = {}) {
      const pageOptions = this.normalizeCloudListLoadOptions(force, options, this.globalSearchPageIndex)
      const keyword = String(this.globalSearchKeyword || '').trim()
      if (this.cloudStatus != 1 || !keyword) {
        this.globalSearchItems = []
        this.globalSearchLoaded = false
        this.resetGlobalSearchPagination()
        this.syncGlobalSearchSelectionWithItems()
        return Promise.resolve([])
      }
      if (pageOptions.append && (this.globalSearchLoading || this.globalSearchAppendLoading)) {
        return Promise.resolve(this.globalSearchItems)
      }
      this.clearGlobalSearchRequestTimer()
      const requestId = this.globalSearchRequestSeq + 1
      this.globalSearchRequestSeq = requestId
      this.globalSearchLoading = !pageOptions.append
      this.globalSearchAppendLoading = pageOptions.append
      return searchResourceSync({
        pageIndex: pageOptions.pageIndex,
        pageSize: this.globalSearchPageSize,
        name: keyword,
        appType: Number(this.globalSearchAppType)
      }, {
        skipGlobalErrorMessage: pageOptions.skipGlobalErrorMessage
      }).then(ret => {
        if (requestId != this.globalSearchRequestSeq) {
          return this.globalSearchItems
        }
        const payload = this.resolveHistoryPayload(ret)
        if (payload === null) {
          if (!pageOptions.append) {
            this.globalSearchItems = []
            this.resetGlobalSearchPagination()
          }
          this.$message.error(ret && ret.data ? (ret.data.msg || ret.data.message) : '')
          return this.globalSearchItems
        }
        this.applyGlobalSearchPage(payload, this.normalizeGlobalSearchItems(payload), pageOptions)
        this.globalSearchLoaded = true
        this.syncGlobalSearchSelectionWithItems()
        this.updateGlobalSearchGridColumnCount()
        return this.globalSearchItems
      }).catch(() => {
        if (requestId == this.globalSearchRequestSeq && !pageOptions.append) {
          this.globalSearchItems = []
          this.resetGlobalSearchPagination()
          this.syncGlobalSearchSelectionWithItems()
        }
        return this.globalSearchItems
      }).finally(() => {
        if (requestId == this.globalSearchRequestSeq) {
          this.globalSearchLoading = false
          this.globalSearchAppendLoading = false
        }
      })
    },
    normalizeGlobalSearchItems(payload) {
      return this.extractRecentArray(payload).map((item, index) => {
        const normalized = this.normalizeRecentItem(item, index)
        normalized.id = `search-${normalized.id}`
        return normalized
      })
    },
    toggleGlobalSearchTypeMenu() {
      this.globalSearchTypeMenuOpen = !this.globalSearchTypeMenuOpen
      if (this.globalSearchTypeMenuOpen) {
        this.closeGlobalSearchViewSheet()
        this.closeGlobalSearchItemActions()
        this.closeGlobalSearchMoreMenu()
      }
    },
    setGlobalSearchType(value) {
      const number = Number(value)
      const nextType = Number.isFinite(number) ? number : -1
      if (this.globalSearchAppType == nextType) {
        this.globalSearchTypeMenuOpen = false
        return
      }
      this.globalSearchAppType = nextType
      this.globalSearchTypeMenuOpen = false
      this.cancelGlobalSearchTouch()
      this.resetGlobalSearchPullRefreshState()
      this.clearGlobalSearchSelection()
      this.closeGlobalSearchMoreMenu()
      if (this.globalSearchKeyword) {
        this.resetGlobalSearchResults()
        this.loadGlobalSearch(true)
      }
    },
    setGlobalSearchViewMode(mode) {
      this.setSharedViewMode(mode)
      this.closeGlobalSearchViewSheet()
      this.closeGlobalSearchItemActions()
      this.closeGlobalSearchMoreMenu()
    },
    toggleGlobalSearchViewSheet() {
      this.globalSearchViewSheetOpen = !this.globalSearchViewSheetOpen
      this.globalSearchTypeMenuOpen = false
      this.closeGlobalSearchItemActions()
      this.closeGlobalSearchMoreMenu()
    },
    closeGlobalSearchViewSheet() {
      this.globalSearchViewSheetOpen = false
    },
    getGlobalSearchFallbackCover(item, mode) {
      if (this.shouldUseGlobalSearchDailyEmptyCover(item, mode)) {
        return RECENT_DAILY_EMPTY_COVER
      }
      if (this.isRecentFolderLike(item)) {
        return this.isGlobalSearchTemplateFolder(item)
          ? GLOBAL_SEARCH_ICONS.folder
          : (this.getRecentFolderChildSize(item) > 0 ? GLOBAL_SEARCH_ICONS.folderFilled : GLOBAL_SEARCH_ICONS.folderEmpty)
      }
      return this.getRecentFallbackCover(item, mode)
    },
    shouldUseGlobalSearchDailyEmptyCover(item, mode = 'list') {
      const cover = mode == 'grid' ? this.getPaperGridCoverImageUrl(item) : (item && item.cover)
      return !!(
        item
        && Number(item.appType) === 5
        && this.resolveAppFolderType(item) == 'daily'
        && !cover
        && !item.encrypted
      )
    },
    isGlobalSearchTemplateFolder(item) {
      return this.isRecentFolderLike(item) && (Number(item && item.resourceType) === 5 || this.isRecentTemplateItem(item))
    },
    shouldDisplayGlobalSearchFallbackCover(item, mode = 'list') {
      return !this.isGlobalSearchBlankCover(item, mode)
    },
    isGlobalSearchDailyCoverLoadFailed(item, mode = 'list') {
      if (!(item && this.resolveAppFolderType(item) == 'daily') || item.encrypted) {
        return false
      }
      if (mode == 'grid') {
        return !!item.gridFallbackCoverFailed && !this.getPaperGridCoverImageUrl(item)
      }
      return !!item.coverFailed
    },
    isGlobalSearchBlankCover(item, mode = 'list') {
      const cover = mode == 'grid' ? this.getPaperGridCoverImageUrl(item) : (item && item.cover)
      if (this.isGlobalSearchDailyCoverLoadFailed(item, mode)) {
        return true
      }
      return !!(
        item
        && this.resolveAppFolderType(item) == 'daily'
        && !cover
        && !this.shouldUseGlobalSearchDailyEmptyCover(item, mode)
        && !this.isRecentDailyTaskOrNoteItem(item)
      )
    },
    isRecentDailyTaskOrNoteItem(item) {
      if (!(item && this.resolveAppFolderType(item) == 'daily')) {
        return false
      }
      const tab = this.resolveRecentDailyTab(item)
      return tab == 'tasks' || tab == 'notes'
    },
    isGlobalSearchSelected(item) {
      if (!item || item.id === undefined || item.id === null || item.id === '') {
        return false
      }
      return this.selectedGlobalSearchIds.some(id => String(id) == String(item.id))
    },
    syncGlobalSearchSelectionWithItems() {
      if (this.selectedGlobalSearchIds.length == 0) {
        this.selectedGlobalSearchId = ''
        this.selectedGlobalSearchAnchorId = ''
        return
      }
      const existingIds = new Set(this.globalSearchItems.map(item => String(item.id)))
      this.selectedGlobalSearchIds = this.selectedGlobalSearchIds.filter(id => existingIds.has(String(id)))
      this.selectedGlobalSearchId = this.selectedGlobalSearchIds[0] || ''
      if (!existingIds.has(String(this.selectedGlobalSearchAnchorId))) {
        this.selectedGlobalSearchAnchorId = this.selectedGlobalSearchId
      }
    },
    selectGlobalSearchItem(item, event) {
      if (!item) {
        return
      }
      this.globalSearchActionTargetId = ''
      const hadSelection = this.selectedGlobalSearchIds.length > 0
      const result = selectItemWithWindowsRange(
        this.visibleGlobalSearchItems,
        this.selectedGlobalSearchIds,
        item,
        this.selectedGlobalSearchAnchorId,
        event
      )
      const selectedIds = result.selectedIds
      this.selectedGlobalSearchIds = selectedIds
      this.selectedGlobalSearchId = selectedIds[0] || ''
      this.selectedGlobalSearchAnchorId = result.anchorId
      if (!hadSelection || selectedIds.length == 0) {
        this.resetGlobalSearchSelectionBarOffset()
      }
      this.closeGlobalSearchMoreMenu()
    },
    clearGlobalSearchSelection() {
      this.clearGlobalSearchItemClickTimer()
      this.selectedGlobalSearchIds = []
      this.selectedGlobalSearchId = ''
      this.selectedGlobalSearchAnchorId = ''
      this.closeGlobalSearchItemActions()
      this.closeGlobalSearchViewSheet()
      this.closeGlobalSearchMoreMenu()
      this.resetGlobalSearchSelectionBarOffset()
    },
    startGlobalSearchSelectionFromItem(item, options = {}) {
      if (!item || item.id === undefined || item.id === null || item.id === '') {
        return
      }
      if (options.preserveExisting && this.selectedGlobalSearchIds.length > 0) {
        const selectedIds = this.selectedGlobalSearchIds.slice()
        const selectedIndex = selectedIds.findIndex(id => String(id) == String(item.id))
        if (selectedIndex >= 0) {
          selectedIds.splice(selectedIndex, 1)
        } else {
          selectedIds.push(item.id)
        }
        this.selectedGlobalSearchIds = selectedIds
        this.selectedGlobalSearchId = selectedIds[0] || ''
        this.selectedGlobalSearchAnchorId = selectedIndex >= 0 ? (selectedIds[0] || '') : item.id
        this.globalSearchActionTargetId = ''
        if (selectedIds.length == 0) {
          this.resetGlobalSearchSelectionBarOffset()
        }
        this.globalSearchTypeMenuOpen = false
        this.closeGlobalSearchMoreMenu()
        this.closeGlobalSearchViewSheet()
        return
      }
      this.setGlobalSearchSingleSelection(item)
      this.globalSearchTypeMenuOpen = false
      this.closeGlobalSearchViewSheet()
    },
    setGlobalSearchSingleSelection(item) {
      if (!item || item.id === undefined || item.id === null || item.id === '') {
        return
      }
      this.selectedGlobalSearchIds = [item.id]
      this.selectedGlobalSearchId = item.id
      this.selectedGlobalSearchAnchorId = item.id
      this.globalSearchActionTargetId = ''
      this.resetGlobalSearchSelectionBarOffset()
      this.closeGlobalSearchMoreMenu()
    },
    setGlobalSearchTouchItemSelection(item, selected) {
      if (!item || item.id === undefined || item.id === null || item.id === '') {
        return
      }
      const currentIds = Array.isArray(this.selectedGlobalSearchIds) ? this.selectedGlobalSearchIds.slice() : []
      const selectedIndex = currentIds.findIndex(id => String(id) == String(item.id))
      if (selected && selectedIndex < 0) {
        currentIds.push(item.id)
      } else if (!selected && selectedIndex >= 0) {
        currentIds.splice(selectedIndex, 1)
      }
      this.selectedGlobalSearchIds = currentIds
      this.selectedGlobalSearchId = currentIds[0] || ''
      this.selectedGlobalSearchAnchorId = currentIds.length > 0 ? item.id : ''
      this.globalSearchActionTargetId = ''
      this.globalSearchTypeMenuOpen = false
      this.closeGlobalSearchMoreMenu()
      this.closeGlobalSearchViewSheet()
      if (currentIds.length == 0) {
        this.resetGlobalSearchSelectionBarOffset()
      }
    },
    applyGlobalSearchTouchSelection(item) {
      const mode = this.globalSearchTouchSelectionMode || (this.isGlobalSearchSelected(item) ? 'deselect' : 'select')
      this.setGlobalSearchTouchItemSelection(item, mode != 'deselect')
    },
    startGlobalSearchTouch(item, event) {
      this.clearGlobalSearchTouchTimer()
      this.clearGlobalSearchLongPressResetTimer()
      this.globalSearchTouchMoved = false
      this.globalSearchLongPressTriggered = false
      this.globalSearchTouchSelectionActive = false
      this.globalSearchTouchSelectionMode = ''
      this.globalSearchTouchGestureType = 'pending'
      const touch = event && event.touches && event.touches[0]
      this.globalSearchTouchStartPoint = touch ? { x: touch.clientX, y: touch.clientY } : null
      this.globalSearchTouchStartTime = Date.now()
      this.globalSearchTouchStartItemId = item && item.id !== undefined && item.id !== null ? item.id : ''
      if (!item) {
        return
      }
      this.globalSearchTouchSelectionMode = this.isGlobalSearchSelected(item) ? 'deselect' : 'select'
      if (typeof window === 'undefined') {
        return
      }
      this.globalSearchTouchTimer = window.setTimeout(() => {
        this.globalSearchTouchTimer = null
        this.globalSearchLongPressTriggered = true
        this.globalSearchTouchSelectionActive = true
        this.globalSearchTouchGestureType = 'selection'
        this.cancelGlobalSearchPullRefreshGesture()
        this.applyGlobalSearchTouchSelection(item)
      }, 520)
    },
    moveGlobalSearchTouch(event) {
      const touch = event && event.touches && event.touches[0]
      if (!touch) {
        return
      }
      const start = this.globalSearchTouchStartPoint
      if (!start) {
        return
      }
      const gestureType = classifyMobileTouchGesture({
        startX: start.x,
        startY: start.y,
        startTime: this.globalSearchTouchStartTime,
        gestureType: this.globalSearchTouchGestureType,
        longPressTriggered: this.globalSearchLongPressTriggered
      }, touch)
      if (gestureType == 'pending') {
        return
      }
      this.globalSearchTouchGestureType = gestureType
      this.globalSearchTouchMoved = true
      this.clearGlobalSearchTouchTimer()
      if (gestureType != 'selection') {
        return
      }
      if (!this.globalSearchLongPressTriggered) {
        if (this.selectedGlobalSearchIds.length == 0) {
          return
        }
        this.globalSearchLongPressTriggered = true
        this.globalSearchTouchSelectionActive = true
        this.cancelGlobalSearchPullRefreshGesture()
        const startItem = this.visibleGlobalSearchItems.find(candidate => candidate && String(candidate.id) == String(this.globalSearchTouchStartItemId))
        if (startItem) {
          this.applyGlobalSearchTouchSelection(startItem)
        }
      }
      if (event.cancelable) {
        event.preventDefault()
      }
      this.extendGlobalSearchTouchSelection(touch.clientX, touch.clientY)
    },
    endGlobalSearchTouch() {
      this.clearGlobalSearchTouchTimer()
      this.globalSearchTouchStartPoint = null
      this.globalSearchTouchStartTime = 0
      this.globalSearchTouchStartItemId = ''
      if ((this.globalSearchLongPressTriggered || this.globalSearchTouchMoved) && typeof window !== 'undefined') {
        const touchMoved = this.globalSearchTouchMoved
        this.globalSearchLongPressResetTimer = window.setTimeout(() => {
          this.globalSearchLongPressResetTimer = null
          this.globalSearchLongPressTriggered = false
          this.globalSearchTouchSelectionActive = false
          this.globalSearchTouchSelectionMode = ''
          this.globalSearchTouchGestureType = 'pending'
          if (touchMoved) {
            this.globalSearchTouchMoved = false
          }
        }, 350)
      } else {
        this.globalSearchTouchSelectionActive = false
        this.globalSearchTouchSelectionMode = ''
      }
    },
    cancelGlobalSearchTouch() {
      this.clearGlobalSearchTouchTimer()
      this.clearGlobalSearchLongPressResetTimer()
      this.globalSearchTouchStartPoint = null
      this.globalSearchTouchStartTime = 0
      this.globalSearchTouchStartItemId = ''
      this.globalSearchTouchMoved = false
      this.globalSearchLongPressTriggered = false
      this.globalSearchTouchSelectionMode = ''
      this.globalSearchTouchSelectionActive = false
      this.globalSearchTouchGestureType = 'pending'
    },
    extendGlobalSearchTouchSelection(clientX, clientY) {
      if (typeof document === 'undefined' || typeof document.elementFromPoint !== 'function') {
        return
      }
      const element = document.elementFromPoint(clientX, clientY)
      const row = element && element.closest ? element.closest('[data-global-search-id]') : null
      const id = row && row.getAttribute('data-global-search-id')
      const item = id ? this.visibleGlobalSearchItems.find(candidate => candidate && String(candidate.id) == id) : null
      if (!item) {
        return
      }
      const startIndex = this.visibleGlobalSearchItems.findIndex(candidate => candidate && String(candidate.id) == String(this.globalSearchTouchStartItemId))
      const endIndex = this.visibleGlobalSearchItems.indexOf(item)
      const crossedItems = startIndex >= 0 && endIndex >= 0
        ? this.visibleGlobalSearchItems.slice(Math.min(startIndex, endIndex), Math.max(startIndex, endIndex) + 1)
        : [item]
      const shouldSelect = this.globalSearchTouchSelectionMode != 'deselect'
      const selectedIds = this.selectedGlobalSearchIds.slice()
      const selectedSet = new Set(selectedIds.map(value => String(value)))
      crossedItems.forEach(candidate => {
        if (!candidate) {
          return
        }
        const candidateKey = String(candidate.id)
        if (shouldSelect) {
          if (!selectedSet.has(candidateKey)) {
            selectedIds.push(candidate.id)
            selectedSet.add(candidateKey)
          }
        } else if (selectedSet.has(candidateKey)) {
          for (let selectedIndex = selectedIds.length - 1; selectedIndex >= 0; selectedIndex -= 1) {
            if (String(selectedIds[selectedIndex]) == candidateKey) {
              selectedIds.splice(selectedIndex, 1)
            }
          }
          selectedSet.delete(candidateKey)
        }
      })
      this.selectedGlobalSearchIds = selectedIds
      this.selectedGlobalSearchId = selectedIds[0] || ''
      this.selectedGlobalSearchAnchorId = selectedIds.length > 0 ? item.id : ''
      this.globalSearchActionTargetId = ''
      if (selectedIds.length == 0) {
        this.resetGlobalSearchSelectionBarOffset()
      }
    },
    handleGlobalSearchContextMenu(item) {
      this.clearGlobalSearchTouchTimer()
      if (this.globalSearchLongPressTriggered || this.globalSearchTouchMoved) {
        return
      }
      this.globalSearchLongPressTriggered = true
      this.globalSearchTouchSelectionActive = true
      this.globalSearchTouchGestureType = 'selection'
      this.globalSearchTouchSelectionMode = this.globalSearchTouchSelectionMode || (this.isGlobalSearchSelected(item) ? 'deselect' : 'select')
      this.cancelGlobalSearchPullRefreshGesture()
      this.applyGlobalSearchTouchSelection(item)
    },
    clearGlobalSearchTouchTimer() {
      if (this.globalSearchTouchTimer) {
        clearTimeout(this.globalSearchTouchTimer)
        this.globalSearchTouchTimer = null
      }
    },
    clearGlobalSearchLongPressResetTimer() {
      if (this.globalSearchLongPressResetTimer) {
        clearTimeout(this.globalSearchLongPressResetTimer)
        this.globalSearchLongPressResetTimer = null
      }
    },
    handleGlobalSearchItemClick(item, event) {
      if (!item) {
        return
      }
      if (event && event.detail > 1) {
        this.clearGlobalSearchItemClickTimer()
        return
      }
      this.clearGlobalSearchItemClickTimer()
      if (this.globalSearchTouchMoved) {
        this.clearGlobalSearchLongPressResetTimer()
        this.globalSearchTouchMoved = false
        this.globalSearchLongPressTriggered = false
        this.globalSearchTouchSelectionActive = false
        this.globalSearchTouchSelectionMode = ''
        this.globalSearchTouchGestureType = 'pending'
        return
      }
      if (this.globalSearchLongPressTriggered) {
        this.clearGlobalSearchLongPressResetTimer()
        this.globalSearchLongPressTriggered = false
        this.globalSearchTouchSelectionActive = false
        this.globalSearchTouchSelectionMode = ''
        this.globalSearchTouchGestureType = 'pending'
        return
      }
      if (this.selectedGlobalSearchIds.length > 0) {
        this.startGlobalSearchSelectionFromItem(item, { preserveExisting: true })
        return
      }
      this.closeGlobalSearchViewSheet()
      this.openGlobalSearchItemFromDoubleAction(item, event)
    },
    handleGlobalSearchItemDblClick(item, event) {
      this.openGlobalSearchItemFromDoubleAction(item, event)
    },
    openGlobalSearchItemFromDoubleAction(item, event) {
      if (!item) {
        return
      }
      this.clearGlobalSearchItemClickTimer()
      const itemId = item.id ? String(item.id) : ''
      const now = Date.now()
      const lastOpen = this.globalSearchDoubleOpenState || {}
      if (lastOpen.id == itemId && now - lastOpen.time < 350) {
        return
      }
      this.globalSearchDoubleOpenState = {
        id: itemId,
        time: now
      }
      this.clearGlobalSearchSelection()
      this.openGlobalSearchItem(item, event)
    },
    handleGlobalSearchItemKeyup(item) {
      if (!item) {
        return
      }
      this.clearGlobalSearchItemClickTimer()
      this.clearGlobalSearchSelection()
      this.openGlobalSearchItem(item)
    },
    clearGlobalSearchItemClickTimer() {
      if (this.globalSearchItemClickTimer) {
        clearTimeout(this.globalSearchItemClickTimer)
        this.globalSearchItemClickTimer = null
      }
    },
    startGlobalSearchSelectionBarDrag(event) {
      if (!event || event.button !== 0) {
        return
      }
      const interactiveTarget = event.target && event.target.closest && event.target.closest('button')
      if (interactiveTarget) {
        return
      }
      this.globalSearchSelectionBarDragging = true
      this.globalSearchSelectionBarDragState = {
        startY: event.clientY,
        startOffset: this.globalSearchSelectionBarOffsetY
      }
      if (typeof document !== 'undefined') {
        document.addEventListener('mousemove', this.handleGlobalSearchSelectionBarDrag)
        document.addEventListener('mouseup', this.stopGlobalSearchSelectionBarDrag)
      }
    },
    handleGlobalSearchSelectionBarDrag(event) {
      if (!this.globalSearchSelectionBarDragState || !event) {
        return
      }
      const nextOffset = this.globalSearchSelectionBarDragState.startOffset + event.clientY - this.globalSearchSelectionBarDragState.startY
      this.globalSearchSelectionBarOffsetY = this.clampGlobalSearchSelectionBarOffset(nextOffset)
    },
    stopGlobalSearchSelectionBarDrag() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('mousemove', this.handleGlobalSearchSelectionBarDrag)
        document.removeEventListener('mouseup', this.stopGlobalSearchSelectionBarDrag)
      }
      this.globalSearchSelectionBarDragging = false
      this.globalSearchSelectionBarDragState = null
    },
    clampGlobalSearchSelectionBarOffset(value) {
      const number = Number(value) || 0
      const maxOffset = this.getGlobalSearchSelectionBarMaxOffset()
      return Math.min(Math.max(0, number), maxOffset)
    },
    getGlobalSearchSelectionBarMaxOffset() {
      const area = this.$refs.cloudContentArea
      const layer = this.$refs.globalSearchSelectionLayer
      if (!area || !layer) {
        return 0
      }
      const areaRect = area.getBoundingClientRect()
      const layerRect = layer.getBoundingClientRect()
      return Math.max(0, areaRect.bottom - layerRect.top - layerRect.height)
    },
    resetGlobalSearchSelectionBarOffset() {
      this.stopGlobalSearchSelectionBarDrag()
      this.globalSearchSelectionBarOffsetY = 0
    },
    toggleGlobalSearchMoreMenu(id) {
      this.globalSearchMoreMenuId = this.globalSearchMoreMenuId == id ? '' : id
    },
    closeGlobalSearchMoreMenu() {
      this.globalSearchMoreMenuId = ''
    },
    openGlobalSearchItemActions(item) {
      if (!item) {
        return
      }
      const shouldClose = this.selectedGlobalSearchCount == 0 && this.globalSearchActionTargetId == item.id
      this.clearGlobalSearchSelection()
      this.globalSearchActionTargetId = shouldClose ? '' : item.id
      this.globalSearchTypeMenuOpen = false
      this.closeGlobalSearchViewSheet()
      this.closeGlobalSearchMoreMenu()
    },
    closeGlobalSearchItemActions() {
      this.globalSearchActionTargetId = ''
    },
    downloadGlobalSearchItem(item) {
      this.closeGlobalSearchMoreMenu()
      this.openRecentDownloadFormatModal(item ? [item] : [], { selectionContext: 'search' })
    },
    downloadSelectedGlobalSearchItems() {
      this.openRecentDownloadFormatModal(this.selectedGlobalSearchItems, { selectionContext: 'search' })
    },
    downloadGlobalSearchActionItems() {
      const items = this.globalSearchActionItems.slice()
      if (items.length == 0) {
        return
      }
      const isSelectionDownload = this.selectedGlobalSearchCount > 0
      this.closeGlobalSearchItemActions()
      this.closeGlobalSearchMoreMenu()
      this.openRecentDownloadFormatModal(items, { selectionContext: 'search' })
      if (isSelectionDownload) {
        this.clearGlobalSearchSelection()
      }
    },
    getGlobalSearchGridItemClasses(item, index) {
      return {
        selected: this.isGlobalSearchSelected(item),
        'grid-edge-left': this.isGlobalSearchGridLeftEdge(index),
        'grid-edge-right': this.isGlobalSearchGridRightEdge(index),
        'grid-edge-top': this.isGlobalSearchGridTopEdge(index),
        'grid-edge-bottom': this.isGlobalSearchGridBottomEdge(index)
      }
    },
    isGlobalSearchGridLeftEdge(index) {
      const columnCount = Math.max(1, Number(this.globalSearchGridColumnCount) || 1)
      if (this.isGlobalSearchGridLastIncompleteRowLastItem(index)) {
        return false
      }
      return columnCount == 1 || index % columnCount == 0
    },
    isGlobalSearchGridRightEdge(index) {
      const columnCount = Math.max(1, Number(this.globalSearchGridColumnCount) || 1)
      if (this.isGlobalSearchGridLastIncompleteRowLastItem(index)) {
        return false
      }
      return columnCount == 1 || (index + 1) % columnCount == 0
    },
    isGlobalSearchGridTopEdge(index) {
      const columnCount = Math.max(1, Number(this.globalSearchGridColumnCount) || 1)
      return index < columnCount
    },
    isGlobalSearchGridBottomEdge() {
      return false
    },
    isGlobalSearchGridLastIncompleteRowLastItem(index) {
      const columnCount = Math.max(1, Number(this.globalSearchGridColumnCount) || 1)
      const itemCount = this.visibleGlobalSearchItems.length
      return itemCount > 0 && itemCount % columnCount != 0 && index == itemCount - 1
    },
    updateGlobalSearchGridColumnCount() {
      if (!this.globalSearchOpen || this.globalSearchViewMode != 'grid') {
        return
      }
      this.$nextTick(() => {
        const grid = this.$refs.globalSearchGrid
        if (!grid || typeof window === 'undefined') {
          this.globalSearchGridColumnCount = 1
          return
        }
        const styles = window.getComputedStyle(grid)
        const columns = String(styles.gridTemplateColumns || '')
          .split(/\s+/)
          .filter(column => column && column != 'none')
        this.globalSearchGridColumnCount = Math.max(1, columns.length || 1)
      })
    },
    openGlobalSearchItem(item, event, options = {}) {
      this.clearGlobalSearchItemClickTimer()
      this.globalSearchFilePreviewMode = false
      this.globalSearchLearningPreviewMode = false
      if (event && typeof event.preventDefault == 'function') {
        event.preventDefault()
      }
      if (!item) {
        return
      }
      this.cancelGlobalSearchTouch()
      this.resetGlobalSearchPullRefreshState()
      this.globalSearchTypeMenuOpen = false
      this.closeGlobalSearchViewSheet()
      this.closeGlobalSearchItemActions()
      this.clearGlobalSearchSelection()
      const folderType = this.resolveAppFolderType(item) || (this.isDirectFilePreviewItem(item) ? 'paper' : '')
      if (!folderType || !item.resourceId) {
        this.$message.warning(this.uiText.openUnavailable || 'Unable to open this item')
        return
      }
      const openOptions = Object.assign({}, options, {
        force: true,
        sourceContext: 'search'
      })
      this.globalSearchFilePreviewMode = this.shouldUseGlobalSearchFilePreview(item, folderType)
      this.pendingRecentOpenItem = null
      this.pendingRecentOpenOptions = null
      if (item.encrypted && !openOptions.skipPasswordPrompt) {
        this.openRecentPasswordModal(item, '', false, 'search', 'open', [], openOptions)
        return
      }
      this.captureMobilePreviewReturnScroll('search')
      if (folderType == 'learning' && !this.isDirectFilePreviewItem(item)) {
        this.activeAppReturnMenu = 'search'
        this.activeAppFolder = ''
        this.activeAppFolderAppType = null
        this.globalSearchOpen = true
        this.openRecentLearningModal(item, openOptions)
        return
      }
      const pendingOptions = this.withRecentResourceDetailPrefetch(
        item,
        folderType,
        openOptions
      )
      this.pendingRecentOpenItem = item
      this.pendingRecentOpenOptions = pendingOptions
      this.activeAppReturnMenu = 'search'
      this.activeAppFolder = folderType
      this.activeAppFolderAppType = item.appType || this.resolveDefaultAppTypeByFolderType(folderType)
      this.globalSearchOpen = false
      this.globalSearchTypeMenuOpen = false
      this.closeGlobalSearchMoreMenu()
      this.scrollNewMobilePageToTop()
      this.$nextTick(() => {
        this.openPendingRecentItem()
      })
    },
    shouldUseGlobalSearchFilePreview(item, folderType = '') {
      const resolvedFolderType = folderType || this.resolveAppFolderType(item)
      if (!['paper', 'meeting', 'learning', 'memo', 'knowledge', 'daily'].includes(resolvedFolderType)) {
        return false
      }
      if (resolvedFolderType == 'learning') {
        return this.isDirectFilePreviewItem(item) && !this.isRecentFolderLike(item)
      }
      if (resolvedFolderType != 'daily') {
        return !this.isRecentFolderLike(item)
      }
      if (this.isRecentDailyTaskOrNoteItem(item)) {
        return true
      }
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : item
      const explicitFolderFlag = this.pickValue(raw || {}, ['isFolder', 'folder', 'isDir', 'directory'])
      if (explicitFolderFlag === undefined || explicitFolderFlag === null || explicitFolderFlag === '') {
        return true
      }
      return !this.pickBoolean(raw || {}, ['isFolder', 'folder', 'isDir', 'directory'])
    },
    resolveHistoryPayload(ret) {
      const data = ret && ret.data ? ret.data : ret
      if (!data) {
        return null
      }
      if (data.code == 200 || data.code == '200') {
        return data.data === undefined ? {} : data.data
      }
      if (data.success === true) {
        return data.data === undefined ? {} : data.data
      }
      if (Array.isArray(data) || data.list || data.records || data.items || data.rows) {
        return data
      }
      return null
    },
    normalizeRecentItems(payload) {
      return this.extractRecentArray(payload).map((item, index) => this.normalizeRecentItem(item, index))
    },
    extractRecentArray(payload, depth = 0) {
      if (Array.isArray(payload)) {
        return payload
      }
      if (!payload || typeof payload != 'object' || depth > 4) {
        return []
      }
      const directKeys = ['list', 'items', 'records', 'rows', 'data', 'historyList', 'resourceList']
      for (let i = 0; i < directKeys.length; i++) {
        const value = payload[directKeys[i]]
        if (Array.isArray(value)) {
          return value
        }
      }
      const values = Object.keys(payload).map(key => payload[key])
      for (let i = 0; i < values.length; i++) {
        const nested = this.extractRecentArray(values[i], depth + 1)
        if (nested.length > 0) {
          return nested
        }
      }
      return []
    },
    normalizeRecentItem(raw, index) {
      const item = raw && typeof raw == 'object' ? raw : {}
      const appType = this.resolveRecentAppType(item)
      const folderType = this.resolveFolderTypeByAppType(appType)
      const resolvedResourceId = this.pickString(item, ['resourceId', 'resource_id', 'resourceID', 'uuid', 'id', 'resourceUuid', 'resource_uuid', 'paperId', 'paper_id', 'dailyId', 'daily_id'])
      const resourceId = resolvedResourceId || `recent-${index}`
      const name = this.pickString(item, ['name', 'title', 'fileName', 'filename', 'resourceName', 'paperName']) || `Recent ${index + 1}`
      const cover = this.pickString(item, ['cover', 'coverUrl', 'imageUrl', 'thumbnail', 'thumbnailUrl', 'url', 'src'])
      const gridCover = this.pickPaperCoverImageUrl(item)
      const resourceType = this.getDirectFilePreviewResourceType(item)
      const filePath = this.isDirectFilePreviewResourceType(resourceType)
        ? this.pickDirectFilePreviewPath(item)
        : this.pickString(item, ['filePath', 'filepath', 'file_path', 'path', 'fileUrl', 'downloadUrl', 'resourceUrl', 'resource_url'])
      const childSize = this.pickValue(item, ['childSize', 'child_size', 'childrenSize', 'childCount', 'childrenCount', 'pageCount', 'pages', 'pageNum', 'totalPage'])
      const fileSize = this.pickFirstPresent(
        this.pickValue(item, ['fileSize']),
        this.pickValue(item, ['fileSizeBytes']),
        this.pickValue(item, ['size'])
      )
      const createdAt = this.pickValue(item, ['creationTime', 'createdAt', 'createAt', 'createTime', 'createdTime', 'createdDate', 'gmtCreate'])
      const updatedAt = this.pickValue(item, ['lastModifiedTime', 'updatedAt', 'updateAt', 'modifyAt', 'modifyTime', 'updatedTime', 'lastModified', 'gmtModified'])
      return {
        id: `${folderType || 'app'}-${resourceId}-${index}`,
        resourceId,
        hasResourceId: !!resolvedResourceId,
        appType,
        folderType,
        name,
        cover,
        gridCover,
        filePath,
        fileSize,
        fileSizeBytes: fileSize,
        childSize,
        createdAt,
        updatedAt,
        resourceType,
        subTab: this.pickValue(item, ['subTab', 'sub_tab', 'subtab', 'dailySubTab', 'daily_sub_tab', 'tab', 'dailyType']),
        favorite: this.pickBoolean(item, ['favorite', 'isFavorite', 'starred', 'isStar', 'star', 'start']),
        encrypted: this.pickBoolean(item, ['encrypted', 'isEncrypted', 'locked', 'isLock', 'encrypt', 'encryp']),
        coverFailed: false,
        raw: item
      }
    },
    resolveRecentAppType(item) {
      const value = this.pickValue(item, ['appType', 'applicationType', 'appId', 'app_id', 'resourceAppType'])
      const number = Number(value)
      if (Number.isFinite(number) && number > 0) {
        return number
      }
      const type = this.resolveFolderType(item)
      return this.resolveDefaultAppTypeByFolderType(type)
    },
    resolveFolderTypeByAppType(appType) {
      const map = {
        1: 'paper',
        2: 'meeting',
        3: 'learning',
        4: 'knowledge',
        5: 'daily',
        6: 'memo'
      }
      return map[Number(appType)] || ''
    },
    getRootFolderDefinitions() {
      return [
        { type: 'paper', name: 'Paper', dir: '/paper/', countFields: ['paperCount', 'paperNum', 'paperTotal', 'paperFileCount', 'paperItemCount'] },
        { type: 'meeting', name: 'Meeting', dir: '/meeting/', countFields: ['meetingCount', 'meetingNum', 'meetingTotal', 'meetingFileCount', 'meetingItemCount'] },
        { type: 'learning', name: 'Learning', dir: '/learning/', countFields: ['learningCount', 'learningNum', 'learningTotal', 'learningFileCount', 'learningItemCount'] },
        { type: 'knowledge', name: 'Knowledge Base', dir: '/knowledge base/', countFields: ['kbCount', 'knowledgeCount', 'knowledgeBaseCount', 'knowledgeNum', 'knowledgeTotal', 'knowledgeFileCount'] },
        { type: 'memo', name: 'Memo', dir: '/memo/', countFields: ['memoCount', 'momoCount', 'memoNum', 'memoTotal', 'memoFileCount', 'memoItemCount'] },
        { type: 'daily', name: 'Daily', dir: '/daily/', countFields: ['dailyCount', 'dailyNum', 'dailyTotal', 'dailyFileCount', 'dailyItemCount'] }
      ]
    },
    getVisibleFolderSource() {
      if (this.activeMenu == 'daily') {
        return this.cloudItems.filter(item => item.type == 'daily')
      }
      if (this.activeMenu == 'files') {
        return this.cloudItems.filter(item => item.type != 'daily')
      }
      return this.cloudItems
    },
    normalizeRootFolders(payload) {
      const list = this.extractRootFolderArray(payload)
      const source = list.length > 0 ? list : this.extractRootFolderObjects(payload)
      return this.mergeDefaultRootFolders(source.map((item, index) => this.normalizeRootFolderItem(item, index)))
    },
    mergeDefaultRootFolders(items) {
      const definitions = this.getRootFolderDefinitions()
      const merged = items.slice()
      definitions.forEach((definition, index) => {
        if (!merged.some(item => item.type == definition.type)) {
          merged.push(this.normalizeRootFolderItem({
            name: definition.name,
            type: definition.type,
            dir: definition.dir,
            appType: this.resolveDefaultAppTypeByFolderType(definition.type),
            count: ''
          }, merged.length + index))
        }
      })
      return merged.sort((a, b) => {
        const aIndex = definitions.findIndex(definition => definition.type == a.type)
        const bIndex = definitions.findIndex(definition => definition.type == b.type)
        if (aIndex < 0 && bIndex < 0) {
          return 0
        }
        if (aIndex < 0) {
          return 1
        }
        if (bIndex < 0) {
          return -1
        }
        return aIndex - bIndex
      })
    },
    extractRootFolderArray(payload, depth = 0) {
      if (Array.isArray(payload)) {
        return payload
      }
      if (!payload || typeof payload != 'object' || depth > 3) {
        return []
      }
      const directKeys = ['list', 'items', 'records', 'folders', 'folderList', 'rootFolders', 'rootFolderList', 'children', 'rows', 'data']
      for (let i = 0; i < directKeys.length; i++) {
        const value = payload[directKeys[i]]
        if (Array.isArray(value)) {
          return value
        }
      }
      const values = Object.keys(payload).map(key => payload[key])
      const arrayValue = values.find(value => Array.isArray(value) && (value.length == 0 || value.some(item => item && typeof item == 'object')))
      if (arrayValue) {
        return arrayValue
      }
      for (let i = 0; i < values.length; i++) {
        const nested = this.extractRootFolderArray(values[i], depth + 1)
        if (nested.length > 0) {
          return nested
        }
      }
      return []
    },
    extractRootFolderObjects(payload) {
      if (!payload || typeof payload != 'object') {
        return []
      }
      return this.getRootFolderDefinitions().reduce((items, definition) => {
        const directValue = this.pickValue(payload, [
          definition.type,
          definition.name,
          definition.dir,
          `${definition.type}Folder`,
          `${definition.type}Data`
        ])
        if (directValue && typeof directValue == 'object' && !Array.isArray(directValue)) {
          items.push(Object.assign({ name: definition.name, type: definition.type, dir: definition.dir }, directValue))
          return items
        }
        if (directValue !== undefined && directValue !== null && directValue !== '') {
          items.push({ name: definition.name, type: definition.type, dir: definition.dir, count: directValue })
          return items
        }
        const countValue = this.pickValue(payload, definition.countFields)
        if (countValue !== undefined && countValue !== null && countValue !== '') {
          items.push({ name: definition.name, type: definition.type, dir: definition.dir, count: countValue })
        }
        return items
      }, [])
    },
    normalizeRootFolderItem(raw, index) {
      const item = raw && typeof raw == 'object' ? raw : { count: raw }
      const type = this.resolveFolderType(item)
      const name = this.resolveFolderName(item, type, index)
      const id = this.resolveFolderId(item, type, index)
      const appType = this.resolveFolderAppType(item, type)
      const count = this.resolveFolderCount(item, type)
      const isEmptyCount = this.isFolderCountEmpty(count)
      const emptyCountIcon = isEmptyCount ? EMPTY_COUNT_FOLDER_ICON : ''
      return {
        id,
        type,
        appType,
        name,
        count,
        icon: this.getMyFileFolderIcon(type, isEmptyCount),
        listIcon: emptyCountIcon || require('@/assets/wap/myfile-folder.png'),
        raw: item
      }
    },
    isFolderCountEmpty(count) {
      if (count === undefined || count === null || count === '') {
        return true
      }
      const number = Number(count)
      return Number.isFinite(number) && number === 0
    },
    pickValue(source, keys) {
      if (!source || typeof source != 'object') {
        return undefined
      }
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          return source[key]
        }
      }
      const sourceKeys = Object.keys(source)
      for (let i = 0; i < keys.length; i++) {
        const normalizedKey = this.normalizeFieldKey(keys[i])
        const matchedKey = sourceKeys.find(sourceKey => this.normalizeFieldKey(sourceKey) == normalizedKey)
        if (matchedKey) {
          return source[matchedKey]
        }
      }
      return undefined
    },
    pickString(source, keys) {
      const value = this.pickValue(source, keys)
      if (value === undefined || value === null) {
        return ''
      }
      return String(value).trim()
    },
    pickBoolean(source, keys) {
      const value = this.pickValue(source, keys)
      if (typeof value == 'boolean') {
        return value
      }
      if (typeof value == 'number') {
        return value !== 0
      }
      if (value === undefined || value === null || value === '') {
        return false
      }
      const normalized = this.normalizeFieldKey(value)
      return ['true', '1', 'yes', 'y', 'favorite', 'starred', 'deleted', 'folder', 'dir', 'locked', 'encrypted'].includes(normalized)
    },
    normalizeFieldKey(value) {
      return String(value || '').toLowerCase().replace(/[\s_\-/.]/g, '')
    },
    normalizeMenuKey(value) {
      if (value == 'recent' || value == 'daily') {
        return value
      }
      return 'files'
    },
    resolveMenuKeyForFolderType(folderType, fallbackMenu = 'files') {
      if (fallbackMenu == 'search') {
        return 'files'
      }
      if (this.normalizeFieldKey(folderType) == 'daily') {
        return 'daily'
      }
      return this.normalizeMenuKey(fallbackMenu) == 'recent' ? 'recent' : 'files'
    },
    resolveAppFolderType(item) {
      if (!item || typeof item != 'object') {
        return ''
      }
      const directType = this.resolveFolderType(item)
      if (directType) {
        return directType
      }
      const byAppType = this.resolveFolderTypeByAppType(item.appType)
      if (byAppType) {
        return byAppType
      }
      const source = item.raw && typeof item.raw == 'object' ? item.raw : item
      return this.resolveFolderType(source)
    },
    isSupportedAppFolderType(type) {
      return ['paper', 'meeting', 'learning', 'knowledge', 'memo', 'daily'].includes(type)
    },
    resolveFolderType(item) {
      const rawType = this.pickString(item, ['type', 'folderType', 'category', 'app', 'appType', 'source'])
      const rawDir = this.pickString(item, ['dir', 'folder', 'folderPath', 'path', 'id', 'folderId'])
      const rawName = this.pickString(item, ['name', 'folderName', 'title', 'fileName', 'appName', 'resourceName', 'dirName', 'displayName', 'label'])
      const text = this.normalizeFieldKey(`${rawType} ${rawDir} ${rawName}`)
      if (text.includes('knowledgebase') || text.includes('knowledge') || text == 'kb' || text.includes('kb')) {
        return 'knowledge'
      }
      if (text.includes('meeting')) {
        return 'meeting'
      }
      if (text.includes('learning')) {
        return 'learning'
      }
      if (text.includes('memo') || text.includes('momo')) {
        return 'memo'
      }
      if (text.includes('daily')) {
        return 'daily'
      }
      if (text.includes('paper')) {
        return 'paper'
      }
      return ''
    },
    resolveFolderName(item, type, index) {
      const definition = this.getRootFolderDefinitions().find(folder => folder.type == type)
      const rawName = this.pickString(item, ['name', 'folderName', 'title', 'fileName', 'appName', 'resourceName', 'dirName', 'displayName', 'label'])
      const rawDir = this.pickString(item, ['dir', 'folder', 'folderPath', 'path'])
      if (definition) {
        return definition.name
      }
      if (rawName) {
        return rawName
      }
      if (rawDir) {
        const dirName = rawDir.replace(/^\/+|\/+$/g, '').split('/').pop()
        return dirName || `Folder ${index + 1}`
      }
      return `Folder ${index + 1}`
    },
    resolveFolderId(item, type, index) {
      const value = this.pickValue(item, ['id', 'folderId', 'resourceId', 'key', 'dir', 'folder', 'folderPath', 'path'])
      if (value !== undefined && value !== null && value !== '') {
        return String(value)
      }
      return `${type || 'folder'}-${index}`
    },
    resolveFolderCount(item, type) {
      const definition = this.getRootFolderDefinitions().find(folder => folder.type == type)
      const countFields = [
        ...(definition ? definition.countFields : []),
        'count',
        'fileCount',
        'fileNum',
        'fileTotal',
        'folderCount',
        'folderNum',
        'folderTotal',
        'total',
        'totalCount',
        'num',
        'number',
        'quantity',
        'itemCount',
        'resourceCount',
        'childrenCount',
        'childrenNum',
        'childCount',
        'childNum'
      ]
      const value = this.pickValue(item, countFields)
      if (value !== undefined && value !== null && value !== '') {
        return value
      }
      const children = this.pickValue(item, ['children', 'items', 'list', 'records'])
      if (Array.isArray(children)) {
        return children.length
      }
      return ''
    },
    resolveDefaultAppTypeByFolderType(type) {
      const map = {
        paper: 1,
        meeting: 2,
        learning: 3,
        knowledge: 4,
        daily: 5,
        memo: 6
      }
      return Object.prototype.hasOwnProperty.call(map, type) ? map[type] : ''
    },
    resolveFolderAppType(item, type = '') {
      const value = this.pickValue(item, ['appType', 'applicationType', 'appId', 'app_id', 'resourceAppType'])
      const number = Number(value)
      if (Number.isFinite(number) && number > 0) {
        return number
      }
      const fallbackType = type || this.resolveFolderType(item)
      return this.resolveDefaultAppTypeByFolderType(fallbackType)
    },
    resolveActiveFolderAppType(item) {
      const direct = Number(item && item.appType)
      if (Number.isFinite(direct) && direct > 0) {
        return direct
      }
      const source = item && item.raw && typeof item.raw == 'object' ? item.raw : item
      return this.resolveFolderAppType(source, item && item.type ? item.type : '')
    },
    getMyFileFolderIcon(type, isEmptyCount = false) {
      const icons = isEmptyCount ? {
        paper: require('@/assets/wap/myfile-paper-empty.png'),
        meeting: require('@/assets/wap/myfile-meeting-empty.png'),
        learning: require('@/assets/wap/myfile-learning-empty.png'),
        knowledge: require('@/assets/wap/myfile-kb-empty.png'),
        memo: require('@/assets/wap/myfile-memo-empty.png'),
        daily: require('@/assets/wap/layer-stack.png')
      } : {
        paper: require('@/assets/wap/myfile-paper.png'),
        meeting: require('@/assets/wap/myfile-meeting.png'),
        learning: require('@/assets/wap/myfile-learning.png'),
        knowledge: require('@/assets/wap/myfile-kb.png'),
        memo: require('@/assets/wap/myfile-memo.png'),
        daily: require('@/assets/wap/myfile-folder.png')
      }
      return icons[type] || require('@/assets/wap/myfile-folder.png')
    },
    formatFolderCount(count, withUnit = true) {
      if (count === undefined || count === null || count === '') {
        return ''
      }
      const number = Number(count)
      const text = Number.isFinite(number) ? String(number) : String(count)
      if (!withUnit) {
        return text
      }
      const compactUnitLanguages = ['zh', 'tw', 'ja', 'ko']
      return compactUnitLanguages.includes(this.selectedLanguage) ? `${text}${this.uiText.itemUnit}` : `${text} ${this.uiText.itemUnit}`
    },
    formatFolderExtra(item) {
      if (!this.isFileListItem(item)) {
        return '-'
      }
      const value = this.resolveFileDate(item)
      return value ? this.formatFileDate(value) : '-'
    },
    isFileListItem(item) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : item
      if (!raw || typeof raw != 'object') {
        return false
      }
      const folderFlag = this.pickValue(raw, ['isDir', 'isDirectory', 'isFolder', 'directory'])
      if (folderFlag !== undefined && folderFlag !== null && folderFlag !== '') {
        if (typeof folderFlag == 'boolean') {
          return !folderFlag
        }
        const normalizedFlag = this.normalizeFieldKey(folderFlag)
        if (['false', '0', 'file', 'no'].includes(normalizedFlag)) {
          return true
        }
        if (['true', '1', 'folder', 'dir', 'directory', 'yes'].includes(normalizedFlag)) {
          return false
        }
      }
      const type = this.normalizeFieldKey(this.pickString(raw, ['itemType', 'resourceType', 'fileType', 'kind', 'type']))
      if (type.includes('folder') || type.includes('directory') || type == 'dir') {
        return false
      }
      if (type.includes('file')) {
        return true
      }
      return Boolean(this.pickString(raw, ['filename', 'fileName', 'originname', 'originName', 'extension', 'ext', 'suffix']))
    },
    resolveFileDate(item) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : item
      return this.pickValue(raw, [
        'updateAt',
        'updatedAt',
        'updateTime',
        'updatedTime',
        'modifyAt',
        'modifiedAt',
        'modifyTime',
        'modifiedTime',
        'lastModified',
        'lastModifiedAt',
        'mtime',
        'date',
        'time',
        'createAt',
        'createdAt',
        'createTime',
        'createdTime'
      ])
    },
    formatFileDate(value) {
      if (value instanceof Date) {
        return `${value.getFullYear()}/${value.getMonth() + 1}/${value.getDate()}`
      }
      const text = String(value || '').trim()
      if (!text) {
        return ''
      }
      const dateMatch = text.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})/)
      if (dateMatch) {
        return `${dateMatch[1]}/${Number(dateMatch[2])}/${Number(dateMatch[3])}`
      }
      const timestamp = Number(text)
      if (Number.isFinite(timestamp)) {
        const date = new Date(timestamp < 1000000000000 ? timestamp * 1000 : timestamp)
        if (!Number.isNaN(date.getTime())) {
          return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
        }
      }
      const date = new Date(text.replace(/-/g, '/'))
      if (Number.isNaN(date.getTime())) {
        return ''
      }
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
    },
    parseRecentDateTime(value) {
      if (value instanceof Date) {
        return value.getTime()
      }
      const number = Number(value)
      if (Number.isFinite(number) && number > 0) {
        return number < 1000000000000 ? number * 1000 : number
      }
      const text = String(value || '').trim()
      if (!text) {
        return 0
      }
      const direct = Date.parse(text)
      if (Number.isFinite(direct)) {
        return direct
      }
      const normalized = Date.parse(text.replace(/-/g, '/'))
      return Number.isFinite(normalized) ? normalized : 0
    },
    formatRecentDate(value) {
      const time = this.parseRecentDateTime(value)
      if (!time) {
        return '-'
      }
      const date = new Date(time)
      const month = `${date.getMonth() + 1}`.padStart(2, '0')
      const day = `${date.getDate()}`.padStart(2, '0')
      return `${date.getFullYear()}/${month}/${day}`
    },
    getRecentDisplayDate(item) {
      return item && (item.createdAt || item.creationTime || item.createTime)
    },
    getRecentLearningFileSizeValue(item) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : {}
      return this.pickFirstPresent(
        this.pickValue(item, ['fileSize']),
        this.pickValue(item, ['fileSizeBytes']),
        this.pickValue(item, ['size']),
        this.pickValue(raw, ['fileSize']),
        this.pickValue(raw, ['fileSizeBytes']),
        this.pickValue(raw, ['size'])
      )
    },
    isRecentLearningFileResource(item) {
      const resourceType = Number(item && item.resourceType)
      return Number.isFinite(resourceType) && resourceType === 6
    },
    formatRecentCount(item) {
      if (this.isRecentLearningFileResource(item)) {
        return this.formatRecentLearningFileSize(this.getRecentLearningFileSizeValue(item))
      }
      const ui = getAppUiText(this.selectedLanguage)
      return this.formatResourceCountLabel(item, {
        language: this.selectedLanguage,
        itemUnit: ui.item,
        pageUnit: ui.page,
        emptyText: ''
      })
    },
    formatRecentGridCount(item) {
      if (this.isRecentLearningFileResource(item)) {
        return this.formatRecentLearningFileSize(this.getRecentLearningFileSizeValue(item))
      }
      return String(Math.max(0, this.getRecentFolderChildSize(item)))
    },
    shouldDisplayRecentCover(item) {
      return !!(item && item.cover && !item.coverFailed && !this.isRecentFolderLike(item) && !item.encrypted)
    },
    shouldDisplayGlobalSearchCover(item) {
      if (!(item && item.cover && !item.coverFailed && !item.encrypted)) {
        return false
      }
      if (this.resolveAppFolderType(item) == 'daily') {
        return true
      }
      return !this.isRecentFolderLike(item)
    },
    shouldDisplayGlobalSearchGridCover(item) {
      if (!(item && this.getPaperGridCoverImageUrl(item) && !item.encrypted)) {
        return false
      }
      if (this.resolveAppFolderType(item) == 'daily') {
        return true
      }
      return !this.isRecentFolderLike(item)
    },
    shouldShowRecentGridCoverFold(item) {
      if (!item || item.encrypted || this.isRecentFolderLike(item)) {
        return false
      }
      const folderType = this.resolveAppFolderType(item)
      if (folderType == 'learning') {
        return true
      }
      if (folderType != 'paper') {
        return false
      }
      return this.isRecentPdfFileItem(item)
    },
    markRecentCoverFailed(item) {
      if (item) {
        this.$set(item, 'coverFailed', true)
      }
    },
    markRecentCoverLoaded(item) {
      if (item && this.resolveAppFolderType(item) == 'memo') {
        this.$set(item, 'coverLoaded', true)
      }
    },
    isRecentMemoCoverPending(item) {
      if (!item || this.resolveAppFolderType(item) != 'memo' || item.encrypted || this.isRecentFolderLike(item)) {
        return false
      }
      if (!this.shouldDisplayRecentCover(item)) {
        return false
      }
      return !item.coverLoaded
    },
    getRecentFallbackCover(item, mode = this.viewMode) {
      const folderType = item && item.folderType ? item.folderType : this.resolveFolderTypeByAppType(item && item.appType)
      const effectiveFolderType = folderType || this.resolveAppFolderType(item)
      const covers = this.getRecentFallbackCoverSet(folderType)
      const isGrid = mode == 'grid'
      if (effectiveFolderType == 'daily' && this.isRecentDailyTaskOrNoteItem(item) && !(item && item.encrypted) && !this.isRecentFolderLike(item)) {
        return RECENT_DAILY_EMPTY_COVER
      }
      if (folderType == 'knowledge') {
        if (this.isRecentKnowledgeBaseResourceTypeOneOrTwo(item) && covers.resourceType12) {
          return covers.resourceType12
        }
        if (this.isRecentKnowledgeBaseResourceType3(item) && covers.resourceType3) {
          return covers.resourceType3
        }
      }
      if (item && item.encrypted) {
        return isGrid ? covers.fileGridEncrypt : covers.fileListEncrypt
      }
      if (this.isRecentFolderLike(item)) {
        const hasChildren = this.getRecentFolderChildSize(item) > 0
        if (this.isRecentTemplateItem(item)) {
          if (isGrid) {
            return hasChildren ? covers.templateGridFilled : covers.templateGridEmpty
          }
          return hasChildren ? covers.templateListFilled : covers.templateListEmpty
        }
        if (isGrid) {
          return hasChildren ? covers.folderGridFilled : covers.folderGridEmpty
        }
        return hasChildren ? covers.folderListFilled : covers.folderListEmpty
      }
      const extension = this.getRecentFileExtension(item)
      const learningIcon = folderType == 'learning'
        ? {
          epub: covers.fileEpub,
          azw: covers.fileAzw,
          azw3: covers.fileAzw,
          mobi: covers.fileMobi
        }[extension]
        : null
      if (learningIcon) {
        return learningIcon
      }
      const pdfIcon = isGrid ? covers.fileGridPdf : covers.fileListPdf
      if (this.isRecentPdfFileItem(item, extension)) {
        return pdfIcon
      }
      if (this.isRecentPlaceholderCoverItem(item, folderType) && covers.placeholder) {
        return covers.placeholder
      }
      const paperIcon = isGrid ? covers.fileGridPaper : covers.fileListPaper
      return paperIcon
    },
    getRecentFallbackCoverSet(folderType) {
      return RECENT_APP_FALLBACK_COVERS[folderType] || RECENT_APP_FALLBACK_COVERS.paper
    },
    getRecentFallbackCoverStyle(item, mode = this.viewMode) {
      if (mode == 'grid') {
        return RECENT_GRID_FALLBACK_COVER_STYLE
      }
      if (item && item.encrypted) {
        return RECENT_ROW_ENCRYPT_FALLBACK_COVER_STYLE
      }
      if (this.isRecentFolderLike(item)) {
        return RECENT_ROW_FOLDER_FALLBACK_COVER_STYLE
      }
      return RECENT_ROW_FALLBACK_COVER_STYLE
    },
    getRecentFallbackCoverSize(item, mode = this.viewMode) {
      if (mode == 'grid') {
        return RECENT_GRID_FALLBACK_COVER_SIZE
      }
      if (item && item.encrypted) {
        return RECENT_ROW_ENCRYPT_FALLBACK_COVER_SIZE
      }
      if (this.isRecentFolderLike(item)) {
        return RECENT_ROW_FOLDER_FALLBACK_COVER_SIZE
      }
      return RECENT_ROW_FALLBACK_COVER_SIZE
    },
    isRecentFolderLike(item) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : item
      const folderFlag = this.pickValue(raw, ['isFolder', 'folder', 'isDir', 'directory'])
      if (folderFlag !== undefined && folderFlag !== null && folderFlag !== '') {
        if (typeof folderFlag == 'boolean') {
          return folderFlag
        }
        const normalizedFlag = this.normalizeFieldKey(folderFlag)
        if (['true', '1', 'folder', 'dir', 'directory', 'yes'].includes(normalizedFlag)) {
          return true
        }
        if (['false', '0', 'file', 'no'].includes(normalizedFlag)) {
          return false
        }
      }
      const resourceType = Number(item && item.resourceType)
      return Number.isFinite(resourceType) && (resourceType === 0 || resourceType === 5)
    },
    isRecentTemplateItem(item) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : item
      return this.pickBoolean(raw, ['template', 'isTemplate', 'templateFolder'])
    },
    isRecentPlaceholderCoverItem(item, folderType) {
      return ['paper', 'meeting', 'memo'].includes(folderType) && !this.isRecentFolderLike(item) && !(item && item.encrypted)
    },
    isRecentPdfFileItem(item, extension = this.getRecentFileExtension(item)) {
      const resourceType = Number(item && item.resourceType)
      return resourceType === 4 || extension == 'pdf'
    },
    getRecentFolderChildSize(item) {
      const value = item && item.childSize !== undefined && item.childSize !== null && item.childSize !== ''
        ? Number(item.childSize)
        : 0
      return Number.isFinite(value) ? value : 0
    },
    getRecentFileExtension(item) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : item
      const candidates = [
        item && item.filePath,
        this.pickString(raw, [
          'filePath',
          'file_path',
          'path',
          'originalFileUrl',
          'original_file_url',
          'downloadUrl',
          'download_url',
          'fileUrl',
          'file_url',
          'originalUrl',
          'original_url',
          'sourceUrl',
          'sourceImageUrl',
          'originalImageUrl',
          'resourceUrl',
          'resource_url',
          'url',
          'src'
        ]),
        item && item.name,
        this.pickString(raw, ['name', 'title', 'fileName', 'filename', 'resourceName', 'paperName'])
      ]
      for (let i = 0; i < candidates.length; i += 1) {
        const extension = this.getRecentUrlExtension(candidates[i]).toLowerCase()
        if (extension) {
          return extension
        }
      }
      return this.normalizeRecentExtension(this.pickString(raw, ['extension', 'ext', 'suffix', 'fileExtension', 'file_extension', 'fileFormat', 'file_format', 'format']))
    },
    normalizeRecentExtension(value) {
      const text = String(value || '').trim().toLowerCase().replace(/^\./, '')
      if (!text) {
        return ''
      }
      const mimeMatch = text.match(/\/([a-z0-9+.-]+)$/)
      const extension = (mimeMatch ? mimeMatch[1] : text).split(/[?#\s]/)[0]
      if (!extension || /^\d+$/.test(extension) || !/^[a-z0-9]{1,8}$/.test(extension)) {
        return ''
      }
      return extension
    },
    isRecentKnowledgeBaseResourceTypeOneOrTwo(item) {
      if (!item) {
        return false
      }
      const resourceType = Number(item.resourceType)
      return resourceType === 1 || resourceType === 2
    },
    isRecentKnowledgeBaseResourceType3(item) {
      return !!(item && Number(item.resourceType) === 3)
    },
    toggleRecentViewSheet() {
      this.recentViewSheetOpen = !this.recentViewSheetOpen
      this.closeMyFileViewSheet()
      this.closeRecentActionSheet()
      this.closeRecentMoreMenu()
    },
    closeRecentViewSheet() {
      this.recentViewSheetOpen = false
    },
    setRecentViewModeFromSheet(mode) {
      this.setViewMode(mode == 'grid' ? 'grid' : 'list')
      this.closeRecentViewSheet()
    },
    toggleMyFileViewSheet() {
      this.myFileViewSheetOpen = !this.myFileViewSheetOpen
      this.closeRecentViewSheet()
      this.closeRecentActionSheet()
      this.closeRecentMoreMenu()
    },
    closeMyFileViewSheet() {
      this.myFileViewSheetOpen = false
    },
    setMyFileViewMode(mode) {
      this.setSharedViewMode(mode)
      this.closeMyFileViewSheet()
      this.closeRecentViewSheet()
      this.closeRecentActionSheet()
      this.closeRecentMoreMenu()
    },
    setMyFileViewModeFromSheet(mode) {
      this.setMyFileViewMode(mode == 'grid' ? 'grid' : 'list')
    },
    isRecentSelected(item) {
      if (!item || item.id === undefined || item.id === null || item.id === '') {
        return false
      }
      return this.selectedRecentIds.some(id => String(id) == String(item.id))
    },
    syncRecentSelectionWithItems() {
      if (this.selectedRecentIds.length == 0) {
        this.selectedRecentId = ''
        this.selectedRecentAnchorId = ''
        return
      }
      const existingIds = new Set(this.recentItems.map(item => String(item.id)))
      this.selectedRecentIds = this.selectedRecentIds.filter(id => existingIds.has(String(id)))
      this.selectedRecentId = this.selectedRecentIds[0] || ''
      if (!existingIds.has(String(this.selectedRecentAnchorId))) {
        this.selectedRecentAnchorId = this.selectedRecentId
      }
    },
    selectRecentItem(item, event) {
      if (!item) {
        return
      }
      this.recentActionTargetId = ''
      const hadSelection = this.selectedRecentIds.length > 0
      const result = selectItemWithWindowsRange(
        this.visibleRecentItems,
        this.selectedRecentIds,
        item,
        this.selectedRecentAnchorId,
        event
      )
      const selectedIds = result.selectedIds

      this.selectedRecentIds = selectedIds
      this.selectedRecentId = selectedIds[0] || ''
      this.selectedRecentAnchorId = result.anchorId
      if (!hadSelection || selectedIds.length == 0) {
        this.resetRecentSelectionBarOffset()
      }
      this.closeRecentMoreMenu()
    },
    clearRecentSelection() {
      this.clearRecentItemClickTimer()
      this.selectedRecentIds = []
      this.selectedRecentId = ''
      this.selectedRecentAnchorId = ''
      this.recentActionTargetId = ''
      this.closeRecentActionSheet()
      this.closeRecentMoreMenu()
      this.resetRecentSelectionBarOffset()
    },
    startRecentSelectionFromItem(item, options = {}) {
      if (!item || item.id === undefined || item.id === null || item.id === '') {
        return
      }
      if (options.preserveExisting && this.selectedRecentIds.length > 0) {
        const selectedIds = this.selectedRecentIds.slice()
        const selectedIndex = selectedIds.findIndex(id => String(id) == String(item.id))
        if (selectedIndex >= 0) {
          selectedIds.splice(selectedIndex, 1)
        } else {
          selectedIds.push(item.id)
        }
        this.selectedRecentIds = selectedIds
        this.selectedRecentId = selectedIds[0] || ''
        this.selectedRecentAnchorId = selectedIndex >= 0 ? (selectedIds[0] || '') : item.id
        this.recentActionTargetId = ''
        if (selectedIds.length == 0) {
          this.closeRecentActionSheet()
          this.resetRecentSelectionBarOffset()
        }
        this.closeRecentMoreMenu()
        this.closeRecentViewSheet()
        return
      }
      this.setRecentSingleSelection(item)
      this.closeRecentViewSheet()
    },
    setRecentSingleSelection(item) {
      if (!item || item.id === undefined || item.id === null || item.id === '') {
        return
      }
      this.selectedRecentIds = [item.id]
      this.selectedRecentId = item.id
      this.selectedRecentAnchorId = item.id
      this.recentActionTargetId = ''
      this.resetRecentSelectionBarOffset()
      this.closeRecentMoreMenu()
    },
    setRecentTouchItemSelection(item, selected) {
      if (!item || item.id === undefined || item.id === null || item.id === '') {
        return
      }
      const currentIds = Array.isArray(this.selectedRecentIds) ? this.selectedRecentIds.slice() : []
      const selectedIndex = currentIds.findIndex(id => String(id) == String(item.id))
      if (selected && selectedIndex < 0) {
        currentIds.push(item.id)
      } else if (!selected && selectedIndex >= 0) {
        currentIds.splice(selectedIndex, 1)
      }
      this.selectedRecentIds = currentIds
      this.selectedRecentId = currentIds[0] || ''
      this.selectedRecentAnchorId = currentIds.length > 0 ? item.id : ''
      this.recentActionTargetId = ''
      this.closeRecentMoreMenu()
      this.closeRecentViewSheet()
      if (currentIds.length == 0) {
        this.resetRecentSelectionBarOffset()
      }
    },
    applyRecentTouchSelection(item) {
      const mode = this.recentTouchSelectionMode || (this.isRecentSelected(item) ? 'deselect' : 'select')
      this.setRecentTouchItemSelection(item, mode != 'deselect')
    },
    startRecentTouch(item, event) {
      this.clearRecentTouchTimer()
      this.clearRecentLongPressResetTimer()
      this.recentTouchMoved = false
      this.recentLongPressTriggered = false
      this.recentTouchSelectionActive = false
      this.recentTouchSelectionMode = ''
      this.recentTouchGestureType = 'pending'
      const touch = event && event.touches && event.touches[0]
      this.recentTouchStartPoint = touch ? { x: touch.clientX, y: touch.clientY } : null
      this.recentTouchStartTime = Date.now()
      this.recentTouchStartItemId = item && item.id !== undefined && item.id !== null ? item.id : ''
      if (!item) {
        return
      }
      this.recentTouchSelectionMode = this.isRecentSelected(item) ? 'deselect' : 'select'
      if (typeof window === 'undefined') {
        return
      }
      this.recentTouchTimer = window.setTimeout(() => {
        this.recentTouchTimer = null
        this.recentLongPressTriggered = true
        this.recentTouchSelectionActive = true
        this.recentTouchGestureType = 'selection'
        this.cancelRecentPullRefreshGesture()
        this.applyRecentTouchSelection(item)
      }, 520)
    },
    moveRecentTouch(event) {
      const touch = event && event.touches && event.touches[0]
      if (!touch) {
        return
      }
      const start = this.recentTouchStartPoint
      if (!start) {
        return
      }
      const gestureType = classifyMobileTouchGesture({
        startX: start.x,
        startY: start.y,
        startTime: this.recentTouchStartTime,
        gestureType: this.recentTouchGestureType,
        longPressTriggered: this.recentLongPressTriggered
      }, touch)
      if (gestureType == 'pending') {
        return
      }
      this.recentTouchGestureType = gestureType
      this.recentTouchMoved = true
      this.clearRecentTouchTimer()
      if (gestureType != 'selection') {
        return
      }
      if (!this.recentLongPressTriggered) {
        if (this.selectedRecentIds.length == 0) {
          return
        }
        this.recentLongPressTriggered = true
        this.recentTouchSelectionActive = true
        this.cancelRecentPullRefreshGesture()
        const startItem = this.visibleRecentItems.find(candidate => candidate && String(candidate.id) == String(this.recentTouchStartItemId))
        if (startItem) {
          this.applyRecentTouchSelection(startItem)
        }
      }
      if (event.cancelable) {
        event.preventDefault()
      }
      this.extendRecentTouchSelection(touch.clientX, touch.clientY)
    },
    endRecentTouch() {
      this.clearRecentTouchTimer()
      this.recentTouchStartPoint = null
      this.recentTouchStartTime = 0
      this.recentTouchStartItemId = ''
      if ((this.recentLongPressTriggered || this.recentTouchMoved) && typeof window !== 'undefined') {
        const touchMoved = this.recentTouchMoved
        this.recentLongPressResetTimer = window.setTimeout(() => {
          this.recentLongPressResetTimer = null
          this.recentLongPressTriggered = false
          this.recentTouchSelectionActive = false
          this.recentTouchSelectionMode = ''
          this.recentTouchGestureType = 'pending'
          if (touchMoved) {
            this.recentTouchMoved = false
          }
        }, 350)
      } else {
        this.recentTouchSelectionActive = false
        this.recentTouchSelectionMode = ''
      }
    },
    cancelRecentTouch() {
      this.clearRecentTouchTimer()
      this.clearRecentLongPressResetTimer()
      this.recentTouchStartPoint = null
      this.recentTouchStartTime = 0
      this.recentTouchStartItemId = ''
      this.recentTouchMoved = false
      this.recentLongPressTriggered = false
      this.recentTouchSelectionMode = ''
      this.recentTouchSelectionActive = false
      this.recentTouchGestureType = 'pending'
    },
    extendRecentTouchSelection(clientX, clientY) {
      if (typeof document === 'undefined' || typeof document.elementFromPoint !== 'function') {
        return
      }
      const element = document.elementFromPoint(clientX, clientY)
      const row = element && element.closest ? element.closest('[data-recent-id]') : null
      const id = row && row.getAttribute('data-recent-id')
      const item = id ? this.visibleRecentItems.find(candidate => candidate && String(candidate.id) == id) : null
      if (!item) {
        return
      }
      const startIndex = this.visibleRecentItems.findIndex(candidate => candidate && String(candidate.id) == String(this.recentTouchStartItemId))
      const endIndex = this.visibleRecentItems.indexOf(item)
      const crossedItems = startIndex >= 0 && endIndex >= 0
        ? this.visibleRecentItems.slice(Math.min(startIndex, endIndex), Math.max(startIndex, endIndex) + 1)
        : [item]
      const shouldSelect = this.recentTouchSelectionMode != 'deselect'
      const selectedIds = this.selectedRecentIds.slice()
      const selectedSet = new Set(selectedIds.map(value => String(value)))
      crossedItems.forEach(candidate => {
        if (!candidate || candidate.id === undefined || candidate.id === null || candidate.id === '') {
          return
        }
        const candidateKey = String(candidate.id)
        if (shouldSelect) {
          if (!selectedSet.has(candidateKey)) {
            selectedIds.push(candidate.id)
            selectedSet.add(candidateKey)
          }
        } else if (selectedSet.has(candidateKey)) {
          for (let selectedIndex = selectedIds.length - 1; selectedIndex >= 0; selectedIndex -= 1) {
            if (String(selectedIds[selectedIndex]) == candidateKey) {
              selectedIds.splice(selectedIndex, 1)
            }
          }
          selectedSet.delete(candidateKey)
        }
      })
      this.selectedRecentIds = selectedIds
      this.selectedRecentId = this.selectedRecentIds[0] || ''
      this.selectedRecentAnchorId = selectedIds.length > 0 ? item.id : ''
      this.recentActionTargetId = ''
      this.closeRecentMoreMenu()
      this.closeRecentViewSheet()
      if (selectedIds.length == 0) {
        this.resetRecentSelectionBarOffset()
      }
    },
    handleRecentContextMenu(item) {
      this.clearRecentTouchTimer()
      if (this.recentLongPressTriggered || this.recentTouchMoved) {
        return
      }
      this.recentLongPressTriggered = true
      this.recentTouchSelectionActive = true
      this.recentTouchGestureType = 'selection'
      this.recentTouchSelectionMode = this.recentTouchSelectionMode || (this.isRecentSelected(item) ? 'deselect' : 'select')
      this.cancelRecentPullRefreshGesture()
      this.applyRecentTouchSelection(item)
    },
    clearRecentTouchTimer() {
      if (this.recentTouchTimer) {
        clearTimeout(this.recentTouchTimer)
        this.recentTouchTimer = null
      }
    },
    clearRecentLongPressResetTimer() {
      if (this.recentLongPressResetTimer) {
        clearTimeout(this.recentLongPressResetTimer)
        this.recentLongPressResetTimer = null
      }
    },
    handleRecentItemClick(item, event) {
      if (!item) {
        return
      }
      if (event && event.detail > 1) {
        this.clearRecentItemClickTimer()
        return
      }
      this.clearRecentItemClickTimer()
      if (this.recentTouchMoved) {
        this.clearRecentLongPressResetTimer()
        this.recentTouchMoved = false
        this.recentLongPressTriggered = false
        this.recentTouchSelectionActive = false
        this.recentTouchSelectionMode = ''
        this.recentTouchGestureType = 'pending'
        return
      }
      if (this.recentLongPressTriggered) {
        this.clearRecentLongPressResetTimer()
        this.recentLongPressTriggered = false
        this.recentTouchSelectionActive = false
        this.recentTouchSelectionMode = ''
        this.recentTouchGestureType = 'pending'
        return
      }
      if (this.selectedRecentIds.length > 0) {
        this.startRecentSelectionFromItem(item, { preserveExisting: true })
        return
      }
      this.closeRecentViewSheet()
      this.openRecentItemFromDoubleAction(item, event)
    },
    handleRecentItemDblClick(item, event) {
      this.openRecentItemFromDoubleAction(item, event)
    },
    openRecentItemFromDoubleAction(item, event) {
      if (!item) {
        return
      }
      this.clearRecentItemClickTimer()
      const rawItemId = item.id || item.resourceId
      const itemId = rawItemId ? String(rawItemId) : ''
      const now = Date.now()
      const lastOpen = this.recentDoubleOpenState || {}
      if (itemId && lastOpen.id == itemId && now - lastOpen.time < 350) {
        return
      }
      this.recentDoubleOpenState = {
        id: itemId,
        time: now
      }
      this.openRecentItem(item, event)
    },
    handleRecentItemKeyup(item) {
      if (!item) {
        return
      }
      this.clearRecentItemClickTimer()
      this.clearRecentSelection()
      this.openRecentItem(item)
    },
    clearRecentItemClickTimer() {
      if (this.recentItemClickTimer) {
        clearTimeout(this.recentItemClickTimer)
        this.recentItemClickTimer = null
      }
    },
    startRecentSelectionBarDrag(event) {
      if (!event || event.button !== 0) {
        return
      }
      const interactiveTarget = event.target && event.target.closest && event.target.closest('button')
      if (interactiveTarget) {
        return
      }
      this.recentSelectionBarDragging = true
      this.recentSelectionBarDragState = {
        startY: event.clientY,
        startOffset: this.recentSelectionBarOffsetY
      }
      if (typeof document !== 'undefined') {
        document.addEventListener('mousemove', this.handleRecentSelectionBarDrag)
        document.addEventListener('mouseup', this.stopRecentSelectionBarDrag)
      }
    },
    handleRecentSelectionBarDrag(event) {
      if (!this.recentSelectionBarDragState || !event) {
        return
      }
      const nextOffset = this.recentSelectionBarDragState.startOffset + event.clientY - this.recentSelectionBarDragState.startY
      this.recentSelectionBarOffsetY = this.clampRecentSelectionBarOffset(nextOffset)
    },
    stopRecentSelectionBarDrag() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('mousemove', this.handleRecentSelectionBarDrag)
        document.removeEventListener('mouseup', this.stopRecentSelectionBarDrag)
      }
      this.recentSelectionBarDragging = false
      this.recentSelectionBarDragState = null
    },
    clampRecentSelectionBarOffset(value) {
      const number = Number(value) || 0
      const maxOffset = this.getRecentSelectionBarMaxOffset()
      return Math.min(Math.max(0, number), maxOffset)
    },
    getRecentSelectionBarMaxOffset() {
      const area = this.$refs.cloudContentArea
      const layer = this.$refs.recentSelectionLayer
      if (!area || !layer) {
        return 0
      }
      const areaRect = area.getBoundingClientRect()
      const layerRect = layer.getBoundingClientRect()
      return Math.max(0, areaRect.bottom - layerRect.top - layerRect.height)
    },
    resetRecentSelectionBarOffset() {
      this.stopRecentSelectionBarDrag()
      this.recentSelectionBarOffsetY = 0
    },
    toggleRecentMoreMenu(id) {
      this.recentMoreMenuId = this.recentMoreMenuId == id ? '' : id
    },
    closeRecentMoreMenu() {
      this.recentMoreMenuId = ''
    },
    openRecentItemActions(item) {
      if (!item) {
        return
      }
      const shouldClose = this.selectedRecentCount == 0 && this.recentActionTargetId == item.id
      this.clearRecentSelection()
      this.recentActionTargetId = shouldClose ? '' : item.id
      this.closeRecentActionSheet()
      this.closeRecentViewSheet()
    },
    closeRecentItemActions() {
      this.recentActionTargetId = ''
    },
    toggleRecentActionSheet() {
      if (this.selectedRecentCount == 0) {
        return
      }
      this.recentActionSheetOpen = !this.recentActionSheetOpen
      this.closeRecentMoreMenu()
      this.closeRecentViewSheet()
    },
    closeRecentActionSheet() {
      this.recentActionSheetOpen = false
    },
    openSelectedRecentItem() {
      const item = this.selectedRecentItems[0]
      if (!item) {
        return
      }
      this.openRecentItem(item)
    },
    canOpenRecentPagesItem(item) {
      if (!item || !item.resourceId || this.isRecentFolderLike(item)) {
        return false
      }
      const folderType = this.resolveAppFolderType(item) || (this.isDirectFilePreviewItem(item) ? 'paper' : '')
      if (!folderType) {
        return false
      }
      if (folderType == 'daily') {
        return this.resolveRecentDailyType(item) !== 2
      }
      if (folderType == 'learning' && !this.isDirectFilePreviewItem(item)) {
        const fallbackDetail = this.normalizeRecentLearningFallback(item)
        return this.getRecentLearningCount(fallbackDetail, 'annotations') > 0
      }
      return ['paper', 'meeting', 'memo', 'knowledge', 'learning'].includes(folderType)
    },
    openSelectedRecentPages() {
      const item = this.selectedRecentItems[0]
      if (!this.canOpenRecentPagesItem(item)) {
        return
      }
      this.openRecentItem(item, null, { openPageGrid: true })
    },
    fakeRecentAction() {
      this.$message.info(this.uiText.actionUnavailable || '暂未开放')
    },
    canPerformRecentAction(type, items) {
      const list = Array.isArray(items) ? items.filter(Boolean) : []
      if (list.length == 0) {
        return false
      }
      if (type == 'download') {
        return list.every(item => this.isRecentDownloadableItem(item))
      }
      if (list.length != 1) {
        return false
      }
      const item = list[0]
      if (type == 'encrypt') {
        return !item.encrypted
      }
      if (type == 'decrypt') {
        return !!item.encrypted
      }
      return type == 'favorite'
    },
    performRecentSelectionAction(type) {
      this.performRecentAction(type, this.selectedRecentItems)
    },
    performRecentAction(type, items) {
      const list = Array.isArray(items) ? items.filter(Boolean) : []
      if (!this.canPerformRecentAction(type, list)) {
        return
      }
      this.closeRecentActionSheet()
      if (type == 'download') {
        this.openRecentDownloadFormatModal(list, { selectionContext: 'recent' })
        return
      }
      if (type == 'favorite') {
        this.$set(list[0], 'favorite', !list[0].favorite)
        return
      }
      if (type == 'encrypt') {
        this.$set(list[0], 'encrypted', true)
        this.$message.info(this.uiText.actionUnavailable || '暂未开放')
        return
      }
      if (type == 'decrypt') {
        this.$set(list[0], 'encrypted', false)
        this.$message.info(this.uiText.actionUnavailable || '暂未开放')
      }
    },
    isRecentDownloadableItem(item) {
      if (!item) {
        return false
      }
      if (this.resolveAppFolderType(item) == 'learning') {
        return false
      }
      if (this.isRecentPngOnlyDownloadItem(item)) {
        return this.isDirectFilePreviewItem(item) || !!(item.hasResourceId && this.resolveAppFolderType(item))
      }
      if (this.isRecentFolderLikeItem(item)) {
        return false
      }
      if (this.isDirectFilePreviewItem(item)) {
        return true
      }
      return !!(item.hasResourceId && this.resolveAppFolderType(item))
    },
    pickFirstPresent(...values) {
      for (let i = 0; i < values.length; i += 1) {
        const value = values[i]
        if (value !== undefined && value !== null && value !== '') {
          return value
        }
      }
      return undefined
    },
    getRecentLearningCount(detail, key) {
      const source = detail || {}
      const list = Array.isArray(source[key]) ? source[key] : []
      if (list.length > 0) {
        return list.length
      }
      const count = source.counts && source.counts[key]
      const number = Number(count)
      return Number.isFinite(number) ? number : 0
    },
    normalizeRecentLearningBookmarks(rawBookmarks) {
      const bookmarks = Array.isArray(rawBookmarks) ? rawBookmarks : []
      return bookmarks.map((bookmark, index) => {
        const item = bookmark && typeof bookmark == 'object' ? bookmark : { title: bookmark }
        const pageNo = this.pickValue(item, ['pageNo', 'page', 'pageIndex', 'index', 'no'])
        return {
          id: this.pickString(item, ['id', 'uuid', 'bookmarkId']) || `recent-learning-bookmark-${index}`,
          title: this.pickString(item, ['bookmarkName', 'title', 'name', 'chapter', 'content', 'text']) || `${this.uiText.bookmarks} ${index + 1}`,
          pageNo,
          pageLabel: this.getRecentLearningPageLabel(pageNo, index),
          createdAt: this.pickValue(item, ['date', 'createdAt', 'createTime', 'time', 'updatedAt', 'modifyTime']),
          raw: item
        }
      })
    },
    normalizeRecentLearningHighlights(rawHighlights) {
      const highlights = Array.isArray(rawHighlights) ? rawHighlights : []
      return highlights.map((highlight, index) => {
        const item = highlight && typeof highlight == 'object' ? highlight : { content: highlight }
        const pageNo = this.pickValue(item, ['pageNo', 'page', 'pageIndex', 'index', 'no'])
        const content = this.pickString(item, ['content', 'centent', 'text', 'highlightText', 'note', 'description', 'summary'])
        const title = this.pickString(item, ['highlightName', 'title', 'name', 'chapter']) || this.getRecentLearningHighlightTitle(content, index)
        return {
          id: this.pickString(item, ['id', 'uuid', 'highlightId']) || `recent-learning-highlight-${index}`,
          title,
          content: content || title,
          pageNo,
          pageLabel: this.getRecentLearningPageLabel(pageNo, index),
          color: this.pickString(item, ['color', 'highlightColor']),
          createdAt: this.pickValue(item, ['date', 'createdAt', 'createTime', 'time', 'updatedAt', 'modifyTime']),
          raw: item
        }
      })
    },
    normalizeRecentLearningAnnotations(rawAnnotations) {
      const annotations = Array.isArray(rawAnnotations) ? rawAnnotations : []
      return annotations.map((annotation, index) => {
        const item = annotation && typeof annotation == 'object' ? annotation : {}
        const pageNo = this.pickValue(item, ['pageNo', 'page', 'pageIndex', 'index', 'no'])
        const title = this.pickString(item, ['readNoteName', 'title', 'name', 'chapter'])
          || `${this.uiText.annotations} ${index + 1}`
        return {
          id: this.pickString(item, ['id', 'uuid', 'annotationId', 'handwritingId']) || `recent-learning-annotation-${index}`,
          title,
          pageNo,
          pageLabel: this.getRecentLearningPageLabel(pageNo, index),
          imageUrl: this.pickPaperBestImageUrl(item) || this.pickString(item, ['imageUrl', 'annotationImageUrl', 'inkImageUrl', 'url', 'src']),
          pageImageUrl: this.pickPaperPageImageUrl(item) || this.pickString(item, ['pageImageUrl', 'backgroundImageUrl', 'baseImageUrl', 'pageUrl', 'pageSrc']),
          screenSize: this.pickString(item, ['screenSize']),
          createdAt: this.pickValue(item, ['date', 'createdAt', 'createTime', 'time', 'updatedAt', 'modifyTime']),
          raw: item
        }
      }).filter(item => item.imageUrl || item.pageImageUrl || item.title)
    },
    getRecentLearningPageLabel(pageNo, index) {
      const number = Number(pageNo)
      return Number.isFinite(number) && number > 0 ? `Page ${number}` : `Page ${index + 1}`
    },
    getRecentLearningHighlightTitle(content, index) {
      const text = String(content || '').replace(/\s+/g, ' ').trim()
      if (!text) {
        return `${this.uiText.highlights} ${index + 1}`
      }
      return text.length > 36 ? `${text.slice(0, 36)}...` : text
    },
    formatRecentLearningPageBadge(item) {
      const pageNo = item && item.pageNo
      const pageLabel = item && item.pageLabel ? String(item.pageLabel) : ''
      const number = Number(pageNo)
      if (Number.isFinite(number) && number > 0) {
        return `P${number}`
      }
      const matched = pageLabel.match(/\d+/)
      return matched ? `P${matched[0]}` : pageLabel
    },
    normalizeRecentLearningProgress(rawProgress) {
      const progress = rawProgress && typeof rawProgress == 'object' ? rawProgress : {}
      const currentPage = this.toRecentFiniteNumber(this.pickValue(progress, ['currentPage', 'pageNo', 'page']))
      const totalPages = this.toRecentFiniteNumber(this.pickValue(progress, ['totalPages', 'totalPage', 'pageCount']))
      const rawPercent = this.pickValue(progress, ['progressPercent', 'percent', 'progress', 'readingProgress'])
      const hasExplicitPercent = rawPercent !== undefined && rawPercent !== null && rawPercent !== ''
      const explicitPercent = this.toRecentFiniteNumber(rawPercent)
      const derivedPercent = totalPages > 0 ? currentPage / totalPages * 100 : 0
      return {
        currentPage,
        totalPages,
        progressPercent: this.clampRecentPercent(hasExplicitPercent ? explicitPercent : derivedPercent)
      }
    },
    toRecentFiniteNumber(value, fallback = 0) {
      const number = Number(value)
      return Number.isFinite(number) ? number : fallback
    },
    clampRecentPercent(value) {
      const number = this.toRecentFiniteNumber(value, 0)
      return Math.max(0, Math.min(100, number))
    },
    formatRecentLearningPercent(value) {
      const percent = this.clampRecentPercent(value)
      return Number.isInteger(percent) ? String(percent) : percent.toFixed(1)
    },
    formatRecentLearningFileFormat(value) {
      const text = String(value || '').trim().replace(/^\./, '')
      return text ? text.toUpperCase() : '-'
    },
    formatRecentLearningFileSize(value) {
      const bytes = Number(value)
      if (!Number.isFinite(bytes) || bytes < 0) {
        return '-'
      }
      if (bytes === 0) {
        return '0B'
      }
      const units = ['B', 'KB', 'MB', 'GB']
      let size = bytes
      let unitIndex = 0
      while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024
        unitIndex += 1
      }
      const precision = unitIndex == 0 || Number.isInteger(size) ? 0 : 2
      return `${Number(size.toFixed(precision))}${units[unitIndex]}`
    },
    normalizeRecentLearningSyncStatus(value) {
      const number = Number(value)
      if (number === 0 || number === 1) {
        return number
      }
      return -1
    },
    isRecentLearningMetaShape(value) {
      if (!value || typeof value != 'object') {
        return false
      }
      return [
        'fileSizeBytes',
        'fileFormat',
        'syncStatus',
        'readingProgress',
        'bookmarks',
        'highlights',
        'readNotes'
      ].some(key => this.pickValue(value, [key]) !== undefined)
    },
    resolveRecentLearningMeta(meta) {
      if (!meta || typeof meta != 'object') {
        return {}
      }
      const nested = this.pickValue(meta, ['learning', 'learngin', 'learn', 'book', 'reader'])
      if (nested && typeof nested == 'object') {
        return nested
      }
      return meta
    },
    extractRecentLearningArray(meta, detail, keys) {
      const directArray = this.extractRecentArray(this.pickValue(meta, keys))
      if (directArray.length > 0) {
        return directArray
      }
      const detailArray = this.extractRecentArray(this.pickValue(detail, keys))
      if (detailArray.length > 0) {
        return detailArray
      }
      return []
    },
    extractRecentLearningCategoryArray(meta, detail, keys, category) {
      const explicit = this.extractRecentLearningArray(meta, detail, keys)
      if (explicit.length > 0) {
        return explicit
      }
      const candidates = this.collectRecentLearningArrayCandidates(meta).concat(this.collectRecentLearningArrayCandidates(detail))
      const matched = []
      candidates.forEach(list => {
        if (!Array.isArray(list) || list.length == 0) {
          return
        }
        const score = list.reduce((total, item) => total + this.getRecentLearningCategoryScore(item, category), 0)
        if (score > 0 && score >= Math.ceil(list.length / 2)) {
          matched.push(...list)
        }
      })
      return matched
    },
    collectRecentLearningArrayCandidates(source, depth = 0) {
      if (!source || typeof source != 'object' || depth > 3) {
        return []
      }
      if (Array.isArray(source)) {
        return source.some(item => item && typeof item == 'object') ? [source] : []
      }
      return Object.keys(source).reduce((arrays, key) => arrays.concat(this.collectRecentLearningArrayCandidates(source[key], depth + 1)), [])
    },
    getRecentLearningCategoryScore(raw, category) {
      const item = raw && typeof raw == 'object' ? raw : {}
      if (category == 'annotation') {
        return this.pickValue(item, ['readNoteName', 'imageUrl', 'pageImageUrl', 'annotationImageUrl', 'inkImageUrl']) !== undefined ? 1 : 0
      }
      if (category == 'highlight') {
        return this.pickValue(item, ['highlightName', 'content', 'centent', 'highlightText']) !== undefined ? 1 : 0
      }
      if (category == 'bookmark') {
        const hasBookmarkName = this.pickValue(item, ['bookmarkName', 'bookmarkTitle']) !== undefined
        const hasOtherCategory = this.getRecentLearningCategoryScore(item, 'annotation') > 0 || this.getRecentLearningCategoryScore(item, 'highlight') > 0
        return hasBookmarkName || (!hasOtherCategory && this.pickValue(item, ['pageNo', 'page']) !== undefined) ? 1 : 0
      }
      return 0
    },
    async parseRecentLearningMeta(value) {
      if (!value) {
        return {}
      }
      if (typeof value == 'object') {
        return value
      }
      const text = String(value).trim()
      if (!text) {
        return {}
      }
      const directMeta = this.parseRecentLearningMetaJson(text)
      if (directMeta) {
        return directMeta
      }
      const bytes = this.decodeRecentLearningBase64Bytes(text)
      if (!bytes || bytes.length == 0) {
        return {}
      }
      if (this.isRecentLearningZipBytes(bytes)) {
        const zipText = await this.decodeRecentLearningZipBytesText(bytes)
        const zipMeta = this.parseRecentLearningMetaJson(zipText)
        if (zipMeta) {
          return zipMeta
        }
      }
      const decodedText = this.decodeRecentLearningCompressedBytesText(bytes)
      return this.parseRecentLearningMetaJson(decodedText) || {}
    },
    parseRecentLearningMetaJson(value) {
      try {
        const parsed = JSON.parse(value)
        return parsed && typeof parsed == 'object' ? parsed : null
      } catch (error) {
        return null
      }
    },
    decodeRecentLearningBase64Bytes(value) {
      try {
        const base64 = String(value || '')
          .trim()
          .replace(/^data:[^,]+,/, '')
          .replace(/\s/g, '')
          .replace(/-/g, '+')
          .replace(/_/g, '/')
        if (!base64) {
          return null
        }
        const padding = base64.length % 4
        const paddedBase64 = padding ? base64 + '='.repeat(4 - padding) : base64
        const binary = typeof window !== 'undefined' && typeof window.atob == 'function'
          ? window.atob(paddedBase64)
          : atob(paddedBase64)
        const bytes = new Uint8Array(binary.length)
        for (let i = 0; i < binary.length; i += 1) {
          bytes[i] = binary.charCodeAt(i)
        }
        return bytes
      } catch (error) {
        return null
      }
    },
    isRecentLearningZipBytes(bytes) {
      return !!(bytes && bytes.length >= 4 && bytes[0] === 0x50 && bytes[1] === 0x4b)
    },
    async decodeRecentLearningZipBytesText(bytes) {
      try {
        const zip = await JSZip.loadAsync(bytes)
        const files = Object.keys(zip.files)
          .map(name => zip.files[name])
          .filter(file => file && !file.dir)
        const file = files.find(item => /\.json$/i.test(item.name || '')) || files.find(item => /\.(txt|meta)$/i.test(item.name || '')) || files[0]
        return file ? await file.async('string') : ''
      } catch (error) {
        return ''
      }
    },
    decodeRecentLearningCompressedBytesText(bytes) {
      if (!bytes || bytes.length == 0) {
        return ''
      }
      const decoders = [
        input => pako.ungzip(input, { to: 'string' }),
        input => pako.inflate(input, { to: 'string' }),
        input => pako.inflateRaw(input, { to: 'string' }),
        input => this.decodeRecentLearningUtf8Bytes(input)
      ]
      for (let i = 0; i < decoders.length; i += 1) {
        try {
          const text = decoders[i](bytes)
          if (text && this.parseRecentLearningMetaJson(text)) {
            return text
          }
        } catch (error) {
          // Try the next compression variant.
        }
      }
      return ''
    },
    decodeRecentLearningUtf8Bytes(bytes) {
      if (typeof TextDecoder !== 'undefined') {
        return new TextDecoder('utf-8').decode(bytes)
      }
      let binary = ''
      for (let i = 0; i < bytes.length; i += 1) {
        binary += String.fromCharCode(bytes[i])
      }
      return decodeURIComponent(escape(binary))
    },
    isRecentFolderLikeItem(item) {
      return this.isRecentFolderLike(item)
    },
    getRecentDownloadUrl(item) {
      if (!item) {
        return ''
      }
      const raw = item.raw && typeof item.raw == 'object' ? item.raw : item
      const direct = item.filePath || this.pickString(raw, [
        'filePath',
        'file_path',
        'path',
        'originalFileUrl',
        'original_file_url',
        'downloadUrl',
        'download_url',
        'fileUrl',
        'file_url',
        'originalUrl',
        'original_url',
        'sourceUrl',
        'sourceImageUrl',
        'originalImageUrl',
        'resourceUrl',
        'resource_url'
      ])
      if (direct) {
        return direct
      }
      return this.pickPaperBestImageUrl(raw, { includeThumbnail: false }) || this.pickPaperBestImageUrl(item, { includeThumbnail: false }) || item.cover || ''
    },
    downloadRecentItem(item) {
      this.closeRecentMoreMenu()
      this.openRecentDownloadFormatModal(item ? [item] : [])
    },
    downloadSelectedRecentItems() {
      this.openRecentDownloadFormatModal(this.selectedRecentItems, { selectionContext: 'recent' })
    },
    downloadRecentActionItems() {
      const items = this.recentActionItems.slice()
      if (items.length == 0) {
        return
      }
      const isSelectionDownload = this.selectedRecentCount > 0
      const options = isSelectionDownload ? { selectionContext: 'recent' } : {}
      this.closeRecentItemActions()
      this.closeRecentActionSheet()
      this.closeRecentMoreMenu()
      this.openRecentDownloadFormatModal(items, options)
      if (isSelectionDownload) {
        this.clearRecentSelection()
      }
    },
    isRecentPngOnlyDownloadItem(item) {
      const folderType = this.resolveAppFolderType(item)
      return (folderType == 'paper' || folderType == 'meeting') && this.isRecentTemplateDownloadItem(item)
    },
    isRecentTemplateDownloadItem(item) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : item
      const resourceType = Number(item && item.resourceType)
      if (resourceType === 5 || this.isRecentTemplateItem(item)) {
        return true
      }
      const parentResourceType = Number(this.pickFirstPresent(
        this.pickValue(item, ['parentResourceType', 'parent_resource_type', 'folderResourceType', 'folder_resource_type', 'directoryResourceType', 'directory_resource_type', 'parentType', 'parent_type']),
        this.pickValue(raw, ['parentResourceType', 'parent_resource_type', 'folderResourceType', 'folder_resource_type', 'directoryResourceType', 'directory_resource_type', 'parentType', 'parent_type'])
      ))
      if (parentResourceType === 5) {
        return true
      }
      return this.pickBoolean(raw, ['inTemplateFolder', 'in_template_folder', 'underTemplateFolder', 'under_template_folder', 'isTemplateChild', 'templateChild'])
    },
    getRecentDownloadFormatForItem(item, format) {
      if (this.isRecentPngOnlyDownloadItem(item)) {
        return 'png'
      }
      return format == 'png' ? 'png' : 'pdf'
    },
    enqueueRecentDownloadItems(items, format, password = '') {
      const entries = (Array.isArray(items) ? items : [])
        .map(entry => (entry && entry.item) ? entry : { item: entry })
        .filter(entry => entry && entry.item)
      const list = entries.map(entry => entry.item)
      if (this.$shouldBundleDownloadItems(list)) {
        const task = this.$createDownloadBundleTask(list, format, password, {
          idPrefix: 'recent-bundle-download',
          kind: 'recent-bundle',
          fallbackName: this.uiText.download || 'download',
          sanitizeFileName: this.sanitizeRecentFileName
        })
        this.$set(task, 'preparedDownloadItems', entries)
        this.$enqueuePaperDownloadTask(task, () => this.runRecentDownloadBundleTask(task))
        return
      }
      entries.forEach(entry => {
        const item = entry.item
        const itemFormat = this.getRecentDownloadFormatForItem(item, format)
        const task = this.createRecentDownloadTask(item, itemFormat, password)
        this.applyRecentDownloadPreparedTask(task, entry)
        this.$enqueuePaperDownloadTask(task, () => this.runRecentDownloadTask(task))
      })
    },
    runRecentDownloadBundleTask(task) {
      const preparedEntries = Array.isArray(task.preparedDownloadItems) ? task.preparedDownloadItems : []
      const getPreparedEntry = item => preparedEntries.find(entry => entry && entry.item === item) || null
      this.$runDownloadBundleTask(task, {
        items: task.sourceItems,
        format: task.format,
        password: task.password || '',
        kind: 'recent-bundle',
        fallbackName: this.uiText.download || 'download',
        sanitizeFileName: this.sanitizeRecentFileName,
        getItemFormat: (item, format) => this.getRecentDownloadFormatForItem(item, format),
        createItemTask: (item, format, password) => {
          const itemTask = this.createRecentDownloadTask(item, format, password)
          this.applyRecentDownloadPreparedTask(itemTask, getPreparedEntry(item))
          return itemTask
        },
        runItemTask: bundleTask => this.runRecentDownloadTask(bundleTask)
      })
    },
    getRecentDownloadSelectionContext(items, requestedContext = '') {
      const list = Array.isArray(items) ? items.filter(Boolean) : []
      if (list.length == 0) {
        return ''
      }
      const matchesSelection = selectedItems => {
        if (!Array.isArray(selectedItems) || selectedItems.length != list.length) {
          return false
        }
        const selectedIds = new Set(selectedItems.map(item => item && item.id).filter(Boolean))
        return selectedIds.size == list.length && list.every(item => item && selectedIds.has(item.id))
      }
      if (requestedContext == 'search' && matchesSelection(this.selectedGlobalSearchItems)) {
        return 'search'
      }
      if (requestedContext == 'recent' && matchesSelection(this.selectedRecentItems)) {
        return 'recent'
      }
      if (matchesSelection(this.selectedGlobalSearchItems)) {
        return 'search'
      }
      if (matchesSelection(this.selectedRecentItems)) {
        return 'recent'
      }
      return ''
    },
    clearRecentDownloadSelection(context) {
      if (context == 'search') {
        this.clearGlobalSearchSelection()
        return
      }
      if (context == 'recent') {
        this.clearRecentSelection()
      }
    },
    isRecentLearningDownloadPrecheckItem(item) {
      return !!(item && this.resolveAppFolderType(item) == 'learning' && !this.isDirectFilePreviewItem(item))
    },
    getRecentLearningDownloadPages(detail) {
      const annotations = detail && Array.isArray(detail.annotations) ? detail.annotations : []
      return annotations
        .filter(page => page && (page.imageUrl || page.pageImageUrl))
        .slice()
        .sort((a, b) => Number(a.pageNo) - Number(b.pageNo))
    },
    async fetchRecentLearningDownloadDetail(item, password = '') {
      const cacheKey = this.getRecentLearningDetailCacheKey(item, password)
      const cachedDetail = this.getCachedRecentLearningDetail(cacheKey)
      if (cachedDetail) {
        return cachedDetail
      }
      const ret = await this.fetchRecentDetailResponse(item, password)
      const payload = this.resolveRecentApiPayload(ret)
      if (payload === null) {
        throw new Error(this.getRecentApiErrorMessage(ret) || (this.uiText.openUnavailable || 'Preview is unavailable for this item'))
      }
      const detail = await this.normalizeRecentLearningDetail(payload, item)
      this.setRecentLearningDetailCache(cacheKey, detail)
      return detail
    },
    async prepareRecentDownloadItemsForQueue(items, password = '') {
      const list = Array.isArray(items) ? items.filter(Boolean) : []
      const entries = await Promise.all(list.map(async item => {
        if (!this.isRecentLearningDownloadPrecheckItem(item)) {
          return { item }
        }
        try {
          const detail = await this.fetchRecentLearningDownloadDetail(item, password)
          const pages = this.getRecentLearningDownloadPages(detail)
          if (pages.length == 0) {
            return { item, skipped: true }
          }
          return { item, detail, pages }
        } catch (error) {
          return { item }
        }
      }))
      return entries.filter(entry => entry && entry.item)
    },
    applyRecentDownloadPreparedTask(task, entry) {
      if (!task || !entry) {
        return
      }
      if (entry.detail) {
        this.$set(task, 'detail', entry.detail)
      }
      if (Array.isArray(entry.pages)) {
        this.$set(task, 'pages', entry.pages.slice())
      }
    },
    openRecentDownloadFormatModal(items, options = {}) {
      const list = (Array.isArray(items) ? items : []).filter(Boolean)
      if (list.length == 0) {
        this.$message.info(this.uiText.downloadUnavailable || 'No downloadable file is available')
        return
      }
      if (list.some(item => !this.isRecentDownloadableItem(item))) {
        this.$message.info(this.uiText.downloadUnavailable || 'No downloadable file is available')
        return
      }
      const selectionContext = this.getRecentDownloadSelectionContext(list, options.selectionContext)
      const encryptedItem = list.find(item => item && item.encrypted)
      if (encryptedItem && !(options && options.skipPasswordPrompt)) {
        this.openRecentPasswordModal(encryptedItem, '', false, this.globalSearchOpen ? 'search' : 'recent', 'download', list)
        return
      }
      const password = options.password || ''
      if (list.every(item => this.isRecentPngOnlyDownloadItem(item))) {
        if (!this.$canStartFileDownloadBatch(list.length)) {
          return
        }
        this.enqueueRecentDownloadItems(list, 'png', password)
        this.clearRecentDownloadSelection(selectionContext)
        return
      }
      this.recentDownloadItems = list
      this.recentDownloadPassword = password
      this.recentDownloadSelectionContext = selectionContext
      this.recentDownloadFormat = 'pdf'
      this.recentDownloadFormatModalOpen = true
    },
    closeRecentDownloadFormatModal() {
      if (this.recentDownloadSubmitting) {
        return
      }
      this.recentDownloadFormatModalOpen = false
      this.recentDownloadItems = []
      this.recentDownloadPassword = ''
      this.recentDownloadSelectionContext = ''
      this.recentDownloadFormat = 'pdf'
    },
    async confirmRecentDownloadFormat() {
      const list = this.recentDownloadItems.slice()
      if (list.length == 0 || this.recentDownloadSubmitting) {
        return
      }
      const format = this.recentDownloadFormat == 'png' ? 'png' : 'pdf'
      const password = this.recentDownloadPassword || ''
      const selectionContext = this.recentDownloadSelectionContext
      this.recentDownloadSubmitting = true
      let preparedItems = []
      try {
        preparedItems = await this.prepareRecentDownloadItemsForQueue(list, password)
      } finally {
        this.recentDownloadSubmitting = false
      }
      const downloadableItems = preparedItems.filter(entry => !entry.skipped)
      if (downloadableItems.length == 0) {
        this.closeRecentDownloadFormatModal()
        if (preparedItems.some(entry => entry && entry.skipped)) {
          this.$notifyLearningAnnotationsEmptyDownload()
        }
        return
      }
      if (!this.$canStartFileDownloadBatch(downloadableItems.length)) {
        return
      }
      this.recentDownloadFormatModalOpen = false
      this.recentDownloadItems = []
      this.recentDownloadPassword = ''
      this.recentDownloadSelectionContext = ''
      this.enqueueRecentDownloadItems(downloadableItems, format, password)
      this.clearRecentDownloadSelection(selectionContext)
    },
    createRecentDownloadTask(item, format, password = '') {
      const safeFormat = this.getRecentDownloadFormatForItem(item, format)
      const baseName = this.$getDownloadBaseName(item && item.name, this.uiText.download, this.sanitizeRecentFileName)
      const extension = safeFormat == 'png' ? 'png' : 'pdf'
      return {
        id: `recent-download-${Date.now()}-${Math.random().toString(16).slice(2)}`,
        kind: 'recent-resource',
        name: baseName,
        fileName: `${baseName}.${extension}`,
        format: safeFormat,
        sourceItem: item,
        password: item && item.encrypted ? password : '',
        openUrl: '',
        abortController: null,
        cancelled: false,
        progress: 0,
        state: 'running',
        statusText: '准备下载'
      }
    },
    async runRecentDownloadTask(task) {
      try {
        this.ensurePaperDownloadTaskActive(task)
        this.updatePaperDownloadTask(task, {
          state: 'running',
          progress: Math.max(task.progress || 0, 5),
          statusText: '下载中'
        })
        await this.downloadRecentItemWithFormat(task.sourceItem, task.format, task)
        this.ensurePaperDownloadTaskActive(task)
        this.updatePaperDownloadTask(task, {
          progress: 100,
          state: 'done',
          statusText: '下载完成'
        })
      } catch (error) {
        if (error && error.isPaperDownloadCancelled) {
          return
        }
        if (this.$isLearningAnnotationsEmptyDownloadError(error)) {
          if (task && task.captureBlob) {
            throw error
          }
          this.$handleLearningAnnotationsEmptyDownloadTask(task)
          return
        }
        const isCorsLikeError = this.isLikelyCorsDownloadError(error)
        this.updatePaperDownloadTask(task, {
          state: 'error',
          progress: task.progress || 0,
          statusText: isCorsLikeError ? '图片读取失败，请点击重试' : (error && error.message ? error.message : '下载失败')
        })
      }
    },
    async downloadRecentItemWithFormat(item, format, task) {
      const safeFormat = this.getRecentDownloadFormatForItem(item, format)
      if (task && task.format != safeFormat) {
        this.$set(task, 'format', safeFormat)
      }
      const handled = await this.downloadRecentItemWithBusinessWorker(task, item, safeFormat)
      if (handled) {
        return
      }
      const url = this.getRecentDownloadUrl(item)
      if (!url) {
        throw new Error('No downloadable file')
      }
      const baseName = this.$getDownloadBaseName(item && item.name, this.uiText.download, this.sanitizeRecentFileName)
      if (safeFormat == 'png') {
        await this.downloadRecentAsPng(item, url, baseName, task)
        return
      }
      await this.downloadRecentAsPdf(item, url, baseName, task)
    },
    async downloadRecentAsPdf(item, url, baseName, task) {
      const extension = this.getRecentUrlExtension(url).toLowerCase()
      const fileName = this.$getDownloadFileName(baseName, 'pdf', this.uiText.download, this.sanitizeRecentFileName)
      if (extension == 'pdf') {
        if (task) {
          try {
            const pdfBlob = await this.fetchRecentBlob(url, percent => {
              this.updatePaperDownloadTask(task, {
                progress: Math.max(task.progress || 0, Math.round(5 + percent * 0.85)),
                statusText: '娑撳娴囨稉?'
              })
            }, task)
            this.ensurePaperDownloadTaskActive(task)
            if (!this.$captureDownloadBlob(task, pdfBlob, fileName)) {
              saveAs(pdfBlob, fileName)
            }
            return
          } catch (error) {
            if (error && error.isPaperDownloadCancelled) {
              throw error
            }
            if (task.cancelled) {
              const cancelError = new Error('Download cancelled')
              cancelError.isPaperDownloadCancelled = true
              throw cancelError
            }
            if (task.captureBlob) {
              throw error
            }
            this.ensurePaperDownloadTaskActive(task)
            this.triggerRecentDownload(url, fileName, true)
            return
          }
        }
        this.triggerRecentDownload(url, fileName, true)
        return
      }
      let sourceBlob = null
      try {
        sourceBlob = await this.fetchRecentBlob(url, percent => {
          this.updatePaperDownloadTask(task, {
            progress: Math.max(task.progress || 0, Math.round(5 + percent * 0.85)),
            statusText: '涓嬭浇涓?'
          })
        }, task)
      } catch (error) {
        if (error && error.isPaperDownloadCancelled) {
          throw error
        }
        if (task && task.cancelled) {
          const cancelError = new Error('Download cancelled')
          cancelError.isPaperDownloadCancelled = true
          throw cancelError
        }
        if (extension == 'pdf') {
          this.triggerRecentDownload(url, this.$getDownloadFileName(baseName, 'pdf', this.uiText.download, this.sanitizeRecentFileName), true)
          return
        }
      }
      if (sourceBlob && this.isRecentPdfBlob(sourceBlob, extension)) {
        if (task) {
          this.ensurePaperDownloadTaskActive(task)
        }
        if (!this.$captureDownloadBlob(task, sourceBlob, fileName)) {
          saveAs(sourceBlob, fileName)
        }
        return
      }
      if (sourceBlob && this.isRecentImageBlob(sourceBlob, extension)) {
        const canvas = await this.createPaperImageFrameCanvas(sourceBlob, null)
        const page = await this.recentCanvasToJpegPage(canvas)
        this.releaseRecentCanvas(canvas)
        const pdfBlob = this.buildRecentPdfBlob([page])
        if (task) {
          this.ensurePaperDownloadTaskActive(task)
        }
        if (!this.$captureDownloadBlob(task, pdfBlob, fileName)) {
          saveAs(pdfBlob, fileName)
        }
        return
      }
      const imageUrl = this.getRecentImageDownloadUrl(item, url)
      if (imageUrl && imageUrl != url) {
        const imageBlob = await this.fetchRecentBlob(imageUrl, null, task)
        const canvas = await this.createPaperImageFrameCanvas(imageBlob, null)
        const page = await this.recentCanvasToJpegPage(canvas)
        this.releaseRecentCanvas(canvas)
        const pdfBlob = this.buildRecentPdfBlob([page])
        if (task) {
          this.ensurePaperDownloadTaskActive(task)
        }
        if (!this.$captureDownloadBlob(task, pdfBlob, fileName)) {
          saveAs(pdfBlob, fileName)
        }
        return
      }
      throw new Error('PDF conversion unavailable')
    },
    async downloadRecentAsPng(item, url, baseName, task) {
      const imageUrl = this.getRecentImageDownloadUrl(item, url)
      if (!imageUrl) {
        throw new Error('PNG conversion unavailable')
      }
      const imageBlob = await this.fetchRecentBlob(imageUrl, percent => {
        this.updatePaperDownloadTask(task, {
          progress: Math.max(task.progress || 0, Math.round(5 + percent * 0.9)),
          statusText: '涓嬭浇涓?'
        })
      }, task)
      if (!this.isRecentImageBlob(imageBlob, this.getRecentUrlExtension(imageUrl).toLowerCase())) {
        throw new Error('PNG conversion unavailable')
      }
      const canvas = await this.createPaperImageFrameCanvas(imageBlob, null)
      const pngBlob = await this.recentCanvasToPngBlob(canvas)
      this.releaseRecentCanvas(canvas)
      const fileName = this.$getDownloadFileName(baseName, 'png', this.uiText.download, this.sanitizeRecentFileName)
      if (task) {
        this.ensurePaperDownloadTaskActive(task)
      }
      if (!this.$captureDownloadBlob(task, pngBlob, fileName)) {
        saveAs(pngBlob, fileName)
      }
    },
    async downloadRecentUrl(url, fileName) {
      if (!url || typeof document === 'undefined') {
        return
      }
      const safeName = this.sanitizeRecentFileName(fileName) || this.getRecentUrlDownloadName(url, this.uiText.download)
      const extension = this.getRecentUrlExtension(url).toLowerCase()
      if (extension == 'pdf' || String(safeName || '').toLowerCase().endsWith('.pdf')) {
        this.triggerRecentDownload(url, safeName, true)
        return
      }
      try {
        if (typeof fetch != 'function') {
          throw new Error('Fetch unavailable')
        }
        const response = await fetch(url)
        if (!response || !response.ok) {
          throw new Error(`Download failed: ${response ? response.status : ''}`)
        }
        const blob = await response.blob()
        const objectUrl = window.URL.createObjectURL(blob)
        this.triggerRecentDownload(objectUrl, safeName)
        window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000)
      } catch (error) {
        this.triggerRecentDownload(url, safeName, true)
      }
    },
    triggerRecentDownload(url, fileName, openInNewTab = false) {
      const link = document.createElement('a')
      link.href = url
      link.download = this.sanitizeRecentFileName(fileName) || ''
      if (openInNewTab) {
        link.target = '_blank'
        link.rel = 'noopener'
      }
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    getRecentDownloadName(item, url) {
      const baseName = this.$getDownloadBaseName(item && item.name, this.uiText.download, this.sanitizeRecentFileName)
      const extension = this.getRecentUrlExtension(url)
      if (!extension || baseName.toLowerCase().endsWith(`.${extension.toLowerCase()}`)) {
        return baseName
      }
      return `${baseName}.${extension}`
    },
    getRecentImageDownloadUrl(item, url) {
      if (this.isRecentImageUrl(url)) {
        return url
      }
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : {}
      return this.pickPaperBestImageUrl(raw, { includeThumbnail: false }) || this.pickPaperBestImageUrl(item, { includeThumbnail: false }) || this.pickString(raw, [
        'sourceImageUrl',
        'source_image_url',
        'originalImageUrl',
        'original_image_url',
        'originImageUrl',
        'fullImageUrl'
      ]) || (item && item.cover ? item.cover : '')
    },
    isRecentImageUrl(url) {
      return ['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp'].includes(this.getRecentUrlExtension(url).toLowerCase())
    },
    isRecentPdfBlob(blob, extension = '') {
      return String(blob && blob.type ? blob.type : '').toLowerCase().includes('pdf') || extension == 'pdf'
    },
    isRecentImageBlob(blob, extension = '') {
      const type = String(blob && blob.type ? blob.type : '').toLowerCase()
      return type.includes('image/') || ['png', 'jpg', 'jpeg', 'webp', 'gif', 'bmp'].includes(extension)
    },
    getRecentImageExtension(url, blob) {
      const extension = this.getRecentUrlExtension(url).toLowerCase()
      if (extension == 'jpg' || extension == 'jpeg') {
        return 'jpg'
      }
      if (extension == 'webp') {
        return 'webp'
      }
      if (extension == 'gif') {
        return 'gif'
      }
      if (extension == 'bmp') {
        return 'bmp'
      }
      const type = String(blob && blob.type ? blob.type : '').toLowerCase()
      if (type.includes('jpeg') || type.includes('jpg')) {
        return 'jpg'
      }
      if (type.includes('webp')) {
        return 'webp'
      }
      if (type.includes('gif')) {
        return 'gif'
      }
      return 'png'
    },
    async fetchRecentBlob(url, onProgress, task) {
      if (!url || typeof fetch != 'function') {
        throw new Error('Fetch unavailable')
      }
      return this.fetchCachedPreviewPerformanceBlob(url, async progressHandler => {
        const requestUrls = this.getRecentPaperImageFetchUrls ? this.getRecentPaperImageFetchUrls(url) : [url]
        let lastError = null
        for (const requestUrl of requestUrls) {
          let controller = null
          try {
            if (task) {
              this.ensurePaperDownloadTaskActive(task)
            }
            if (typeof AbortController !== 'undefined') {
              controller = new AbortController()
              if (task) {
                this.registerPreviewPerformanceTaskAbortController(task, controller)
              }
            }
            const response = await fetch(requestUrl, controller ? { signal: controller.signal } : undefined)
            if (!response || !response.ok) {
              throw new Error(`Download failed: ${response ? response.status : ''}`)
            }
            if (this.isRecentUnexpectedProxyResponse(response, requestUrl, url)) {
              throw new Error('Download proxy returned unexpected content')
            }
            return await this.readRecentPaperImageResponseBlob(response, progressHandler)
          } catch (error) {
            if (error && (error.name == 'AbortError' || task && task.cancelled)) {
              const cancelError = new Error('Download cancelled')
              cancelError.isPaperDownloadCancelled = true
              throw cancelError
            }
            if (error) {
              error.isCorsLikeDownloadError = requestUrl != url
            }
            lastError = error
          } finally {
            if (task) {
              this.unregisterPreviewPerformanceTaskAbortController(task, controller)
            }
          }
        }
        throw lastError || new Error('Download failed')
      }, { onProgress, task })
    },
    recentBlobToArrayBuffer(blob) {
      if (blob && typeof blob.arrayBuffer == 'function') {
        return blob.arrayBuffer()
      }
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsArrayBuffer(blob)
      })
    },
    recentImageBlobToJpegPage(blob) {
      return new Promise((resolve, reject) => {
        if (typeof URL === 'undefined' || typeof Image === 'undefined' || typeof document === 'undefined') {
          reject(new Error('Image conversion unavailable'))
          return
        }
        const objectUrl = URL.createObjectURL(blob)
        const image = new Image()
        image.onload = () => {
          const width = image.naturalWidth || image.width || 1
          const height = image.naturalHeight || image.height || 1
          const canvas = document.createElement('canvas')
          canvas.width = width
          canvas.height = height
          const context = canvas.getContext('2d')
          if (context && 'imageSmoothingEnabled' in context) {
            context.imageSmoothingEnabled = true
            if ('imageSmoothingQuality' in context) {
              context.imageSmoothingQuality = 'high'
            }
          }
          context.fillStyle = '#fff'
          context.fillRect(0, 0, width, height)
          context.drawImage(image, 0, 0, width, height)
          URL.revokeObjectURL(objectUrl)
          canvas.toBlob(async jpegBlob => {
            canvas.width = 0
            canvas.height = 0
            if (!jpegBlob) {
              reject(new Error('Image convert failed'))
              return
            }
            resolve({
              width,
              height,
              data: new Uint8Array(await this.recentBlobToArrayBuffer(jpegBlob))
            })
          }, 'image/jpeg', 1)
        }
        image.onerror = () => {
          URL.revokeObjectURL(objectUrl)
          reject(new Error('Image load failed'))
        }
        image.src = objectUrl
      })
    },
    buildRecentPdfBlob(imagePages) {
      const encoder = new TextEncoder()
      const chunks = []
      const offsets = []
      let offset = 0
      const writeString = value => {
        const bytes = encoder.encode(value)
        chunks.push(bytes)
        offset += bytes.length
      }
      const writeBytes = bytes => {
        chunks.push(bytes)
        offset += bytes.length
      }
      const objectCount = 2 + imagePages.length * 3
      const writeObject = (id, parts) => {
        offsets[id] = offset
        writeString(`${id} 0 obj\n`)
        parts.forEach(part => {
          if (typeof part == 'string') {
            writeString(part)
          } else {
            writeBytes(part)
          }
        })
        writeString('\nendobj\n')
      }
      writeString('%PDF-1.4\n')
      writeObject(1, ['<< /Type /Catalog /Pages 2 0 R >>'])
      const pageIds = imagePages.map((page, index) => 3 + index * 3)
      writeObject(2, [`<< /Type /Pages /Kids [${pageIds.map(id => `${id} 0 R`).join(' ')}] /Count ${pageIds.length} >>`])
      imagePages.forEach((page, index) => {
        const pageId = 3 + index * 3
        const contentId = pageId + 1
        const imageId = pageId + 2
        const width = Math.max(1, Math.round(page.width))
        const height = Math.max(1, Math.round(page.height))
        const imageName = `Im${index + 1}`
        const content = `q\n${width} 0 0 ${height} 0 0 cm\n/${imageName} Do\nQ`
        writeObject(pageId, [`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${width} ${height}] /Resources << /XObject << /${imageName} ${imageId} 0 R >> >> /Contents ${contentId} 0 R >>`])
        writeObject(contentId, [`<< /Length ${encoder.encode(content).length} >>\nstream\n${content}\nendstream`])
        writeObject(imageId, [
          `<< /Type /XObject /Subtype /Image /Width ${width} /Height ${height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${page.data.length} >>\nstream\n`,
          page.data,
          '\nendstream'
        ])
      })
      const xrefOffset = offset
      writeString(`xref\n0 ${objectCount + 1}\n`)
      writeString('0000000000 65535 f \n')
      for (let id = 1; id <= objectCount; id += 1) {
        writeString(`${String(offsets[id]).padStart(10, '0')} 00000 n \n`)
      }
      writeString(`trailer\n<< /Size ${objectCount + 1} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`)
      return new Blob(chunks, { type: 'application/pdf' })
    },
    getRecentUrlDownloadName(url, fallbackName) {
      const extension = this.getRecentUrlExtension(url)
      const baseName = this.$getDownloadBaseName(fallbackName, 'download', this.sanitizeRecentFileName)
      return extension ? `${baseName}.${extension}` : baseName
    },
    getRecentUrlExtension(url) {
      try {
        const parser = new URL(url, window.location.href)
        const match = parser.pathname.match(/\.([a-zA-Z0-9]{1,8})$/)
        return match ? match[1] : ''
      } catch (error) {
        const cleanUrl = String(url || '').split('?')[0].split('#')[0]
        const match = cleanUrl.match(/\.([a-zA-Z0-9]{1,8})$/)
        return match ? match[1] : ''
      }
    },
    sanitizeRecentFileName(fileName) {
      return String(fileName || '').replace(/[\\/:*?"<>|]/g, '_').trim()
    },
    getRecentGridItemClasses(item, index) {
      return {
        selected: this.isRecentSelected(item),
        'grid-edge-left': this.isRecentGridLeftEdge(index),
        'grid-edge-right': this.isRecentGridRightEdge(index),
        'grid-edge-top': this.isRecentGridTopEdge(index),
        'grid-edge-bottom': this.isRecentGridBottomEdge(index)
      }
    },
    isRecentGridLeftEdge(index) {
      const columnCount = Math.max(1, Number(this.recentGridColumnCount) || 1)
      if (this.isRecentGridLastIncompleteRowLastItem(index)) {
        return false
      }
      return columnCount == 1 || index % columnCount == 0
    },
    isRecentGridRightEdge(index) {
      const columnCount = Math.max(1, Number(this.recentGridColumnCount) || 1)
      if (this.isRecentGridLastIncompleteRowLastItem(index)) {
        return false
      }
      return columnCount == 1 || (index + 1) % columnCount == 0
    },
    isRecentGridTopEdge(index) {
      const columnCount = Math.max(1, Number(this.recentGridColumnCount) || 1)
      return index < columnCount
    },
    isRecentGridBottomEdge() {
      return false
    },
    isRecentGridLastIncompleteRowLastItem(index) {
      const columnCount = Math.max(1, Number(this.recentGridColumnCount) || 1)
      const itemCount = this.visibleRecentItems.length
      return itemCount > 0 && itemCount % columnCount != 0 && index == itemCount - 1
    },
    updateRecentGridColumnCount() {
      if (this.activeMenu != 'recent' || this.viewMode != 'grid') {
        return
      }
      this.$nextTick(() => {
        const grid = this.$refs.recentGrid
        if (!grid || typeof window === 'undefined') {
          this.recentGridColumnCount = 1
          return
        }
        const styles = window.getComputedStyle(grid)
        const columns = String(styles.gridTemplateColumns || '')
          .split(/\s+/)
          .filter(column => column && column != 'none')
        this.recentGridColumnCount = Math.max(1, columns.length || 1)
      })
    },
    handleCloudWindowResize() {
      this.updateGlobalSearchGridColumnCount()
      this.updateRecentGridColumnCount()
      this.updateRecentLearningAnnotationGridColumnCount()
      this.updateRecentLearningAnnotationPreviewGridColumnCount()
      this.updateRecentLearningTabTitleOverflow()
      this.syncGlobalSearchSelectionBarScrollbarOffset()
      this.syncRecentSelectionBarScrollbarOffset()
    },
    syncGlobalSearchSelectionBarScrollbarOffset() {
      this.$nextTick(() => {
        const area = this.$refs.cloudContentArea
        const nextOffset = area ? Math.max(0, area.offsetWidth - area.clientWidth) : 0
        if (this.globalSearchSelectionBarScrollbarOffset != nextOffset) {
          this.globalSearchSelectionBarScrollbarOffset = nextOffset
        }
      })
    },
    syncRecentSelectionBarScrollbarOffset() {
      this.$nextTick(() => {
        const area = this.$refs.cloudContentArea
        const nextOffset = area ? Math.max(0, area.offsetWidth - area.clientWidth) : 0
        if (this.recentSelectionBarScrollbarOffset != nextOffset) {
          this.recentSelectionBarScrollbarOffset = nextOffset
        }
      })
    },
    openMyFileLearningDetail(item, options = {}) {
      if (!item || this.activeAppFolder != 'learning' || this.activeAppReturnMenu != 'files') {
        return false
      }
      const raw = item.raw && typeof item.raw == 'object' ? item.raw : item
      const learningItem = Object.assign({}, item, {
        type: 'learning',
        folderType: 'learning',
        appType: item.appType || this.activeAppFolderAppType || this.resolveDefaultAppTypeByFolderType('learning'),
        raw
      })
      return this.openRecentLearningModal(learningItem, Object.assign({}, options, { sourceContext: 'files' }))
    },
    async openRecentLearningModal(item, options = {}) {
      const isGlobalSearchPreview = this.activeAppReturnMenu == 'search'
      const sourceContext = isGlobalSearchPreview
        ? 'search'
        : (options.sourceContext == 'files' ? 'files' : 'recent')
      if (this.mobilePreviewReturnScrollTops[sourceContext] === null) {
        this.captureMobilePreviewReturnScroll(sourceContext)
      }
      this.recentLearningCacheContext = options.sourceContext == 'files' ? 'files' : 'recent'
      this.globalSearchLearningPreviewMode = isGlobalSearchPreview
      if (isGlobalSearchPreview) {
        this.globalSearchTypeMenuOpen = false
        this.closeGlobalSearchViewSheet()
        this.closeGlobalSearchItemActions()
        this.closeGlobalSearchMoreMenu()
      }
      const requestId = this.recentLearningRequestSeq + 1
      this.recentLearningRequestSeq = requestId
      this.resetRecentLearningDetailState()
      this.recentLearningItem = item
      this.recentLearningDetail = this.normalizeRecentLearningFallback(item)
      this.recentLearningError = ''
      this.recentLearningLoading = true
      this.recentLearningModalOpen = true
      const cacheKey = this.getRecentLearningDetailCacheKey(item, options.password || '')
      const cachedDetail = !options.force ? this.getCachedRecentLearningDetail(cacheKey) : null
      if (cachedDetail) {
        this.recentLearningDetail = cachedDetail
        this.applyRecentLearningDetailState()
        this.recentLearningLoading = false
        if (options.openPageGrid) {
          this.openRecentLearningPagesFromRecent()
        }
        return
      }
      try {
        const ret = options.prefetchedRet || await this.fetchRecentDetailResponse(item, options.password || '')
        if (requestId != this.recentLearningRequestSeq) {
          return
        }
        const payload = this.resolveRecentApiPayload(ret)
        if (payload === null) {
          throw new Error(this.getRecentApiErrorMessage(ret) || '')
        }
        const detail = await this.normalizeRecentLearningDetail(payload, item)
        if (requestId != this.recentLearningRequestSeq) {
          return
        }
        this.recentLearningDetail = detail
        this.setRecentLearningDetailCache(cacheKey, detail)
        this.applyRecentLearningDetailState()
        if (options.openPageGrid) {
          this.openRecentLearningPagesFromRecent()
        }
      } catch (error) {
        if (requestId != this.recentLearningRequestSeq) {
          return
        }
        const message = error && error.message ? error.message : ''
        this.recentLearningError = message || (this.uiText.openUnavailable || 'Preview is unavailable for this item')
      } finally {
        if (requestId == this.recentLearningRequestSeq) {
          this.recentLearningLoading = false
        }
      }
    },
    closeRecentLearningModal() {
      const shouldRestoreGlobalSearch = this.globalSearchLearningPreviewMode && this.activeAppReturnMenu == 'search'
      const shouldRestoreSource = this.recentLearningModalOpen
      const shouldRestoreCloudList = shouldRestoreSource && !this.activeAppFolder
      const returnContext = shouldRestoreGlobalSearch
        ? 'search'
        : (this.recentLearningCacheContext == 'files' ? 'files' : 'recent')
      this.recentLearningRequestSeq += 1
      this.recentLearningModalOpen = false
      this.globalSearchLearningPreviewMode = false
      this.recentLearningLoading = false
      this.recentLearningError = ''
      this.recentLearningItem = null
      this.recentLearningDetail = null
      this.closePaperDownloadFormatModal()
      this.resetRecentLearningDetailState()
      this.recentLearningCacheContext = 'recent'
      if (shouldRestoreCloudList && shouldRestoreGlobalSearch) {
        this.globalSearchOpen = true
        this.$nextTick(() => {
          this.updateGlobalSearchGridColumnCount()
          if (this.$refs.globalSearchInput) {
            try {
              this.$refs.globalSearchInput.focus({ preventScroll: true })
            } catch (error) {
              this.$refs.globalSearchInput.focus()
            }
          }
          this.restoreMobilePreviewReturnScroll(returnContext)
        })
        return
      }
      if (shouldRestoreCloudList) {
        this.restoreMobilePreviewReturnScroll(returnContext)
      }
    },
    resetRecentLearningDetailState() {
      this.recentLearningActiveTab = 'summary'
      this.recentLearningActiveHighlightId = ''
      this.recentLearningHighlightDetailOpen = false
      this.recentLearningActiveAnnotationId = ''
      this.recentLearningAnnotationViewMode = 'grid'
      this.recentLearningAnnotationScreenSize = ''
      this.recentLearningAnnotationPreviewOpen = false
      this.recentLearningAnnotationPreviewGridOpen = false
      this.recentLearningAnnotationPreviewSelectedIds = []
      this.recentLearningAnnotationPreviewSelectionAnchorId = ''
      this.resetRecentLearningAnnotationPreviewZoom()
      this.clearPreviewZoomTip()
      this.stopRecentLearningAnnotationPreviewDrag()
      this.cancelRecentLearningTabTitleTouch()
      this.hideRecentLearningTabTitlePopup()
      this.recentLearningTabOverflowKeys = []
    },
    isRecentLearningTabTitleOverflow(key) {
      return this.recentLearningTabOverflowKeySet.has(key)
    },
    updateRecentLearningTabTitleOverflow() {
      const shouldMeasure = this.recentLearningModalOpen
        && !this.recentLearningLoading
        && !this.recentLearningError
        && this.recentLearningActiveTab != 'summary'
        && !this.recentLearningAnnotationPreviewOpen
        && !this.recentLearningHighlightDetailOpen
      if (!shouldMeasure) {
        this.hideRecentLearningTabTitlePopup()
        this.recentLearningTabOverflowKeys = []
        return
      }
      const measure = () => {
        const labels = this.$refs.recentLearningTabLabel
        const labelList = Array.isArray(labels) ? labels : (labels ? [labels] : [])
        const overflowKeys = []
        labelList.forEach(label => {
          const button = label && label.closest ? label.closest('.recent-learning-tab-button') : null
          const key = button && button.getAttribute ? button.getAttribute('data-recent-learning-tab-key') : ''
          if (!key) {
            return
          }
          if (label.scrollWidth > label.clientWidth + 1) {
            overflowKeys.push(key)
          }
        })
        this.recentLearningTabOverflowKeys = overflowKeys
        if (this.recentLearningTabTitlePopup && !overflowKeys.includes(this.recentLearningTabTitlePopup.key)) {
          this.hideRecentLearningTabTitlePopup()
        }
      }
      if (this.recentLearningTabOverflowKeys.length > 0) {
        this.recentLearningTabOverflowKeys = []
        this.$nextTick(measure)
        return
      }
      this.$nextTick(measure)
    },
    handleRecentLearningTabButtonClick(tab) {
      if (!tab || this.isRecentLearningTabClickBlocked()) {
        return
      }
      this.hideRecentLearningTabTitlePopup()
      this.setRecentLearningTab(tab.key)
    },
    startRecentLearningTabTitleTouch(tab, event) {
      if (!tab || !this.isRecentLearningTabTitleOverflow(tab.key)) {
        return
      }
      this.cancelRecentLearningTabTitleTouch()
      this.hideRecentLearningTabTitlePopup()
      const touch = event && event.touches && event.touches[0]
      this.recentLearningTabTitleTouchState = {
        key: tab.key,
        label: tab.label,
        startX: touch ? touch.clientX : 0,
        startY: touch ? touch.clientY : 0,
        target: event && event.currentTarget ? event.currentTarget : null
      }
      if (typeof window === 'undefined') {
        return
      }
      this.recentLearningTabTitleTouchTimer = window.setTimeout(() => {
        this.recentLearningTabTitleTouchTimer = null
        const state = this.recentLearningTabTitleTouchState
        if (!state || state.key != tab.key) {
          return
        }
        this.recentLearningTabTitleClickBlockedUntil = Date.now() + 450
        this.showRecentLearningTabTitlePopup({ key: state.key, label: state.label }, state.target)
      }, 520)
    },
    moveRecentLearningTabTitleTouch(event) {
      const touch = event && event.touches && event.touches[0]
      const state = this.recentLearningTabTitleTouchState
      if (!touch || !state) {
        return
      }
      if (Math.abs(touch.clientX - state.startX) > 10 || Math.abs(touch.clientY - state.startY) > 10) {
        this.cancelRecentLearningTabTitleTouch()
      }
    },
    endRecentLearningTabTitleTouch() {
      this.clearRecentLearningTabTitleTouchTimer()
      this.recentLearningTabTitleTouchState = null
    },
    cancelRecentLearningTabTitleTouch() {
      this.clearRecentLearningTabTitleTouchTimer()
      this.recentLearningTabTitleTouchState = null
    },
    clearRecentLearningTabTitleTouchTimer() {
      if (this.recentLearningTabTitleTouchTimer) {
        clearTimeout(this.recentLearningTabTitleTouchTimer)
        this.recentLearningTabTitleTouchTimer = null
      }
    },
    showRecentLearningTabTitlePopup(tab, anchor) {
      if (!tab || !this.isRecentLearningTabTitleOverflow(tab.key)) {
        return
      }
      const tabs = this.$refs.recentLearningTabs
      const target = anchor && typeof anchor.getBoundingClientRect == 'function' ? anchor : null
      let left = 0
      let top = 0
      if (tabs && target && typeof tabs.getBoundingClientRect == 'function') {
        const tabsRect = tabs.getBoundingClientRect()
        const targetRect = target.getBoundingClientRect()
        const popupWidth = Math.min(260, Math.max(180, tabsRect.width - 24))
        left = targetRect.left - tabsRect.left + targetRect.width / 2 - popupWidth / 2
        left = Math.max(12, Math.min(left, tabsRect.width - popupWidth - 12))
        top = targetRect.bottom - tabsRect.top + 8
      }
      this.clearRecentLearningTabTitlePopupTimer()
      this.recentLearningTabTitlePopup = {
        key: tab.key,
        label: tab.label,
        left,
        top
      }
      this.recentLearningTabTitlePopupTimer = setTimeout(() => {
        this.hideRecentLearningTabTitlePopup()
      }, 1000)
    },
    hideRecentLearningTabTitlePopup() {
      this.clearRecentLearningTabTitlePopupTimer()
      this.recentLearningTabTitlePopup = null
    },
    clearRecentLearningTabTitlePopupTimer() {
      if (this.recentLearningTabTitlePopupTimer) {
        clearTimeout(this.recentLearningTabTitlePopupTimer)
        this.recentLearningTabTitlePopupTimer = null
      }
    },
    isRecentLearningTabClickBlocked() {
      return Date.now() < this.recentLearningTabTitleClickBlockedUntil
    },
    getRecentLearningDetailCacheScope() {
      return this.recentLearningCacheContext == 'files'
        ? 'CloudHome:my-files-learning'
        : 'CloudHome:recent-learning'
    },
    getRecentLearningDetailCacheKey(item, password = '') {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : {}
      const resourceId = (item && item.resourceId) || this.pickString(raw, ['resourceId', 'uuid', 'id'])
      if (!resourceId) {
        return ''
      }
      return item && item.encrypted ? `${resourceId}:${password || 'encrypted'}` : String(resourceId)
    },
    getCachedRecentLearningDetail(cacheKey) {
      const cached = typeof this.getSharedPaperPreviewDetailCache == 'function'
        ? this.getSharedPaperPreviewDetailCache(this.getRecentLearningDetailCacheScope(), cacheKey)
        : null
      return cached && cached.detail ? cached.detail : null
    },
    setRecentLearningDetailCache(cacheKey, detail) {
      if (!cacheKey || !detail || typeof this.setSharedPaperPreviewDetailCache != 'function') {
        return
      }
      this.setSharedPaperPreviewDetailCache(this.getRecentLearningDetailCacheScope(), cacheKey, detail, [])
    },
    applyRecentLearningDetailState() {
      const annotations = this.recentLearningAnnotations
      this.recentLearningActiveHighlightId = ''
      this.recentLearningActiveAnnotationId = annotations[0] ? annotations[0].id : ''
      this.recentLearningAnnotationViewMode = annotations.length > 0 ? 'grid' : this.recentLearningAnnotationViewMode
      this.recentLearningAnnotationScreenSize = ''
      this.recentLearningAnnotationPreviewGridOpen = false
      this.recentLearningAnnotationPreviewSelectedIds = []
      this.recentLearningAnnotationPreviewSelectionAnchorId = this.recentLearningActiveAnnotationId
      this.updateRecentLearningAnnotationGridColumnCount()
    },
    openRecentLearningPagesFromRecent() {
      const annotation = this.recentLearningAnnotations[0]
      if (!annotation) {
        return false
      }
      this.setRecentLearningTab('annotations')
      this.openRecentLearningAnnotationPreview(annotation)
      this.$nextTick(() => {
        if (!this.recentLearningAnnotationPreviewGridOpen) {
          this.toggleRecentLearningAnnotationPreviewGrid()
        }
      })
      return true
    },
    openRecentLearningTab(tab) {
      if (!tab) {
        return
      }
      this.setRecentLearningTab(tab)
    },
    returnToRecentLearningSummary() {
      this.recentLearningActiveTab = 'summary'
      this.recentLearningHighlightDetailOpen = false
      this.hideRecentLearningTabTitlePopup()
      this.closeRecentLearningAnnotationPreview()
    },
    setRecentLearningTab(tab) {
      this.recentLearningActiveTab = tab
      this.recentLearningHighlightDetailOpen = false
      this.hideRecentLearningTabTitlePopup()
      if (tab == 'annotations') {
        if (!this.recentLearningAnnotationViewMode) {
          this.recentLearningAnnotationViewMode = 'grid'
        }
        if (!this.recentLearningActiveAnnotationId && this.recentLearningAnnotations[0]) {
          this.recentLearningActiveAnnotationId = this.recentLearningAnnotations[0].id
        }
      }
      this.updateRecentLearningAnnotationGridColumnCount()
    },
    openRecentLearningHighlight(highlight) {
      if (highlight && highlight.id) {
        this.recentLearningActiveHighlightId = highlight.id
      }
      this.recentLearningHighlightDetailOpen = !!highlight
    },
    closeRecentLearningHighlightDetail() {
      this.recentLearningHighlightDetailOpen = false
    },
    setRecentLearningAnnotationViewMode(mode) {
      this.recentLearningAnnotationViewMode = mode == 'list' ? 'list' : 'grid'
      this.updateRecentLearningAnnotationGridColumnCount()
    },
    selectRecentLearningAnnotation(annotation, options = {}) {
      if (annotation && annotation.id) {
        if (!options.force && this.recentLearningActiveTab == 'annotations' && this.recentLearningAnnotationViewMode == 'grid') {
          return
        }
        this.recentLearningActiveAnnotationId = annotation.id
      }
    },
    isRecentLearningAnnotationActive(annotation) {
      if (this.recentLearningActiveTab == 'annotations' && this.recentLearningAnnotationViewMode == 'grid') {
        return false
      }
      return !!(annotation && annotation.id && this.recentLearningActiveAnnotationId && annotation.id == this.recentLearningActiveAnnotationId)
    },
    getRecentLearningAnnotationGridItemClasses(annotation, index) {
      return {
        active: this.isRecentLearningAnnotationActive(annotation),
        'grid-edge-left': this.isRecentLearningAnnotationGridLeftEdge(index),
        'grid-edge-right': this.isRecentLearningAnnotationGridRightEdge(index),
        'grid-edge-top': this.isRecentLearningAnnotationGridTopEdge(index),
        'grid-edge-bottom': false
      }
    },
    isRecentLearningAnnotationGridLeftEdge(index) {
      const columnCount = Math.max(1, Number(this.recentLearningAnnotationGridColumnCount) || 1)
      if (this.isRecentLearningAnnotationGridLastIncompleteRowLastItem(index)) {
        return false
      }
      return columnCount == 1 || index % columnCount == 0
    },
    isRecentLearningAnnotationGridRightEdge(index) {
      const columnCount = Math.max(1, Number(this.recentLearningAnnotationGridColumnCount) || 1)
      if (this.isRecentLearningAnnotationGridLastIncompleteRowLastItem(index)) {
        return false
      }
      return columnCount == 1 || (index + 1) % columnCount == 0
    },
    isRecentLearningAnnotationGridTopEdge(index) {
      const columnCount = Math.max(1, Number(this.recentLearningAnnotationGridColumnCount) || 1)
      return index < columnCount
    },
    isRecentLearningAnnotationGridLastIncompleteRowLastItem(index) {
      const columnCount = Math.max(1, Number(this.recentLearningAnnotationGridColumnCount) || 1)
      const itemCount = this.filteredRecentLearningAnnotations.length
      return itemCount > 0 && itemCount % columnCount != 0 && index == itemCount - 1
    },
    updateRecentLearningAnnotationGridColumnCount() {
      if (!this.recentLearningModalOpen || this.recentLearningActiveTab != 'annotations' || this.recentLearningAnnotationViewMode != 'grid') {
        return
      }
      this.$nextTick(() => {
        const grid = this.$refs.recentLearningAnnotationGrid
        if (!grid || typeof window === 'undefined') {
          this.recentLearningAnnotationGridColumnCount = 1
          return
        }
        const styles = window.getComputedStyle(grid)
        const columns = String(styles.gridTemplateColumns || '')
          .split(/\s+/)
          .filter(column => column && column != 'none')
        this.recentLearningAnnotationGridColumnCount = Math.max(1, columns.length || 1)
      })
    },
    openRecentLearningAnnotationPreview(annotation) {
      if (!annotation) {
        return
      }
      this.selectRecentLearningAnnotation(annotation, { force: true })
      this.recentLearningAnnotationPreviewGridOpen = false
      this.clearRecentLearningAnnotationPreviewSelection({ preserveCurrent: true })
      this.resetRecentLearningAnnotationPreviewZoom()
      this.clearPreviewZoomTip()
      this.clearRecentPreviewZoomToast()
      this.resetRecentPreviewTouchState()
      this.recentLearningAnnotationPreviewOpen = true
      this.stopRecentLearningAnnotationPreviewDrag()
      this.centerRecentLearningAnnotationPreviewScroll()
    },
    closeRecentLearningAnnotationPreview() {
      this.recentLearningAnnotationPreviewOpen = false
      this.recentLearningAnnotationPreviewGridOpen = false
      this.clearRecentLearningAnnotationPreviewSelection({ preserveCurrent: false })
      this.resetRecentLearningAnnotationPreviewZoom()
      this.clearPreviewZoomTip()
      this.clearRecentPreviewZoomToast()
      this.resetRecentPreviewTouchState()
      this.stopRecentLearningAnnotationPreviewDrag()
    },
    handleRecentLearningAnnotationPreviewBack() {
      if (this.recentLearningAnnotationPreviewGridOpen) {
        const returnZoomLevel = this.takePreviewGridZoomLevel('recent-learning-annotation')
        this.recentLearningAnnotationPreviewGridOpen = false
        this.clearRecentLearningAnnotationPreviewSelection({ preserveCurrent: false })
        this.cancelMobilePreviewGridTouch()
        this.setRecentLearningAnnotationPreviewZoomLevel(returnZoomLevel)
        return
      }
      this.closeRecentLearningAnnotationPreview()
    },
    toggleRecentLearningAnnotationPreviewGrid() {
      if (!this.recentLearningAnnotationPreviewOpen || this.recentLearningAnnotations.length == 0 || this.recentLearningAnnotationPreviewGridOpen) {
        return
      }
      this.recentLearningActiveTab = 'annotations'
      this.recentLearningAnnotationViewMode = 'grid'
      this.selectCurrentRecentLearningAnnotationPreviewInGrid()
      this.rememberPreviewGridZoomLevel('recent-learning-annotation', this.recentLearningAnnotationPreviewZoomLevel)
      this.recentLearningAnnotationPreviewGridOpen = true
      this.clearPreviewZoomTip()
      this.clearRecentPreviewZoomToast()
      this.resetRecentPreviewTouchState()
      this.updateRecentLearningAnnotationPreviewGridColumnCount()
      this.stopRecentLearningAnnotationPreviewDrag()
    },
    zoomInRecentLearningAnnotationPreview() {
      if (this.recentLearningAnnotationPreviewGridOpen) {
        return
      }
      const nextLevel = this.setRecentLearningAnnotationPreviewZoomLevel(this.recentLearningAnnotationPreviewZoomLevel + 1)
      this.showPreviewZoomTip('recent-learning-annotation', 'in', nextLevel, this.uiText)
    },
    zoomOutRecentLearningAnnotationPreview() {
      if (this.recentLearningAnnotationPreviewGridOpen) {
        return
      }
      const nextLevel = this.setRecentLearningAnnotationPreviewZoomLevel(this.recentLearningAnnotationPreviewZoomLevel - 1)
      this.showPreviewZoomTip('recent-learning-annotation', 'out', nextLevel, this.uiText)
    },
    resetRecentLearningAnnotationPreviewZoom() {
      this.setRecentLearningAnnotationPreviewZoomLevel(0)
    },
    setRecentLearningAnnotationPreviewZoomLevel(level, options = {}) {
      const nextLevel = this.clampPreviewZoomLevel(level)
      this.recentLearningAnnotationPreviewZoomLevel = nextLevel
      this.recentLearningAnnotationPreviewZoomValue = this.getPreviewZoomValue(nextLevel)
      if (!options.keepScrollPosition) {
        this.centerRecentLearningAnnotationPreviewScroll()
      }
      return nextLevel
    },
    selectCurrentRecentLearningAnnotationPreviewInGrid() {
      if (!this.recentLearningActiveAnnotationId && this.recentLearningAnnotations[0]) {
        this.recentLearningActiveAnnotationId = this.recentLearningAnnotations[0].id
      }
      this.recentLearningAnnotationPreviewSelectedIds = []
      this.recentLearningAnnotationPreviewSelectionAnchorId = this.recentLearningActiveAnnotationId
    },
    isRecentLearningAnnotationPreviewSelected(annotationId) {
      return this.recentLearningAnnotationPreviewSelectedIds.includes(annotationId)
    },
    toggleRecentLearningAnnotationPreviewSelection(annotation, event) {
      if (!annotation || !annotation.id) {
        return
      }
      const result = selectItemWithWindowsRange(
        this.recentLearningAnnotations,
        this.recentLearningAnnotationPreviewSelectedIds,
        annotation,
        this.recentLearningAnnotationPreviewSelectionAnchorId || this.recentLearningActiveAnnotationId,
        event
      )
      this.recentLearningAnnotationPreviewSelectedIds = result.selectedIds
      this.recentLearningAnnotationPreviewSelectionAnchorId = result.anchorId
    },
    clearRecentLearningAnnotationPreviewSelection(options = {}) {
      const preserveCurrent = !!options.preserveCurrent
      this.recentLearningAnnotationPreviewSelectedIds = preserveCurrent && this.recentLearningActiveAnnotationId
        ? [this.recentLearningActiveAnnotationId]
        : []
      this.recentLearningAnnotationPreviewSelectionAnchorId = preserveCurrent && this.recentLearningActiveAnnotationId
        ? this.recentLearningActiveAnnotationId
        : ''
    },
    openRecentLearningAnnotationFromPreviewGrid(annotation) {
      if (!annotation || !annotation.id) {
        return
      }
      const isSameAnnotation = annotation.id == this.recentLearningActiveAnnotationId
      const returnZoomLevel = this.takePreviewGridZoomLevel('recent-learning-annotation')
      this.recentLearningActiveAnnotationId = annotation.id
      this.recentLearningAnnotationPreviewGridOpen = false
      if (isSameAnnotation) {
        this.setRecentLearningAnnotationPreviewZoomLevel(returnZoomLevel)
        return
      }
      this.resetRecentLearningAnnotationPreviewZoom()
      this.clearPreviewZoomTip()
    },
    goPrevRecentLearningAnnotationPreview() {
      if (this.recentLearningAnnotationPreviewGridOpen || this.recentLearningAnnotationPreviewIndex <= 0) {
        return
      }
      this.recentLearningActiveAnnotationId = this.recentLearningAnnotations[this.recentLearningAnnotationPreviewIndex - 1].id
      this.clearPreviewZoomTip()
      this.centerRecentLearningAnnotationPreviewScroll()
    },
    goNextRecentLearningAnnotationPreview() {
      if (this.recentLearningAnnotationPreviewGridOpen || this.recentLearningAnnotationPreviewIndex >= this.recentLearningAnnotations.length - 1) {
        return
      }
      this.recentLearningActiveAnnotationId = this.recentLearningAnnotations[this.recentLearningAnnotationPreviewIndex + 1].id
      this.clearPreviewZoomTip()
      this.centerRecentLearningAnnotationPreviewScroll()
    },
    downloadCurrentRecentLearningAnnotationPreview() {
      if (this.recentLearningAnnotationPreviewGridOpen) {
        this.downloadSelectedRecentLearningAnnotations()
        return
      }
      this.openRecentLearningAnnotationPreviewDownloadFormatModal(this.recentLearningActiveAnnotation ? [this.recentLearningActiveAnnotation] : [])
    },
    downloadSelectedRecentLearningAnnotations() {
      this.openRecentLearningAnnotationPreviewDownloadFormatModal(this.recentLearningAnnotationPreviewSelectedAnnotations)
    },
    openRecentLearningAnnotationPreviewDownloadFormatModal(annotations) {
      const list = (Array.isArray(annotations) ? annotations : []).filter(item => item && (item.imageUrl || item.pageImageUrl))
      if (list.length == 0) {
        this.$message.info('\u8bf7\u9009\u62e9\u53ef\u4e0b\u8f7d\u7684\u6279\u6ce8')
        return
      }
      if (!this.$canStartDownloadBatch(list.length, 1, { skipSelectionLimit: true })) {
        return
      }
      this.paperDownloadItems = []
      this.paperDownloadDetailPages = []
      this.learningAnnotationDownloadItems = list
      this.paperDownloadFormatContext = 'learning-annotation-preview-pages'
      this.paperDownloadFormat = 'png'
      this.paperDownloadFormatModalOpen = true
    },
    closePaperDownloadFormatModal() {
      this.paperDownloadFormatModalOpen = false
      this.paperDownloadItems = []
      this.paperDownloadDetailPages = []
      this.learningAnnotationDownloadItems = []
      this.paperDownloadFormatContext = 'items'
    },
    confirmPaperDownloadFormat() {
      const format = this.paperDownloadFormat == 'png' ? 'png' : 'pdf'
      if (this.paperDownloadFormatContext == 'learning-annotation-preview-pages') {
        const annotations = this.learningAnnotationDownloadItems.slice()
        if (!this.$canStartDownloadBatch(annotations.length, 1, { skipSelectionLimit: true })) {
          return
        }
        this.closePaperDownloadFormatModal()
        this.startRecentLearningAnnotationPreviewDownload(annotations, format)
        return
      }
      this.closePaperDownloadFormatModal()
    },
    startRecentLearningAnnotationPreviewDownload(annotations, format = 'png') {
      const list = Array.isArray(annotations) ? annotations.filter(item => item && (item.imageUrl || item.pageImageUrl)) : []
      if (list.length == 0) {
        this.$message.info('\u8bf7\u9009\u62e9\u53ef\u4e0b\u8f7d\u7684\u6279\u6ce8')
        return
      }
      if (!this.$canStartDownloadBatch(list.length, 1, { skipSelectionLimit: true })) {
        return
      }
      const task = this.createRecentLearningAnnotationPreviewDownloadTask(list, format)
      this.$enqueuePaperDownloadTask(task, () => this.runRecentLearningAnnotationPreviewDownloadTask(task))
      if (this.recentLearningAnnotationPreviewGridOpen) {
        this.recentLearningAnnotationPreviewSelectedIds = []
        this.recentLearningAnnotationPreviewSelectionAnchorId = ''
      }
    },
    createRecentLearningAnnotationPreviewDownloadTask(annotations, format = 'png') {
      const list = Array.isArray(annotations) ? annotations.slice() : []
      const baseName = this.$getDownloadBaseName(this.recentLearningTitle, this.uiText.annotations, this.sanitizeRecentFileName)
      const safeFormat = format == 'pdf' ? 'pdf' : 'png'
      const isSingle = list.length == 1
      const pageNo = isSingle ? (list[0].pageNo || 1) : 0
      const extension = safeFormat == 'pdf' ? 'pdf' : (isSingle ? 'png' : 'zip')
      return {
        id: `learning-annotation-preview-download-${Date.now()}-${Math.random().toString(16).slice(2)}`,
        kind: 'learning-annotation-preview-pages',
        name: baseName,
        fileName: isSingle ? `${baseName} page ${pageNo}.${extension}` : `${baseName}.${extension}`,
        format: safeFormat,
        annotations: list,
        pngFiles: [],
        pdfPages: [],
        compositeFrameSize: null,
        failedPageIndex: 0,
        openUrl: '',
        abortController: null,
        cancelled: false,
        progress: 0,
        state: 'running',
        statusText: '\u51c6\u5907\u4e0b\u8f7d'
      }
    },
    async runRecentLearningAnnotationPreviewDownloadTask(task) {
      try {
        this.ensurePaperDownloadTaskActive(task)
        const annotations = Array.isArray(task.annotations) ? task.annotations : []
        if (annotations.length == 0) {
          throw new Error('No annotations')
        }
        await this.getRecentLearningAnnotationCompositeFrameSize(annotations, task)
        if (task.format == 'pdf') {
          const pdfPages = Array.isArray(task.pdfPages) ? task.pdfPages.slice() : []
          this.updatePaperDownloadTask(task, { pdfPages })
          for (let i = 0; i < annotations.length; i += 1) {
            this.ensurePaperDownloadTaskActive(task)
            if (pdfPages[i]) {
              continue
            }
            const annotation = annotations[i]
            this.updatePaperDownloadTask(task, {
              failedPageIndex: i,
              progress: this.getPaperDownloadImageProgress(i, annotations.length, 5, 85, 0),
              statusText: '\u4e0b\u8f7d\u4e2d'
            })
            const blob = await this.fetchRecentLearningAnnotationBlob(annotation, percent => {
              this.updatePaperDownloadTask(task, {
                progress: this.getPaperDownloadImageProgress(i, annotations.length, 5, 85, percent),
                statusText: '\u4e0b\u8f7d\u4e2d'
              })
            }, task)
            pdfPages[i] = await this.recentImageBlobToJpegPage(blob)
            this.updatePaperDownloadTask(task, {
              pdfPages: pdfPages.slice(),
              failedPageIndex: i + 1
            })
          }
          this.ensurePaperDownloadTaskActive(task)
          this.updatePaperDownloadTask(task, { progress: 90, statusText: '\u751f\u6210 PDF' })
          const pdfBlob = this.buildRecentPdfBlob(pdfPages)
          this.ensurePaperDownloadTaskActive(task)
          this.savePaperDownloadBlob(task, pdfBlob)
        } else {
          const pngFiles = Array.isArray(task.pngFiles) ? task.pngFiles.slice() : []
          for (let i = 0; i < annotations.length; i += 1) {
            this.ensurePaperDownloadTaskActive(task)
            if (pngFiles[i]) {
              continue
            }
            const annotation = annotations[i]
            this.updatePaperDownloadTask(task, {
              failedPageIndex: i,
              progress: this.getPaperDownloadImageProgress(i, annotations.length, 5, 85, 0),
              statusText: '\u4e0b\u8f7d\u4e2d'
            })
            const blob = await this.fetchRecentLearningAnnotationBlob(annotation, percent => {
              this.updatePaperDownloadTask(task, {
                progress: this.getPaperDownloadImageProgress(i, annotations.length, 5, 85, percent),
                statusText: '\u4e0b\u8f7d\u4e2d'
              })
            }, task)
            pngFiles[i] = {
              fileName: this.getRecentLearningAnnotationFileName(annotation, i, 'png'),
              buffer: await this.recentBlobToArrayBuffer(blob)
            }
            this.updatePaperDownloadTask(task, {
              pngFiles: pngFiles.slice(),
              failedPageIndex: i + 1
            })
          }
          this.ensurePaperDownloadTaskActive(task)
          if (annotations.length == 1 && pngFiles[0]) {
            this.updatePaperDownloadTask(task, { progress: 99, statusText: '\u4fdd\u5b58\u6587\u4ef6' })
            this.savePaperDownloadBlob(task, new Blob([pngFiles[0].buffer], { type: 'image/png' }))
          } else {
            const zip = new JSZip()
            pngFiles.forEach((file, index) => {
              if (file) {
                zip.file(file.fileName || this.getRecentLearningAnnotationFileName(annotations[index], index, 'png'), file.buffer)
              }
            })
            this.updatePaperDownloadTask(task, { progress: 90, statusText: '\u6253\u5305 ZIP' })
            const zipBlob = await zip.generateAsync({ type: 'blob' }, metadata => {
              this.updatePaperDownloadTask(task, {
                progress: Math.min(98, Math.round(90 + (metadata.percent || 0) * 0.08)),
                statusText: '\u6253\u5305 ZIP'
              })
            })
            this.ensurePaperDownloadTaskActive(task)
            this.savePaperDownloadBlob(task, zipBlob)
          }
        }
        this.updatePaperDownloadTask(task, {
          progress: 100,
          state: 'done',
          statusText: '\u4e0b\u8f7d\u5b8c\u6210'
        })
      } catch (error) {
        if (error && error.isPaperDownloadCancelled) {
          return
        }
        const isCorsLikeError = this.isLikelyCorsDownloadError(error)
        this.updatePaperDownloadTask(task, {
          state: 'error',
          progress: task.progress || 0,
          statusText: isCorsLikeError ? '\u56fe\u7247\u8bfb\u53d6\u5931\u8d25\uff0c\u8bf7\u70b9\u51fb\u91cd\u8bd5' : (error && error.message ? error.message : '\u4e0b\u8f7d\u5931\u8d25')
        })
      }
    },
    updatePaperDownloadTask(task, patch) {
      patch = typeof this.$normalizePaperDownloadTaskPatch == 'function' ? this.$normalizePaperDownloadTaskPatch(task, patch) : patch
      Object.keys(patch || {}).forEach(key => {
        this.$set(task, key, patch[key])
      })
    },
    retryPaperDownloadTask(task) {
      if (!task || task.state != 'error') {
        return
      }
      this.paperDownloadListVisible = true
      this.$set(task, 'cancelled', false)
      this.$set(task, 'abortController', null)
      this.updatePaperDownloadTask(task, {
        progress: task.progress || 0,
        state: 'running',
        statusText: '\u7ee7\u7eed\u4e0b\u8f7d'
      })
      if (task.kind == 'learning-annotation-preview-pages') {
        this.runRecentLearningAnnotationPreviewDownloadTask(task)
        return
      }
      if (task.kind == 'recent-bundle') {
        this.runRecentDownloadBundleTask(task)
        return
      }
      if (task.kind == 'recent-resource') {
        this.runRecentDownloadTask(task)
      }
    },
    getPaperDownloadNativeOpener() {
      if (typeof window === 'undefined') {
        return null
      }
      return window.viwoodsNative || window.electronAPI || window.nativeBridge || null
    },
    canOpenPaperDownloadTask(task) {
      if (!task || task.state != 'done') {
        return false
      }
      const nativeOpener = this.getPaperDownloadNativeOpener()
      if (task.filePath && nativeOpener && typeof nativeOpener.showItemInFolder == 'function') {
        return true
      }
      return !!(nativeOpener && typeof nativeOpener.openDownloadFolder == 'function')
    },
    openPaperDownloadTask(task) {
      if (!this.canOpenPaperDownloadTask(task)) {
        return
      }
      const nativeOpener = this.getPaperDownloadNativeOpener()
      if (task.filePath && nativeOpener && typeof nativeOpener.showItemInFolder == 'function') {
        nativeOpener.showItemInFolder(task.filePath)
        return
      }
      if (nativeOpener && typeof nativeOpener.openDownloadFolder == 'function') {
        nativeOpener.openDownloadFolder()
      }
    },
    removePaperDownloadTask(task) {
      if (!task) {
        return
      }
      this.$set(task, 'cancelled', true)
      if (task.abortController && typeof task.abortController.abort == 'function') {
        task.abortController.abort()
      }
      this.revokePaperDownloadTaskUrl(task)
      this.paperDownloadTasks = this.paperDownloadTasks.filter(item => item.id != task.id)
      if (this.paperDownloadTasks.length == 0) {
        this.paperDownloadListVisible = false
      }
    },
    closePaperDownloadList() {
      this.paperDownloadTasks.forEach(task => {
        this.$set(task, 'cancelled', true)
        if (task.abortController && typeof task.abortController.abort == 'function') {
          task.abortController.abort()
        }
        this.revokePaperDownloadTaskUrl(task)
      })
      this.paperDownloadTasks = []
      this.paperDownloadListVisible = false
    },
    ensurePaperDownloadTaskActive(task) {
      const isInList = !!(task && this.paperDownloadTasks.some(item => item.id == task.id))
      if (!task || task.cancelled || !isInList) {
        const error = new Error('Download cancelled')
        error.isPaperDownloadCancelled = true
        throw error
      }
    },
    getPaperDownloadImageProgress(index, total, start, end, percent) {
      const safeTotal = Math.max(total || 1, 1)
      const safePercent = Math.max(0, Math.min(Number(percent) || 0, 100))
      return Math.min(end, Math.round(start + ((index + safePercent / 100) / safeTotal) * (end - start)))
    },
    savePaperDownloadBlob(task, blob) {
      if (this.$captureDownloadBlob(task, blob, task && task.fileName)) {
        return
      }
      this.revokePaperDownloadTaskUrl(task)
      const openUrl = URL.createObjectURL(blob)
      this.updatePaperDownloadTask(task, { openUrl, progress: Math.max(task.progress || 0, 99) })
      saveAs(blob, task.fileName)
    },
    revokePaperDownloadTaskUrl(task) {
      if (task && task.openUrl && String(task.openUrl).startsWith('blob:')) {
        URL.revokeObjectURL(task.openUrl)
      }
      if (task) {
        this.$set(task, 'openUrl', '')
      }
    },
    isLikelyCorsDownloadError(error) {
      return !!(error && (error.isCorsLikeDownloadError || error.name == 'TypeError' || String(error.message || '').toLowerCase().includes('failed to fetch')))
    },
    async fetchRecentLearningAnnotationBlob(annotation, onProgress, task) {
      const imageUrl = annotation && annotation.imageUrl ? String(annotation.imageUrl).trim() : ''
      const pageImageUrl = annotation && annotation.pageImageUrl ? String(annotation.pageImageUrl).trim() : ''
      const report = value => {
        if (typeof onProgress == 'function') {
          onProgress(Math.max(0, Math.min(100, Math.round(Number(value) || 0))))
        }
      }
      if (!pageImageUrl) {
        if (task) {
          this.ensurePaperDownloadTaskActive(task)
        }
        const blob = await this.fetchRecentPaperImageBlob(imageUrl, onProgress, task)
        if (task) {
          this.ensurePaperDownloadTaskActive(task)
        }
        return this.fitRecentLearningAnnotationBlobToTaskFrame(blob, task)
      }
      if (!imageUrl) {
        if (task) {
          this.ensurePaperDownloadTaskActive(task)
        }
        const blob = await this.fetchRecentPaperImageBlob(pageImageUrl, onProgress, task)
        if (task) {
          this.ensurePaperDownloadTaskActive(task)
        }
        return this.fitRecentLearningAnnotationBlobToTaskFrame(blob, task)
      }
      const frameKey = task && task.compositeFrameSize
        ? `${task.compositeFrameSize.width}x${task.compositeFrameSize.height}`
        : (task ? 'download-source' : 'preview-source')
      const cacheKey = `recent-learning-annotation:${pageImageUrl}|${imageUrl}|${frameKey}`
      return this.fetchCachedPreviewPerformanceBlob(cacheKey, async () => {
        if (task) {
          this.ensurePaperDownloadTaskActive(task)
        }
        let baseProgress = 0
        let overlayProgress = 0
        const reportCompositeProgress = () => {
          report(baseProgress * 0.55 + overlayProgress * 0.4)
        }
        const [baseBlob, overlayBlob] = await Promise.all([
          this.fetchRecentPaperImageBlob(pageImageUrl, percent => {
            baseProgress = Math.max(baseProgress, Math.max(0, Math.min(Number(percent) || 0, 100)))
            reportCompositeProgress()
          }, task),
          this.fetchRecentPaperImageBlob(imageUrl, percent => {
            overlayProgress = Math.max(overlayProgress, Math.max(0, Math.min(Number(percent) || 0, 100)))
            reportCompositeProgress()
          }, task)
        ])
        if (task) {
          this.ensurePaperDownloadTaskActive(task)
        }
        const canvas = await this.composeRecentLearningAnnotationCanvas(baseBlob, overlayBlob, task && task.compositeFrameSize)
        try {
          const blob = await this.recentCanvasToPngBlob(canvas)
          if (task) {
            this.ensurePaperDownloadTaskActive(task)
          }
          report(100)
          return blob
        } finally {
          this.releaseRecentCanvas(canvas)
        }
      }, { cacheKey, onProgress, task })
    },
    async fitRecentLearningAnnotationBlobToTaskFrame(blob, task) {
      if (!task || !task.compositeFrameSize) {
        return blob
      }
      const canvas = await this.createPaperImageFrameCanvas(blob, task.compositeFrameSize)
      try {
        return await this.recentCanvasToPngBlob(canvas)
      } finally {
        this.releaseRecentCanvas(canvas)
      }
    },
    async getRecentLearningAnnotationCompositeFrameSize(annotations, task) {
      if (task && task.compositeFrameSize && task.compositeFrameSize.width > 0 && task.compositeFrameSize.height > 0) {
        return task.compositeFrameSize
      }
      const imageUrls = Array.from(new Set((Array.isArray(annotations) ? annotations : [])
        .reduce((urls, annotation) => {
          if (annotation && annotation.pageImageUrl) {
            urls.push(String(annotation.pageImageUrl).trim())
          }
          if (annotation && annotation.imageUrl) {
            urls.push(String(annotation.imageUrl).trim())
          }
          return urls
        }, [])
        .filter(Boolean)))
      const sizes = await this.runPaperPerformanceTasks(
        imageUrls,
        this.getPaperPreviewRenderConcurrency(),
        async imageUrl => {
          const blob = await this.fetchRecentPaperImageBlob(imageUrl, null, task)
          return this.getPaperImageBlobSize(blob)
        }
      )
      const frameSize = this.getPaperWidthAlignedFrameSize(sizes)
      if (task && frameSize && frameSize.width > 0 && frameSize.height > 0) {
        this.$set(task, 'compositeFrameSize', frameSize)
      }
      return frameSize && frameSize.width > 0 && frameSize.height > 0 ? frameSize : null
    },
    async fetchRecentPaperImageBlob(url, onProgress, task) {
      return this.fetchCachedPreviewPerformanceBlob(url, async progressHandler => {
        const requestUrls = this.getRecentPaperImageFetchUrls(url)
        let lastError = null
        for (const requestUrl of requestUrls) {
          let controller = null
          try {
            if (task) {
              this.ensurePaperDownloadTaskActive(task)
            }
            if (typeof AbortController !== 'undefined') {
              controller = new AbortController()
              if (task) {
                this.registerPreviewPerformanceTaskAbortController(task, controller)
              }
            }
            const response = await fetch(requestUrl, controller ? { signal: controller.signal } : undefined)
            if (!response.ok) {
              const error = new Error(`Image failed: ${response.status}`)
              error.isCorsLikeDownloadError = requestUrl != url
              throw error
            }
            const contentType = response.headers && response.headers.get ? response.headers.get('content-type') : ''
            const normalizedContentType = String(contentType).toLowerCase()
            const isImageResponse = normalizedContentType.includes('image/') || normalizedContentType.includes('octet-stream')
            if (contentType && !isImageResponse) {
              const error = new Error('Image proxy returned non-image content')
              error.isCorsLikeDownloadError = true
              throw error
            }
            const blob = await this.readRecentPaperImageResponseBlob(response, progressHandler)
            if (task) {
              this.ensurePaperDownloadTaskActive(task)
            }
            const imageMimeType = this.getRecentPaperImageMimeType(url)
            if (imageMimeType && !String(blob.type || '').toLowerCase().includes('image/')) {
              return new Blob([blob], { type: imageMimeType })
            }
            return blob
          } catch (error) {
            if (error && (error.name == 'AbortError' || task && task.cancelled)) {
              const cancelError = new Error('Download cancelled')
              cancelError.isPaperDownloadCancelled = true
              throw cancelError
            }
            error.isCorsLikeDownloadError = true
            lastError = error
          } finally {
            if (task) {
              this.unregisterPreviewPerformanceTaskAbortController(task, controller)
            }
          }
        }
        throw lastError || new Error('Image download failed')
      }, { onProgress, task })
    },
    async readRecentPaperImageResponseBlob(response, onProgress) {
      const contentType = response.headers && response.headers.get ? response.headers.get('content-type') : ''
      const contentLength = Number(response.headers && response.headers.get ? response.headers.get('content-length') : 0)
      if (!response.body || typeof response.body.getReader != 'function' || !contentLength) {
        const blob = await response.blob()
        if (onProgress) {
          onProgress(100)
        }
        return blob
      }
      const reader = response.body.getReader()
      const chunks = []
      let receivedLength = 0
      let result = await reader.read()
      while (!result.done) {
        chunks.push(result.value)
        receivedLength += result.value.length
        if (onProgress) {
          onProgress(Math.min(100, Math.round((receivedLength / contentLength) * 100)))
        }
        result = await reader.read()
      }
      if (onProgress) {
        onProgress(100)
      }
      return new Blob(chunks, { type: contentType || 'application/octet-stream' })
    },
    getRecentPaperImageFetchUrls(url) {
      return url ? [url] : []
    },
    getRecentPaperProxyFetchUrl(url) {
      return url || ''
    },
    getRecentPaperProxyBaseUrl() {
      return ''
    },
    canUseRecentPaperImageProxy() {
      return false
    },
    isRecentUnexpectedProxyResponse() {
      return false
    },
    getRecentPaperImageMimeType(url) {
      const extension = this.getRecentUrlExtension(url).toLowerCase()
      if (extension == 'jpg' || extension == 'jpeg') {
        return 'image/jpeg'
      }
      if (extension == 'png') {
        return 'image/png'
      }
      if (extension == 'webp') {
        return 'image/webp'
      }
      if (extension == 'gif') {
        return 'image/gif'
      }
      if (extension == 'bmp') {
        return 'image/bmp'
      }
      return ''
    },
    composeRecentLearningAnnotationCanvas(baseBlob, overlayBlob, targetSize) {
      return Promise.all([
        this.loadRecentDrawableImageFromBlob(baseBlob),
        this.loadRecentDrawableImageFromBlob(overlayBlob)
      ]).then(([baseImage, overlayImage]) => {
        try {
          const baseWidth = Math.max(1, Math.round(baseImage.naturalWidth || baseImage.width || 0))
          const baseHeight = Math.max(1, Math.round(baseImage.naturalHeight || baseImage.height || 0))
          const overlayWidth = Math.max(1, Math.round(overlayImage.naturalWidth || overlayImage.width || 0))
          const overlayHeight = Math.max(1, Math.round(overlayImage.naturalHeight || overlayImage.height || 0))
          const useOverlaySize = overlayWidth * overlayHeight > baseWidth * baseHeight
          const fallbackWidth = useOverlaySize ? overlayWidth : baseWidth
          const fallbackHeight = useOverlaySize ? overlayHeight : baseHeight
          const rect = this.getPaperWidthAlignedDrawRect(
            fallbackWidth,
            fallbackHeight,
            Number(targetSize && targetSize.width) || fallbackWidth,
            Number(targetSize && targetSize.height) || fallbackHeight
          )
          const width = rect.targetWidth
          const height = rect.targetHeight
          const canvas = document.createElement('canvas')
          canvas.width = width
          canvas.height = height
          const context = canvas.getContext('2d')
          if (context && 'imageSmoothingEnabled' in context) {
            context.imageSmoothingEnabled = true
            if ('imageSmoothingQuality' in context) {
              context.imageSmoothingQuality = 'high'
            }
          }
          context.fillStyle = '#fff'
          context.fillRect(0, 0, width, height)
          context.drawImage(baseImage, rect.x, rect.y, rect.drawWidth, rect.drawHeight)
          context.drawImage(overlayImage, rect.x, rect.y, rect.drawWidth, rect.drawHeight)
          return canvas
        } finally {
          this.releaseRecentDrawableImage(baseImage)
          this.releaseRecentDrawableImage(overlayImage)
        }
      })
    },
    async loadRecentDrawableImageFromBlob(blob) {
      if (typeof window !== 'undefined' && typeof window.createImageBitmap == 'function') {
        try {
          return await window.createImageBitmap(blob)
        } catch (error) {
          // Fall back to Image for formats the browser cannot bitmap-decode here.
        }
      }
      return this.loadRecentImageFromBlob(blob)
    },
    releaseRecentDrawableImage(image) {
      if (image && typeof image.close == 'function') {
        image.close()
      }
    },
    loadRecentImageFromBlob(blob) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(blob)
        const image = new Image()
        image.onload = () => {
          URL.revokeObjectURL(url)
          resolve(image)
        }
        image.onerror = () => {
          URL.revokeObjectURL(url)
          reject(new Error('Image load failed'))
        }
        image.src = url
      })
    },
    recentCanvasToPngBlob(canvas) {
      return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
          if (blob) {
            resolve(blob)
            return
          }
          reject(new Error('Canvas export failed'))
        }, 'image/png')
      })
    },
    recentCanvasToJpegPage(canvas) {
      return new Promise((resolve, reject) => {
        canvas.toBlob(async blob => {
          if (!blob) {
            reject(new Error('Image convert failed'))
            return
          }
          resolve({
            width: canvas.width,
            height: canvas.height,
            data: new Uint8Array(await this.recentBlobToArrayBuffer(blob))
          })
        }, 'image/jpeg', 1)
      })
    },
    releaseRecentCanvas(canvas) {
      if (canvas) {
        canvas.width = 0
        canvas.height = 0
      }
    },
    getRecentLearningAnnotationFileName(annotation, index, extension) {
      const pageNo = annotation && annotation.pageNo ? annotation.pageNo : index + 1
      return `${pageNo}.${extension || 'png'}`
    },
    isRecentLearningAnnotationPreviewGridTopEdge(index) {
      const columnCount = Math.max(1, Number(this.recentLearningAnnotationPreviewGridColumnCount) || 1)
      return index < columnCount
    },
    isRecentLearningAnnotationPreviewGridSelectedRowStart(index) {
      const columnCount = Math.max(1, Number(this.recentLearningAnnotationPreviewGridColumnCount) || 1)
      const previousAnnotation = this.recentLearningAnnotations[index - columnCount]
      return !previousAnnotation || !this.isRecentLearningAnnotationPreviewSelected(previousAnnotation.id)
    },
    isRecentLearningAnnotationPreviewGridSelectionContinuesBelow(index) {
      const columnCount = Math.max(1, Number(this.recentLearningAnnotationPreviewGridColumnCount) || 1)
      const nextAnnotation = this.recentLearningAnnotations[index + columnCount]
      return !!(nextAnnotation && this.isRecentLearningAnnotationPreviewSelected(nextAnnotation.id))
    },
    hasSelectedRecentLearningAnnotationPreviewGridRow(rowStart, columnCount) {
      if (rowStart < 0 || rowStart >= this.recentLearningAnnotations.length) {
        return false
      }
      const rowEnd = Math.min(rowStart + columnCount, this.recentLearningAnnotations.length)
      for (let index = rowStart; index < rowEnd; index += 1) {
        const annotation = this.recentLearningAnnotations[index]
        if (annotation && this.isRecentLearningAnnotationPreviewSelected(annotation.id)) {
          return true
        }
      }
      return false
    },
    updateRecentLearningAnnotationPreviewGridColumnCount() {
      if (!this.recentLearningAnnotationPreviewGridOpen) {
        return
      }
      this.$nextTick(() => {
        const grid = this.$refs.recentLearningAnnotationPreviewGrid
        if (!grid || typeof window === 'undefined') {
          this.recentLearningAnnotationPreviewGridColumnCount = 1
          return
        }
        const styles = window.getComputedStyle(grid)
        const columns = String(styles.gridTemplateColumns || '')
          .split(/\s+/)
          .filter(column => column && column != 'none')
        this.recentLearningAnnotationPreviewGridColumnCount = Math.max(1, columns.length || 1)
      })
    },
    centerRecentLearningAnnotationPreviewScroll() {
      this.$nextTick(() => {
        if (typeof window !== 'undefined' && typeof window.requestAnimationFrame == 'function') {
          window.requestAnimationFrame(this.applyRecentLearningAnnotationPreviewCenterScroll)
          return
        }
        this.applyRecentLearningAnnotationPreviewCenterScroll()
      })
    },
    applyRecentLearningAnnotationPreviewCenterScroll() {
      const shell = this.$refs.recentLearningAnnotationPreviewShell
      if (!shell) {
        return
      }
      shell.scrollLeft = Math.max(0, (shell.scrollWidth - shell.clientWidth) / 2)
      shell.scrollTop = Math.max(0, (shell.scrollHeight - shell.clientHeight) / 2)
    },
    startRecentLearningAnnotationPreviewDrag(event) {
      const shell = this.$refs.recentLearningAnnotationPreviewShell
      if (this.recentLearningAnnotationPreviewGridOpen || !event || event.button !== 0 || !shell) {
        return
      }
      if (shell.scrollWidth <= shell.clientWidth && shell.scrollHeight <= shell.clientHeight) {
        return
      }
      event.preventDefault()
      this.recentLearningAnnotationPreviewDragState = {
        x: event.clientX,
        y: event.clientY,
        scrollLeft: shell.scrollLeft,
        scrollTop: shell.scrollTop
      }
      if (typeof document !== 'undefined') {
        document.addEventListener('mousemove', this.handleRecentLearningAnnotationPreviewDrag)
        document.addEventListener('mouseup', this.stopRecentLearningAnnotationPreviewDrag)
      }
    },
    handleRecentLearningAnnotationPreviewDrag(event) {
      const shell = this.$refs.recentLearningAnnotationPreviewShell
      const state = this.recentLearningAnnotationPreviewDragState
      if (!shell || !state || !event) {
        return
      }
      shell.scrollLeft = state.scrollLeft - (event.clientX - state.x)
      shell.scrollTop = state.scrollTop - (event.clientY - state.y)
    },
    stopRecentLearningAnnotationPreviewDrag() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('mousemove', this.handleRecentLearningAnnotationPreviewDrag)
        document.removeEventListener('mouseup', this.stopRecentLearningAnnotationPreviewDrag)
      }
      this.recentLearningAnnotationPreviewDragState = null
    },
    getRecentDetailFolderType(item) {
      return this.resolveAppFolderType(item)
    },
    fetchRecentDetailResponse(item, password = '', folderTypeOverride = '') {
      const folderType = folderTypeOverride || this.getRecentDetailFolderType(item)
      const resourceId = item && item.resourceId ? item.resourceId : ''
      if (!folderType || !resourceId) {
        return Promise.reject(new Error(this.uiText.openUnavailable || 'Unable to open this item'))
      }
      const params = { uuid: resourceId }
      if (password || (item && item.encrypted)) {
        params.password = password
      }
      if (folderType == 'paper') {
        return getPaperSyncDetail(params, { skipGlobalErrorMessage: true })
      }
      if (folderType == 'learning') {
        return getLearningSyncDetail(params, { skipGlobalErrorMessage: true })
      }
      if (folderType == 'memo') {
        return getMemoSyncDetail(params, { skipGlobalErrorMessage: true })
      }
      if (folderType == 'meeting') {
        return getMeetingSyncDetail(params, { skipGlobalErrorMessage: true })
      }
      if (folderType == 'knowledge') {
        return getKnowledgeBaseSyncDetail(params, { skipGlobalErrorMessage: true })
      }
      return Promise.reject(new Error(this.uiText.openUnavailable || 'Unable to open this item'))
    },
    withRecentResourceDetailPrefetch(item, folderType, options = {}) {
      const nextOptions = Object.assign({}, options)
      if (Object.prototype.hasOwnProperty.call(nextOptions, 'prefetchedRet')) {
        Promise.resolve(nextOptions.prefetchedRet).catch(() => {})
        return nextOptions
      }
      const scope = RECENT_DETAIL_PREFETCH_CACHE_SCOPES[folderType]
      const resourceId = item && item.resourceId ? String(item.resourceId) : ''
      const password = String(nextOptions.password || '')
      if (
        !scope
        || !resourceId
        || (item && item.hasResourceId === false)
        || /^recent-\d+$/.test(resourceId)
        || this.isRecentFolderLike(item)
        || this.isDirectFilePreviewItem(item)
        || (item && item.encrypted && !password)
      ) {
        return nextOptions
      }
      const cacheKey = item && item.encrypted ? `${resourceId}:${password || 'encrypted'}` : resourceId
      const cachedDetail = typeof this.getSharedPaperPreviewDetailCache == 'function'
        ? this.getSharedPaperPreviewDetailCache(scope, cacheKey)
        : null
      if (!nextOptions.force && cachedDetail && cachedDetail.detail) {
        return nextOptions
      }
      const prefetchedRet = Promise.resolve().then(() => this.fetchRecentDetailResponse(item, password, folderType))
      prefetchedRet.catch(() => {})
      nextOptions.prefetchedRet = prefetchedRet
      return nextOptions
    },
    getRecentApiResponseData(source) {
      const responseData = source && source.response && source.response.data ? source.response.data : null
      return responseData || (source && source.data ? source.data : source)
    },
    getRecentApiCode(source) {
      const data = this.getRecentApiResponseData(source)
      if (!data || typeof data != 'object') {
        return undefined
      }
      return this.pickValue(data, ['code', 'statusCode'])
    },
    isRecentApiCodeFailed(source) {
      const code = this.getRecentApiCode(source)
      if (code === undefined || code === null || code === '') {
        return false
      }
      return code != 200 && code != '200'
    },
    isRecentPasswordCodeError(source) {
      const code = this.getRecentApiCode(source)
      return code == 10013 || code == '10013'
    },
    getRecentApiErrorMessage(error) {
      const data = this.getRecentApiResponseData(error)
      if (data && typeof data == 'object') {
        return this.pickString(data, ['msg', 'message', 'errorMessage', 'error'])
      }
      if (error && error.message) {
        return error.message
      }
      return ''
    },
    getRecentPasswordErrorMessage() {
      return this.recentPasswordUi.wrong
    },
    resolveRecentApiPayload(ret) {
      const data = ret && ret.data ? ret.data : ret
      if (!data) {
        return null
      }
      if (data.code == 200 || data.code == '200' || data.success === true) {
        return data.data === undefined ? {} : data.data
      }
      if (data.resource || data.meta || data.name || data.title) {
        return data
      }
      return null
    },
    normalizeRecentLearningFallback(item) {
      const source = item && item.raw && typeof item.raw == 'object' ? item.raw : {}
      return {
        name: item && item.name ? item.name : this.pickString(source, ['name', 'title', 'fileName', 'bookName']) || 'Learning',
        fileSizeBytes: this.pickValue(source, ['fileSizeBytes', 'fileSize', 'size']),
        fileFormat: this.pickString(source, ['fileFormat', 'format', 'suffix']) || this.getRecentUrlExtension(item && item.filePath),
        syncStatus: this.pickValue(source, ['syncStatus']),
        readingProgress: this.normalizeRecentLearningProgress(this.pickValue(source, ['readingProgress']) || source),
        bookmarks: [],
        highlights: [],
        annotations: [],
        counts: {
          bookmarks: this.pickValue(source, ['bookmarkCount', 'bookmarksCount', 'bookmarkSize']),
          highlights: this.pickValue(source, ['highlightCount', 'highlightsCount', 'highlightSize']),
          annotations: this.pickValue(source, ['annotationCount', 'annotationsCount', 'readNoteCount', 'readNotesCount', 'readNoteSize', 'handwritingCount'])
        }
      }
    },
    async normalizeRecentLearningDetail(payload, sourceItem) {
      const raw = payload && typeof payload == 'object' ? payload : {}
      const detail = raw.resource && typeof raw.resource == 'object' ? raw.resource : raw
      const sourceRaw = sourceItem && sourceItem.raw && typeof sourceItem.raw == 'object' ? sourceItem.raw : {}
      const [sourceMeta, detailMeta] = await Promise.all([
        this.parseRecentLearningMeta(this.pickValue(sourceRaw, ['meta'])),
        this.parseRecentLearningMeta(this.pickValue(detail, ['meta']))
      ])
      const meta = Object.assign({}, sourceMeta, detailMeta)
      const learningMeta = this.resolveRecentLearningMeta(meta)
      const directLearningMeta = this.resolveRecentLearningMeta(detail)
      const effectiveLearningMeta = this.isRecentLearningMetaShape(directLearningMeta)
        ? Object.assign({}, learningMeta, directLearningMeta)
        : learningMeta
      const bookmarks = this.normalizeRecentLearningBookmarks(this.extractRecentLearningCategoryArray(effectiveLearningMeta, detail, [
        'bookmarks',
        'bookmarkList',
        'bookMarkList',
        'marks',
        'markList'
      ], 'bookmark'))
      const highlights = this.normalizeRecentLearningHighlights(this.extractRecentLearningCategoryArray(effectiveLearningMeta, detail, [
        'highlights',
        'highlightList',
        'highlightNotes',
        'readHighlights'
      ], 'highlight'))
      const annotations = this.normalizeRecentLearningAnnotations(this.extractRecentLearningCategoryArray(effectiveLearningMeta, detail, [
        'readNotes',
        'readNoteList',
        'annotations',
        'annotationList',
        'handwriting',
        'handwritings',
        'handwritten',
        'handwrittenList',
        'handwrite',
        'handwriteList',
        'penNotes',
        'scribbles'
      ], 'annotation'))
      return {
        name: this.pickString(effectiveLearningMeta, ['name', 'title', 'resourceName', 'bookName', 'fileName'])
          || this.pickString(detail, ['name', 'title', 'resourceName', 'bookName', 'fileName'])
          || (sourceItem && sourceItem.name ? sourceItem.name : 'Learning'),
        fileSizeBytes: this.pickFirstPresent(
          this.pickValue(effectiveLearningMeta, ['fileSizeBytes', 'fileSize', 'size']),
          this.pickValue(detail, ['fileSizeBytes', 'fileSize', 'size']),
          this.pickValue(sourceRaw, ['fileSizeBytes', 'fileSize', 'size'])
        ),
        fileFormat: this.pickString(effectiveLearningMeta, ['fileFormat', 'format', 'suffix'])
          || this.pickString(detail, ['fileFormat', 'format', 'suffix'])
          || this.pickString(sourceRaw, ['fileFormat', 'format', 'suffix'])
          || this.getRecentUrlExtension(sourceItem && sourceItem.filePath),
        syncStatus: this.normalizeRecentLearningSyncStatus(this.pickFirstPresent(
          this.pickValue(effectiveLearningMeta, ['syncStatus']),
          this.pickValue(detail, ['syncStatus']),
          this.pickValue(sourceRaw, ['syncStatus'])
        )),
        readingProgress: this.normalizeRecentLearningProgress(this.pickFirstPresent(
          this.pickValue(effectiveLearningMeta, ['readingProgress']),
          this.pickValue(detail, ['readingProgress']),
          this.pickValue(sourceRaw, ['readingProgress']),
          effectiveLearningMeta,
          detail
        )),
        bookmarks,
        highlights,
        annotations,
        counts: {
          bookmarks: this.pickFirstPresent(
            this.pickValue(effectiveLearningMeta, ['bookmarkCount', 'bookmarksCount', 'bookmarkSize']),
            this.pickValue(detail, ['bookmarkCount', 'bookmarksCount', 'bookmarkSize'])
          ),
          highlights: this.pickFirstPresent(
            this.pickValue(effectiveLearningMeta, ['highlightCount', 'highlightsCount', 'highlightSize']),
            this.pickValue(detail, ['highlightCount', 'highlightsCount', 'highlightSize'])
          ),
          annotations: this.pickFirstPresent(
            this.pickValue(effectiveLearningMeta, ['annotationCount', 'annotationsCount', 'readNoteCount', 'readNotesCount', 'readNoteSize', 'handwritingCount']),
            this.pickValue(detail, ['annotationCount', 'annotationsCount', 'readNoteCount', 'readNotesCount', 'readNoteSize', 'handwritingCount'])
          )
        }
      }
    },
    openRecentPasswordModal(item, error = '', keepInput = false, returnContext = 'recent', action = 'open', items = [], openOptions = {}) {
      this.recentPasswordTarget = item
      this.recentPasswordAction = action == 'download' ? 'download' : 'open'
      this.recentPasswordItems = Array.isArray(items) ? items.filter(Boolean) : []
      this.recentPasswordOpenOptions = openOptions && typeof openOptions == 'object' ? Object.assign({}, openOptions) : {}
      this.recentPasswordError = error || ''
      this.recentPasswordVisible = false
      this.recentPasswordSubmitting = false
      this.recentPasswordReturnContext = returnContext == 'search' ? 'search' : 'recent'
      if (!keepInput) {
        this.recentPasswordInput = ''
      }
      this.recentPasswordModalOpen = true
      this.$nextTick(() => {
        const input = this.$refs.recentPasswordInput
        if (input && typeof input.focus == 'function') {
          input.focus()
        }
      })
    },
    closeRecentPasswordModal() {
      if (this.recentPasswordSubmitting) {
        return
      }
      this.recentPasswordRequestSeq += 1
      this.recentPasswordModalOpen = false
      this.recentPasswordTarget = null
      this.recentPasswordInput = ''
      this.recentPasswordVisible = false
      this.recentPasswordSubmitting = false
      this.recentPasswordError = ''
      this.recentPasswordReturnContext = 'recent'
      this.recentPasswordAction = 'open'
      this.recentPasswordItems = []
      this.recentPasswordOpenOptions = {}
    },
    toggleRecentPasswordVisible() {
      this.recentPasswordVisible = !this.recentPasswordVisible
    },
    async confirmRecentPassword() {
      if (this.recentPasswordSubmitting) {
        return
      }
      const item = this.recentPasswordTarget
      const rawPassword = String(this.recentPasswordInput || '')
      if (!rawPassword) {
        this.recentPasswordError = this.recentPasswordUi.required
        this.$nextTick(() => {
          const input = this.$refs.recentPasswordInput
          if (input && typeof input.focus == 'function') {
            input.focus()
          }
        })
        return
      }
      if (!item) {
        this.closeRecentPasswordModal()
        return
      }
      const action = this.recentPasswordAction == 'download' ? 'download' : 'open'
      const actionItems = Array.isArray(this.recentPasswordItems) ? this.recentPasswordItems.slice() : []
      const passwordOpenOptions = Object.assign({}, this.recentPasswordOpenOptions || {})
      this.recentPasswordSubmitting = true
      this.recentPasswordError = ''
      const requestId = this.recentPasswordRequestSeq + 1
      this.recentPasswordRequestSeq = requestId
      try {
        const hashedPassword = await this.encryptRecentPasswordToSHA256String(rawPassword)
        if (requestId != this.recentPasswordRequestSeq) {
          return
        }
        const ret = await checkCloudPassword({ password: hashedPassword }, { skipGlobalErrorMessage: true })
        if (requestId != this.recentPasswordRequestSeq) {
          return
        }
        if (this.isRecentApiCodeFailed(ret)) {
          this.recentPasswordError = this.getRecentPasswordErrorMessage()
          return
        }
        const returnContext = this.recentPasswordReturnContext
        this.recentPasswordModalOpen = false
        this.recentPasswordSubmitting = false
        this.recentPasswordTarget = null
        this.recentPasswordInput = ''
        this.recentPasswordVisible = false
        this.recentPasswordError = ''
        this.recentPasswordReturnContext = 'recent'
        this.recentPasswordAction = 'open'
        this.recentPasswordItems = []
        this.recentPasswordOpenOptions = {}
        if (action == 'download') {
          this.openRecentDownloadFormatModal(actionItems.length > 0 ? actionItems : [item], { skipPasswordPrompt: true, password: hashedPassword, selectionContext: returnContext })
          return
        }
        const openOptions = Object.assign({}, passwordOpenOptions, {
          password: hashedPassword,
          skipPasswordPrompt: true
        })
        if (returnContext == 'search') {
          this.openGlobalSearchItem(item, null, openOptions)
        } else {
          this.openRecentItem(item, null, openOptions)
        }
      } catch (error) {
        if (requestId != this.recentPasswordRequestSeq) {
          return
        }
        if (this.isRecentPasswordCodeError(error) || this.isRecentApiCodeFailed(error)) {
          this.recentPasswordError = this.getRecentPasswordErrorMessage()
        } else {
          this.recentPasswordError = this.getRecentApiErrorMessage(error) || this.getRecentPasswordErrorMessage()
        }
      } finally {
        if (requestId == this.recentPasswordRequestSeq) {
          this.recentPasswordSubmitting = false
        }
      }
    },
    async encryptRecentPasswordToSHA256String(pass) {
      if (!pass) {
        return ''
      }
      if (typeof window === 'undefined' || !window.crypto || !window.crypto.subtle || typeof TextEncoder === 'undefined') {
        throw new Error(this.recentPasswordUi.cryptoUnsupported)
      }
      const bytes = new TextEncoder().encode(pass)
      const hashBuffer = await window.crypto.subtle.digest('SHA-256', bytes)
      return Array.from(new Uint8Array(hashBuffer))
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase()
    },
    openRecentItem(item, event, options = {}) {
      this.clearRecentItemClickTimer()
      if (event && typeof event.preventDefault == 'function') {
        event.preventDefault()
      }
      if (!item) {
        return
      }
      this.clearRecentSelection()
      const folderType = this.resolveAppFolderType(item) || this.activeAppFolder || (this.isDirectFilePreviewItem(item) ? 'paper' : '')
      if (!folderType || !item.resourceId) {
        this.$message.warning(this.uiText.openUnavailable || 'Unable to open this item')
        return
      }
      const openOptions = Object.assign({}, options, { force: true })
      this.pendingRecentOpenItem = null
      this.pendingRecentOpenOptions = null
      if (item.encrypted && !openOptions.skipPasswordPrompt) {
        this.openRecentPasswordModal(item, '', false, 'recent', 'open', [], openOptions)
        return
      }
      this.captureMobilePreviewReturnScroll('recent')
      if (folderType == 'learning' && !this.isDirectFilePreviewItem(item)) {
        this.activeMenu = 'recent'
        this.activeAppReturnMenu = 'recent'
        this.activeAppFolder = ''
        this.activeAppFolderAppType = null
        this.closeSearchPage()
        this.openRecentLearningModal(item, openOptions)
        return
      }
      const pendingOptions = this.withRecentResourceDetailPrefetch(item, folderType, openOptions)
      this.pendingRecentOpenItem = item
      this.pendingRecentOpenOptions = pendingOptions
      this.activeMenu = this.resolveMenuKeyForFolderType(folderType, 'recent')
      this.activeAppReturnMenu = 'recent'
      this.activeAppFolder = folderType
      this.activeAppFolderAppType = item.appType || this.resolveDefaultAppTypeByFolderType(folderType)
      this.closeSearchPage()
      this.scrollNewMobilePageToTop()
      this.$nextTick(() => {
        this.openPendingRecentItem()
      })
    },
    openPendingRecentItem(attempt = 0) {
      const item = this.pendingRecentOpenItem
      const options = this.pendingRecentOpenOptions || {}
      if (!item) {
        return
      }
      const sync = this.$refs.activeAppSync
      if (!sync) {
        if (attempt < 8) {
          window.setTimeout(() => this.openPendingRecentItem(attempt + 1), 60)
        }
        return
      }
      const folderType = this.resolveAppFolderType(item) || this.activeAppFolder
      const opened = folderType == 'daily'
        ? this.openRecentDailyItem(sync, item, options)
        : this.openRecentResourceItem(sync, item, options)
      this.pendingRecentOpenItem = null
      this.pendingRecentOpenOptions = null
      if (opened === false) {
        this.$message.info(this.uiText.openUnavailable || 'Unable to open this item')
      }
    },
    openRecentResourceItem(sync, item, options = {}) {
      if (!sync || typeof sync.openPaperItem != 'function') {
        return false
      }
      const source = this.buildRecentResourceSource(item)
      const normalized = typeof sync.normalizePaperItem == 'function'
        ? sync.normalizePaperItem(source, 0)
        : source
      const hasPrefetchedRet = Object.prototype.hasOwnProperty.call(options, 'prefetchedRet')
      if ((hasPrefetchedRet || options.password || options.openPageGrid) && typeof sync.openPaperDetail == 'function' && normalized && !normalized.isFolder && normalized.resourceId) {
        const detailOptions = hasPrefetchedRet ? { prefetchedRet: options.prefetchedRet } : {}
        if (options.force === true) {
          detailOptions.force = true
        }
        sync.openPaperDetail(normalized, options.password || '', detailOptions)
        if (options.openPageGrid) {
          this.openRecentSyncPageGridWhenReady(sync, 'paper')
        }
        return true
      }
      if (typeof sync.handlePaperItemDblClick == 'function') {
        sync.handlePaperItemDblClick(normalized)
      } else {
        sync.openPaperItem(normalized)
      }
      if (options.openPageGrid) {
        this.openRecentSyncPageGridWhenReady(sync, 'paper')
      }
      return true
    },
    buildRecentResourceSource(item) {
      const source = Object.assign({}, item && item.raw && typeof item.raw == 'object' ? item.raw : {})
      const values = {
        resourceId: item.resourceId,
        name: item.name,
        cover: item.cover,
        filePath: item.filePath,
        childSize: item.childSize,
        resourceType: item.resourceType,
        subTab: item.subTab,
        appType: item.appType,
        encrypted: item.encrypted
      }
      Object.keys(values).forEach(key => {
        const value = values[key]
        if (value !== undefined && value !== null && (typeof value != 'string' || value.trim() !== '')) {
          source[key] = value
        }
      })
      return source
    },
    openRecentDailyItem(sync, item, options = {}) {
      if (!sync || typeof sync.openDailyGroupPreview != 'function') {
        return false
      }
      const previewType = this.resolveRecentDailyType(item)
      const dailyTab = previewType === 1 ? 'tasks' : (previewType === 0 ? 'notes' : this.resolveRecentDailyTab(item))
      const isSearchOpen = this.activeAppReturnMenu == 'search' || options.sourceContext == 'search'
      if (dailyTab == 'todo' && !isSearchOpen) {
        sync.dailyActiveTab = 'todo'
        if (typeof sync.loadDailyList == 'function') {
          sync.loadDailyList()
        }
        return true
      }
      sync.dailyActiveTab = dailyTab == 'todo' ? 'tasks' : dailyTab
      sync.dailyViewMode = normalizeMobileCloudViewMode(sync.viewMode)
      const dailyDate = this.resolveRecentDailyDate(item, sync)
      const dailyResourceDate = this.resolveRecentDailyPreviewResourceId(item)
      const dailyPreviewDate = dailyDate || this.normalizeRecentDailyDateValue(dailyResourceDate, sync)
      const source = Object.assign({}, item.raw || {}, {
        id: dailyResourceDate || item.resourceId,
        resourceId: dailyResourceDate || item.resourceId,
        dailyId: dailyResourceDate || item.resourceId,
        name: item.name,
        cover: item.cover,
        imageUrl: item.cover,
        childSize: item.childSize,
        date: dailyPreviewDate || item.createdAt || item.updatedAt || ''
      })
      const normalized = typeof sync.normalizeDailyItem == 'function'
        ? sync.normalizeDailyItem(source, 0)
        : source
      const previewRequest = dailyPreviewDate && (previewType === 0 || previewType === 1)
        ? {
            startDate: dailyPreviewDate,
            endDate: dailyPreviewDate,
            type: previewType,
            isFinish: -1
          }
        : null
      const group = {
        id: `recent-daily-${item.resourceId}`,
        name: normalized.name || item.name || 'Daily',
        cover: normalized.imageUrl || item.cover || '',
        date: normalized.date || dailyPreviewDate || item.createdAt || item.updatedAt || '',
        count: 1,
        items: [normalized],
        previewRequest
      }
      sync.openDailyGroupPreview(group, null, { force: options.force === true })
      if (options.openPageGrid) {
        this.openRecentSyncPageGridWhenReady(sync, 'daily')
      }
      return true
    },
    openRecentSyncPageGridWhenReady(sync, mode = 'paper', attempt = 0) {
      if (!sync || typeof window === 'undefined') {
        return
      }
      const maxAttempts = 45
      const tryOpen = () => {
        if (mode == 'daily') {
          const items = Array.isArray(sync.dailyPreviewItems) ? sync.dailyPreviewItems : []
          if (sync.dailyPreviewOpen && !sync.dailyPreviewLoading && items.length > 0) {
            if (!sync.dailyPreviewGridOpen && typeof sync.toggleDailyPreviewGrid == 'function') {
              sync.toggleDailyPreviewGrid()
            }
            return
          }
        } else {
          const pages = Array.isArray(sync.detailPages) ? sync.detailPages : []
          const canUsePageGrid = sync.canUsePageGridButton === undefined || !!sync.canUsePageGridButton
          if (sync.detailMode && !sync.paperDetailLoading && pages.length > 0 && canUsePageGrid) {
            if (!sync.pageGridOpen && typeof sync.togglePageGrid == 'function') {
              sync.togglePageGrid()
            }
            return
          }
        }
        if (attempt < maxAttempts) {
          window.setTimeout(() => this.openRecentSyncPageGridWhenReady(sync, mode, attempt + 1), 100)
        }
      }
      window.setTimeout(tryOpen, attempt == 0 ? 120 : 0)
    },
    resolveRecentDailyPreviewResourceId(item) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : {}
      const keys = ['resourceId', 'resource_id', 'resourceID', 'uuid', 'id', 'resourceUuid', 'resource_uuid', 'dailyId', 'daily_id']
      const value = this.pickString(item || {}, keys)
      const rawValue = this.pickString(raw, keys)
      return value && !/^recent-\d+$/.test(value) ? value : (rawValue || value)
    },
    resolveRecentDailyDate(item, sync = null) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : {}
      const source = Object.assign({}, raw, item || {})
      const dailyDate = this.pickValue(source, [
        'date',
        'day',
        'syncDate',
        'sync_date',
        'dailyDate',
        'daily_date',
        'resourceDate',
        'resource_date',
        'startDate',
        'start_date'
      ])
      const normalizedDailyDate = this.normalizeRecentDailyDateValue(dailyDate, sync)
      if (normalizedDailyDate) {
        return normalizedDailyDate
      }
      const resourceDate = this.pickValue(source, ['resourceId', 'dailyId'])
      const normalizedResourceDate = this.normalizeRecentDailyDateValue(resourceDate, sync)
      if (normalizedResourceDate) {
        return normalizedResourceDate
      }
      const genericDate = this.pickValue(source, [
        'createdAt',
        'createAt',
        'createTime',
        'createdTime',
        'time',
        'updatedAt',
        'updateAt',
        'updateTime',
        'updatedTime'
      ])
      return this.normalizeRecentDailyDateValue(genericDate, sync)
    },
    normalizeRecentDailyDateValue(value, sync = null) {
      if (value === undefined || value === null || value === '') {
        return ''
      }
      if (value instanceof Date) {
        return this.formatRecentDailyDateValue(value)
      }
      const text = String(value || '').trim()
      if (!text) {
        return ''
      }
      const compactDate = text.match(/^(\d{4})(\d{2})(\d{2})$/)
      if (compactDate) {
        return `${compactDate[1]}-${compactDate[2]}-${compactDate[3]}`
      }
      const matchedDate = text.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/)
      if (matchedDate) {
        return [
          matchedDate[1],
          String(Number(matchedDate[2])).padStart(2, '0'),
          String(Number(matchedDate[3])).padStart(2, '0')
        ].join('-')
      }
      if (/^\d+$/.test(text)) {
        if (text.length < 10) {
          return ''
        }
        const number = Number(text)
        if (!Number.isFinite(number)) {
          return ''
        }
        return this.formatRecentDailyDateValue(new Date(number < 1000000000000 ? number * 1000 : number))
      }
      if (sync && typeof sync.normalizeDailyDateValue == 'function') {
        const normalized = sync.normalizeDailyDateValue(text)
        if (normalized) {
          return normalized
        }
      }
      return this.formatRecentDailyDateValue(new Date(text.replace(/-/g, '/')))
    },
    formatRecentDailyDateValue(value) {
      const date = value instanceof Date ? value : new Date(value)
      if (!date || Number.isNaN(date.getTime())) {
        return ''
      }
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${date.getFullYear()}-${month}-${day}`
    },
    resolveRecentDailyType(item) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : {}
      const value = this.pickValue(item || {}, ['subTab', 'sub_tab', 'subtab', 'dailySubTab', 'daily_sub_tab'])
      const rawValue = this.pickValue(raw, ['subTab', 'sub_tab', 'subtab', 'dailySubTab', 'daily_sub_tab'])
      const fallbackValue = this.pickValue(item || {}, ['tab', 'dailyType', 'daily_type', 'type'])
      const rawFallbackValue = this.pickValue(raw, ['tab', 'dailyType', 'daily_type', 'type'])
      const effectiveValue = value === undefined || value === null || value === '' ? rawValue : value
      const effectiveFallbackValue = fallbackValue === undefined || fallbackValue === null || fallbackValue === '' ? rawFallbackValue : fallbackValue
      const number = effectiveValue === undefined || effectiveValue === null || effectiveValue === '' ? NaN : Number(effectiveValue)
      if (number === 0 || number === 1 || number === 2) {
        return number
      }
      const fallbackNumber = effectiveFallbackValue === undefined || effectiveFallbackValue === null || effectiveFallbackValue === '' ? NaN : Number(effectiveFallbackValue)
      if (fallbackNumber === 0 || fallbackNumber === 1 || fallbackNumber === 2) {
        return fallbackNumber
      }
      const tab = this.resolveRecentDailyTab(item)
      if (tab == 'tasks') {
        return 1
      }
      if (tab == 'todo') {
        return 2
      }
      return 0
    },
    resolveRecentDailyTab(item) {
      const raw = item && item.raw && typeof item.raw == 'object' ? item.raw : {}
      const value = this.pickValue(item || {}, ['subTab', 'sub_tab', 'subtab', 'dailySubTab', 'daily_sub_tab', 'tab', 'dailyType', 'daily_type', 'type'])
      const rawValue = this.pickValue(raw, ['subTab', 'sub_tab', 'subtab', 'dailySubTab', 'daily_sub_tab', 'tab', 'dailyType', 'daily_type', 'type'])
      const effectiveValue = value === undefined || value === null || value === '' ? rawValue : value
      const number = effectiveValue === undefined || effectiveValue === null || effectiveValue === '' ? NaN : Number(effectiveValue)
      if (number === 1) {
        return 'tasks'
      }
      if (number === 0) {
        return 'notes'
      }
      if (number === 2) {
        return 'todo'
      }
      const text = this.normalizeFieldKey(effectiveValue || this.pickString(item || {}, ['category', 'name', 'title']) || this.pickString(raw, ['category', 'name', 'title']))
      if (text.includes('task')) {
        return 'tasks'
      }
      if (text.includes('note')) {
        return 'notes'
      }
      if (text.includes('todo') || text.includes('to-do')) {
        return 'todo'
      }
      return 'tasks'
    },
    changeMenu(key) {
      const menuKey = this.normalizeMenuKey(key)
      const sameTarget = !this.settingModalVisible
        && !this.globalSearchOpen
        && (menuKey == 'daily'
          ? this.activeAppFolder == 'daily'
          : !this.activeAppFolder && this.normalizeMenuKey(this.activeMenu) == menuKey)
      this.closeLanguageModal()
      this.closeSettingModal()
      this.activeMenu = menuKey
      this.selectedFolderRowId = ''
      this.selectedRecentIds = []
      this.selectedRecentId = ''
      this.selectedRecentAnchorId = ''
      this.resetNormalAppNavigationState()
      this.closeRecentPasswordModal()
      this.closeRecentMoreMenu()
      this.closeRecentActionSheet()
      this.closeRecentViewSheet()
      this.closeMyFileViewSheet()
      this.closeRecentLearningModal()
      this.closeSearchPage()
      if (this.cloudStatus != 1) {
        this.activeAppFolder = ''
        this.activeAppFolderAppType = null
        this.activeAppReturnMenu = menuKey
        this.cloudItems = []
        this.recentItems = []
        if (!sameTarget) {
          this.scrollNewMobilePageToTop()
        }
        return
      }
      if (menuKey == 'daily') {
        this.activeAppFolder = 'daily'
        this.activeAppFolderAppType = this.resolveDefaultAppTypeByFolderType('daily') || 5
        this.activeAppReturnMenu = 'daily'
        if (!sameTarget) {
          this.scrollNewMobilePageToTop()
        }
        return
      }
      this.activeAppFolder = ''
      this.activeAppFolderAppType = null
      if (menuKey == 'recent') {
        this.activeAppReturnMenu = 'recent'
        this.applySharedViewMode(getMobileCloudViewMode(this.viewMode))
        this.loadRecentHistory(true)
      } else {
        this.activeAppReturnMenu = 'files'
        this.loadRootFolders(true)
      }
      if (!sameTarget) {
        this.scrollNewMobilePageToTop()
      }
    },
    selectFolderRow(item, event) {
      if (event && event.detail > 1) {
        this.clearFolderItemClickTimer()
        return
      }
      this.clearFolderItemClickTimer()
      this.folderItemClickTimer = window.setTimeout(() => {
        this.folderItemClickTimer = null
        this.selectedFolderRowId = item && item.id ? item.id : ''
      }, 220)
    },
    clearFolderItemClickTimer() {
      if (this.folderItemClickTimer) {
        clearTimeout(this.folderItemClickTimer)
        this.folderItemClickTimer = null
      }
    },
    resetNormalAppNavigationState() {
      this.clearPendingAppRefreshState()
      this.clearMobilePreviewReturnScroll()
      this.pendingRecentOpenItem = null
      this.pendingRecentOpenOptions = null
      this.globalSearchReturnContext = null
      this.dailyInitialActiveTab = 'todo'
    },
    handleActiveAppDetailModeChange(active) {
      this.activeAppDetailMode = active === true
    },
    handleActiveAppSelectionModeChange(active) {
      this.activeAppSelectionMode = active === true
    },
    openFolder(item) {
      this.clearFolderItemClickTimer()
      this.selectedFolderRowId = ''
      this.globalSearchFilePreviewMode = false
      this.globalSearchLearningPreviewMode = false
      this.closeMyFileViewSheet()
      const folderType = this.resolveAppFolderType(item)
      if (!this.isSupportedAppFolderType(folderType)) {
        return
      }
      const returnScrollTop = this.$refs.cloudContentArea
        ? Math.max(0, Number(this.$refs.cloudContentArea.scrollTop) || 0)
        : null
      this.resetNormalAppNavigationState()
      this.activeAppFolderAppType = null
      if (returnScrollTop !== null) {
        this.mobilePreviewReturnScrollSeq += 1
        this.mobilePreviewReturnScrollTops.files = returnScrollTop
      }
      const menuKey = this.resolveMenuKeyForFolderType(folderType, 'files')
      this.activeMenu = menuKey
      this.activeAppReturnMenu = menuKey
      this.activeAppFolder = folderType
      this.activeAppFolderAppType = this.resolveActiveFolderAppType(Object.assign({}, item, { type: folderType })) || null
      this.closeSearchPage()
      this.scrollNewMobilePageToTop()
    },
    closeAppFolder() {
      const returnContext = this.activeAppReturnMenu == 'search' ? 'search' : this.normalizeMenuKey(this.activeAppReturnMenu || 'files')
      this.activeAppFolder = ''
      this.activeAppFolderAppType = null
      this.globalSearchFilePreviewMode = false
      this.globalSearchLearningPreviewMode = false
      this.pendingRecentOpenItem = null
      this.pendingRecentOpenOptions = null
      this.closeRecentMoreMenu()
      this.closeMyFileViewSheet()
      this.closeRecentLearningModal()
      this.selectedFolderRowId = ''
      if (returnContext == 'search') {
        this.cancelGlobalSearchTouch()
        this.resetGlobalSearchPullRefreshState()
        this.closeGlobalSearchViewSheet()
        this.closeGlobalSearchItemActions()
        this.clearGlobalSearchItemClickTimer()
        this.globalSearchDoubleOpenState = null
        this.activeAppReturnMenu = 'search'
        this.searchOpen = false
        this.searchKeyword = ''
        this.globalSearchOpen = true
        this.globalSearchTypeMenuOpen = false
        this.$nextTick(() => {
          this.updateGlobalSearchGridColumnCount()
          if (this.$refs.globalSearchInput) {
            try {
              this.$refs.globalSearchInput.focus({ preventScroll: true })
            } catch (error) {
              this.$refs.globalSearchInput.focus()
            }
          }
          this.restoreMobilePreviewReturnScroll(returnContext)
        })
        return
      }
      this.activeMenu = returnContext
      this.closeSearchPage()
      const returnLoadTask = returnContext == 'recent'
        ? this.loadRecentHistory()
        : this.loadRootFolders()
      Promise.resolve(returnLoadTask).finally(() => {
        this.restoreMobilePreviewReturnScroll(returnContext)
      })
    },
    setViewMode(mode) {
      this.setSharedViewMode(mode)
      this.closeMyFileViewSheet()
      this.closeRecentMoreMenu()
    },
    openSearchPage() {
      this.openGlobalSearchPage()
    },
    closeSearchPage() {
      this.closeRecentMoreMenu()
      this.searchOpen = false
      this.searchKeyword = ''
      this.closeGlobalSearchPage(true)
    },
    handleUserMenuVisibleChange(visible) {
      if (!visible && this.keepUserMenuAfterSettingClose) {
        this.keepUserMenuAfterSettingClose = false
        this.userMenuVisible = true
        return
      }
      if (!visible && (this.languageModalVisible || this.exitModalVisible || this.settingModalVisible)) {
        this.userMenuVisible = true
        return
      }
      this.userMenuVisible = visible
    },
    closeUserMenu() {
      this.keepUserMenuAfterSettingClose = false
      this.userMenuVisible = false
    },
    openLanguageModal() {
      this.userMenuVisible = false
      this.pendingLanguage = this.selectedLanguage
      this.languageModalVisible = true
    },
    selectLanguage(language) {
      const nextLanguage = normalizeLanguage(language)
      if (!this.languageList.some(item => item.id == nextLanguage)) {
        return
      }
      this.pendingLanguage = nextLanguage
      if (normalizeLanguage(this.selectedLanguage) == nextLanguage) {
        return
      }
      this.selectedLanguage = nextLanguage
      setLanguage(nextLanguage)
    },
    closeLanguageModal() {
      this.languageModalVisible = false
      this.pendingLanguage = this.selectedLanguage
    },
    openSettingModal() {
      const sameTarget = this.settingModalVisible && this.settingActiveTab == 'root'
      this.userMenuVisible = false
      this.closeLanguageModal()
      this.settingActiveTab = 'root'
      this.editingUsername = false
      this.usernameRenameVisible = false
      this.editUsername = this.username || ''
      this.settingPasswordVisible = false
      this.settingModalVisible = true
      if (!sameTarget) {
        this.scrollNewMobilePageToTop()
      }
    },
    closeSettingModal() {
      this.keepUserMenuAfterSettingClose = false
      this.userMenuVisible = false
      this.settingModalVisible = false
      this.settingActiveTab = 'root'
      this.editingUsername = false
      this.usernameRenameVisible = false
      this.settingPasswordVisible = false
      this.stopSettingResetCountdown()
    },
    backToMobileSettings() {
      const leavingDetail = this.settingActiveTab != 'root'
      this.settingActiveTab = 'root'
      this.editingUsername = false
      this.usernameRenameVisible = false
      this.settingPasswordVisible = false
      this.stopSettingResetCountdown()
      if (leavingDetail) {
        this.scrollNewMobilePageToTop()
      }
    },
    selectSettingTab(key) {
      if (key == 'feedback') {
        this.openFeedback()
        return
      }
      if (key == 'server' && !this.showServerSettingTab) {
        return
      }
      const changed = this.settingActiveTab != key
      this.settingActiveTab = key
      this.editingUsername = false
      this.usernameRenameVisible = false
      this.settingPasswordVisible = false
      if (key == 'cloud') {
        this.loadSettingCloudStatus(true)
      }
      if (key == 'server') {
        this.cloudServerKey = getActiveCloudServerKey()
      }
      if (changed) {
        this.scrollNewMobilePageToTop()
      }
    },
    openFeedback() {
      window.open('https://my.viwoods.com/feedback.html', '_blank', 'noopener')
    },
    startEditUsername() {
      this.editUsername = this.username || ''
      this.usernameRenameVisible = true
      this.$nextTick(() => {
        if (this.$refs.usernameRenameInput) {
          this.$refs.usernameRenameInput.focus()
        }
      })
    },
    cancelEditUsername() {
      if (this.updatingUsername) {
        return
      }
      this.editUsername = this.username || ''
      this.editingUsername = false
      this.usernameRenameVisible = false
    },
    saveUsername() {
      const username = String(this.editUsername || '').trim()
      if (!username) {
        return this.$message.error(this.uiText.usernameRequired)
      }
      if (username.length > this.usernameMaxLength) {
        return this.$message.error(this.uiText.updateFailed)
      }
      if (this.updatingUsername) {
        return
      }
      this.updatingUsername = true
      updateUser({ username }).then(ret => {
        const data = ret && ret.data ? ret.data : {}
        if (data.code == 200) {
          this.username = username
          this.editingUsername = false
          this.usernameRenameVisible = false
          this.$message.success(this.uiText.updateSuccess)
        } else {
          this.$message.error(data.msg || data.message || this.uiText.updateFailed)
        }
      }).catch(error => {
        const data = error && error.response && error.response.data ? error.response.data : {}
        this.$message.error(data.msg || data.message || this.uiText.updateFailed)
      }).finally(() => {
        this.updatingUsername = false
      })
    },
    openExitFromSetting() {
      this.openExitModal()
    },
    openSettingPasswordReset() {
      this.settingPasswordVisible = true
      this.resetSettingPasswordFlow()
      this.loadAreaCodes()
    },
    closeSettingPasswordModal() {
      this.settingPasswordVisible = false
      this.resetSettingPasswordFlow()
    },
    resetSettingPasswordFlow() {
      this.settingResetMode = this.email ? 'email' : 'phone'
      this.settingResetStep = 'account'
      this.settingResetForm.email = this.email || ''
      this.settingResetForm.phone = this.phone || ''
      this.settingResetForm.areaCode = this.areaCode || '+86'
      this.settingResetForm.code = ''
      this.settingResetForm.password = ''
      this.settingResetForm.confirmPassword = ''
      this.settingResetCheckedCode = ''
      this.settingResetLoading = false
      this.settingResetSending = false
      this.settingResetReSendTime = 0
      this.settingAreaOpen = false
      this.settingResetPhoneFocused = false
      this.settingResetAreaOptionsHeight = 0
      this.stopSettingResetCountdown()
    },
    settingResetGoBack() {
      this.settingAreaOpen = false
      if (this.settingResetStep == 'account') {
        this.settingPasswordVisible = false
        this.resetSettingPasswordFlow()
        return
      }
      if (this.settingResetStep == 'password') {
        this.settingResetStep = 'code'
        this.settingResetForm.password = ''
        this.settingResetForm.confirmPassword = ''
        return
      }
      this.settingResetStep = 'account'
      this.settingResetForm.code = ''
      this.settingResetCheckedCode = ''
      this.settingResetReSendTime = 0
      this.stopSettingResetCountdown()
    },
    switchSettingResetMode(mode) {
      this.settingResetMode = mode
      this.settingAreaOpen = false
      this.settingResetAreaOptionsHeight = 0
      this.settingResetStep = 'account'
      this.settingResetForm.code = ''
      this.settingResetForm.password = ''
      this.settingResetForm.confirmPassword = ''
      this.settingResetCheckedCode = ''
      this.settingResetReSendTime = 0
      this.stopSettingResetCountdown()
    },
    stopSettingResetCountdown() {
      if (this.settingResetTimer) {
        clearInterval(this.settingResetTimer)
        this.settingResetTimer = null
      }
    },
    changeSettingStartChoose() {
      this.settingAreaOpen = !this.settingAreaOpen
      if (this.settingAreaOpen) {
        this.loadAreaCodes()
        this.updateSettingResetAreaOptionsHeight()
      }
    },
    updateSettingResetAreaOptionsHeight() {
      this.$nextTick(() => {
        const panel = document.querySelector('.cloud-password-modal .setting-password-panel')
        const field = this.$refs.settingResetPhoneField
        if (!panel || !field || !panel.getBoundingClientRect || !field.getBoundingClientRect) {
          return
        }
        const panelRect = panel.getBoundingClientRect()
        const fieldRect = field.getBoundingClientRect()
        const dropdownTop = fieldRect.top + 44
        this.settingResetAreaOptionsHeight = Math.max(160, Math.floor(panelRect.bottom - dropdownTop))
      })
    },
    loadAreaCodes() {
      if (this.areaCodes.length > 0) {
        return
      }
      getAreaCode({}).then(ret => {
        if (ret.data.code == 200) {
          this.areaCodes = ret.data.data || []
        }
      }).catch(() => {
      })
    },
    changeSettingResetAreaCode(newVal) {
      this.settingResetForm.areaCode = newVal.areaCode
      this.settingAreaOpen = false
      this.settingResetReSendTime = 0
      this.stopSettingResetCountdown()
    },
    clearSettingResetField(field) {
      this.settingResetForm[field] = ''
      if (field == 'phone' || field == 'email') {
        this.settingResetForm.code = ''
        this.settingResetCheckedCode = ''
        this.settingResetReSendTime = 0
        this.stopSettingResetCountdown()
        return
      }
      if (field == 'code') {
        this.settingResetCheckedCode = ''
      }
    },
    getSettingResetValidationMessage() {
      if (this.settingResetMode == 'email') {
        return this.settingResetForm.email ? '' : this.uiText.emailLabel
      }
      if (!this.settingResetForm.areaCode) {
        return this.uiText.areaCode
      }
      const phoneValidationMessage = getPhoneValidationMessage(this.settingResetForm.areaCode, this.settingResetForm.phone)
      if (phoneValidationMessage) {
        return phoneValidationMessage
      }
      return this.settingResetForm.phone ? '' : this.uiText.phoneLabel
    },
    getSettingResetCodePayload() {
      const payload = { type: '3' }
      if (this.settingResetMode == 'email') {
        payload.email = this.settingResetForm.email
      } else {
        payload.areaCode = this.settingResetForm.areaCode
        payload.phone = this.settingResetForm.phone
      }
      return payload
    },
    getSettingResetPasswordPayload() {
      const payload = {
        type: '3',
        password: this.settingResetForm.password,
        code: this.settingResetCheckedCode || this.settingResetForm.code
      }
      if (this.settingResetMode == 'email') {
        payload.email = this.settingResetForm.email
      } else {
        payload.areaCode = this.settingResetForm.areaCode
        payload.phone = this.settingResetForm.phone
      }
      return payload
    },
    startSettingResetCountdown(value) {
      this.stopSettingResetCountdown()
      this.settingResetReSendTime = Number(value) || 120
      this.settingResetTimer = setInterval(() => {
        if (this.settingResetReSendTime <= 0) {
          this.stopSettingResetCountdown()
          return
        }
        this.settingResetReSendTime--
      }, 1000)
    },
    sendSettingResetCode() {
      if (this.settingResetSending || this.settingResetLoading) {
        return
      }
      if (this.settingResetStep == 'code' && this.settingResetReSendTime > 0) {
        return
      }
      const validationMessage = this.getSettingResetValidationMessage()
      if (validationMessage) {
        return this.$message.error(validationMessage)
      }
      const payload = this.getSettingResetCodePayload()
      const requestApi = this.settingResetMode == 'email' ? sendEmailCodeAuth : sendSmsCodeAuth
      this.settingResetSending = true
      requestApi(Object.assign({}, payload)).then(ret => {
        if (ret.data.code == 200) {
          this.settingResetStep = 'code'
          this.settingResetForm.code = ''
          this.settingResetCheckedCode = ''
          const reSendTime = ret.data.data && ret.data.data.reSendTime
          this.startSettingResetCountdown(reSendTime || 120)
        } else {
          this.$message.error(ret.data.msg || ret.data.message)
        }
      }).catch(() => {
      }).finally(() => {
        this.settingResetSending = false
      })
    },
    checkSettingResetCode() {
      if (this.settingResetLoading) {
        return
      }
      const validationMessage = this.getSettingResetValidationMessage()
      if (validationMessage) {
        return this.$message.error(validationMessage)
      }
      if (!this.canSubmitSettingResetCode) {
        return this.$message.error(this.uiText.codeRequired)
      }
      const payload = Object.assign({}, this.getSettingResetCodePayload(), { code: this.settingResetForm.code })
      this.settingResetLoading = true
      checkCodeAuth(payload).then(ret => {
        if (ret.data.code == 200) {
          this.settingResetCheckedCode = this.settingResetForm.code
          this.settingResetStep = 'password'
        } else {
          this.$message.error(ret.data.msg || ret.data.message)
        }
      }).catch(() => {
      }).finally(() => {
        this.settingResetLoading = false
      })
    },
    submitSettingResetPassword() {
      if (this.settingResetLoading) {
        return
      }
      const validationMessage = this.getSettingResetValidationMessage()
      if (validationMessage) {
        return this.$message.error(validationMessage)
      }
      if (!this.settingResetForm.password || this.settingResetForm.password.length < 8) {
        return this.$message.error(this.uiText.passwordMin)
      }
      if (this.settingResetForm.password != this.settingResetForm.confirmPassword) {
        return this.$message.error(this.uiText.passwordMatch)
      }
      this.settingResetLoading = true
      resetPasswordAuth(this.getSettingResetPasswordPayload()).then(ret => {
        if (ret.data.code == 200) {
          this.$message.success(this.uiText.passwordUpdateSuccess)
          this.settingPasswordVisible = false
          this.resetSettingPasswordFlow()
        } else {
          this.$message.error(ret.data.msg || ret.data.message)
        }
      }).catch(() => {
      }).finally(() => {
        this.settingResetLoading = false
      })
    },
    loadSettingCloudStatus(force, options = {}) {
      if (this.cloudStatusLoading || (this.cloudStatusLoaded && !force)) {
        return
      }
      this.cloudStatusLoading = true
      getCloudStatus({}, {
        skipGlobalErrorMessage: options.skipGlobalErrorMessage
      }).then(ret => {
        if (ret.data.code == 200) {
          this.cloudStorage = ret.data.data || {}
          this.cloudStatusLoaded = true
        } else {
          this.$message.error(ret.data.msg || ret.data.message)
        }
      }).catch(() => {
      }).finally(() => {
        this.cloudStatusLoading = false
      })
    },
    getStorageSizeBytes(value) {
      const number = Number(value)
      if (!Number.isFinite(number) || number <= 0) {
        return 0
      }
      return number
    },
    trimStorageNumber(value) {
      const fixed = value >= 100 ? value.toFixed(0) : value.toFixed(2)
      return fixed.replace(/\.00$/, '').replace(/(\.\d)0$/, '$1')
    },
    formatStorageSize(value) {
      const bytes = this.getStorageSizeBytes(value)
      if (bytes >= 1024 * 1024 * 1024) {
        return `${this.trimStorageNumber(bytes / 1024 / 1024 / 1024)}GB`
      }
      if (bytes >= 1024 * 1024) {
        return `${this.trimStorageNumber(bytes / 1024 / 1024)}MB`
      }
      if (bytes >= 1024) {
        return `${this.trimStorageNumber(bytes / 1024)}KB`
      }
      return `${this.trimStorageNumber(bytes)}B`
    },
    openExitModal() {
      this.userMenuVisible = false
      this.exitModalVisible = true
    },
    maskEmail(email) {
      const value = String(email || '')
      const atIndex = value.indexOf('@')
      if (atIndex < 0) {
        return `${value.slice(0, 3)}****`
      }
      return `${value.slice(0, atIndex).slice(0, 3)}****${value.slice(atIndex)}`
    },
    maskPhone(phone) {
      const value = String(phone || '')
      if (value.length <= 6) {
        return value
      }
      return `${value.slice(0, 3)}****${value.slice(-3)}`
    },
    confirmLogout() {
      this.exitModalVisible = false
      this.clearCloudRefreshState()
      removeToken()
      this.$router.push({ name: 'login' })
    },
    redirectToLogin() {
      this.clearCloudRefreshState()
      removeToken()
      this.loading = false
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style>
.cloud-language-modal .ant-modal-content,
.cloud-language-modal .ant-modal-header,
.cloud-language-modal .ant-modal-footer,
.cloud-rename-modal .ant-modal-content {
  border-radius: 0;
}

.cloud-rename-modal .ant-modal-body {
  padding: 0;
}

.cloud-language-modal .ant-modal-body {
  padding: 24px 24px 92px;
}

.cloud-language-modal .ant-radio-checked .ant-radio-inner {
  border-color: #1F3A2D;
}

.cloud-language-modal .ant-radio-inner::after {
  background-color: #1F3A2D;
}

.cloud-language-modal .ant-radio-wrapper:hover .ant-radio,
.cloud-language-modal .ant-radio:hover .ant-radio-inner,
.cloud-language-modal .ant-radio-input:focus + .ant-radio-inner {
  border-color: #1F3A2D;
}

body .cloud-setting-modal .server-radio .ant-radio-checked .ant-radio-inner {
  border-color: #1f2326 !important;
}

body .cloud-setting-modal .server-radio .ant-radio-checked::after {
  border-color: #1f2326 !important;
}

body .cloud-setting-modal .server-radio .ant-radio-inner::after {
  background-color: #1f2326 !important;
}

body .cloud-setting-modal .server-radio .ant-radio:hover .ant-radio-inner,
body .cloud-setting-modal .server-radio.ant-radio-wrapper:hover .ant-radio-inner,
body .cloud-setting-modal .server-radio .ant-radio-input:focus + .ant-radio-inner {
  border-color: #1f2326 !important;
}

.cloud-language-modal .ant-btn-primary,
.cloud-language-modal .ant-btn-primary:hover,
.cloud-language-modal .ant-btn-primary:focus,
.cloud-language-modal .ant-btn-primary:active,
.cloud-exit-modal .ant-btn-primary,
.cloud-exit-modal .ant-btn-primary:hover,
.cloud-exit-modal .ant-btn-primary:focus,
.cloud-exit-modal .ant-btn-primary:active,
.cloud-setting-modal .ant-btn-primary,
.cloud-setting-modal .ant-btn-primary:hover,
.cloud-setting-modal .ant-btn-primary:focus,
.cloud-setting-modal .ant-btn-primary:active,
.cloud-password-modal .ant-btn-primary,
.cloud-password-modal .ant-btn-primary:hover,
.cloud-password-modal .ant-btn-primary:focus,
.cloud-password-modal .ant-btn-primary:active {
  background: #1F3A2D;
  border-color: #1F3A2D;
  color: #fff;
}

.cloud-language-modal .ant-btn:not(.ant-btn-primary):hover,
.cloud-language-modal .ant-btn:not(.ant-btn-primary):focus,
.cloud-language-modal .ant-btn:not(.ant-btn-primary):active,
.cloud-exit-modal .ant-btn:not(.ant-btn-primary):hover,
.cloud-exit-modal .ant-btn:not(.ant-btn-primary):focus,
.cloud-exit-modal .ant-btn:not(.ant-btn-primary):active,
.cloud-setting-modal .ant-btn:not(.ant-btn-primary):hover,
.cloud-setting-modal .ant-btn:not(.ant-btn-primary):focus,
.cloud-setting-modal .ant-btn:not(.ant-btn-primary):active,
.cloud-password-modal .ant-btn:not(.ant-btn-primary):hover,
.cloud-password-modal .ant-btn:not(.ant-btn-primary):focus,
.cloud-password-modal .ant-btn:not(.ant-btn-primary):active {
  background: #fff;
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, .65);
}

.cloud-exit-modal .ant-modal-content,
.cloud-exit-modal .ant-modal-header,
.cloud-exit-modal .ant-modal-footer {
  border-radius: 0;
}

.cloud-setting-modal .ant-modal-content,
.cloud-setting-modal .ant-modal-header {
  border-radius: 0;
}

.cloud-setting-modal .ant-modal-body {
  padding: 0;
}

.cloud-password-modal .ant-modal-content {
  border-radius: 0;
  box-shadow: none;
}

.cloud-password-modal .ant-modal-body {
  padding: 0;
}

.cloud-rename-modal .ant-modal,
.cloud-exit-modal .ant-modal {
  width: calc(100vw - 32px) !important;
  max-width: 488px;
  margin: 0 auto;
}

.cloud-password-modal .ant-modal {
  width: calc(100vw - 16px) !important;
  max-width: 488px;
  margin: 8px auto;
  padding-bottom: 0;
}

.user-menu-overlay {
  z-index: 1200;
  margin: 0;
  padding: 0;
}

.user-menu-overlay-under-modal {
  z-index: 900;
}

.user-menu-overlay.ant-dropdown-placement-topLeft {
  padding-bottom: 0;
}
</style>

<style scoped src="./CloudHomeSearchPreview.css"></style>

<style scoped>
.cloud-shell {
  position: fixed;
  inset: 0;
  width: 100%;
  height: auto;
  overflow: hidden;
  background: #f3f2ed;
  overscroll-behavior: none;
}

.cloud-shell > .paper-download-list {
  z-index: 1110;
}

.user-popover-mask {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(0, 0, 0, .45);
}

.cloud-page {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 306px 1fr;
  background: #f3f2ed;
  color: #1e2328;
  overflow: hidden;
  font-family: var(--viwoods-wap-font-family, "PingFang SC", "PingFangSC-Medium", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif);
}

.cloud-page.collapsed {
  grid-template-columns: 70px 1fr;
}

.cloud-sidebar {
  min-width: 0;
  height: 100vh;
  background: #f3f2ed;
  border-right: 1px solid #d9d9d5;
  display: flex;
  flex-direction: column;
}

.brand-row {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px 0 34px;
  flex-shrink: 0;
}

.collapsed .brand-row {
  justify-content: center;
  padding: 0;
}

.brand-logo {
  width: 123.17px;
  height: 24px;
  object-fit: contain;
}

.collapse-button,
.icon-button,
.view-button,
.global-search-filter-button,
.global-search-filter-menu button,
.global-search-close-button,
.global-search-card,
.global-search-row,
.global-search-more-button,
.global-search-more-menu button,
.global-search-selection-close,
.global-search-selection-actions button,
.side-item,
.user-entry,
.folder-card,
.folder-row,
.popover-action,
.setting-tab,
.setting-edit-button,
.setting-logout-button,
.setting-back-button,
.setting-reset-switch button,
.setting-reset-resend,
.password-reset-back,
.area-code,
.input-clear,
.switch-login,
.reset-resend {
  font: inherit;
}

.collapse-button {
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.collapse-button img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.side-nav {
  flex: 1;
}

.side-item {
  width: 100%;
  height: 78px;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 0 32px;
  color: #202428;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
}

.collapsed .side-item {
  justify-content: center;
  padding: 0;
}

.side-item.active {
  background: #dce2d8;
}

.menu-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex: 0 0 24px;
  display: block;
}

.user-entry {
  height: 78px;
  border: 0;
  border-top: 1px solid #d9d9d5;
  background: #f3f2ed;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 32px;
  cursor: pointer;
  text-align: left;
}

.collapsed .user-entry {
  justify-content: center;
  padding: 0;
}

.user-avatar {
  width: 29px;
  height: 29px;
  border-radius: 50%;
  background: #bf4b42;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 29px;
  font-weight: 700;
  flex: 0 0 29px;
  text-align: center;
}

.popover-avatar {
  width: 29px;
  height: 29px;
  border-radius: 50%;
  background: #bf4b42;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 29px;
  font-weight: 700;
  flex: 0 0 29px;
  text-align: center;
}

.user-name {
  color: #111;
  font-size: 16px;
  font-weight: 700;
  line-height: 42px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-entry-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  height: 42px;
}

.user-detail {
  color: #7a7d7b;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-popover {
  width: 306px;
  background: #fff;
  border: 1px solid #d8d8d8;
  box-shadow: none;
  box-sizing: border-box;
  padding: 10px 18px 11px;
}

.popover-profile {
  min-height: 78px;
  display: flex;
  align-items: center;
  gap: 16px;
  border-bottom: 1px solid #e8e8e8;
  margin: 0 -18px 6px;
  padding: 0 18px;
}

.popover-profile-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.popover-name {
  color: #111;
  font-size: 15px;
  line-height: 24px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.popover-detail {
  color: #777c7a;
  font-size: 14px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.popover-action {
  width: 100%;
  height: 64px;
  border: 0;
  background: #fff;
  color: #4a4f51;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0;
  cursor: pointer;
  text-align: left;
}

.popover-text {
  min-width: 0;
  color: #4a4f51;
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.popover-open {
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex: 0 0 24px;
  margin-left: auto;
}

.popover-icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
  flex: 0 0 25px;
  margin-left: 2px;
}

.cloud-main {
  min-width: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.content-header {
  height: 64px;
  border-bottom: 1px solid #dededb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px 0 35px;
  flex-shrink: 0;
}

.content-header.is-search-page {
  justify-content: flex-start;
  gap: 18px;
}

.content-header h1 {
  margin: 0;
  color: #202428;
  font-size: 22px;
  line-height: 32px;
  font-weight: 700;
  letter-spacing: 0;
}

.icon-button {
  width: 36px;
  height: 36px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.search-button img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.search-back-button {
  width: 34px;
  height: 34px;
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex: 0 0 34px;
}

.search-back-button span {
  width: 13px;
  height: 13px;
  border-left: 2px solid #111;
  border-bottom: 2px solid #111;
  transform: rotate(45deg);
  display: block;
}

.search-back-button img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.search-page-box {
  width: min(640px, calc(100% - 60px));
  height: 40px;
  border: 1px solid #d7d9d6;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 10px;
  box-sizing: border-box;
}

.search-page-box img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex: 0 0 22px;
}

.search-page-box input {
  min-width: 0;
  flex: 1;
  height: 38px;
  border: 0;
  outline: none;
  color: #202428;
  font-size: 16px;
  line-height: 38px;
  background: transparent;
}

.global-search-box {
  flex: 1;
  width: auto;
  max-width: none;
  height: 40px;
  border: 0;
  background: transparent;
  padding: 0;
  gap: 8px;
}

.global-search-submit-button {
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  border: 0;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.global-search-box img {
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
}

.global-search-box input {
  height: 24px;
  line-height: 24px;
  border-left: 1px solid #d9d9d5;
  padding: 0 0 0 9px;
  font-size: 13px;
  color: #1f2326;
}

.global-search-box input::placeholder {
  color: #8f9490;
}

.global-search-close-button {
  width: 34px;
  height: 34px;
  margin-left: auto;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
}

.global-search-close-button img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
}

.view-switch {
  width: 72px;
  height: 36px;
  position: relative;
  flex: 0 0 72px;
}

.view-switch img {
  width: 72px;
  height: 36px;
  object-fit: contain;
  display: block;
}

.view-button {
  width: 36px;
  height: 36px;
  border: 0;
  background: transparent;
  cursor: pointer;
  position: absolute;
  top: 0;
  z-index: 1;
}

.view-list-hotspot {
  left: 0;
}

.view-grid-hotspot {
  right: 0;
}

.content-toolbar {
  height: 78px;
  border-bottom: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 22px 32px 0 0;
  box-sizing: border-box;
  flex-shrink: 0;
}

.global-search-toolbar {
  height: 78px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 22px 32px 0 35px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.global-search-filter {
  position: relative;
  z-index: 30;
}

.global-search-filter-button {
  width: 138px;
  height: 36px;
  border: 1px solid #c8c8c5;
  background: transparent;
  color: #202428;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  box-sizing: border-box;
  cursor: pointer;
  text-align: left;
  font-size: 14px;
  line-height: 20px;
}

.global-search-filter-button span:not(.global-search-filter-arrow) {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 20px;
}

.global-search-filter-icon,
.global-search-menu-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex: 0 0 22px;
  display: block;
}

.global-search-filter-arrow {
  width: 9px;
  height: 9px;
  border-right: 1px solid #111;
  border-bottom: 1px solid #111;
  transform: rotate(45deg) translateY(-3px);
  flex: 0 0 9px;
  margin-left: auto;
}

.global-search-filter-arrow.open {
  transform: rotate(225deg) translate(-2px, -1px);
}

.global-search-filter-menu {
  position: absolute;
  left: 0;
  top: 40px;
  min-width: 100%;
  width: max-content;
  max-width: calc(100vw - 24px);
  border: 1px solid #d8d8d8;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, .04);
  box-sizing: border-box;
  z-index: 40;
}

.global-search-filter-menu button {
  width: max-content;
  min-width: 100%;
  height: 40px;
  border: 0;
  background: #fff;
  color: #171b1d;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 17px;
  box-sizing: border-box;
  cursor: pointer;
  text-align: left;
  white-space: nowrap;
  font-size: 14px;
}

.global-search-filter-menu button:hover,
.global-search-filter-menu button.active {
  background: #dce2d8;
}

.global-search-filter-menu button span {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 20px;
}

.global-search-menu-check {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex: 0 0 16px;
  display: block;
}

.content-area {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 32px 40px;
  position: relative;
}

.content-area.is-search-page {
  padding-top: 24px;
}

.content-area.is-empty {
  padding: 0;
  overflow: hidden;
}

.content-area /deep/ .ant-spin-nested-loading,
.content-area /deep/ .ant-spin-container {
  min-height: calc(100vh - 142px);
}

.content-area.is-empty /deep/ .ant-spin-nested-loading,
.content-area.is-empty /deep/ .ant-spin-container {
  min-height: calc(100vh - 64px);
}

.content-area.is-search-page /deep/ .ant-spin-nested-loading,
.content-area.is-search-page /deep/ .ant-spin-container {
  min-height: calc(100vh - 64px);
}

.content-area.is-global-search /deep/ .ant-spin-nested-loading,
.content-area.is-global-search /deep/ .ant-spin-container {
  min-height: calc(100vh - 142px);
}

.content-area /deep/ .cloud-list-spin.ant-spin-nested-loading,
.cloud-list-content {
  min-height: calc(100vh - 142px);
}

.content-area.is-empty /deep/ .cloud-list-spin.ant-spin-nested-loading,
.content-area.is-empty .cloud-list-content,
.content-area.is-search-page /deep/ .cloud-list-spin.ant-spin-nested-loading,
.content-area.is-search-page .cloud-list-content {
  min-height: calc(100vh - 64px);
}

.content-area.is-global-search /deep/ .cloud-list-spin.ant-spin-nested-loading,
.content-area.is-global-search .cloud-list-content {
  min-height: calc(100vh - 142px);
}

.content-area.has-toolbar /deep/ .cloud-list-spin.ant-spin-nested-loading > div > .ant-spin {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  max-height: none;
  padding-top: 24px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  color: #275B52;
}

.content-area.has-toolbar /deep/ .cloud-list-spin.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: static;
  margin: 0;
}

.content-area.has-toolbar /deep/ .cloud-list-spin .ant-spin-dot-item {
  background-color: #275B52;
}

.empty-state {
  min-height: calc(100vh - 120px - var(--viwoods-safe-area-bottom, 0px));
  min-height: calc(100dvh - 120px - var(--viwoods-safe-area-bottom, 0px));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  color: #15191b;
  font-size: 14px;
  line-height: 22px;
}

.empty-image {
  width: 130px;
  height: auto;
  object-fit: contain;
  margin-bottom: 0;
  display: block;
}

.cloud-empty-image {
  width: 110px;
  height: 110px;
  object-fit: contain;
  margin-bottom: 6px;
  display: block;
}

.empty-state p {
  margin: 0;
  width: calc(100vw - 60px);
  max-width: calc(100vw - 60px);
  text-align: center;
}

.recent-empty {
  min-height: calc(100vh - 142px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  color: #15191b;
  font-size: 14px;
  line-height: 22px;
  transform: translateY(-6px);
}

.recent-empty p {
  margin: 0;
}

.global-search-empty {
  min-height: calc(100vh - 166px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  color: #15191b;
  font-size: 14px;
  line-height: 22px;
  transform: translateY(-6px);
}

.global-search-empty p {
  margin: 0;
}

.global-search-empty-image {
  width: 140px;
  height: 102px;
  object-fit: contain;
  display: block;
  margin-bottom: 0;
}

.global-search-selection-layer {
  position: absolute;
  top: 64px;
  right: 0;
  left: 0;
  z-index: 40;
  padding: 12px 12px 10px;
  box-sizing: border-box;
  pointer-events: none;
  will-change: transform;
}

.global-search-selection-layer.dragging {
  user-select: none;
}

.global-search-selection-bar {
  height: 48px;
  width: 100%;
  min-width: 0;
  padding: 0 16px;
  background: #DDE4D9;
  color: #333;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 18px;
  box-sizing: border-box;
  flex-shrink: 0;
  overflow-x: auto;
  overflow-y: hidden;
  pointer-events: auto;
  cursor: grab;
  scrollbar-width: thin;
}

.global-search-selection-layer.dragging .global-search-selection-bar {
  cursor: grabbing;
}

.global-search-selection-close {
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  position: relative;
}

.global-search-selection-close span {
  width: 14px;
  height: 14px;
  display: block;
  position: relative;
}

.global-search-selection-close span::before,
.global-search-selection-close span::after {
  content: '';
  width: 14px;
  height: 1.5px;
  background: #111;
  position: absolute;
  left: 0;
  top: 6px;
}

.global-search-selection-close span::before {
  transform: rotate(45deg);
}

.global-search-selection-close span::after {
  transform: rotate(-45deg);
}

.global-search-selection-bar > span {
  color: #606462;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  flex: 0 0 auto;
  white-space: nowrap;
}

.global-search-selection-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  gap: 34px;
}

.global-search-selection-actions button {
  height: 32px;
  border: 0;
  background: transparent;
  padding: 0;
  color: #1f2326;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
}

.global-search-selection-actions button:disabled {
  color: #9da39f;
  cursor: not-allowed;
  opacity: .45;
}

.global-search-selection-actions img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
}

.global-search-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(148px, 148px));
  gap: 29.5px 15px;
  align-items: start;
  min-width: calc(148px * 4 + 15px * 3);
  padding-top: 7.5px;
  box-sizing: border-box;
}

.global-search-card {
  width: 148px;
  height: 245.4px;
  min-height: 245.4px;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  outline: none;
  z-index: 0;
  --global-search-grid-column-gap: 15px;
  --global-search-grid-row-gap: 44px;
  --global-search-grid-column-gap-half: calc(var(--global-search-grid-column-gap) / 2);
  --global-search-grid-row-gap-half: calc(var(--global-search-grid-row-gap) / 2);
}

.global-search-card.selected {
  z-index: 1;
}

.global-search-card.selected::before {
  content: '';
  position: absolute;
  top: calc(-1 * var(--global-search-grid-column-gap-half));
  right: calc(-1 * var(--global-search-grid-column-gap-half));
  bottom: calc(-1 * var(--global-search-grid-row-gap-half));
  left: calc(-1 * var(--global-search-grid-column-gap-half));
  background: #DDE4D9;
  pointer-events: none;
  z-index: 0;
}

.global-search-card.selected.grid-edge-bottom::before {
  bottom: 0;
}

.global-search-card.selected.grid-edge-top::before {
  top: calc(-1 * var(--global-search-grid-column-gap-half));
}

.global-search-card > * {
  position: relative;
  z-index: 1;
}

.global-search-card.selected .global-search-cover,
.global-search-card:hover .global-search-cover,
.global-search-card:focus-visible .global-search-cover {
  border-color: #b6b8b4;
  background: #f8f8f6;
}

.global-search-card.selected .global-search-cover {
  background: #fff;
}

.global-search-cover {
  width: 148px;
  height: 196.4px;
  flex: 0 0 196.4px;
  border: 1px solid #d7d9d6;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.global-search-cover.blank {
  background: #fff;
}

.global-search-cover-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center center;
  display: block;
}

.global-search-cover-default {
  width: 46px;
  height: auto;
  object-fit: contain;
  display: block;
}

.global-search-cover.folded-cover::before,
.recent-cover.folded-cover::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: var(--cover-fold-size);
  height: var(--cover-fold-size);
  background: var(--cover-fold-backdrop);
  pointer-events: none;
  z-index: 2;
}

.global-search-cover.folded-cover::after,
.recent-cover.folded-cover::after {
  content: '';
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 148 196.4' preserveAspectRatio='none'%3E%3Cpath d='M0.5 0.5H126.5L147.5 21.5V195.9H0.5V0.5Z' fill='none' stroke='%23d7d9d6' stroke-width='1' stroke-linecap='square' stroke-linejoin='miter'/%3E%3Cpath d='M126.5 0.5V21.5H147.5' fill='none' stroke='%23d7d9d6' stroke-width='1' stroke-linecap='square' stroke-linejoin='miter'/%3E%3C/svg%3E");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  pointer-events: none;
  z-index: 3;
}

.global-search-cover-default.folder {
  width: 46px;
}

.global-search-card-title-row,
.recent-card-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  height: 22px;
  flex: 0 0 22px;
  box-sizing: border-box;
  margin-top: 8px;
  min-width: 0;
}

.global-search-card-name {
  display: block;
  min-width: 0;
  flex: 1 1 auto;
  height: 22px;
  color: #0f1112;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.global-search-card-meta {
  height: 19px;
  flex: 0 0 19px;
  margin-top: 0;
  color: #9a9a9a;
  font-size: 13px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.resource-grid-count {
  min-width: 0;
  max-width: 50%;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.global-search-table {
  margin: 0 -20px;
}

.global-search-row {
  min-height: 78px;
  border-bottom: 1px solid #dededb;
  display: grid;
  grid-template-columns: 66px minmax(220px, 1fr) 120px 48px 170px 48px 52px 48px 56px;
  align-items: center;
  gap: 0;
  padding: 0 16px;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
}

.global-search-row:hover,
.global-search-row.selected,
.global-search-row:focus-visible {
  background: #f1eee8;
}

.global-search-row-cover {
  width: 54px;
  height: 54px;
  border: 1px solid transparent;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.global-search-row-cover.blank {
  border-color: #d7d9d6;
  background: #fff;
}

.global-search-row-cover.has-cover {
  height: 62px;
}

.global-search-row-cover-image {
  width: 46px;
  height: 62px;
  border: 1px solid #d7d9d6;
  background: #fff;
  box-sizing: border-box;
  object-fit: cover;
  display: block;
}

.global-search-row-cover-default {
  width: 46px;
  height: auto;
  object-fit: contain;
  display: block;
}

.global-search-row-cover-default.folder {
  width: 46px;
}

.global-search-row strong {
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 78px;
  min-width: 0;
  color: #121618;
  font-size: 15px;
  line-height: 22px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.global-search-row > span:not(.global-search-row-cover):not(.global-search-row-more-wrap) {
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 78px;
  color: #7d8284;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.global-search-row-count {
  grid-column: 3;
}

.global-search-row-date {
  grid-column: 5;
}

.global-search-row-favorite-status {
  grid-column: 7;
}

.global-search-row-more-wrap {
  align-self: center;
  grid-column: 9;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 78px;
}

.global-search-more-button {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  color: #3b403d;
}

.global-search-more-button:hover,
.global-search-more-button:focus-visible {
  background: rgba(31, 58, 45, .08);
  outline: none;
}

.global-search-more-button svg {
  width: 12px;
  height: 4px;
  fill: currentColor;
  display: block;
}

.global-search-more-menu {
  position: absolute;
  right: 0;
  top: 52px;
  min-width: 118px;
  padding: 6px;
  border: 1px solid #dededb;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(0, 0, 0, .12);
  z-index: 6;
}

.global-search-more-menu button {
  width: 100%;
  height: 34px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  color: #15191b;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  text-align: left;
}

.global-search-more-menu button:hover,
.global-search-more-menu button:focus-visible {
  background: #F1EEE8;
  outline: none;
}

.global-search-more-menu button:disabled {
  cursor: not-allowed;
  opacity: .45;
}

.global-search-more-menu img {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
}

.recent-selection-layer {
  position: absolute;
  top: 64px;
  right: 0;
  left: 0;
  z-index: 40;
  padding: 12px 12px 10px;
  box-sizing: border-box;
  pointer-events: none;
  will-change: transform;
}

.recent-selection-layer.dragging {
  user-select: none;
}

.recent-selection-bar {
  height: 48px;
  width: 100%;
  min-width: 0;
  padding: 0 16px;
  background: #DDE4D9;
  color: #333;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 18px;
  box-sizing: border-box;
  flex-shrink: 0;
  overflow-x: auto;
  overflow-y: hidden;
  pointer-events: auto;
  cursor: grab;
  scrollbar-width: thin;
}

.recent-selection-layer.dragging .recent-selection-bar {
  cursor: grabbing;
}

.recent-selection-close {
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  position: relative;
}

.recent-selection-close span {
  width: 14px;
  height: 14px;
  display: block;
  position: relative;
}

.recent-selection-close span::before,
.recent-selection-close span::after {
  content: '';
  width: 14px;
  height: 1.5px;
  background: #111;
  position: absolute;
  left: 0;
  top: 6px;
}

.recent-selection-close span::before {
  transform: rotate(45deg);
}

.recent-selection-close span::after {
  transform: rotate(-45deg);
}

.recent-selection-bar > span {
  color: #606462;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  flex: 0 0 auto;
  white-space: nowrap;
}

.recent-selection-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  gap: 34px;
}

.recent-selection-actions button {
  height: 32px;
  border: 0;
  background: transparent;
  padding: 0;
  color: #1f2326;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
}

.recent-selection-actions button:disabled {
  color: #9da39f;
  cursor: not-allowed;
  opacity: .45;
}

.recent-selection-actions img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
}

.recent-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(148px, 148px));
  gap: 29.5px 15px;
  align-items: start;
  min-width: calc(148px * 4 + 15px * 3);
  padding-top: 7.5px;
  box-sizing: border-box;
}

.recent-card {
  width: 148px;
  height: 245.4px;
  min-height: 245.4px;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  outline: none;
  z-index: 0;
  --recent-grid-column-gap: 15px;
  --recent-grid-row-gap: 44px;
  --recent-grid-column-gap-half: calc(var(--recent-grid-column-gap) / 2);
  --recent-grid-row-gap-half: calc(var(--recent-grid-row-gap) / 2);
}

.recent-card.selected {
  z-index: 1;
}

.recent-card.selected::before {
  content: '';
  position: absolute;
  top: calc(-1 * var(--recent-grid-column-gap-half));
  right: calc(-1 * var(--recent-grid-column-gap-half));
  bottom: calc(-1 * var(--recent-grid-row-gap-half));
  left: calc(-1 * var(--recent-grid-column-gap-half));
  background: #DDE4D9;
  pointer-events: none;
  z-index: 0;
}

.recent-card.selected.grid-edge-bottom::before {
  bottom: 0;
}

.recent-card.selected.grid-edge-top::before {
  top: calc(-1 * var(--recent-grid-column-gap-half));
}

.recent-card > * {
  position: relative;
  z-index: 1;
}

.recent-card.selected .recent-cover,
.recent-card:hover .recent-cover,
.recent-card:focus-visible .recent-cover {
  border-color: #b6b8b4;
  background: #f8f8f6;
}

.recent-card.selected .recent-cover {
  background: #fff;
}

.recent-cover {
  width: 148px;
  height: 196.4px;
  flex: 0 0 196.4px;
  border: 1px solid #d7d9d6;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.global-search-cover.folded-cover,
.recent-cover.folded-cover {
  --cover-fold-size: 22px;
  --cover-fold-mask-bleed: 1.5px;
  --cover-fold-backdrop: #f8f4ef;
  border: 0;
}

.global-search-card.selected .global-search-cover.folded-cover,
.recent-card.selected .recent-cover.folded-cover {
  --cover-fold-backdrop: #DDE4D9;
}

.recent-cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.recent-cover-default.memo-cover-fallback,
.recent-row-cover-default.memo-cover-fallback {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
}

.recent-cover-image.memo-cover-image,
.recent-row-cover-image.memo-cover-image {
  position: relative;
  z-index: 2;
}

.recent-cover-image.memo-cover-image.is-pending,
.recent-row-cover-image.memo-cover-image.is-pending {
  opacity: 0;
}

.recent-cover-default {
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  height: 30px;
  min-height: 30px;
  max-height: 30px;
  inline-size: 30px;
  min-inline-size: 30px;
  max-inline-size: 30px;
  block-size: 30px;
  min-block-size: 30px;
  max-block-size: 30px;
  flex: 0 0 30px;
  object-fit: contain;
  display: block;
  box-sizing: content-box;
}

.recent-card-name {
  display: block;
  min-width: 0;
  flex: 1 1 auto;
  height: 22px;
  color: #0f1112;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-card-meta {
  height: 19px;
  flex: 0 0 19px;
  margin-top: 0;
  color: #9a9a9a;
  font-size: 13px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.recent-favorite-status {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
}

.recent-card-favorite-status {
  flex: 0 0 18px;
}

.recent-more-button {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  color: #3b403d;
}

.recent-more-button:hover,
.recent-more-button:focus-visible {
  background: rgba(31, 58, 45, .08);
  outline: none;
}

.recent-more-button svg {
  width: 12px;
  height: 4px;
  fill: currentColor;
  display: block;
}

.recent-more-menu {
  position: absolute;
  right: 0;
  top: 34px;
  min-width: 118px;
  padding: 6px;
  border: 1px solid #dededb;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(0, 0, 0, .12);
  z-index: 6;
}

.recent-more-menu button {
  width: 100%;
  height: 34px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  color: #15191b;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  text-align: left;
}

.recent-more-menu button:hover,
.recent-more-menu button:focus-visible {
  background: #F1EEE8;
  outline: none;
}

.recent-more-menu button:disabled {
  cursor: not-allowed;
  opacity: .45;
}

.recent-more-menu img {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
}

.recent-table {
  margin: 0 -20px;
}

.recent-row {
  min-height: 78px;
  border-bottom: 1px solid #dededb;
  display: grid;
  grid-template-columns: 66px minmax(220px, 1fr) 120px 48px 170px 48px 52px 48px 56px;
  align-items: center;
  gap: 0;
  padding: 0 16px;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
}

.recent-row:hover,
.recent-row.selected,
.recent-row:focus-visible {
  background: #f1eee8;
}

.recent-row-cover {
  width: 54px;
  height: 54px;
  border: 1px solid transparent;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.recent-row-cover.has-cover {
  height: 62px;
}

.recent-row-cover-image {
  width: 46px;
  height: 62px;
  border: 1px solid #d7d9d6;
  background: #fff;
  box-sizing: border-box;
  object-fit: cover;
  display: block;
}

.recent-row-cover-default {
  width: 32px;
  min-width: 32px;
  max-width: 32px;
  height: 32px;
  min-height: 32px;
  max-height: 32px;
  inline-size: 32px;
  min-inline-size: 32px;
  max-inline-size: 32px;
  block-size: 32px;
  min-block-size: 32px;
  max-block-size: 32px;
  flex: 0 0 32px;
  object-fit: contain;
  display: block;
  box-sizing: content-box;
}

.recent-row strong {
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 78px;
  min-width: 0;
  color: #121618;
  font-size: 15px;
  line-height: 22px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-row > span:not(.recent-row-cover):not(.recent-row-more-wrap) {
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 78px;
  color: #7d8284;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.recent-row-count {
  grid-column: 3;
}

.recent-row-date {
  grid-column: 5;
}

.recent-row-favorite-status {
  grid-column: 7;
}

.recent-row-more-wrap {
  align-self: center;
  grid-column: 9;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 78px;
}

.recent-row-more-wrap .recent-more-menu {
  top: 52px;
  right: 0;
}

.recent-learning-mask {
  position: fixed;
  inset: 0;
  z-index: 1080;
  background: transparent;
}

.recent-learning-mask.preview-open {
  left: 306px;
}

.cloud-page.collapsed ~ .recent-learning-mask.preview-open {
  left: 70px;
}

.recent-learning-modal {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 1081;
  width: min(930px, calc(100% - 96px));
  height: min(560px, calc(100% - 96px));
  border: 1px solid #efede8;
  background: #fff;
  box-shadow: 0 10px 24px rgba(29, 31, 28, .13);
  transform: translate(-50%, -50%);
  overflow: hidden;
}

.recent-learning-modal.preview-open {
  left: 306px;
  top: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  border: 0;
  background: #f3f2ed;
  box-shadow: none;
  transform: none;
}

.cloud-page.collapsed ~ .recent-learning-modal.preview-open {
  left: 70px;
}

.recent-learning-resolving {
  min-height: 100%;
  padding: 82px 138px;
  background: #fff;
  color: #202423;
  box-sizing: border-box;
}

.recent-learning-resolving strong {
  display: block;
  font-size: 18px;
  line-height: 28px;
  font-weight: 700;
}

.recent-learning-resolving p {
  margin: 12px 0 0;
  color: #7a7d7b;
  font-size: 14px;
  line-height: 22px;
}

.recent-learning-summary-panel {
  position: relative;
  height: 100%;
  padding: 0;
  background: #fff;
  box-sizing: border-box;
}

.recent-learning-close {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  padding: 0;
  opacity: 1;
  cursor: pointer;
  z-index: 1;
}

.recent-learning-close:hover {
  background: #F1EEE8;
}

.recent-learning-close span {
  position: relative;
  display: block;
  width: 14px;
  height: 14px;
  margin: 7px auto;
}

.recent-learning-close span::before,
.recent-learning-close span::after {
  content: "";
  position: absolute;
  left: -1px;
  top: 6px;
  width: 16px;
  height: 1px;
  background: #000;
}

.recent-learning-close span::before {
  transform: rotate(45deg);
}

.recent-learning-close span::after {
  transform: rotate(-45deg);
}

.recent-learning-head {
  display: flex;
  align-items: flex-start;
  height: 132px;
  padding: 34px 44px 24px;
  background: #f7f5f0;
  box-sizing: border-box;
}

.recent-learning-main {
  min-width: 0;
  flex: 1;
}

.recent-learning-main strong {
  display: block;
  color: #202423;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-meta {
  display: flex;
  align-items: center;
  gap: 13px;
  margin: 13px 0 0;
  color: #59615e;
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
}

.recent-learning-size {
  color: #59615e;
  font-size: 13px;
  line-height: 26px;
  font-weight: 500;
}

.recent-learning-chip {
  min-width: 42px;
  height: 28px;
  border: 1px solid #ccd3cd;
  background: #fbfcf9;
  color: #1F3A2D;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}

.recent-learning-chip.is-sync {
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
}

.recent-learning-chip.is-sync i {
  position: relative;
  width: 13px;
  height: 13px;
  border: 1px solid #52635b;
  border-radius: 50%;
  box-sizing: border-box;
  flex: 0 0 13px;
}

.recent-learning-chip.is-sync i::before,
.recent-learning-chip.is-sync i::after {
  content: "";
  position: absolute;
  box-sizing: border-box;
}

.recent-learning-chip.is-synced i {
  border-color: #1F3A2D;
}

.recent-learning-chip.is-synced i::before {
  display: none;
}

.recent-learning-chip.is-synced i::after {
  left: 50%;
  top: 50%;
  width: 4px;
  height: 7px;
  border-right: 1px solid #1F3A2D;
  border-bottom: 1px solid #1F3A2D;
  transform: translate(-50%, -57%) rotate(45deg);
}

.recent-learning-chip.is-unsynced i {
  border-color: #d84d45;
}

.recent-learning-chip.is-unsynced i::before,
.recent-learning-chip.is-unsynced i::after {
  left: 50%;
  top: 50%;
  width: 7px;
  height: 1px;
  background: #d84d45;
  transform-origin: center;
}

.recent-learning-chip.is-unsynced i::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.recent-learning-chip.is-unsynced i::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.recent-learning-chip.is-unknown i {
  border-color: #aeb6b1;
}

.recent-learning-chip.is-unknown i::before {
  display: none;
}

.recent-learning-chip.is-unknown i::after {
  left: 3px;
  top: 5px;
  width: 4px;
  height: 1px;
  background: #aeb6b1;
}

.recent-learning-list {
  width: 100%;
  max-width: none;
  margin: 0;
  border-top: 0;
}

.recent-learning-row {
  width: 100%;
  height: 96px;
  border: 0;
  border-bottom: 1px solid #e9e9e5;
  background: #fff;
  display: grid;
  grid-template-columns: 108px minmax(0, 1fr) 92px;
  column-gap: 24px;
  align-items: center;
  padding: 0 44px;
  box-sizing: border-box;
  color: #202423;
  font: inherit;
  text-align: left;
}

.recent-learning-row:not(.is-progress) {
  cursor: pointer;
}

.recent-learning-row:not(.is-progress):hover,
.recent-learning-row:not(.is-progress):focus-visible {
  background: #edf3ea;
  outline: none;
}

.recent-learning-row strong {
  grid-column: 1;
  color: #232827;
  font-size: 17px;
  line-height: 24px;
  font-weight: 700;
}

.recent-learning-row em {
  grid-column: 3;
  width: 100%;
  color: #18372c;
  font-size: 23px;
  line-height: 32px;
  font-weight: 700;
  font-style: normal;
  text-align: center;
  justify-self: stretch;
}

.recent-learning-progress {
  grid-column: 2;
  position: relative;
  height: 7px;
  background: #e0e2df;
  overflow: hidden;
}

.recent-learning-progress i {
  display: block;
  height: 100%;
  background: #1d4435;
}

.recent-learning-detail-panel,
.recent-learning-preview-panel,
.recent-learning-highlight-page {
  height: 100%;
  min-height: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.recent-learning-tabs {
  height: 92px;
  flex: 0 0 92px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 0 74px 0 34px;
  border-bottom: 1px solid #ebe8e0;
  background: #F6F4F0;
  box-sizing: border-box;
}

.recent-learning-tabs-main {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 18px;
}

.recent-learning-tabs-right {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.recent-learning-tabs-back {
  width: 24px;
  height: 36px;
  border: 0;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  flex: 0 0 24px;
}

.recent-learning-tabs-back:hover {
  background: #F1EEE8;
}

.recent-learning-tabs-back span {
  display: block;
  width: 10px;
  height: 10px;
  border-left: 1px solid #151715;
  border-bottom: 1px solid #151715;
  transform: rotate(45deg);
}

.recent-learning-tab-button {
  height: 92px;
  border: 0;
  border-bottom: 4px solid transparent;
  background: transparent;
  color: #3d413f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px 0;
  font-size: 19px;
  line-height: 26px;
  font-weight: 600;
  cursor: pointer;
}

.recent-learning-tab-button.active {
  color: #1d201f;
  border-bottom-color: #0e100f;
}

.recent-learning-tab-button em {
  display: none;
}

.recent-learning-tabs-close {
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  opacity: 1;
  z-index: 2;
}

.recent-learning-tabs-close:hover {
  background: #F1EEE8;
}

.recent-learning-tabs-close span {
  position: relative;
  display: block;
  width: 14px;
  height: 14px;
  margin: 7px auto;
}

.recent-learning-tabs-close span::before,
.recent-learning-tabs-close span::after {
  content: "";
  position: absolute;
  left: -1px;
  top: 6px;
  width: 16px;
  height: 1px;
  background: #000;
}

.recent-learning-tabs-close span::before {
  transform: rotate(45deg);
}

.recent-learning-tabs-close span::after {
  transform: rotate(-45deg);
}

.recent-learning-detail-content {
  flex: 1;
  min-height: 0;
  overflow: auto;
  background: #fff;
  padding: 0;
  box-sizing: border-box;
}

.recent-learning-list-box {
  width: 100%;
  border: 0;
  background: #fff;
}

.recent-learning-info-row,
.recent-learning-annotation-row {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #ecece8;
  background: #fff;
  color: #15191b;
  display: grid;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  text-align: left;
}

.recent-learning-info-row:last-child,
.recent-learning-annotation-row:last-child {
  border-bottom: 0;
}

.recent-learning-info-row:hover,
.recent-learning-info-row.active {
  background: #F1EEE8;
}

.recent-learning-bookmark-row {
  min-height: 112px;
  grid-template-columns: minmax(0, 1fr) 46px;
  column-gap: 14px;
  padding: 0 42px 0 34px;
  cursor: default;
}

.recent-learning-bookmark-main,
.recent-learning-highlight-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.recent-learning-bookmark-main {
  gap: 14px;
}

.recent-learning-highlight-main {
  gap: 11px;
  padding: 18px 0;
}

.recent-learning-bookmark-main strong,
.recent-learning-highlight-main strong {
  color: #252927;
  font-size: 19px;
  line-height: 25px;
  font-weight: 700;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.recent-learning-bookmark-main em,
.recent-learning-highlight-main em {
  color: #a6aca8;
  font-size: 15px;
  line-height: 20px;
  font-style: normal;
  font-weight: 500;
}

.recent-learning-row-page {
  color: #9ca29f;
  font-size: 15px;
  line-height: 20px;
  text-align: right;
  align-self: center;
}

.recent-learning-highlight-row {
  min-height: 112px;
  grid-template-columns: minmax(0, 1fr) 18px;
  column-gap: 22px;
  padding: 0 42px 0 34px;
}

.recent-learning-highlight-row i {
  width: 10px;
  height: 10px;
  border-top: 2px solid #555d58;
  border-right: 2px solid #555d58;
  transform: rotate(45deg);
  justify-self: end;
}

.recent-learning-highlight-page header {
  height: 92px;
  flex: 0 0 92px;
  position: relative;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: center;
  border-bottom: 1px solid #ebe8e0;
  padding: 0 74px 0 34px;
  background: #F6F4F0;
  box-sizing: border-box;
}

.recent-learning-highlight-back {
  width: 24px;
  height: 36px;
  border: 0;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}

.recent-learning-highlight-back span {
  display: block;
  width: 10px;
  height: 10px;
  border-left: 1px solid #151715;
  border-bottom: 1px solid #151715;
  transform: rotate(45deg);
}

.recent-learning-highlight-page header strong {
  min-width: 0;
  color: #1d201f;
  font-size: 18px;
  line-height: 26px;
  font-weight: 700;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.recent-learning-highlight-page article {
  flex: 1;
  min-height: 0;
  padding: 30px 34px 34px;
  background: #fff;
  overflow: auto;
  box-sizing: border-box;
}

.recent-learning-highlight-meta {
  margin: 0 0 16px;
  color: #8f9590;
  font-size: 14px;
  line-height: 20px;
}

.recent-learning-highlight-text {
  margin: 0;
  color: #252a27;
  font-size: 16px;
  line-height: 30px;
  white-space: pre-wrap;
  word-break: break-word;
}

.recent-learning-view-switch {
  width: 68px;
  height: 36px;
  flex-basis: 68px;
  position: relative;
}

.recent-learning-view-switch img {
  width: 68px;
  height: 36px;
  display: block;
}

.recent-learning-view-hotspot {
  position: absolute;
  top: 0;
  width: 34px;
  height: 36px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.recent-learning-view-list {
  left: 0;
}

.recent-learning-view-grid {
  right: 0;
}

.recent-learning-detail-content.is-annotations {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.recent-learning-annotation-toolbar {
  min-height: 62px;
  padding: 18px 34px 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex: 0 0 auto;
  box-sizing: border-box;
}

.recent-learning-annotation-source-select {
  width: 148px;
  height: 36px;
  flex: 0 0 148px;
}

.recent-learning-annotation-source-select /deep/ .ant-select-selection--single {
  height: 36px;
  border-color: #c8c8c5;
  border-radius: 0;
  box-shadow: none;
}

.recent-learning-annotation-source-select /deep/ .ant-select-selection__rendered {
  line-height: 34px;
}

.recent-learning-annotation-grid {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(148px, 148px));
  align-content: start;
  justify-content: start;
  gap: 29.5px 15px;
  padding: 10px 34px 40px;
  overflow: auto;
  box-sizing: border-box;
}

.recent-learning-annotation-card {
  width: 148px;
  height: 245px;
  min-height: 245px;
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  outline: none;
  z-index: 0;
  --recent-learning-grid-column-gap: 15px;
  --recent-learning-grid-row-gap: 44px;
  --recent-learning-grid-column-gap-half: calc(var(--recent-learning-grid-column-gap) / 2);
  --recent-learning-grid-row-gap-half: calc(var(--recent-learning-grid-row-gap) / 2);
}

.recent-learning-annotation-card > * {
  position: relative;
  z-index: 1;
}

.recent-learning-annotation-card.active {
  z-index: 1;
}

.recent-learning-annotation-card.active::before {
  content: '';
  position: absolute;
  top: calc(-1 * var(--recent-learning-grid-column-gap-half));
  right: calc(-1 * var(--recent-learning-grid-column-gap-half));
  bottom: calc(-1 * var(--recent-learning-grid-row-gap-half));
  left: calc(-1 * var(--recent-learning-grid-column-gap-half));
  background: #DDE4D9;
  pointer-events: none;
  z-index: 0;
}

.recent-learning-annotation-cover {
  width: 148px;
  height: 196px;
  border: 1px solid #e0ddd5;
  background: #fff;
  display: block;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}

.recent-learning-annotation-cover.small {
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
}

.recent-learning-annotation-card:hover .recent-learning-annotation-cover,
.recent-learning-annotation-card:focus-visible .recent-learning-annotation-cover,
.recent-learning-annotation-card.active .recent-learning-annotation-cover {
  border-color: #b6b8b4;
  background: #f8f8f6;
}

.recent-learning-annotation-page,
.recent-learning-annotation-ink {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.recent-learning-annotation-ink {
  z-index: 1;
  pointer-events: none;
}

.recent-learning-annotation-screen-size {
  position: absolute;
  right: 3px;
  bottom: 3px;
  z-index: 2;
  min-height: 18px;
  padding: 1px 5px;
  background: rgba(72, 72, 72, .68);
  color: #fff;
  font-size: 11px;
  line-height: 16px;
  font-weight: 400;
  box-sizing: border-box;
  white-space: nowrap;
}

.recent-learning-annotation-card strong {
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin-top: 8px;
  color: #121618;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-annotation-card em {
  display: block;
  color: #8a8f8e;
  font-size: 12px;
  line-height: 18px;
  font-style: normal;
}

.recent-learning-annotation-list {
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.recent-learning-annotation-row {
  min-height: 78px;
  grid-template-columns: 66px minmax(0, 1fr) 170px;
  column-gap: 0;
  padding: 0 34px;
  border-bottom-color: #dededb;
}

.recent-learning-annotation-row strong {
  min-width: 0;
  color: #15191b;
  font-size: 15px;
  line-height: 22px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-annotation-row em {
  color: #7d8284;
  font-size: 14px;
  line-height: 22px;
  font-style: normal;
  justify-self: end;
  text-align: right;
}

.recent-learning-empty-box {
  width: 100%;
  min-height: 100%;
  border: 0;
  background: #fff;
  color: #8a8f8e;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 14px;
}

.recent-learning-detail-content.is-annotations > .recent-learning-empty-box {
  flex: 1;
  min-height: 0;
}

.recent-learning-empty-box img {
  width: 130px;
  height: auto;
  display: block;
}

.recent-learning-preview-head {
  height: 64px;
  flex: 0 0 64px;
  border-bottom: 1px solid #dededb;
  background: #f3f2ed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 0 32px;
  box-sizing: border-box;
}

.recent-learning-preview-title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 14px;
}

.recent-learning-preview-back {
  width: 26px;
  height: 36px;
  border: 0;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.recent-learning-preview-back span {
  width: 12px;
  height: 12px;
  border-left: 2px solid #111;
  border-bottom: 2px solid #111;
  transform: rotate(45deg);
  display: block;
}

.recent-learning-preview-title strong {
  min-width: 0;
  color: #14191b;
  font-size: 22px;
  line-height: 32px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-preview-actions {
  display: flex;
  align-items: center;
  gap: 24px;
}

.recent-learning-preview-tool {
  width: 36px;
  height: 36px;
  border: 0;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.recent-learning-preview-tool img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.recent-learning-preview-tool:disabled,
.recent-learning-preview-back:disabled {
  opacity: .35;
  cursor: default;
}

.recent-learning-preview-body {
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: hidden;
  background: #f3f2ed;
  --recent-learning-preview-base-height: max(480px, calc(100vh - 64px));
  --recent-learning-preview-base-width: calc(var(--recent-learning-preview-base-height) * 0.75);
}

.recent-learning-preview-shell {
  height: 100%;
  overflow: auto;
  display: block;
  padding: 0 96px 0 32px;
  box-sizing: border-box;
  --recent-learning-preview-zoom: 1;
  cursor: grab;
  user-select: none;
}

.recent-learning-preview-shell.dragging {
  cursor: grabbing;
}

.recent-learning-preview-zoom {
  width: calc(var(--recent-learning-preview-base-width) * var(--recent-learning-preview-zoom));
  height: calc(var(--recent-learning-preview-base-height) * var(--recent-learning-preview-zoom));
  margin: 0 auto;
}

.recent-learning-preview-stage {
  width: var(--recent-learning-preview-base-width);
  height: var(--recent-learning-preview-base-height);
  background: #fff;
  border: 1px solid #d7d9d6;
  transform-origin: top left;
  transform: scale(var(--recent-learning-preview-zoom));
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
}

.recent-learning-preview-page {
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
}

.recent-learning-preview-empty {
  width: 100%;
  height: 100%;
  background: #fff;
}

.recent-learning-preview-pages-grid {
  height: 100%;
  overflow: auto;
  padding: 20px 20px 44px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(148px, 148px));
  align-content: start;
  justify-content: start;
  gap: 29.5px 15px;
  min-width: calc(148px * 4 + 15px * 3);
  box-sizing: border-box;
}

.recent-learning-preview-pages-grid button {
  width: 148px;
  height: 245px;
  min-height: 245px;
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  outline: none;
  z-index: 0;
}

.recent-learning-preview-pages-grid button.selected {
  z-index: 1;
}

.recent-learning-preview-pages-grid button.selected::before {
  content: '';
  position: absolute;
  top: -7.5px;
  right: -7.5px;
  bottom: -22px;
  left: -7.5px;
  background: #DDE4D9;
  pointer-events: none;
  z-index: 0;
}

.recent-learning-preview-pages-grid button > * {
  position: relative;
  z-index: 1;
}

.recent-learning-preview-pages-grid button > span {
  width: 148px;
  height: 196px;
  flex: 0 0 196px;
  border: 1px solid #d7d9d6;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.recent-learning-preview-page-thumb {
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
}

.recent-learning-preview-pages-grid button.active > span {
  border-bottom: 5px solid #050505;
}

.recent-learning-preview-pages-grid strong {
  display: block;
  width: 100%;
  margin-top: 8px;
  color: #121618;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-preview-controls {
  position: absolute;
  right: 24px;
  bottom: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.recent-learning-preview-count {
  display: flex;
  align-items: center;
  gap: 10px;
}

.recent-learning-preview-count button {
  width: 36px;
  height: 36px;
  border: 1px solid #d8d8d8;
  background: transparent;
  position: relative;
  cursor: pointer;
}

.recent-learning-preview-count button::before {
  content: "";
  width: 9px;
  height: 9px;
  border-left: 1px solid #111;
  border-bottom: 1px solid #111;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-35%, -50%) rotate(45deg);
}

.recent-learning-preview-count button:last-child::before {
  transform: translate(-65%, -50%) rotate(225deg);
}

.recent-learning-preview-count button:disabled {
  opacity: .3;
  cursor: default;
}

.recent-learning-preview-count span {
  min-width: 66px;
  height: 36px;
  border: 1px solid #d8d8d8;
  background: #f3f2ed;
  color: #5d6062;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-sizing: border-box;
}

.recent-password-mask {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(0, 0, 0, .38);
}

.recent-password-modal {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 372px;
  min-height: 180px;
  transform: translate(-50%, -50%);
  background: #fff;
  z-index: 1101;
  padding: 22px 20px 20px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, .12);
}

.recent-password-modal header {
  color: #1d1d1f;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  margin-bottom: 18px;
}

.recent-password-field {
  height: 35px;
  border: 1px solid #c9c9c9;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.recent-password-field.error {
  border-color: #c85f58;
}

.recent-password-field input {
  min-width: 0;
  flex: 1;
  height: 33px;
  border: 0;
  outline: 0;
  padding: 0 10px;
  color: #1d1d1f;
  font-size: 14px;
  box-sizing: border-box;
}

.recent-password-field input::placeholder {
  color: #b9b9b9;
}

.recent-password-field button {
  width: 36px;
  height: 33px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.recent-password-field button:disabled {
  cursor: default;
  opacity: .55;
}

.recent-password-field button span {
  width: 18px;
  height: 11px;
  border: 2px solid #5b5f62;
  border-radius: 50%;
  position: relative;
  display: block;
  box-sizing: border-box;
}

.recent-password-field button span::before {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #5b5f62;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.recent-password-field button span::after {
  content: "";
  width: 21px;
  height: 2px;
  background: #5b5f62;
  position: absolute;
  left: -3px;
  top: 3px;
  transform: rotate(-38deg);
}

.recent-password-field button span.visible::after {
  display: none;
}

.recent-password-error {
  min-height: 18px;
  margin: 6px 0 0;
  color: #c85f58;
  font-size: 12px;
  line-height: 18px;
}

.recent-password-modal footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0;
  margin-top: 32px;
}

.recent-password-modal footer > div {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.recent-password-modal footer > div button {
  min-width: 60px;
  height: 32px;
  border: 1px solid #d8d8d8;
  background: #fff;
  color: #333;
  font-size: 14px;
  cursor: pointer;
}

.recent-password-modal footer > div button:last-child {
  border-color: #1f3a2d;
  background: #1f3a2d;
  color: #fff;
}

.recent-password-modal footer > div button:disabled {
  cursor: default;
  opacity: .6;
}

.paper-download-mask {
  position: fixed;
  inset: 0;
  z-index: 1100;
  background: rgba(0, 0, 0, .38);
}

.paper-download-modal {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 474px;
  min-height: 223px;
  transform: translate(-50%, -50%);
  background: #fff;
  z-index: 1101;
  padding: 24px 28px 26px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.paper-download-modal header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #111;
  font-size: 19px;
  line-height: 27px;
  font-weight: 500;
}

.paper-download-modal header button {
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.paper-download-modal header button span {
  width: 18px;
  height: 18px;
  position: relative;
  display: block;
}

.paper-download-modal header button span::before,
.paper-download-modal header button span::after {
  content: "";
  width: 18px;
  height: 2px;
  background: #111;
  position: absolute;
  left: 0;
  top: 8px;
}

.paper-download-modal header button span::before {
  transform: rotate(45deg);
}

.paper-download-modal header button span::after {
  transform: rotate(-45deg);
}

.paper-download-options {
  padding: 30px 0 38px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 44px;
}

.paper-download-options label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #111;
  font-size: 17px;
  line-height: 23px;
  cursor: pointer;
}

.paper-download-options input {
  width: 20px;
  height: 20px;
  accent-color: #111;
}

.paper-download-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.paper-download-modal footer button {
  min-width: 80px;
  height: 40px;
  border: 1px solid #d8d8d8;
  background: #fff;
  color: #333;
  font-size: 15px;
  cursor: pointer;
}

.paper-download-modal footer button:last-child {
  border-color: #1f3a2d;
  background: #1f3a2d;
  color: #fff;
}

.paper-download-modal footer button:disabled {
  cursor: not-allowed;
  opacity: .55;
}

.paper-download-modal.recent-password-modal {
  width: 80%;
  min-height: 0;
  padding: 20px;
  box-shadow: none;
}

.paper-download-modal.recent-password-modal header,
.paper-download-modal.recent-password-modal footer {
  margin-top: 0;
  margin-bottom: 0;
}

.paper-download-modal.recent-password-modal header button {
  width: 22px;
  height: 22px;
}

.paper-download-modal.recent-password-modal header button span {
  width: 14px;
  height: 14px;
}

.paper-download-modal.recent-password-modal header button span::before,
.paper-download-modal.recent-password-modal header button span::after {
  width: 14px;
  height: 1.5px;
  top: 6px;
}

.recent-password-content {
  display: block;
}

.paper-download-modal.recent-password-modal .recent-password-field input {
  font-size: 15px;
}

.paper-download-modal.recent-password-modal footer button {
  width: 70px;
  min-width: 70px;
  height: 35px;
  font-size: 14px;
}

.folder-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(148px, 148px));
  gap: 30px 15px;
  align-items: start;
}

.folder-card {
  width: 148px;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  text-align: left;
}

.folder-card .folder-art {
  width: 148px;
  height: 198px;
  border: 1px solid #d7d9d6;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.folder-card.selected .folder-art,
.folder-card:focus-visible .folder-art {
  background: #f4f6f3;
  border-color: #1f3a2d;
}

.folder-art img {
  width: 46px;
  height: auto;
  object-fit: contain;
  display: block;
}

.folder-name {
  display: block;
  color: #0f1112;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.folder-card .folder-name {
  margin-top: 9px;
}

.folder-card-count {
  display: block;
  margin-top: 1px;
  color: #9a9a9a;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

.folder-art.small {
  width: 54px;
  height: 54px;
  border: 0;
  background: transparent;
  flex: 0 0 54px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.folder-art.small img {
  width: 46px;
  height: auto;
}

.folder-list {
  margin: 0 -20px;
  padding: 7px 0 0;
}

.folder-row {
  width: 100%;
  height: 78px;
  box-sizing: border-box;
  border: 0;
  border-bottom: 1px solid #dededb;
  background: transparent;
  display: grid;
  grid-template-columns: 74px minmax(220px, 1fr) 140px 140px minmax(96px, 16%);
  align-items: center;
  text-align: left;
  cursor: pointer;
  padding: 0 28px;
}

.folder-row:hover,
.folder-row.selected,
.folder-row:active,
.folder-row:focus-visible {
  background: #F1EEE8;
}

.folder-row .folder-name {
  font-size: 15px;
  line-height: 28px;
}

.folder-count,
.folder-extra {
  color: #8a8d8b;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}

.language-modal-title {
  color: #000;
  font-size: 14px;
  font-weight: 700;
}

.exit-modal-title {
  color: #000;
  font-size: 14px;
  font-weight: 700;
}

.exit-confirm-text {
  margin: 18px 0 10px;
  color: #1e202b;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.language-radio-group {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 26px;
}

.language-radio {
  margin: 0;
  min-height: 24px;
  color: #1e202b;
  font-size: 14px;
  line-height: 24px;
}

.setting-password-frame {
  width: 488px;
  height: 650px;
  background: #fff;
  box-sizing: border-box;
}

.setting-password-panel {
  width: 100%;
  height: 100%;
  padding: 42px 75px 56px;
  box-sizing: border-box;
  position: relative;
}

.password-reset-back {
  position: absolute;
  top: 18px;
  left: 37px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #000;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.password-reset-back span {
  width: 18px;
  height: 18px;
  position: relative;
  display: inline-block;
  flex: 0 0 18px;
}

.password-reset-back span::before {
  content: "";
  width: 10px;
  height: 10px;
  border-left: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-35%, -50%) rotate(45deg);
}

.password-reset-main {
  padding-top: 86px;
  text-align: center;
}

.password-reset-main h1 {
  margin: 0;
  color: #1d2328;
  font-size: 24px;
  line-height: 34px;
  font-weight: 600;
  letter-spacing: 0;
}

.password-reset-subtitle {
  margin: 8px 0 0;
  min-height: 20px;
  color: #38383d;
  font-size: 13px;
  line-height: 20px;
  font-weight: 400;
}

.password-reset-switch {
  display: inline-flex;
  border: 1px solid #d8d8d8;
  margin-top: 28px;
  margin-bottom: 20px;
}

.password-reset-switch button {
  min-width: 112px;
  height: 34px;
  border: 0;
  background: #fff;
  color: #404548;
  font-size: 14px;
  cursor: pointer;
}

.password-reset-switch button.active {
  background: #1f3a2d;
  color: #fff;
}

.password-reset-input {
  width: 100%;
  margin: 0;
}

.password-reset-main /deep/ .password-reset-input.ant-input {
  height: 44px;
  padding: 0 14px;
  border-radius: 0;
  color: #1d2328;
  font-size: 15px;
  line-height: 44px;
  box-shadow: none;
}

.password-reset-main /deep/ .password-reset-input.ant-input:focus,
.password-reset-main /deep/ .password-reset-input.ant-input-focused {
  border-color: #1f4032;
  box-shadow: 0 0 0 1px #1f4032;
}

.password-reset-main /deep/ .password-reset-password-input.ant-input-affix-wrapper {
  height: 44px;
  border-radius: 0;
  border: 1px solid #d9dfe3;
  background: #fff;
  color: #1d2328;
  font-size: 15px;
  box-shadow: none;
  padding: 0 40px 0 14px;
}

.password-reset-main /deep/ .password-reset-password-input .ant-input {
  height: 42px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1d2328;
  font-size: 15px;
  box-shadow: none;
}

.password-reset-main /deep/ .password-reset-password-input.ant-input-affix-wrapper-focused,
.password-reset-main /deep/ .password-reset-password-input.ant-input-affix-wrapper:focus-within {
  border-color: #1f4032;
  box-shadow: 0 0 0 1px #1f4032;
}

.password-reset-phone {
  display: grid;
  grid-template-columns: 82px minmax(0, 1fr);
  gap: 10px;
}

.password-reset-area {
  width: 100%;
}

.password-reset-phone /deep/ .password-reset-area.ant-input {
  height: 44px;
  padding: 0 12px;
  border-radius: 0;
  color: #1d2328;
  font-size: 15px;
  line-height: 44px;
  box-shadow: none;
}

.password-reset-submit {
  width: 100%;
  height: 45px;
  font-size: 15px;
  line-height: 1;
}

.password-reset-account .password-reset-submit {
  margin-top: 70px;
}

.password-reset-code .password-reset-input {
  margin-top: 32px;
}

.password-reset-code .password-reset-submit {
  margin-top: 58px;
}

.password-reset-resend {
  display: block;
  max-width: 180px;
  height: 18px;
  margin: 10px 0 0 auto;
  border: 0;
  padding: 0;
  background: transparent;
  color: #1f4032;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  cursor: pointer;
}

.password-reset-password .password-reset-password-input {
  margin-top: 36px;
}

.password-reset-password .password-reset-password-input + .password-reset-password-input {
  margin-top: 16px;
}

.password-reset-password .password-reset-submit {
  margin-top: 38px;
}

.reset-main {
  padding-top: 86px;
  text-align: center;
}

.reset-main h1 {
  margin: 0;
  color: #1d2328;
  font-size: 24px;
  line-height: 34px;
  font-weight: 600;
  letter-spacing: 0;
}

.reset-main .login-subtitle {
  margin: 8px 0 0;
  min-height: 20px;
  color: #38383d;
  font-size: 13px;
  line-height: 20px;
  font-weight: 400;
  white-space: normal;
}

.reset-field {
  width: 100%;
  margin: 0;
}

.reset-main > .reset-field {
  margin-top: 32px;
}

.phone-field,
.code-field {
  display: flex;
  position: relative;
}

.setting-password-panel /deep/ .login-input.ant-input {
  height: 44px;
  padding: 0 14px;
  border-radius: 0;
  color: #1d2328;
  font-size: 15px;
  line-height: 44px;
  box-shadow: none;
}

.setting-password-panel /deep/ .login-input.ant-input:focus,
.setting-password-panel /deep/ .login-input.ant-input-focused {
  border-color: #1f4032;
  box-shadow: 0 0 0 1px #1f4032;
}

.phone-field {
  height: 44px;
}

.area-code {
  width: auto;
  min-width: 68px;
  max-width: 112px;
  height: 44px;
  border: 1px solid #d9dfe3;
  border-right: 0;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 12px;
  color: #1d2328;
  font-size: 14px;
  font-weight: 400;
  box-sizing: border-box;
}

.area-arrow {
  width: 7px;
  height: 7px;
  border-right: 1px solid #1d2328;
  border-bottom: 1px solid #1d2328;
  transform: rotate(45deg) translateY(-2px);
  flex-shrink: 0;
  transition: transform .16s ease;
}

.area-arrow.open {
  transform: rotate(225deg) translate(-2px, -2px);
}

.phone-input {
  flex: 1;
  min-width: 0;
}

.phone-field.focused {
  box-shadow: 0 0 0 1px #1f4032;
}

.phone-field.focused .area-code {
  border-color: #1f4032;
  border-right: 0;
  box-shadow: none;
  position: relative;
  z-index: 2;
}

.phone-field.focused /deep/ .phone-input.ant-input,
.phone-field.focused /deep/ .phone-input.ant-input:focus,
.phone-field.focused /deep/ .phone-input.ant-input-focused {
  border-left-color: #d9dfe3;
  box-shadow: none;
}

.area-options {
  position: absolute;
  top: 44px;
  left: 0;
  width: 338px;
  height: 360px;
  max-height: 360px;
  overflow-y: auto;
  z-index: 20;
  background: #fff;
  border: 1px solid #d9dfe3;
  box-sizing: border-box;
  box-shadow: 0 8px 18px rgba(0, 0, 0, .08);
}

.area-option {
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
}

.area-option:hover {
  background: #F1EEE8;
}

.area-country {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.area-country img {
  width: 20px;
  height: 14px;
  object-fit: cover;
}

.area-country span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.clearable-field {
  position: relative;
  width: 100%;
}

.code-input-field {
  flex: 1;
  min-width: 0;
}

.clearable-field /deep/ .login-input.ant-input,
.phone-field /deep/ .phone-input.ant-input {
  padding-right: 38px;
}

.setting-password-panel /deep/ .password-input.ant-input-affix-wrapper {
  height: 44px;
  border-radius: 0;
  border: 1px solid #d9dfe3;
  background: #fff;
  color: #1d2328;
  font-size: 15px;
  box-shadow: none;
  padding: 0 40px 0 14px;
}

.setting-password-panel /deep/ .password-input .ant-input {
  height: 42px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1d2328;
  font-size: 15px;
  box-shadow: none;
}

.setting-password-panel /deep/ .password-input.ant-input-affix-wrapper-focused,
.setting-password-panel /deep/ .password-input.ant-input-affix-wrapper:focus-within {
  border-color: #1f4032;
  box-shadow: 0 0 0 1px #1f4032;
}

.setting-password-panel /deep/ .password-input .ant-input-password-icon {
  width: 22px;
  height: 22px;
  display: inline-block;
  vertical-align: -4px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.setting-password-panel /deep/ .password-input .ant-input-password-icon svg {
  display: none;
}

.setting-password-panel /deep/ .password-input .ant-input-password-icon.anticon-eye {
  background-image: url("~@/assets/wap/common/password-eye.png");
}

.setting-password-panel /deep/ .password-input .ant-input-password-icon.anticon-eye-invisible {
  background-image: url("~@/assets/wap/common/password-eye-hidden.png");
}

.clearable-password-field /deep/ .password-input.ant-input-affix-wrapper {
  width: 100%;
  padding-right: 68px;
}

.input-clear {
  position: absolute;
  top: 50%;
  right: 12px;
  width: 18px;
  height: 18px;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  transform: translateY(-50%);
  z-index: 5;
}

.clearable-password-field .input-clear {
  right: 43px;
}

.input-clear::before,
.input-clear::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 8px;
  width: 10px;
  height: 1px;
  background: #9aa19d;
}

.input-clear::before {
  transform: rotate(45deg);
}

.input-clear::after {
  transform: rotate(-45deg);
}

.input-clear:hover::before,
.input-clear:hover::after {
  background: #1d2328;
}

.login-submit {
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 0;
  border-color: #809086;
  background: #809086;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  line-height: 1;
  box-shadow: none;
  text-shadow: none;
}

.login-submit:hover,
.login-submit:focus {
  border-color: #809086;
  background: #809086;
  color: #fff;
}

.login-submit.ready,
.login-submit.ready:hover,
.login-submit.ready:focus {
  border-color: #1F3A2D;
  background: #1F3A2D;
  color: #fff;
}

.login-submit[disabled],
.login-submit[disabled]:hover,
.login-submit[disabled]:focus,
.login-submit[disabled]:active {
  border-color: #809086;
  background: #809086;
  color: #fff;
  opacity: 1;
  cursor: not-allowed;
}

.reset-submit {
  width: 100%;
  height: 45px;
  margin-top: 0;
  font-size: 15px;
  line-height: 1;
}

.divider {
  margin: 22px 0 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #9b9f9d;
  font-size: 13px;
  line-height: 19px;
  font-weight: 400;
  font-style: normal;
}

.divider span {
  flex: 1;
  height: 1px;
  background: #d9dfe3;
}

.divider em {
  font-style: normal;
  white-space: nowrap;
}

.switch-login {
  width: 176px;
  height: 34px;
  border: 1px solid #d9dfe3;
  border-radius: 4px;
  background: #fff;
  color: #1d2328;
  font-size: 14px;
  line-height: 32px;
  font-weight: 400;
  cursor: pointer;
  display: block;
  margin: 0 auto;
}

.reset-divider {
  margin: 24px 0 18px;
  gap: 12px;
  font-size: 13px;
  line-height: 19px;
}

.reset-switch {
  width: 176px;
  height: 34px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 32px;
}

.reset-account .reset-submit {
  margin-top: 70px;
}

.reset-code .reset-submit {
  margin-top: 58px;
}

.reset-password .reset-field {
  margin-top: 36px;
}

.reset-password .reset-field + .reset-field {
  margin-top: 16px;
}

.reset-password .reset-submit {
  margin-top: 38px;
}

.reset-resend {
  display: block;
  max-width: 180px;
  height: 18px;
  margin: 10px 0 0 auto;
  border: 0;
  padding: 0;
  background: transparent;
  color: #1f4032;
  font-size: 12px;
  line-height: 18px;
  text-decoration: underline;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: right;
  cursor: pointer;
}

.setting-modal-title {
  color: #000;
  font-size: 16px;
  font-weight: 700;
}

.setting-layout {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  min-height: 430px;
  background: #fff;
}

.setting-nav {
  border-right: 1px solid #e3e3e3;
  background: #fbfbf9;
}

.setting-tab {
  width: 100%;
  height: 58px;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 24px;
  color: #1e2328;
  font-size: 15px;
  line-height: 22px;
  cursor: pointer;
  text-align: left;
}

.setting-tab.active {
  background: #edf1ec;
}

.setting-tab img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex: 0 0 24px;
}

.setting-content {
  min-width: 0;
  padding: 30px 34px;
  color: #171b1f;
}

.setting-profile {
  min-height: 70px;
  display: flex;
  align-items: center;
  gap: 18px;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 24px;
}

.setting-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #bf4b42;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  flex: 0 0 42px;
}

.setting-profile-main {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 42px;
}

.setting-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #111;
  font-size: 17px;
  line-height: 26px;
  font-weight: 700;
  min-height: 42px;
}

.setting-edit-button {
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  cursor: pointer;
  position: relative;
  top: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  padding: 0;
}

.setting-edit-button::before {
  content: "";
  position: absolute;
  left: 7px;
  top: 8px;
  width: 9px;
  height: 3px;
  border: 1px solid #1c2428;
  border-left: 0;
  transform: rotate(-45deg);
}

.setting-edit-button::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 15px;
  width: 11px;
  height: 1px;
  background: #1c2428;
}

.setting-username-edit {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.setting-username-edit /deep/ .ant-input {
  height: 34px;
  border-radius: 0;
  padding: 0 12px;
  font-size: 14px;
  line-height: 34px;
}

.setting-username-edit /deep/ .ant-input:hover {
  border-color: #d9d9d9;
}

.setting-username-edit /deep/ .ant-input:focus,
.setting-username-edit /deep/ .ant-input-focused {
  border-color: #1F3A2D;
  box-shadow: none;
}

.setting-username-edit /deep/ .ant-btn {
  height: 34px;
  border-radius: 0;
  padding: 0 14px;
  font-size: 14px;
}

.rename-panel {
  background: #fff;
  padding: 20px 24px 20px;
}

.rename-head {
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.rename-head h3 {
  margin: 0;
  color: #1f2428;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}

.rename-close {
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  cursor: pointer;
  position: relative;
  padding: 0;
}

.rename-close::before,
.rename-close::after {
  content: "";
  position: absolute;
  left: 6px;
  top: 11px;
  width: 13px;
  height: 2px;
  background: #111;
}

.rename-close::before {
  transform: rotate(45deg);
}

.rename-close::after {
  transform: rotate(-45deg);
}

.rename-input /deep/ .ant-input,
.rename-input.ant-input {
  width: 100%;
  height: 36px;
  border-radius: 0;
  border-color: #a5a5a5;
  color: #1f2428;
  font-size: 14px;
  line-height: 36px;
  padding: 0 10px;
  box-shadow: none;
}

.rename-input /deep/ .ant-input:hover,
.rename-input.ant-input:hover {
  border-color: #1F3A2D;
}

.rename-input /deep/ .ant-input:focus,
.rename-input /deep/ .ant-input-focused,
.rename-input.ant-input:focus {
  border-color: #1F3A2D;
  box-shadow: 0 0 0 1px #1F3A2D;
}

.rename-actions {
  margin-top: 36px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.rename-button {
  min-width: 66px;
  height: 34px;
  border-radius: 0;
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #1f2428;
  font-size: 14px;
  line-height: 32px;
  cursor: pointer;
  padding: 0 18px;
}

.rename-confirm {
  background: #1F3A2D;
  border-color: #1F3A2D;
  color: #fff;
}

.rename-confirm:disabled {
  cursor: not-allowed;
  opacity: .72;
}

.setting-info-list {
  margin-top: 7px;
}

.setting-info-row {
  width: 100%;
  min-height: 56px;
  border: 0;
  border-bottom: 1px solid #ededed;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #111;
  font-size: 15px;
  line-height: 22px;
  padding: 0 10px 0 0;
  text-align: left;
}

.setting-info-row strong {
  color: #7a7d7b;
  font-size: 14px;
  font-weight: 400;
  text-align: right;
}

.setting-link-row {
  cursor: pointer;
}

.setting-row-open {
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex: 0 0 24px;
}

.setting-logout-button {
  height: 34px;
  margin-top: 20px;
  border: 1px solid #cfcfcf;
  background: #fff;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  color: #111;
  font-size: 14px;
  cursor: pointer;
}

.setting-logout-button img {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.setting-back-button {
  border: 0;
  background: transparent;
  color: #1f3a2d;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 0;
}

.setting-back-button span {
  width: 9px;
  height: 9px;
  border-left: 2px solid #1f3a2d;
  border-bottom: 2px solid #1f3a2d;
  transform: rotate(45deg);
}

.setting-reset-panel {
  max-width: 420px;
  margin-top: 26px;
}

.setting-reset-panel h3 {
  margin: 0 0 18px;
  color: #111;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
}

.setting-reset-panel p {
  margin: -6px 0 14px;
  color: #777c7a;
  font-size: 13px;
  line-height: 20px;
}

.setting-reset-switch {
  display: inline-flex;
  border: 1px solid #d8d8d8;
  margin-bottom: 16px;
}

.setting-reset-switch button {
  min-width: 112px;
  height: 32px;
  border: 0;
  background: #fff;
  color: #404548;
  font-size: 13px;
  cursor: pointer;
}

.setting-reset-switch button.active {
  background: #1f3a2d;
  color: #fff;
}

.setting-reset-input {
  width: 100%;
  margin-bottom: 14px;
}

.setting-reset-phone {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr);
  gap: 10px;
}

.setting-reset-area {
  margin-bottom: 14px;
}

.setting-reset-submit {
  min-width: 120px;
  height: 34px;
}

.setting-reset-resend {
  display: block;
  border: 0;
  background: transparent;
  color: #1f3a2d;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
  padding: 0;
  margin: -4px 0 18px;
}

.cloud-storage-summary {
  padding-bottom: 30px;
  border-bottom: 1px solid #e8e8e8;
}

.cloud-storage-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #111;
  font-size: 15px;
  line-height: 24px;
  margin-bottom: 14px;
}

.cloud-storage-head strong {
  font-weight: 400;
}

.cloud-storage-track {
  height: 9px;
  background: #d9ded2;
  overflow: hidden;
}

.cloud-storage-track span {
  display: block;
  height: 100%;
  min-width: 0;
  background: #000;
}

.cloud-usage-title {
  margin-top: 28px;
  margin-bottom: 10px;
  color: #111;
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
}

.cloud-usage-list {
  border-top: 1px solid #ededed;
}

.cloud-usage-row {
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ededed;
  color: #111;
  font-size: 15px;
}

.cloud-usage-name {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.cloud-usage-name img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex: 0 0 24px;
}

.cloud-usage-row strong {
  color: #54595c;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
}

.setting-server {
  min-height: 260px;
  display: flex;
  align-items: flex-start;
}

.server-radio-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 34px;
  padding-top: 4px;
  max-width: 100%;
}

.server-radio {
  display: inline-flex;
  align-items: center;
  margin-right: 0 !important;
  color: #111;
  font-size: 15px;
  line-height: 22px;
}

.server-radio .ant-radio-checked .ant-radio-inner {
  border-color: #1f2326 !important;
}

.server-radio .ant-radio-checked::after {
  border-color: #1f2326 !important;
}

.server-radio .ant-radio-inner::after {
  background-color: #1f2326 !important;
}

.server-radio .ant-radio:hover .ant-radio-inner,
.server-radio .ant-radio-wrapper:hover .ant-radio-inner,
.server-radio .ant-radio-input:focus + .ant-radio-inner {
  border-color: #1f2326 !important;
}

.cloud-page,
.cloud-page.collapsed {
  display: block;
  grid-template-columns: none;
  background: #f3f2ed;
}

.cloud-sidebar {
  display: none;
}

.cloud-main {
  width: 100vw;
  height: 100%;
  min-height: 0;
  background: #f3f2ed;
  overflow: hidden;
}

.mobile-user-center {
  width: 100%;
  height: 100%;
  min-height: 0;
  padding-bottom: calc(68px + env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: #f3f2ed;
  color: #111;
}

.mobile-user-center-header {
  width: 100%;
  height: 52px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 52px;
  box-sizing: border-box;
  background: #f3f2ed;
}

.mobile-user-center-header h1 {
  min-width: 0;
  margin: 0;
  color: #111;
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.mobile-user-center-back {
  width: 36px;
  height: 36px;
  border: 1px solid #dedbd5;
  border-radius: 50% !important;
  padding: 0;
  background: #f3f2ed;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
}

.mobile-user-center-back + h1 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}

.mobile-user-center-back span {
  width: 10px;
  height: 10px;
  margin-left: 4px;
  border-left: 2px solid #111;
  border-bottom: 2px solid #111;
  transform: rotate(45deg);
  box-sizing: border-box;
}

.mobile-user-center-scroll {
  min-height: 0;
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  background: #f3f2ed;
}

.mobile-settings-home,
.mobile-setting-detail {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  background: #f3f2ed;
}

.mobile-settings-home {
  padding: 4px 16px 24px;
}

.mobile-settings-profile-card {
  width: 100%;
  height: 80px;
  border: 1px solid #dedbd5;
  padding: 0 23px;
  background: #f3f2ed;
  display: flex;
  align-items: center;
  gap: 20px;
  color: #111;
  text-align: left;
  box-sizing: border-box;
}

.mobile-settings-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #bf4b42;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
  font-size: 18px;
  line-height: 36px;
  font-weight: 700;
}

.mobile-settings-profile-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.mobile-settings-profile-meta strong,
.mobile-settings-profile-meta span {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.mobile-settings-profile-meta strong {
  color: #111;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}

.mobile-settings-profile-meta span {
  margin-top: 1px;
  color: #777;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
}

.mobile-settings-menu {
  margin-top: 6px;
}

.mobile-settings-menu-row {
  width: 100%;
  height: 60px;
  border: 0;
  padding: 0 0 0 8px;
  background: #f3f2ed;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) 24px;
  align-items: center;
  column-gap: 8px;
  color: #111;
  text-align: left;
}

.mobile-settings-menu-row img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.mobile-settings-menu-row > span {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 15px;
  line-height: 22px;
  font-weight: 500;
}

.mobile-settings-menu-row > i,
.mobile-account-link-row > i {
  width: 9px;
  height: 9px;
  margin-left: 5px;
  border-top: 1.5px solid #232323;
  border-right: 1.5px solid #232323;
  transform: rotate(45deg);
  box-sizing: border-box;
}

.mobile-account-page {
  padding-top: 4px;
}

.mobile-account-profile {
  height: 78px;
  margin: 0 16px;
  padding: 0 24px;
  border-bottom: 1px solid #dedbd5;
  display: flex;
  align-items: center;
  gap: 20px;
  box-sizing: border-box;
}

.mobile-account-name-row {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-account-name-row strong {
  max-width: calc(100vw - 148px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #111;
  font-size: 17px;
  line-height: 26px;
  font-weight: 700;
}

.mobile-account-name-row .setting-edit-button {
  top: 1px;
}

.mobile-account-info {
  margin: 5px 16px 0;
}

.mobile-account-info-row {
  width: 100%;
  min-height: 62px;
  border: 0;
  padding: 0;
  background: #f3f2ed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  color: #111;
  font-size: 15px;
  line-height: 22px;
  text-align: left;
}

.mobile-account-link-row,
.mobile-account-logout {
  font-family: inherit;
}

.mobile-account-link-row > span,
.mobile-account-logout > span {
  font-size: 15px;
  line-height: 22px;
  font-weight: 500;
}

.mobile-account-info-row strong {
  min-width: 0;
  max-width: 68%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #777;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  text-align: right;
}

.mobile-account-info-row strong.muted {
  color: #aaa7a2;
}

.mobile-account-link-row {
  cursor: pointer;
}

.mobile-account-logout {
  min-width: 120px;
  height: 44px;
  margin: 38px 16px 24px;
  border: 1px solid #d8d3cc;
  padding: 0 18px;
  background: #f3f2ed;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #111;
  font-size: 15px;
  line-height: 22px;
}

.mobile-account-logout img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.mobile-cloud-page {
  padding-top: 21px;
}

.mobile-cloud-page /deep/ .ant-spin-nested-loading,
.mobile-cloud-page /deep/ .ant-spin-container {
  min-height: 100%;
}

.mobile-cloud-summary {
  margin: 0 16px;
  padding: 0 0 33px;
  border-bottom: 1px solid #dedbd5;
}

.mobile-cloud-summary-head {
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #111;
  font-size: 15px;
  line-height: 24px;
}

.mobile-cloud-summary-head strong {
  font-weight: 400;
  white-space: nowrap;
}

.mobile-cloud-progress {
  width: 100%;
  height: 7px;
  margin-top: 12px;
  background: #d9d9d9;
  overflow: hidden;
}

.mobile-cloud-progress span {
  display: block;
  height: 100%;
  min-width: 0;
  background: #1f3a2d;
}

.mobile-cloud-page h2 {
  margin: 24px 16px 9px;
  color: #111;
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
}

.mobile-cloud-usage-list {
  margin: 0 16px;
}

.mobile-cloud-usage-row {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.mobile-cloud-usage-name {
  min-width: 0;
  flex: 1;
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.mobile-cloud-usage-name img {
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  object-fit: contain;
}

.mobile-cloud-usage-row strong {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #111;
  font-size: 15px;
  line-height: 22px;
  font-weight: 600;
}

.mobile-cloud-usage-value {
  flex: 0 0 auto;
  color: #777;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  white-space: nowrap;
}

.mobile-server-page {
  padding: 27px 24px 24px;
}

.mobile-server-options {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.mobile-server-option {
  height: 50px;
  margin: 0 !important;
  display: flex !important;
  align-items: center;
  color: #111;
  font-size: 15px;
  line-height: 22px;
}

.mobile-server-option /deep/ .ant-radio {
  top: 0;
  margin-right: 4px;
}

.mobile-server-option /deep/ .ant-radio-inner {
  width: 20px;
  height: 20px;
  border-color: #afafa9;
  background: #f3f2ed;
}

.mobile-server-option /deep/ .ant-radio-inner::after {
  top: 4px;
  left: 4px;
  width: 10px;
  height: 10px;
  background: #111;
}

.mobile-server-option /deep/ .ant-radio-checked .ant-radio-inner,
.mobile-server-option:hover /deep/ .ant-radio-inner,
.mobile-server-option /deep/ .ant-radio-input:focus + .ant-radio-inner {
  border-color: #111;
}

.mobile-language-sheet-layer {
  position: fixed;
  inset: 0;
  z-index: 1300;
}

.mobile-language-sheet-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 20vh;
  height: 20dvh;
  border: 0;
  padding: 0;
  background: rgba(0, 0, 0, .36);
}

.mobile-language-sheet {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80vh;
  height: 80dvh;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  color: #111;
  box-sizing: border-box;
}

.mobile-language-sheet > header {
  height: 52px;
  padding: 0 16px;
  border-bottom: 1px solid #dedbd5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 52px;
  background: #fff;
  box-sizing: border-box;
}

.mobile-language-sheet > header h2 {
  margin: 0;
  color: #111;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}

.mobile-language-sheet > header button {
  width: 32px;
  height: 32px;
  border: 0;
  padding: 0;
  background: transparent;
  position: relative;
}

.mobile-language-sheet > header button::before,
.mobile-language-sheet > header button::after {
  content: "";
  position: absolute;
  top: 15px;
  left: 8px;
  width: 16px;
  height: 1.5px;
  background: #111;
}

.mobile-language-sheet > header button::before {
  transform: rotate(45deg);
}

.mobile-language-sheet > header button::after {
  transform: rotate(-45deg);
}

.mobile-language-list {
  min-height: 0;
  flex: 1;
  padding: 6px 16px calc(6px + env(safe-area-inset-bottom));
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-auto-rows: minmax(52px, auto);
  align-content: start;
  gap: 0 12px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  background: #fff;
  box-sizing: border-box;
}

.mobile-language-option {
  min-width: 0;
  min-height: 52px;
  border: 0;
  padding: 6px 4px;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #111;
  text-align: left;
  font-size: 14px;
  line-height: 19px;
}

.mobile-language-option i {
  width: 19px;
  height: 19px;
  border: 1px solid #afafa9;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 19px;
  box-sizing: border-box;
}

.mobile-language-option.active i {
  border-color: #111;
}

.mobile-language-option.active i::after {
  content: "";
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #111;
}

.mobile-language-option > span {
  min-width: 0;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.setting-password-frame {
  width: 100%;
  height: calc(100vh - 16px);
  max-height: 650px;
  height: min(650px, calc(100dvh - 16px));
}

.setting-password-panel {
  padding: 50px 24px 32px;
  overflow-x: hidden;
  overflow-y: auto;
}

.password-reset-back {
  top: 8px;
  left: 16px;
  width: 36px;
  height: 36px;
  border: 1px solid #dedbd5;
  border-radius: 50% !important;
  padding: 0;
  background: #fff;
  justify-content: center;
  gap: 0;
}

.cloud-main.is-recent-detail /deep/ .paper-detail-body.is-resolving .paper-detail-resolving {
  padding: 0 30px;
  align-items: center;
  justify-content: center;
}

.cloud-main.is-recent-detail /deep/ .paper-detail-body.is-resolving .paper-detail-progress-box {
  width: 100%;
  flex: 0 1 100%;
  margin: 0;
  transform: translateY(calc((100vh - 55px) / -6));
}

.cloud-main.is-recent-knowledge-detail /deep/ .paper-detail-progress-track {
  height: 4px;
}

.cloud-main.is-recent-memo-detail /deep/ .paper-detail-progress-track {
  height: 4px;
}

.cloud-main.is-recent-detail /deep/ .paper-workspace.is-detail {
  background: #f3f2ed;
}

.cloud-main.is-recent-detail /deep/ .paper-detail-header {
  height: 55px;
  flex: 0 0 55px;
  position: relative;
  z-index: 40;
  padding: 0 10px 0 16px;
  border-bottom: 0;
  background: #f3f2ed;
}

.cloud-main.is-recent-detail /deep/ .paper-detail-body {
  position: relative;
  z-index: 0;
  isolation: isolate;
}

.cloud-main.is-recent-detail /deep/ .paper-detail-title {
  flex: 1;
  gap: 0;
}

.cloud-main.is-recent-detail /deep/ .paper-detail-title strong,
.cloud-main.is-recent-detail /deep/ .paper-zoom-button {
  display: none;
}

.cloud-main.is-recent-detail /deep/ .paper-back-button {
  width: 36px;
  height: 36px;
  border: 1px solid #e5d5c8;
  border-radius: 50% !important;
  background: transparent;
  flex: 0 0 36px;
}

.cloud-main.is-recent-detail /deep/ .paper-back-button span {
  width: 11px;
  height: 11px;
  border-left-width: 2px;
  border-bottom-width: 2px;
  transform: translateX(2px) rotate(45deg);
}

.cloud-main.is-recent-detail /deep/ .paper-detail-actions {
  gap: 20px;
}

.cloud-main.is-recent-detail /deep/ .paper-detail-body:not(.pages-open):not(.is-resolving),
.cloud-main.is-recent-detail /deep/ .daily-preview-page:not(.pages-open) {
  --paper-preview-base-width: 100vw;
  --paper-preview-base-height: 133.333333vw;
  --daily-preview-base-width: 100vw;
  --daily-preview-base-height: 133.333333vw;
}

.cloud-main.is-recent-knowledge-detail /deep/ .paper-detail-body:not(.pages-open):not(.is-resolving) {
  --paper-preview-base-height: calc(100vh - 55px - 66px);
}

.cloud-main.is-recent-detail /deep/ .learning-annotation-preview-body:not(.pages-open) {
  --learning-annotation-preview-base-width: 100vw;
  --learning-annotation-preview-base-height: 133.333333vw;
}

.cloud-main.is-recent-detail /deep/ .paper-preview-shell,
.cloud-main.is-recent-detail /deep/ .daily-preview-shell,
.cloud-main.is-recent-detail /deep/ .learning-annotation-preview-shell {
  --recent-preview-center-min: 0px;
  padding: 0;
  overflow: auto;
  background: #f3f2ed;
  touch-action: none;
  overscroll-behavior: contain;
  cursor: default;
}

.cloud-main.is-recent-detail /deep/ .paper-preview-shell {
  height: calc(100vh - 55px - 66px);
  position: relative;
  z-index: 0;
}

.cloud-main.is-recent-detail /deep/ .daily-preview-shell,
.cloud-main.is-recent-detail /deep/ .learning-annotation-preview-shell {
  height: calc(100% - 66px);
}

.cloud-main.is-recent-knowledge-detail /deep/ .paper-preview-shell {
  overflow-x: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.cloud-main.is-recent-detail /deep/ .paper-preview-zoom {
  margin: max(var(--recent-preview-center-min), calc((100vh - 55px - 66px - var(--paper-preview-base-height) * var(--paper-preview-zoom)) / 2)) auto 0;
  margin-right: auto;
  margin-left: auto;
}

.cloud-main.is-recent-paper-detail /deep/ .paper-preview-zoom,
.cloud-main.is-recent-meeting-detail /deep/ .paper-preview-zoom {
  margin:
    max(var(--recent-preview-center-min), calc((100vh - 55px - 66px - var(--paper-preview-base-height) * var(--paper-preview-zoom)) / 2))
    max(var(--recent-preview-center-min), calc((100vw - var(--paper-preview-base-width) * var(--paper-preview-zoom)) / 2));
}

.cloud-main.is-recent-detail /deep/ .daily-preview-zoom {
  margin: max(0px, calc((100vh - 55px - 66px - var(--daily-preview-base-height) * var(--daily-preview-zoom)) / 2)) auto 0;
}

.cloud-main.is-recent-detail /deep/ .learning-annotation-preview-zoom {
  margin: max(var(--recent-preview-center-min), calc((100vh - 55px - 66px - var(--learning-annotation-preview-base-height) * var(--learning-annotation-preview-zoom)) / 2)) auto 0;
}

.recent-preview-zoom-toast {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 90;
  min-width: 94px;
  height: 40px;
  padding: 0 16px;
  border-radius: 4px;
  box-sizing: border-box;
  background: rgba(24, 28, 29, .78);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  font-size: 15px;
  line-height: 20px;
  white-space: nowrap;
  pointer-events: none;
  animation: recent-preview-zoom-toast 1.3s linear forwards;
}

@keyframes recent-preview-zoom-toast {
  0%,
  76.923% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.cloud-main.is-recent-detail /deep/ .paper-preview-stage {
  border: 0;
  background: #fff;
}

.cloud-main.is-recent-detail /deep/ .paper-preview-stage img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.cloud-main.is-recent-paper-detail /deep/ .paper-preview-stage img {
  object-position: center center;
}

.cloud-main.is-recent-detail /deep/ .paper-page-controls,
.cloud-main.is-recent-detail /deep/ .daily-preview-controls {
  left: 50%;
  right: auto;
  bottom: 16px;
  z-index: 40;
  align-items: center;
  transform: translateX(-50%);
  pointer-events: auto;
}

.cloud-main.is-recent-detail /deep/ .paper-page-count,
.cloud-main.is-recent-detail /deep/ .daily-preview-count {
  gap: 0;
}

.cloud-main.is-recent-detail /deep/ .paper-page-count button,
.cloud-main.is-recent-detail /deep/ .daily-preview-count button {
  display: none;
}

.cloud-main.is-recent-detail /deep/ .paper-page-count span,
.cloud-main.is-recent-detail /deep/ .daily-preview-count span {
  min-width: 68px;
  height: 40px;
  border: 1px solid #c7c9c8;
  background: #f3f2ed;
  color: #44484a;
  font-size: 16px;
}

.cloud-main.is-recent-knowledge-detail /deep/ .paper-detail-body.is-knowledge-ai-note-preview .knowledge-text-page {
  padding-bottom: 60px;
}

.cloud-main.is-recent-knowledge-detail /deep/ .paper-page-count span {
  height: 34px;
}

.cloud-main.is-recent-detail /deep/ .paper-detail-resolving,
.cloud-main.is-recent-detail /deep/ .paper-pages-grid,
.cloud-main.is-recent-detail /deep/ .daily-preview-grid {
  height: calc(100vh - 55px);
}

.cloud-main.is-recent-preview-grid-detail /deep/ .paper-detail-body.pages-open {
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid {
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-width: 0;
  padding: 16px 15px calc(82px + env(safe-area-inset-bottom));
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: max-content;
  align-content: start;
  align-items: start;
  column-gap: 6px;
  row-gap: 3px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: auto;
  min-height: 0;
  padding: 0 0 19px;
  align-items: stretch;
  overflow: visible;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button:hover > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button:focus > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button:focus-visible > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button:active > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button.active > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button.selected > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button:hover > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button:focus > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button:focus-visible > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button:active > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button.active > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button.selected > span {
  border-color: transparent;
  background: #fff;
}

.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button.selected::before,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button.selected::before {
  top: -3px;
  right: -3px;
  bottom: 0;
  left: -3px;
}

.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button.selected.grid-edge-top::before,
.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button.selected:not(.grid-selected-row-start)::before,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button.selected.grid-edge-top::before,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button.selected:not(.grid-selected-row-start)::before {
  top: -3px;
}

.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button.selected.grid-selection-continues-below::before,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button.selected.grid-selection-continues-below::before {
  bottom: -3px;
}

.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid button > span,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid button > span {
  width: 100%;
  max-width: 100%;
  height: auto;
  aspect-ratio: 74 / 98;
  flex: 0 0 auto;
  margin: 0;
  box-sizing: border-box;
}

.cloud-main.is-recent-preview-current-line /deep/ .paper-pages-grid button.active > span,
.cloud-main.is-recent-preview-current-line /deep/ .daily-preview-grid button.active > span {
  position: relative;
  border-bottom: 0;
  border-radius: 0;
}

.cloud-main.is-recent-preview-current-line /deep/ .paper-pages-grid button.active > span::after,
.cloud-main.is-recent-preview-current-line /deep/ .daily-preview-grid button.active > span::after {
  content: '';
  position: absolute;
  right: -1px;
  bottom: -1px;
  left: -1px;
  z-index: 2;
  height: 3.333333px;
  border-radius: 0;
  background: #050505;
  pointer-events: none;
}

.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid img,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid img {
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  object-position: center center;
}

.cloud-main.is-recent-preview-grid-detail /deep/ .paper-pages-grid strong,
.cloud-main.is-recent-preview-grid-detail /deep/ .daily-preview-grid strong {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.cloud-main.is-recent-daily-preview-detail /deep/ .daily-preview-page .paper-detail-progress-track,
.cloud-main.is-search-daily-preview-detail /deep/ .daily-preview-page .paper-detail-progress-track {
  height: 4px;
}

.cloud-main.is-recent-daily-preview-detail /deep/ .daily-preview-grid button.selected::before,
.cloud-main.is-search-daily-preview-detail /deep/ .daily-preview-grid button.selected::before {
  background: #daded5;
}

.cloud-main.is-recent-daily-preview-detail /deep/ .daily-preview-grid button > span,
.cloud-main.is-search-daily-preview-detail /deep/ .daily-preview-grid button > span {
  border: 1px solid #eee6df;
}

.cloud-main.is-recent-daily-preview-detail /deep/ .daily-preview-grid strong,
.cloud-main.is-search-daily-preview-detail /deep/ .daily-preview-grid strong {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 22px;
  flex: 0 0 22px;
  margin-top: 8px;
  padding: 0 4px;
  box-sizing: border-box;
  color: #121618;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cloud-main.is-recent-memo-detail /deep/ .paper-pages-grid {
  justify-content: normal;
}

.cloud-main.is-recent-memo-detail /deep/ .paper-pages-grid button.selected::before {
  background: #daded5;
}

.cloud-main.is-recent-memo-detail /deep/ .paper-pages-grid button > span {
  border: 1px solid #eee6df;
}

.cloud-main.is-recent-memo-detail /deep/ .paper-pages-grid button:hover > span,
.cloud-main.is-recent-memo-detail /deep/ .paper-pages-grid button:focus > span,
.cloud-main.is-recent-memo-detail /deep/ .paper-pages-grid button:focus-visible > span,
.cloud-main.is-recent-memo-detail /deep/ .paper-pages-grid button:active > span,
.cloud-main.is-recent-memo-detail /deep/ .paper-pages-grid button.active > span,
.cloud-main.is-recent-memo-detail /deep/ .paper-pages-grid button.selected > span {
  border-color: transparent;
  background: #fff;
}

.cloud-main.is-recent-memo-detail /deep/ .paper-pages-grid strong {
  height: 22px;
  flex: 0 0 22px;
  margin-top: 8px;
  padding: 0 4px;
  color: #121618;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}

.content-header {
  height: 52px;
  padding: 0 14px;
  border-bottom: 0;
  background: #f3f2ed;
}

.content-header h1 {
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #181c1d;
}

.content-header.is-recent-page h1 {
  font-family: PingFangSC, PingFang SC;
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  color: #020202;
  font-style: normal;
}

.content-header.is-myfile-page h1 {
  font-family: PingFangSC, PingFang SC;
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
  color: #020202;
  font-style: normal;
}

.content-header.is-recent-page {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 75;
  box-sizing: border-box;
  background: #f3f2ed;
}

.content-header.is-myfile-page {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 75;
  box-sizing: border-box;
  background: #f3f2ed;
}

.content-header-actions {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.content-header.is-recent-page .content-header-actions {
  gap: 20px;
}

.content-header.is-myfile-page .content-header-actions {
  gap: 20px;
}

/* Search is an independent mobile surface; keep its geometry isolated from Recent. */
.content-header.is-search-page {
  height: 60px;
  flex: 0 0 60px;
  padding: 0 16px;
  border-bottom: 1px solid #e6dfda;
  background: #f3f2ed;
  gap: 15px;
}

.content-header.is-search-page .search-back-button {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border: 1px solid #eadbd0;
  border-radius: 999px !important;
  background: #f3f2ed;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.content-header.is-search-page .search-back-button img {
  width: 24px;
  height: 24px;
}

.content-header.is-search-page .global-search-box {
  height: 36px;
  gap: 10px;
}

.content-header.is-search-page .global-search-submit-button,
.content-header.is-search-page .global-search-box img {
  width: 24px;
  height: 24px;
  flex-basis: 24px;
}

.content-header.is-search-page .global-search-box input {
  height: 36px;
  line-height: 36px;
  border-left: 0;
  padding-left: 0;
  font-size: 15px;
}

.content-header.is-search-page .global-search-close-button {
  width: 24px;
  height: 36px;
  flex-basis: 24px;
}

.content-header.is-search-page .global-search-close-button img {
  width: 24px;
  height: 24px;
}

.content-area.is-global-search {
  position: fixed;
  top: 108px;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0 16px calc(20px + env(safe-area-inset-bottom));
  background: #f3f2ed;
  transition: padding-top .28s ease;
}

.content-area.is-global-search.is-search-pull-refreshing {
  padding-top: 100px;
}

.content-area.is-global-search /deep/ .ant-spin-nested-loading,
.content-area.is-global-search /deep/ .ant-spin-container,
.content-area.is-global-search /deep/ .cloud-list-spin.ant-spin-nested-loading,
.content-area.is-global-search .cloud-list-content {
  min-height: calc(100vh - 108px);
  background: #f3f2ed;
}

.global-search-pull-refresh {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 20;
  height: 100px;
  color: #1f3a2d;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.global-search-pull-refresh > strong {
  font-size: 15px;
  line-height: 22px;
  font-weight: 500;
}

.global-search-toolbar {
  height: 48px;
  flex: 0 0 48px;
  padding: 0 12px 0 16px;
  align-items: center;
  background: #f3f2ed;
  border-bottom: 0;
}

.global-search-filter-button {
  width: auto;
  min-width: 0;
  max-width: calc(100vw - 72px);
  height: 48px;
  border: 0;
  padding: 0;
  gap: 0;
  font-size: 15px;
  justify-content: flex-start;
}

.global-search-filter-button .global-search-filter-icon {
  display: none;
}

.global-search-filter-button span:not(.global-search-filter-arrow) {
  font-size: 15px;
  line-height: 22px;
}

.global-search-filter-button .global-search-filter-arrow {
  margin-left: 10px;
}

.global-search-filter-menu {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  top: min(362px, max(0px, calc(100vh - 420px - env(safe-area-inset-bottom))));
  top: min(362px, max(0px, calc(100dvh - 420px - env(safe-area-inset-bottom))));
  width: 100%;
  max-width: none;
  min-width: 0;
  border: 0;
  background: #fff;
  box-shadow: none;
  z-index: 101;
  padding-bottom: calc(30px + env(safe-area-inset-bottom));
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.global-search-filter-mask {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(0, 0, 0, .3);
}

.global-search-filter-menu-header {
  height: 54px;
  width: 100%;
  padding: 0 54px 0 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  position: relative;
}

.global-search-filter-menu-header strong {
  color: #1d2222;
  font-size: 19px;
  line-height: 28px;
  font-weight: 600;
  white-space: nowrap;
  flex: 0 0 auto;
}

.global-search-filter-menu-close {
  position: absolute !important;
  top: 0;
  right: 0;
  width: 54px !important;
  min-width: 54px !important;
  max-width: 54px !important;
  height: 54px !important;
  flex: 0 0 54px !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 0;
  background: transparent !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  text-align: center;
  white-space: normal;
  gap: 0;
  cursor: pointer;
  outline: none;
}

.global-search-filter-menu-close:hover,
.global-search-filter-menu-close:focus,
.global-search-filter-menu-close:active {
  background: transparent !important;
}

.global-search-filter-menu-close img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.global-search-filter-menu button:not(.global-search-filter-menu-close) {
  width: 100%;
  min-width: 0;
  height: 48px;
  padding: 0 16px;
  gap: 8px;
  font-size: 15px;
  background: #fff;
}

.global-search-filter-menu button:not(.global-search-filter-menu-close) span {
  font-size: 15px;
  flex: 0 1 auto;
}

.global-search-filter-menu button.active,
.global-search-filter-menu button:hover {
  background: #eff3ed;
}

.global-search-filter-menu .global-search-menu-icon {
  width: 24px;
  height: 24px;
  flex-basis: 24px;
}

.global-search-filter-menu .global-search-menu-check {
  width: 24px;
  height: 24px;
  flex-basis: 24px;
  margin-left: auto;
}

.global-search-empty {
  min-height: calc(100vh - 108px);
  transform: translateY(-54px);
  gap: 12px;
  background: #f3f2ed;
}

.global-search-empty p {
  display: block;
}

.global-search-empty-image {
  width: 130px;
  height: auto;
}

.global-search-table {
  margin: 0;
}

.global-search-row {
  min-height: 76px;
  grid-template-columns: 43px minmax(0, 1fr) 26px;
  column-gap: 8px;
  padding: 0;
  border-bottom: 1px solid #e3e4e4;
  background: transparent;
}

.global-search-row:hover,
.global-search-row:focus-visible {
  background: transparent;
}

.global-search-row.selected {
  background: #daded5;
  width: calc(100% + 32px);
  margin-left: -16px;
  padding-right: 16px;
  padding-left: 16px;
}

.global-search-row-cover {
  width: 43px;
  height: 43px;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.global-search-row-cover.blank {
  width: 43px;
  height: 58px;
  border: 1px solid #d7d9d8;
  border-radius: 3px;
  background: #fff;
  box-sizing: border-box;
}

.global-search-row-cover.has-cover,
.global-search-row-cover.locked {
  width: 43px;
  height: 58px;
  border: 1px solid #d7d9d8;
  border-radius: 3px;
  background: #fff;
  box-sizing: border-box;
}

.global-search-row-cover-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  border: 0;
  background: transparent;
  box-sizing: border-box;
  object-fit: contain;
  object-position: center center;
  display: block;
}

.global-search-row.selected .global-search-row-cover.has-cover,
.global-search-row.selected .global-search-row-cover.locked {
  border-color: transparent;
}

.global-search-row-cover-default {
  width: 32px;
  max-height: 42px;
}

.global-search-row-cover.folder-like {
  width: 43px;
  height: 58px;
}

.global-search-row-cover-default.folder-template {
  width: 42px;
  height: 56px;
}

.global-search-row-cover-default.folder-child-icon {
  width: 32px;
  height: 32px;
}

.global-search-table .global-search-row > span.global-search-row-main {
  grid-column: 2;
  min-width: 0;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  color: inherit;
  line-height: normal;
  text-align: left;
}

.global-search-row-title-line {
  min-width: 0;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 9px;
}

.global-search-row-main strong,
.global-search-row strong {
  height: auto;
  display: block;
  min-width: 0;
  color: #3a3a3a;
  font-size: 15px;
  line-height: 22px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.global-search-row-meta {
  width: 100%;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 9px;
  color: #979ba2;
  font-size: 13px;
  line-height: 19px;
  font-weight: 500;
}

.global-search-row-meta i {
  width: 1px;
  height: 9px;
  background: #aeb0b5;
}

.global-search-favorite-status {
  width: 15px;
  height: 15px;
  flex: 0 0 15px;
  object-fit: contain;
  display: block;
}

.global-search-row-more-wrap {
  grid-column: 3;
  width: 26px;
  height: 75px;
}

.global-search-more-button {
  width: 26px;
  height: 26px;
  color: #858995;
}

.global-search-more-button:hover,
.global-search-more-button:focus-visible {
  background: transparent;
}

.global-search-more-menu {
  display: none;
}

.global-search-view-trigger {
  width: 32px;
  height: 32px;
}

.global-search-view-trigger img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.global-search-grid {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  padding: 16px 0 82px;
}

.global-search-card {
  width: auto;
  height: auto;
  min-height: 0;
  align-items: stretch;
  padding: 0;
  --global-search-grid-column-gap: 6px;
  --global-search-grid-row-gap: 6px;
}

.global-search-card.selected::before {
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  background: #daded5;
}

.global-search-card.selected.grid-edge-top::before {
  top: -3px;
}

.global-search-cover {
  width: 100%;
  max-width: none;
  height: auto;
  aspect-ratio: 74 / 98;
  flex: 0 0 auto;
  margin: 0 auto;
  border-color: #eee6df;
}

.global-search-card.selected .global-search-cover,
.global-search-card:focus-visible .global-search-cover {
  border-color: transparent;
}

.global-search-card:hover:not(.selected) .global-search-cover,
.global-search-card:active:not(.selected) .global-search-cover {
  border-color: #eee6df;
  background: #fff;
}

.global-search-cover.folded-cover::before {
  width: 14.8648649%;
  height: 11.2016293%;
}

.content-area.is-global-search .global-search-cover.folded-cover {
  --cover-fold-backdrop: #f3f2ed;
}

.content-area.is-global-search .global-search-card.selected .global-search-cover.folded-cover {
  --cover-fold-backdrop: #daded5;
}

.global-search-cover.folded-cover::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 148 196.4' preserveAspectRatio='none'%3E%3Cpath d='M126.5 0.5V21.5H147.5Z' fill='%23fff'/%3E%3Cpath d='M0.5 0.5H126.5L147.5 21.5V195.9H0.5V0.5Z' fill='none' stroke='%23d7d9d6' stroke-width='1' stroke-linecap='square' stroke-linejoin='miter'/%3E%3Cpath d='M126.5 0.5V21.5H147.5' fill='none' stroke='%23d7d9d6' stroke-width='1' stroke-linecap='square' stroke-linejoin='miter'/%3E%3C/svg%3E");
}

.global-search-cover-default {
  width: 30px;
}

.global-search-cover-default.folder-template {
  width: 42px;
  height: 56px;
}

.global-search-cover-default.folder-child-icon {
  width: 46px;
  height: 46px;
}

.global-search-card-title-row {
  height: 22px;
  flex-basis: 22px;
  margin-top: 8px;
  padding: 0 4px;
  gap: 4px;
}

.global-search-card-name {
  height: 22px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}

.global-search-card-meta {
  height: 29px;
  flex-basis: 29px;
  padding: 0 4px 10px;
  box-sizing: border-box;
  color: #a9a19b;
  font-size: 12px;
  line-height: 19px;
  justify-content: space-between;
  gap: 8px;
}

.global-search-selection-layer {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 90;
  height: 52px;
  padding: 0;
  pointer-events: auto;
  will-change: auto;
  transform: none !important;
}

.global-search-selection-bar {
  width: 100%;
  height: 52px;
  padding: 0 14px;
  background: #f3f2ed;
  color: #1c2021;
  display: flex;
  align-items: center;
  gap: 0;
  box-sizing: border-box;
  overflow: visible;
  pointer-events: auto;
  cursor: default;
}

.cloud-main.is-active-preview-detail /deep/ .paper-preview-shell,
.cloud-main.is-active-preview-detail /deep/ .daily-preview-shell,
.cloud-main.is-active-preview-detail /deep/ .learning-annotation-preview-shell {
  touch-action: none;
  overscroll-behavior: contain;
}

.global-search-selection-bar > span {
  color: #000;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  white-space: nowrap;
}

.global-search-selection-bar .global-search-selection-close {
  order: 2;
  width: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  height: 36px !important;
  min-height: 36px !important;
  max-height: 36px !important;
  flex: 0 0 36px !important;
  margin-left: auto;
  border: 0;
  border-radius: 999px !important;
  background: #daded5 !important;
  padding: 0;
  box-sizing: border-box;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  appearance: none;
  -webkit-appearance: none;
}

.global-search-selection-close span {
  width: 12px;
  height: 12px;
  display: block;
  position: relative;
}

.global-search-selection-close span::before,
.global-search-selection-close span::after {
  content: '';
  position: absolute;
  left: 0;
  top: 5px;
  width: 12px;
  height: 1.5px;
  background: #000;
}

.global-search-selection-close span::before {
  transform: rotate(45deg);
}

.global-search-selection-close span::after {
  transform: rotate(-45deg);
}

.global-search-quick-action-mask {
  position: fixed;
  inset: 0;
  z-index: 90;
  background: transparent;
}

.global-search-selection-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 91;
  height: calc(58px + env(safe-area-inset-bottom));
  margin: 0;
  padding: 0 20px env(safe-area-inset-bottom);
  box-sizing: border-box;
  background: #daded5;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
}

.global-search-selection-actions button {
  width: 28px;
  height: 44px;
  border: 0;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-8px);
}

.global-search-selection-actions button:disabled {
  opacity: .45;
}

.global-search-selection-actions img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  display: block;
}

.global-search-view-sheet-mask {
  position: fixed;
  inset: 0;
  z-index: 80;
  background: rgba(0, 0, 0, .38);
}

.global-search-view-sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 92;
  min-height: 226px;
  background: #fff;
  padding: 12px 0 calc(22px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  box-shadow: 0 -6px 22px rgba(0, 0, 0, .08);
}

.global-search-view-sheet h3 {
  height: 48px;
  margin: 0;
  padding: 0 17px;
  color: #1b2021;
  font-size: 15px;
  line-height: 48px;
  font-weight: 600;
}

.global-search-view-sheet-row {
  width: 100%;
  height: 50px;
  border: 0;
  background: #fff;
  padding: 0 18px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 13px;
  color: #2c302f;
  font-size: 15px;
  line-height: 22px;
  text-align: left;
}

.global-search-view-sheet-row.active {
  background: #eff3ed;
}

.global-search-view-sheet-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  display: block;
  flex: 0 0 22px;
}

.global-search-view-sheet-check {
  width: 12px;
  height: 7px;
  border-left: 1.5px solid #343936;
  border-bottom: 1.5px solid #343936;
  transform: rotate(-45deg);
  margin-left: auto;
}

.icon-button {
  width: 28px;
  height: 28px;
}

.search-button img,
.recent-view-trigger img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.myfile-view-trigger img {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.content-toolbar {
  height: 46px;
  padding: 8px 14px 0;
  justify-content: flex-end;
}

.content-area {
  padding: 0 12px calc(78px + env(safe-area-inset-bottom));
  background: #f3f2ed;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.content-area::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}

.content-area.has-toolbar {
  padding-top: 0;
}

.content-area.is-empty {
  padding: 0 12px calc(78px + env(safe-area-inset-bottom));
  overflow: auto;
}

.content-area.is-recent-page {
  position: fixed;
  top: 52px;
  right: 0;
  bottom: 0;
  left: 0;
  padding-top: 0;
  padding-right: 15px;
  padding-left: 15px;
  background: #f3f2ed;
  transition: padding-top .28s ease;
}

.content-area.is-recent-page.is-pull-refreshing {
  padding-top: 100px;
}

.content-area.is-myfile-page {
  position: fixed;
  top: 52px;
  right: 0;
  bottom: 0;
  left: 0;
  padding-top: 0;
  padding-right: 15px;
  padding-left: 15px;
  background: #f3f2ed;
  transition: padding-top .28s ease;
}

.content-area.is-myfile-page.is-pull-refreshing {
  padding-top: 100px;
}

.content-area.is-myfile-page .folder-grid {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  padding: 16px 0 82px;
}

.content-area.is-myfile-page .folder-card {
  width: auto;
  min-width: 0;
  height: auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0;
  text-align: left;
}

.content-area.is-myfile-page .folder-card .folder-art {
  width: 100%;
  height: auto;
  aspect-ratio: 148 / 198;
  border-color: #eee6df;
  background: #fff;
}

.content-area.is-myfile-page .folder-card.selected .folder-art,
.content-area.is-myfile-page .folder-card:focus-visible .folder-art {
  border-color: transparent;
  background: #fff;
}

.content-area.is-myfile-page .folder-card:hover .folder-art,
.content-area.is-myfile-page .folder-card:active .folder-art {
  border-color: #eee6df;
  background: #fff;
}

.content-area.is-myfile-page .folder-card .folder-name {
  height: 22px;
  flex: 0 0 22px;
  margin-top: 8px;
  padding: 0 4px;
  color: #121618;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  box-sizing: border-box;
}

.content-area.is-myfile-page .folder-card-count {
  height: 29px;
  flex: 0 0 29px;
  margin-top: 0;
  padding: 0 4px 10px;
  box-sizing: border-box;
  color: #a9a19b;
  font-size: 12px;
  line-height: 19px;
  font-weight: 500;
}

.content-area.is-myfile-page .folder-list {
  margin: 0;
  padding: 7px 0 82px;
}

.content-area.is-myfile-page .folder-row {
  width: 100%;
  min-height: 76px;
  height: auto;
  display: grid;
  grid-template-columns: 43px minmax(0, 1fr);
  column-gap: 8px;
  align-items: center;
  padding: 0;
  border-bottom: 1px solid #e3e4e4;
  background: transparent;
}

.content-area.is-myfile-page .folder-row:hover,
.content-area.is-myfile-page .folder-row:focus-visible,
.content-area.is-myfile-page .folder-row:active {
  background: transparent;
}

.content-area.is-myfile-page .folder-row.selected {
  width: calc(100% + 30px);
  margin-left: -15px;
  padding-right: 15px;
  padding-left: 15px;
  background: #daded5;
}

.content-area.is-myfile-page .folder-art.small {
  width: 43px;
  height: 43px;
  flex: 0 0 43px;
}

.content-area.is-myfile-page .folder-art img {
  width: 38px;
}

.content-area.is-myfile-page .folder-art.small img {
  width: 46px;
  height: auto;
}

.content-area.is-myfile-page .folder-row-main {
  min-width: 0;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  color: inherit;
  font-size: inherit;
  line-height: normal;
  text-align: left;
}

.content-area.is-myfile-page .folder-row .folder-name {
  min-width: 0;
  width: 100%;
  height: auto;
  display: block;
  color: #3a3a3a;
  font-size: 15px;
  line-height: 22px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-area.is-myfile-page .folder-row .folder-count {
  height: 19px;
  display: block;
  color: #979ba2;
  font-size: 13px;
  line-height: 19px;
  font-weight: 500;
  text-align: left;
}

.recent-pull-refresh {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 20;
  height: 100px;
  color: #1f3a2d;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.recent-pull-refresh > strong {
  font-size: 15px;
  line-height: 22px;
  font-weight: 500;
}

.content-area /deep/ .ant-spin-container,
.content-area /deep/ .ant-spin-nested-loading,
.cloud-list-content {
  min-height: calc(100vh - 52px);
}

.recent-empty {
  min-height: calc(100vh - 130px);
}

.recent-table {
  margin: 0;
}

.recent-row {
  min-height: 76px;
  display: grid;
  grid-template-columns: 43px minmax(0, 1fr) 26px;
  column-gap: 8px;
  align-items: center;
  padding: 0;
  border-bottom: 1px solid #e3e4e4;
  background: transparent;
  cursor: pointer;
}

.recent-row:hover,
.recent-row:focus-visible {
  background: transparent;
}

.recent-row.selected {
  background: #daded5;
  width: calc(100% + 30px);
  margin-left: -15px;
  padding-right: 15px;
  padding-left: 15px;
}

.recent-row-cover {
  width: 43px;
  height: 43px;
  border: 0;
  background: transparent;
}

.recent-row-cover.has-cover,
.recent-row-cover.locked {
  width: 43px;
  height: 58px;
}

.recent-row-cover.has-cover {
  border: 1px solid #d7d9d8;
  border-radius: 3px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.recent-row-cover-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-sizing: border-box;
  object-fit: contain;
  object-position: center center;
  display: block;
}

.recent-row.selected .recent-row-cover.has-cover {
  border-color: transparent;
}

.recent-row-cover-default {
  width: 32px;
  min-width: 32px;
  max-width: 32px;
  height: 32px;
  min-height: 32px;
  max-height: 32px;
  inline-size: 32px;
  min-inline-size: 32px;
  max-inline-size: 32px;
  block-size: 32px;
  min-block-size: 32px;
  max-block-size: 32px;
  flex: 0 0 32px;
  object-fit: contain;
  display: block;
  box-sizing: content-box;
}

.recent-row-cover-default.folder-icon {
  width: 46px;
  min-width: 46px;
  max-width: 46px;
  height: 46px;
  min-height: 46px;
  max-height: 46px;
  inline-size: 46px;
  min-inline-size: 46px;
  max-inline-size: 46px;
  block-size: 46px;
  min-block-size: 46px;
  max-block-size: 46px;
  flex: 0 0 46px;
}

.recent-table .recent-row > span.recent-row-main {
  grid-column: 2;
  min-width: 0;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  color: inherit;
  font-size: inherit;
  line-height: normal;
  text-align: left;
}

.recent-row-title-line {
  min-width: 0;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 9px;
}

.recent-row-meta {
  width: 100%;
  justify-content: flex-start;
}

.recent-row-main strong,
.recent-row strong {
  height: auto;
  display: block;
  min-width: 0;
  font-family: PingFangSC, PingFang SC;
  color: #3a3a3a;
  font-size: 15px;
  line-height: 22px;
  font-weight: 500;
  font-style: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-row-meta {
  height: 19px;
  display: flex;
  align-items: center;
  gap: 9px;
  font-family: PingFangSC, PingFang SC;
  color: #979ba2;
  font-size: 13px;
  line-height: 19px;
  font-weight: 500;
  font-style: normal;
}

.recent-row-meta i {
  width: 1px;
  height: 9px;
  background: #aeb0b5;
}

.recent-row-more-wrap {
  grid-column: 3;
  width: 26px;
  height: 75px;
}

.recent-more-button {
  width: 26px;
  height: 26px;
  color: #858995;
}

.recent-more-button:hover,
.recent-more-button:focus-visible {
  background: transparent;
}

.recent-more-menu {
  display: none;
}

.recent-favorite-status {
  width: 15px;
  height: 15px;
  flex: 0 0 15px;
}

.recent-grid {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  padding: 16px 0 82px;
}

.recent-card {
  width: auto;
  height: auto;
  min-height: 0;
  align-items: stretch;
  padding: 0;
}

.recent-card.selected::before {
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  background: #daded5;
}

.recent-card.selected.grid-edge-top::before {
  top: -3px;
}

.recent-cover {
  width: 124px;
  max-width: 100%;
  height: auto;
  aspect-ratio: 116 / 154;
  flex: 0 0 auto;
  margin: 0 auto;
  border-color: #eee6df;
  background: #fff;
}

.recent-cover-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  border: 0;
  background: transparent;
  box-sizing: border-box;
  object-fit: contain;
  object-position: center center;
  display: block;
}

.recent-card.selected .recent-cover,
.recent-card:focus-visible .recent-cover {
  border-color: transparent;
}

.recent-card:hover:not(.selected) .recent-cover,
.recent-card:active:not(.selected) .recent-cover {
  border-color: #eee6df;
  background: #fff;
}

.recent-cover.folded-cover::after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 148 196.4' preserveAspectRatio='none'%3E%3Cpath d='M126.5 0.5V21.5H147.5Z' fill='%23fff'/%3E%3Cpath d='M0.5 0.5H126.5L147.5 21.5V195.9H0.5V0.5Z' fill='none' stroke='%23d7d9d6' stroke-width='1' stroke-linecap='square' stroke-linejoin='miter'/%3E%3Cpath d='M126.5 0.5V21.5H147.5' fill='none' stroke='%23d7d9d6' stroke-width='1' stroke-linecap='square' stroke-linejoin='miter'/%3E%3C/svg%3E");
}

.recent-cover.folded-cover::before {
  width: 14.8648649%;
  height: 11.2016293%;
}

.recent-cover-default {
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  height: 30px;
  min-height: 30px;
  max-height: 30px;
  inline-size: 30px;
  min-inline-size: 30px;
  max-inline-size: 30px;
  block-size: 30px;
  min-block-size: 30px;
  max-block-size: 30px;
  flex: 0 0 30px;
  object-fit: contain;
  display: block;
  box-sizing: content-box;
}

.recent-card-title-row {
  height: 22px;
  flex-basis: 22px;
  margin-top: 8px;
  padding: 0 4px;
  gap: 4px;
}

.recent-card-name {
  height: 22px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}

.recent-card-meta {
  height: 29px;
  flex-basis: 29px;
  padding: 0 4px 10px;
  box-sizing: border-box;
  color: #a9a19b;
  font-size: 12px;
  line-height: 19px;
  justify-content: space-between;
  gap: 8px;
}

.recent-selection-layer {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 90;
  height: 52px;
  padding: 0;
  pointer-events: auto;
  will-change: auto;
  transform: none !important;
}

.recent-selection-bar {
  height: 52px;
  padding: 0 14px;
  background: #f3f2ed;
  color: #1c2021;
  gap: 0;
  overflow: visible;
  cursor: default;
}

.recent-selection-bar > span {
  font-family: PingFangSC, PingFang SC;
  color: #000;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  font-style: normal;
}

.recent-selection-close {
  order: 2;
  width: 36px;
  min-width: 36px;
  height: 36px;
  flex: 0 0 36px;
  margin-left: auto;
  border: 0;
  border-radius: 50% !important;
  background: #daded5;
  padding: 0;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.recent-selection-close span {
  width: 12px;
  height: 12px;
}

.recent-selection-close span::before,
.recent-selection-close span::after {
  width: 12px;
  top: 5px;
  background: #000;
}

.recent-quick-action-mask {
  position: fixed;
  inset: 0;
  z-index: 90;
  background: transparent;
}

.recent-selection-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 91;
  height: calc(58px + env(safe-area-inset-bottom));
  margin: 0;
  padding: 0 20px env(safe-area-inset-bottom);
  box-sizing: border-box;
  background: #daded5;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
}

.recent-selection-actions button {
  width: 28px;
  height: 44px;
  justify-content: center;
  transform: translateY(-8px);
}

.recent-selection-actions img {
  width: 22px;
  height: 22px;
}

.recent-action-edit-icon,
.recent-action-share-icon,
.recent-action-delete-icon,
.recent-action-more-icon {
  width: 22px;
  height: 22px;
  display: block;
  position: relative;
  color: #1f2422;
}

.recent-action-edit-icon::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 4px;
  width: 13px;
  height: 13px;
  border: 1.5px solid currentColor;
}

.recent-action-edit-icon::after {
  content: '';
  position: absolute;
  right: 2px;
  top: 2px;
  width: 10px;
  height: 1.5px;
  background: currentColor;
  transform: rotate(-45deg);
  transform-origin: right center;
}

.recent-action-share-icon::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 10px;
  width: 14px;
  height: 1.5px;
  background: currentColor;
  transform: rotate(-25deg);
  box-shadow: 0 8px 0 currentColor;
}

.recent-action-share-icon::after {
  content: '';
  position: absolute;
  left: 2px;
  top: 4px;
  width: 5px;
  height: 5px;
  border: 1.5px solid currentColor;
  border-radius: 50%;
  box-shadow: 13px 6px 0 -1.5px #dde4d9, 13px 6px 0 0 currentColor, 2px 14px 0 -1.5px #dde4d9, 2px 14px 0 0 currentColor;
}

.recent-action-delete-icon::before {
  content: '';
  position: absolute;
  left: 6px;
  top: 7px;
  width: 10px;
  height: 12px;
  border: 1.5px solid currentColor;
  border-top: 0;
}

.recent-action-delete-icon::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 4px;
  width: 12px;
  height: 1.5px;
  background: currentColor;
  box-shadow: 3px -2px 0 -0.5px currentColor;
}

.recent-action-more-icon::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 10px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 7px 0 0 currentColor, 14px 0 0 currentColor;
}

.recent-sheet-mask {
  position: fixed;
  inset: 0;
  z-index: 80;
  background: rgba(0, 0, 0, .38);
}

.recent-view-sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 92;
  min-height: 226px;
  background: #fff;
  padding: 12px 0 calc(22px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  box-shadow: 0 -6px 22px rgba(0, 0, 0, .08);
}

.recent-view-sheet h3 {
  height: 48px;
  margin: 0;
  padding: 0 17px;
  color: #1b2021;
  font-size: 15px;
  line-height: 48px;
  font-weight: 600;
}

.recent-sheet-row {
  width: 100%;
  height: 50px;
  border: 0;
  background: #fff;
  padding: 0 18px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 13px;
  color: #2c302f;
  font-size: 15px;
  line-height: 22px;
  text-align: left;
}

.recent-sheet-row.active {
  background: #eef3eb;
}

.recent-sheet-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  display: block;
  flex: 0 0 22px;
}

.recent-sheet-check {
  width: 12px;
  height: 7px;
  border-left: 1.5px solid #343936;
  border-bottom: 1.5px solid #343936;
  transform: rotate(-45deg);
  margin-left: auto;
}

.myfile-sheet-mask {
  position: fixed;
  inset: 0;
  z-index: 80;
  background: rgba(0, 0, 0, .38);
}

.myfile-view-sheet {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 92;
  min-height: 226px;
  background: #fff;
  padding: 12px 0 calc(22px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  box-shadow: 0 -6px 22px rgba(0, 0, 0, .08);
}

.myfile-view-sheet h3 {
  height: 48px;
  margin: 0;
  padding: 0 17px;
  color: #1b2021;
  font-size: 15px;
  line-height: 48px;
  font-weight: 600;
}

.myfile-sheet-row {
  width: 100%;
  height: 50px;
  border: 0;
  background: #fff;
  padding: 0 18px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 13px;
  color: #2c302f;
  font-size: 15px;
  line-height: 22px;
  text-align: left;
}

.myfile-sheet-row.active {
  background: #eef3eb;
}

.myfile-sheet-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  display: block;
  flex: 0 0 22px;
}

.myfile-sheet-check {
  width: 12px;
  height: 7px;
  border-left: 1.5px solid #343936;
  border-bottom: 1.5px solid #343936;
  transform: rotate(-45deg);
  margin-left: auto;
}

.recent-action-sheet-mask {
  position: fixed;
  inset: 0;
  z-index: 88;
  background: transparent;
}

.recent-action-sheet {
  position: fixed;
  right: 12px;
  bottom: 56px;
  z-index: 93;
  width: 126px;
  background: #fff;
  padding: 7px 0;
  box-sizing: border-box;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .12);
}

.recent-action-sheet button {
  width: 100%;
  height: 44px;
  border: 0;
  background: transparent;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #222725;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
}

.recent-action-sheet button:disabled {
  opacity: .36;
}

.recent-action-sheet img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  display: block;
}

.mobile-tabbar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 70;
  height: 56px;
  padding: 6px 10px 6px;
  padding: 6px 10px calc(6px + constant(safe-area-inset-bottom));
  padding: 6px 10px calc(6px + env(safe-area-inset-bottom));
  background: #f3f2ed;
  border-top: 1px solid #eee5de;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  align-items: center;
  justify-items: stretch;
  box-sizing: content-box;
}

.cloud-shell.is-daily-root .mobile-tabbar {
  background: #f3f2ed;
  border-top-color: #e8e0da;
}

.cloud-shell.is-daily-root .mobile-tab.active .mobile-tab-icon-frame {
  background: #daded6;
}

.mobile-tab {
  width: 100%;
  min-width: 0;
  height: 44px;
  border: 0;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-tab-icon-frame {
  width: 54px;
  max-width: 100%;
  height: 34px;
  border-radius: 17px !important;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.mobile-tab.active .mobile-tab-icon-frame {
  width: 63px;
  height: 39.6667px;
  border-radius: 19.8333px !important;
  background: #dce5db;
}

.mobile-user-tab.active .mobile-tab-icon-frame {
  width: 63px;
  height: 39.6667px;
  border-radius: 19.8333px !important;
}

.mobile-tab img {
  width: 28px;
  max-width: 100%;
  height: 28px;
  max-height: 100%;
  object-fit: contain;
  display: block;
}

.recent-learning-mask.preview-open,
.cloud-page.collapsed ~ .recent-learning-mask.preview-open {
  left: 0;
}

.recent-learning-modal.preview-open,
.cloud-page.collapsed ~ .recent-learning-modal.preview-open {
  left: 0;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  height: 100dvh;
}

.recent-learning-modal {
  width: 95vw;
  box-sizing: border-box;
}

.recent-learning-modal.loading-open {
  height: auto;
}

.recent-learning-modal.loading-open .recent-learning-resolving {
  min-height: 320px;
  padding: 106.6667px 20px 20px;
  text-align: center;
}

.recent-learning-mask {
  background: rgba(0, 0, 0, .3);
}

.recent-learning-modal.summary-open {
  height: auto;
}

.recent-learning-modal.detail-open {
  height: auto;
  max-height: calc(100% - 20px);
}

.recent-learning-summary-panel {
  height: auto;
  padding-bottom: 20px;
}

.recent-learning-modal.detail-open .recent-learning-detail-panel {
  height: auto;
  max-height: calc(100vh - 20px);
  overflow: hidden;
}

.recent-learning-modal.annotations-open,
.recent-learning-modal.annotations-open .recent-learning-detail-panel {
  max-height: 80vh;
}

.recent-learning-close span {
  width: 10.5px;
  height: 10.5px;
  margin: 8.75px auto;
}

.recent-learning-close span::before,
.recent-learning-close span::after {
  left: -.75px;
  top: 4.5px;
  width: 12px;
}

.recent-learning-head {
  height: 100px;
  padding: 18px 44px 8px 20px;
}

.recent-learning-main strong {
  font-size: 18px;
}

.recent-learning-chip {
  font-size: 13px;
}

.recent-learning-list {
  width: 100%;
  margin: 0 auto;
}

.recent-learning-row {
  height: auto;
  min-height: 50px;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) 48px;
  column-gap: 8px;
  padding: 7px 20px;
}

.recent-learning-row:not(.is-progress) {
  grid-template-columns: minmax(0, 1fr) 48px;
}

.recent-learning-row strong {
  min-width: 0;
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
}

.recent-learning-row:not(.is-progress) strong {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  word-break: break-word;
}

.recent-learning-row em {
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
}

.recent-learning-row:not(.is-progress) em {
  grid-column: 2;
}

.recent-learning-progress {
  height: 4px;
}

.recent-learning-tabs {
  height: 70px;
  flex: 0 0 70px;
  padding: 0 53px 0 20px;
}

.recent-learning-tabs-main {
  flex: 1;
  gap: 10px;
  overflow: hidden;
}

.recent-learning-tabs-back {
  width: 36px;
  flex: 0 0 36px;
  justify-content: center;
  position: relative;
  z-index: 3;
}

.recent-learning-tab-button {
  height: 70px;
  min-width: 0;
  max-width: none;
  flex: 0 1 auto;
  padding: 2px 6px 0;
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
}

.recent-learning-tab-button > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-tabs-close span {
  width: 11.2px;
  height: 11.2px;
  margin: 8.4px auto;
}

.recent-learning-tabs-close span::before,
.recent-learning-tabs-close span::after {
  left: -.8px;
  top: 4.8px;
  width: 12.8px;
}

.recent-learning-detail-content {
  flex: 0 1 auto;
  min-height: 250px;
  max-height: 500px;
}

.recent-learning-detail-content.is-empty {
  display: flex;
  flex-direction: column;
}

.recent-learning-detail-content.is-empty > .recent-learning-empty-box {
  flex: 1;
  min-height: 0;
}

.recent-learning-detail-content.is-annotations {
  min-height: min(442px, calc(80vh - 70px));
  max-height: calc(80vh - 70px);
}

.recent-learning-annotation-toolbar {
  padding-right: 20px;
  gap: 8px;
}

.recent-learning-annotation-source-select {
  width: 118.4px;
  height: 28.8px;
  flex-basis: 118.4px;
}

.recent-learning-annotation-source-select /deep/ .ant-select-selection--single {
  height: 28.8px;
}

.recent-learning-annotation-source-select /deep/ .ant-select-selection__rendered {
  line-height: 27.2px;
}

.recent-learning-view-switch,
.recent-learning-view-switch img {
  width: 54.4px;
  height: 28.8px;
}

.recent-learning-view-switch {
  flex-basis: 54.4px;
}

.recent-learning-view-hotspot {
  width: 27.2px;
  height: 28.8px;
}

.recent-learning-list-box,
.recent-learning-annotation-list {
  width: 100%;
  min-height: 250px;
  max-height: 500px;
  margin-right: auto;
  margin-left: auto;
  overflow-y: auto;
}

.recent-learning-info-row,
.recent-learning-bookmark-row,
.recent-learning-highlight-row,
.recent-learning-annotation-row {
  height: 50px;
  min-height: 50px;
}

.recent-learning-bookmark-row {
  grid-template-columns: minmax(0, 1fr) 52px;
  column-gap: 8px;
  padding: 0 8px;
}

.recent-learning-highlight-row {
  grid-template-columns: minmax(0, 1fr) 12px;
  column-gap: 8px;
  padding: 0 8px;
}

.recent-learning-bookmark-main,
.recent-learning-highlight-main {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 0;
}

.recent-learning-bookmark-main strong,
.recent-learning-highlight-main strong {
  min-width: 0;
  flex: 1;
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
}

.recent-learning-bookmark-main em,
.recent-learning-highlight-main em,
.recent-learning-row-page {
  flex: 0 0 auto;
  font-size: 11px;
  line-height: 16px;
}

.recent-learning-bookmark-row .recent-learning-bookmark-main em,
.recent-learning-bookmark-row .recent-learning-row-page {
  font-size: 13px;
}

.recent-learning-bookmark-list,
.recent-learning-bookmark-row,
.recent-learning-bookmark-row:hover,
.recent-learning-bookmark-row:focus-visible,
.recent-learning-bookmark-row.active {
  background: transparent;
}

.recent-learning-highlight-row:hover,
.recent-learning-highlight-row:focus-visible,
.recent-learning-highlight-row.active {
  background: transparent;
}

.recent-learning-highlight-main strong {
  font-size: 14px;
}

.recent-learning-highlight-main em {
  font-size: 13px;
}

.recent-learning-highlight-row i {
  width: 7px;
  height: 7px;
  border-top-width: 1px;
  border-right-width: 1px;
}

.recent-learning-highlight-page header {
  height: 65px;
  flex: 0 0 65px;
}

.recent-learning-annotation-grid {
  width: calc(100vw - 30px);
  max-width: 100%;
  margin: 0 auto;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: max-content;
  align-items: start;
  gap: 6px;
  padding: 16px 0 82px;
}

.recent-learning-annotation-card {
  width: auto;
  height: auto;
  min-height: 0;
  align-items: stretch;
  overflow: visible;
  --recent-learning-grid-column-gap: 6px;
  --recent-learning-grid-row-gap: 6px;
}

.recent-learning-annotation-card.active::before {
  top: -3px;
  right: -3px;
  bottom: -3px;
  left: -3px;
  background: #daded5;
}

.recent-learning-annotation-cover {
  width: 100%;
  height: auto;
  aspect-ratio: 74 / 98;
  flex: 0 0 auto;
  border-color: #eee6df;
}

.recent-learning-annotation-card strong {
  height: 22px;
  flex: 0 0 22px;
  margin-top: 8px;
  padding: 0 4px;
  color: #0f1112;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}

.recent-learning-annotation-card em {
  height: 29px;
  flex: 0 0 29px;
  padding: 0 4px 10px;
  box-sizing: border-box;
  color: #a9a19b;
  font-size: 12px;
  line-height: 19px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-bookmark-main strong {
  font-size: 14px;
}

.recent-learning-annotation-row {
  height: 76px;
  min-height: 76px;
  grid-template-columns: 43px minmax(0, 1fr) minmax(64px, 82px);
  column-gap: 8px;
  padding: 0 8px;
}

.recent-learning-annotation-cover.small {
  width: 43px;
  height: 58px;
  flex-basis: 43px;
  aspect-ratio: auto;
}

.recent-learning-annotation-row strong {
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
}

.recent-learning-annotation-row em {
  min-width: 0;
  font-size: 13px;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-annotation-list {
  min-height: min(380px, calc(80vh - 132px));
  max-height: min(760px, calc(80vh - 132px));
}

.recent-learning-preview-head {
  height: 55px;
  flex: 0 0 55px;
  position: relative;
  z-index: 40;
  padding: 0 10px 0 16px;
  border-bottom: 0;
  background: #f3f2ed;
}

.recent-learning-preview-title {
  flex: 1;
  gap: 0;
}

.recent-learning-preview-title strong,
.recent-learning-preview-zoom-tool {
  display: none;
}

.recent-learning-preview-back {
  width: 36px;
  height: 36px;
  border: 1px solid #e5d5c8;
  border-radius: 50% !important;
  background: transparent;
  flex: 0 0 36px;
}

.recent-learning-preview-back span {
  width: 11px;
  height: 11px;
  border-left-width: 2px;
  border-bottom-width: 2px;
  transform: translateX(2px) rotate(45deg);
}

.recent-learning-preview-actions {
  gap: 20px;
}

.recent-learning-preview-body:not(.pages-open) {
  --recent-learning-preview-base-width: 100vw;
  --recent-learning-preview-base-height: 133.333333vw;
}

.recent-learning-preview-shell {
  --recent-preview-center-min: 0px;
  height: calc(100vh - 55px - 66px);
  position: relative;
  z-index: 0;
  padding: 0;
  overflow: auto;
  background: #f3f2ed;
  touch-action: none;
  overscroll-behavior: contain;
  cursor: default;
}

.recent-learning-preview-zoom {
  margin: max(var(--recent-preview-center-min), calc((100vh - 55px - 66px - 133.333333vw * var(--recent-learning-preview-zoom)) / 2)) auto 0;
}

.recent-learning-preview-stage {
  border: 0;
  background: #fff;
}

.recent-learning-preview-controls {
  left: 50%;
  right: auto;
  bottom: 16px;
  z-index: 40;
  align-items: center;
  transform: translateX(-50%);
  pointer-events: auto;
}

.recent-learning-preview-count {
  gap: 0;
}

.recent-learning-preview-count button {
  display: none;
}

.recent-learning-preview-count span {
  min-width: 68px;
  height: 40px;
  border: 1px solid #c7c9c8;
  background: #f3f2ed;
  color: #44484a;
  font-size: 16px;
}

.recent-learning-preview-pages-grid {
  width: 100%;
  max-width: 100%;
  height: 100%;
  min-width: 0;
  padding: 16px 15px calc(82px + env(safe-area-inset-bottom));
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: max-content;
  align-content: start;
  align-items: start;
  justify-content: stretch;
  column-gap: 6px;
  row-gap: 3px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

.recent-learning-preview-pages-grid button {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: auto;
  min-height: 0;
  padding: 0 0 19px;
  align-items: stretch;
  overflow: visible;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

.recent-learning-preview-pages-grid button:hover > span,
.recent-learning-preview-pages-grid button:focus > span,
.recent-learning-preview-pages-grid button:focus-visible > span,
.recent-learning-preview-pages-grid button:active > span,
.recent-learning-preview-pages-grid button.active > span,
.recent-learning-preview-pages-grid button.selected > span {
  border-color: transparent;
  background: #fff;
}

.recent-learning-preview-pages-grid button.selected::before {
  top: -3px;
  right: -3px;
  bottom: 0;
  left: -3px;
  background: #daded5;
}

.recent-learning-preview-pages-grid button.selected.grid-edge-top::before,
.recent-learning-preview-pages-grid button.selected:not(.grid-selected-row-start)::before {
  top: -3px;
}

.recent-learning-preview-pages-grid button.selected.grid-selection-continues-below::before {
  bottom: -3px;
}

.recent-learning-preview-pages-grid button > span {
  width: 100%;
  max-width: 100%;
  height: auto;
  aspect-ratio: 74 / 98;
  flex: 0 0 auto;
  margin: 0;
  border: 1px solid #eee6df;
  box-sizing: border-box;
}

.recent-learning-preview-pages-grid button.active > span {
  position: relative;
  border-bottom: 0;
  border-radius: 0;
}

.recent-learning-preview-pages-grid button.active > span::after {
  content: '';
  position: absolute;
  right: -1px;
  bottom: -1px;
  left: -1px;
  z-index: 2;
  height: 3.333333px;
  border-radius: 0;
  background: #050505;
  pointer-events: none;
}

.recent-learning-preview-pages-grid img {
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  object-position: center center;
}

.recent-learning-preview-pages-grid strong {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 22px;
  flex: 0 0 22px;
  margin-top: 8px;
  padding: 0 4px;
  box-sizing: border-box;
  color: #121618;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}

.content-header-title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.content-header.is-recent-learning-detail {
  position: relative;
  z-index: 1079;
  background: #f3f2ed;
}

.recent-learning-root-back {
  width: 34px;
  height: 34px;
  border: 1px solid #e5d5c8;
  border-radius: 50% !important;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
}

.recent-learning-root-back span {
  width: 9px;
  height: 9px;
  border-left: 1.5px solid #171a19;
  border-bottom: 1.5px solid #171a19;
  transform: translateX(2px) rotate(45deg);
}

.recent-learning-mask:not(.preview-open) {
  display: block;
  inset: 0 0 auto;
  width: 100vw;
  height: 100px;
  background: rgba(0, 0, 0, .32);
}

.recent-learning-modal:not(.preview-open),
.recent-learning-modal.loading-open:not(.preview-open),
.recent-learning-modal.summary-open:not(.preview-open),
.recent-learning-modal.detail-open:not(.preview-open),
.recent-learning-modal.annotations-open:not(.preview-open) {
  left: 0;
  top: 100px;
  right: 0;
  bottom: 0;
  width: 100vw;
  max-width: 100vw;
  height: calc(100vh - 100px);
  height: calc(100dvh - 100px);
  max-height: none;
  border: 0;
  background: #fff;
  box-shadow: none;
  transform: none;
}

.recent-learning-mask.is-my-files-learning:not(.preview-open) {
  height: 100px;
}

.recent-learning-modal.is-my-files-learning:not(.preview-open) {
  top: 100px;
  height: calc(100vh - 100px);
  height: calc(100dvh - 100px);
}

.recent-learning-modal.loading-open .recent-learning-resolving {
  min-height: 100%;
}

.recent-learning-summary-panel,
.recent-learning-modal.detail-open .recent-learning-detail-panel,
.recent-learning-modal.annotations-open .recent-learning-detail-panel {
  height: 100%;
  max-height: none;
}

.recent-learning-summary-panel {
  padding-bottom: 0;
}

.recent-learning-head {
  height: 94px;
  padding: 23px 48px 15px 28px;
  background: #fbf7f3;
}

.recent-learning-main strong {
  max-width: 100%;
  font-size: 17px;
  line-height: 24px;
}

.recent-learning-meta {
  gap: 10px;
  margin-top: 7px;
}

.recent-learning-size {
  font-size: 12px;
  line-height: 20px;
}

.recent-learning-chip {
  min-width: 34px;
  height: 20px;
  padding: 0 6px;
  font-size: 11px;
  line-height: 18px;
}

.recent-learning-close {
  top: 10px;
  right: 9px;
  width: 32px;
  height: 32px;
}

.recent-learning-row {
  height: auto;
  min-height: 80px;
  grid-template-columns: minmax(70px, 1fr) minmax(72px, 1.4fr) 44px;
  column-gap: 10px;
  padding: 10px 28px;
}

.recent-learning-row:not(.is-progress) {
  grid-template-columns: minmax(0, 1fr) 44px;
}

.recent-learning-row.is-progress {
  height: 100px;
  min-height: 100px;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: 22px 5px;
  align-content: center;
  row-gap: 13px;
  padding-top: 0;
  padding-bottom: 0;
}

.recent-learning-row.is-progress strong {
  grid-column: 1;
  grid-row: 1;
}

.recent-learning-row.is-progress em {
  grid-column: 2;
  grid-row: 1;
  width: auto;
  text-align: right;
}

.recent-learning-row.is-progress .recent-learning-progress {
  grid-column: 1 / -1;
  grid-row: 2;
  width: 100%;
}

.recent-learning-row strong,
.recent-learning-row em {
  font-size: 15px;
  line-height: 22px;
  font-weight: 600;
}

.recent-learning-row:not(.is-progress) strong {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  word-break: break-word;
}

.recent-learning-row:not(.is-progress) em {
  grid-column: 2;
}

.recent-learning-progress {
  height: 5px;
}

.recent-learning-tabs {
  height: 76px;
  flex: 0 0 76px;
  gap: 6px;
  padding: 0 45px 0 14px;
  background: #fbf7f3;
}

.recent-learning-tabs-main {
  width: 100%;
  flex: 1;
  gap: 4px;
  overflow: hidden;
}

.recent-learning-tabs-back,
.recent-learning-highlight-back {
  width: 36px;
  height: 36px;
  border: 1px solid #e5d5c8;
  border-radius: 50% !important;
  justify-content: center;
  flex: 0 0 36px;
}

.recent-learning-tabs-back span,
.recent-learning-highlight-back span {
  width: 9px;
  height: 9px;
  border-left-width: 1.5px;
  border-bottom-width: 1.5px;
  transform: translateX(2px) rotate(45deg);
}

.recent-learning-tab-button {
  min-width: 0;
  max-width: 100%;
  height: 36px;
  flex: 0 1 auto;
  border: 0;
  border-radius: 20px !important;
  padding: 8px 20px;
  box-sizing: border-box;
  color: #242826;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.recent-learning-tab-button.is-title-overflow {
  padding-right: 10px;
  padding-left: 10px;
}

.recent-learning-tab-button.active {
  border-bottom-color: transparent;
  background: #dfe6df;
  color: #202422;
}

.recent-learning-tab-button > span {
  display: block;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.recent-learning-tab-title-popover {
  position: fixed;
  z-index: 1000;
  max-width: calc(100vw - 50px);
  border-radius: 1px;
  background: transparent;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .24);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 25px;
  box-sizing: border-box;
  color: #fff;
  text-align: center;
  pointer-events: none;
  overflow: hidden;
  isolation: isolate;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.recent-learning-tab-title-popover::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  border-radius: inherit;
  background: #000;
  opacity: .75;
}

.recent-learning-tab-title-popover span {
  position: relative;
  display: block;
  min-width: 0;
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
  word-break: break-word;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.recent-learning-tabs-close {
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
}

.recent-learning-detail-content,
.recent-learning-detail-content.is-annotations {
  flex: 1;
  min-height: 0;
  max-height: none;
}

.recent-learning-list-box,
.recent-learning-annotation-list {
  min-height: 0;
  max-height: none;
}

.recent-learning-bookmark-row,
.recent-learning-highlight-row {
  height: 92px;
  min-height: 92px;
  padding: 0 17px;
}

.recent-learning-bookmark-row {
  grid-template-columns: minmax(0, 1fr) minmax(34px, 52px);
  column-gap: 12px;
}

.recent-learning-highlight-row {
  grid-template-columns: minmax(0, 1fr) 14px;
  column-gap: 12px;
}

.recent-learning-bookmark-main,
.recent-learning-highlight-main {
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 7px;
  padding: 0;
}

.recent-learning-bookmark-main strong,
.recent-learning-highlight-main strong {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  flex: 0 1 auto;
  font-size: 15px;
  line-height: 21px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-bookmark-main em,
.recent-learning-highlight-main em,
.recent-learning-row-page {
  max-width: 100%;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-highlight-row i,
.recent-learning-row-arrow {
  width: 8px;
  height: 8px;
  border: 0;
  border-top: 1px solid #555d58;
  border-right: 1px solid #555d58;
  transform: rotate(45deg);
  justify-self: end;
}

.recent-learning-highlight-page header {
  height: 76px;
  flex: 0 0 76px;
  grid-template-columns: 36px minmax(0, 1fr);
  gap: 10px;
  padding: 0 48px 0 14px;
  background: #fbf7f3;
}

.recent-learning-highlight-page header strong {
  width: 100%;
  max-width: 100%;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
}

.recent-learning-highlight-page article {
  padding: 24px 18px 30px;
}

.recent-learning-highlight-meta {
  margin-bottom: 14px;
  font-size: 12px;
  line-height: 18px;
}

.recent-learning-highlight-text {
  font-size: 15px;
  line-height: 22px;
  overflow-wrap: anywhere;
}

.recent-learning-annotation-toolbar {
  min-height: 58px;
  padding: 13px 16px 9px;
  gap: 8px;
}

.recent-learning-annotation-list {
  flex: 1;
  width: 100%;
  overflow-y: auto;
}

.recent-learning-annotation-row {
  height: 82px;
  min-height: 82px;
  grid-template-columns: 48px minmax(0, 1fr) 12px;
  column-gap: 12px;
  padding: 8px 17px;
}

.recent-learning-annotation-cover.small {
  width: 44px;
  height: 58px;
  flex-basis: 44px;
}

.recent-learning-annotation-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 5px;
}

.recent-learning-annotation-main strong {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  font-size: 15px;
  line-height: 21px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-annotation-main em {
  min-width: 0;
  max-width: 100%;
  color: #a2a7a4;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-learning-detail-content.is-empty > .recent-learning-empty-box,
.recent-learning-detail-content.is-annotations > .recent-learning-empty-box {
  min-height: 0;
}

.recent-learning-modal:not(.preview-open),
.recent-learning-summary-panel,
.recent-learning-row,
.recent-learning-detail-panel,
.recent-learning-detail-content,
.recent-learning-list-box,
.recent-learning-info-row,
.recent-learning-annotation-list,
.recent-learning-annotation-row,
.recent-learning-empty-box {
  background: #fff;
}
</style>
